(function () {
	'use strict';

	angular.module('app.operation', ['app']).service('OperationWS', Service);

	/** @ngInject */
	function Service($http) {
		var service = this;
		

		
		// PARTIE REMBOURSEMENT
		service.getListRemboursement = function (searchText, statuts,pagination) {
			var paramsgetListRemboursement = {
				'searchText': searchText,
				'statut': statuts
				
			};
			
			paramsgetListRemboursement = _.extend(paramsgetListRemboursement, pagination);
			
	
			return $http.get('/api/demande/remboursement',{
				'params': paramsgetListRemboursement
			});
			
		};
		

		service.getOneDemandeRemboursement = function (id) {
			return $http.get('/api/demande/remboursement/' + id);
		};
		
		service.deleteDemandeRemboursement = function (demande) {
			return $http.delete('/api/demande/remboursement/' + demande.id);
		};
		
		// Permet d'enregistrer ou de mettre à jour une demande de remboursement
		service.saveOrUpdateDemandeRemboursement = function (demande) {
			if (demande.id) {
				return $http.put('/api/demande/remboursement', demande);
			} else {
				return $http.post('/api/demande/remboursement', demande);
			}
		};
		
		service.uploadFilesRemboursement = function (idDemande) {
			return $http.put('/api/demande/remboursement_fichier/uploadall',idDemande);
		};
		
		
		// PARTIE ACHAT
	service.getListAchat = function (searchText, statuts, AValiderParEtablissement, pagination) {
			var paramsListAchat = {
					'searchText': searchText,
					'statut': statuts,
					'aValiderParEtablissement' : AValiderParEtablissement
				};
			
			paramsListAchat = _.extend(paramsListAchat, pagination);
		
		
				return $http.get('/api/demande/achat',{
					'params': paramsListAchat
				});
			
		};

		
		service.getOneDemandeAchat = function (id) {
			return $http.get('/api/demande/achat/' + id);
		};

		service.deleteDemandeAchat = function (demande) {
			return $http.delete('/api/demande/achat/' + demande.id);
		};

		// Permet d'enregistrer ou de mettre à jour une demande
		service.saveOrUpdateDemandeAchat = function (demande, paiement, validerParEtablissement) {
			if (demande.id) {
				return $http.put('/api/demande/achat', demande, {
					params:{
						'paiement': paiement,
						'numeroCheque' : demande.numeroPaiement,
						'validerParEtablissement' : validerParEtablissement
					}
				});
			} else {
				return $http.post('/api/demande/achat', demande);
			}
		};
		
		service.uploadFilesAchat = function (idDemande) {
			return $http.put('/api/demande/achat_fichier/uploadall',idDemande);
		};
		
		// PARTIE MISSION
		
		service.getListMission = function (searchText, statuts,pagination) {
			
				 var paramsListMission = {
					'searchText': searchText,
					'statut': statuts
				};
				
				 paramsListMission = _.extend(paramsListMission, pagination);
				
				return $http.get('/api/demande/mission',{
					'params': paramsListMission
				});
				
			
		};
		
		service.getOneDemandeMission = function (id) {
			return $http.get('/api/demande/mission/' + id);
		};

		service.deleteDemandeMission = function (demande) {
			return $http.delete('/api/demande/mission/' + demande.id);
		};

		// Permet d'enregistrer ou de mettre à jour une demande de mission
		service.saveOrUpdateDemandeMission = function (demande, paiement) {
			if (demande.id) {
				return $http.put('/api/demande/mission', demande, {
					params:{
						'paiement': paiement,
						'numeroCheque' : demande.numeroPaiement
					}
				});
			} else {
				return $http.post('/api/demande/mission', demande);
			}
		};
		
		service.uploadFilesMission = function (idDemande) {
			return $http.put('/api/demande/mission_fichier/uploadall',idDemande);
		};

		service.updateDemandeRemboursementImport = function (id) {
			return $http.put('/api/demande/remboursement/updateEasydore/' + id)
				.then(function (response) {
					return response.data.content;
				});
		};

		service.updateDemandeAchatImport = function (id) {
			return $http.put('/api/demande/achat/updateEasydore/' + id)
				.then(function (response) {
					return response.data.content;
				});
		};

	}
})();

(function() {
	'use strict';

	angular.module('app.operation').controller('EtapeController', Controller);

	function Controller($stateParams, $state, $scope, CategoryWS) {
		var ctrl = this;

		ctrl.detail = {};
		ctrl.etape = {};
		ctrl.listCategories = [];

		ctrl.idModified = $stateParams.id;

		// Permet de gérer les dates de début et de fin
		$('#datetimepickerDebut').on('dp.change', function(e) {
			$('#datetimepickerFin').data('DateTimePicker').minDate(e.date);
		});

		$('#datetimepickerFin').on('dp.change', function(e) {
			$('#datetimepickerDebut').data('DateTimePicker').maxDate(e.date);
		});

		// Initialisation de la demande avec celle passé en paramètre
		ctrl.init = function() {
			ctrl.demande = $stateParams.demande;
			ctrl.loadCategories();
			ctrl.fraisRepas = false;
			ctrl.fraisHotel = false;
		};

		ctrl.loadCategories = function() {
			CategoryWS.getList().then(function(response) {
				ctrl.listCategories = response.data.content;
			});
		};

		// Retour à la demande de mission
		ctrl.goToDemandeMission = function() {
			$state.go('operation.item_demande_mission', {
				id : ctrl.idModified,
				demande : ctrl.demande
			});
		};

		// Action effectué pour ajouter l'étape à la demande de mission
		ctrl.valider = function() {
			ctrl.addEtape();
			ctrl.addVehicule();
			ctrl.goToDemandeMission();
		};

		// Ajout un détail dans la liste des détail de la demande passé en
		// paramètre
		ctrl.addEtape = function() {
			ctrl.etape.numero = ctrl.demande.etapes.length + 1;
			ctrl.etape.lieu = ctrl.destination.libelle;
			ctrl.demande.etapes.push(ctrl.etape);
			ctrl.addDepenses();
		};

		ctrl.addDepenses = function() {
			var nbEtape = ctrl.demande.etapes.length;
			var details = ctrl.destination.details;

			// Détails pour les catégories d'hébergement
			_.forEach(details, function(detail) {
				var poste = {
					numeroEtape : nbEtape,
					poste : detail.libelle,
					typeFrais : detail.typeFrais,
					compteCharge : detail.compteCharge,
					montant : ctrl.calculMontant(detail),
					quantite : ctrl.ajouterQuantitePoste(detail.typeFrais),
					montantUnite : ctrl.ajouterMontantUnite(detail),
					selectionne : true,
					remboursement : true,
					fraisReel : ctrl.isFraisReel(detail)
				};
				ctrl.demande.depenses.push(poste);
			});
		};

		// Permet d'ajouter des information sur le libellé du poste (nombre de
		// nuités et de repas)
		ctrl.ajouterQuantitePoste = function(typeFrais) {
			var qte = 1;
			if (typeFrais === 'REPAS') {
				qte = ctrl.nbRepas;
			} else if (typeFrais === 'HOTEL') {
				qte = ctrl.nbNuit;
			}

			return qte;
		};

		// Permet d'avoir le montant de chaque item de catégorie (à l'unité)
		ctrl.ajouterMontantUnite = function(detail) {
			var montantUnite = 0.0;
			if (detail.typeFrais === 'REPAS') {
				montantUnite = ctrl.getDetailMontantRepas(detail);
			} else if (detail.typeFrais === 'HOTEL') {
				montantUnite = ctrl.getDetailMontantHotel(detail);
			}
			return montantUnite;
		};

		// Permet de choisir les différents mode de calcul selon le type de la
		// dépense
		ctrl.calculMontant = function(detail) {
			var montant;
			switch (detail.typeFrais) {
			case 'REPAS':
				montant = ctrl.calculMontantRepas(detail);
				break;
			case 'HOTEL':
				montant = ctrl.calculMontantHotel(detail);
				break;
			case 'TRANSPORT1':
			case 'TRANSPORT2':
			case 'AUTRE':
				montant = 0;
				break;
			default:
				montant = detail.reel;
				break;
			}
			return montant;
		};

		// Permet de calculer le montant pour les repas en France
		ctrl.calculMontantRepas = function(detail) {
			var nbPeriode = ctrl.calculPeriodeRepas();

			var montantDetail = ctrl.getDetailMontantRepas(detail);

			return Number(nbPeriode * montantDetail);
		};

		// Permet de calculer le nombre de repas selon la dates de début et de
		// fin de l'étape
		ctrl.calculPeriodeRepas = function() {
			var heureDebut = moment({
				hour : moment(ctrl.etape.dateDebut).format('HH'),
				minute : moment(ctrl.etape.dateDebut).format('mm')
			});

			var heureFin = moment({
				hour : moment(ctrl.etape.dateFin).format('HH'),
				minute : moment(ctrl.etape.dateFin).format('mm')
			});

			// Les périodes pour les repas du midi et du soir

			var debutPeriodeMidi = moment({
				h : 11
			});

			var finPeriodeMidi = moment({
				h : 14
			});

			var debutPeriodeSoir = moment({
				h : 18
			});

			var finPeriodeSoir = moment({
				h : 21
			});

			var nbPeriode = Number(0);
			var nbJour = moment(ctrl.etape.dateFin).diff(
					moment(ctrl.etape.dateDebut), 'days');

			if (nbJour === 0) {
				var jourDebut = moment(ctrl.etape.dateDebut).date();
				var jourFin = moment(ctrl.etape.dateFin).date();

				if (jourDebut === jourFin) {
					if (heureDebut.isBefore(debutPeriodeMidi)) {
						if (heureFin.isBefore(finPeriodeMidi)) {
							nbPeriode = 0;
						} else if (heureFin.isBefore(finPeriodeSoir)) {
							nbPeriode = 1;
						} else {
							nbPeriode = 2;
						}
					} else if (heureDebut.isBefore(debutPeriodeSoir)) {
						if (heureFin.isBefore(finPeriodeSoir)) {
							nbPeriode = 0;
						} else {
							nbPeriode = 1;
						}
					} else {
						nbPeriode = 0;
					}
				} else {
					if (heureDebut.isBefore(debutPeriodeMidi)|| heureDebut.isSame(debutPeriodeMidi)) {
						nbPeriode = 2;
					} else if (heureDebut.isBefore(debutPeriodeSoir)&& heureDebut.isAfter(debutPeriodeMidi)	|| heureDebut.isSame(debutPeriodeSoir)) {
						nbPeriode = 1;
					} else {
						nbPeriode = 0;
					}
				}

			} else {
				// Permet de connaitre le nombre de jour entier entre le début
				// et la date de fin.
				// Exemple heure debut = 12h et heure fin = 10h le lendemain. Il
				// y a bien un jour de différence mais pas de jour entier entre
				// les deux donc 1-1 = 0 jour entier
				if (heureDebut.isBefore(heureFin)|| heureDebut.isSame(heureFin)) {
					nbJour -= 1;
				}

				// Pour les heures de début
				if (heureDebut.isBefore(debutPeriodeMidi)) {
					nbPeriode += 2;
				} else if (heureDebut.isAfter(debutPeriodeMidi)	&& heureDebut.isBefore(debutPeriodeSoir)) {
					nbPeriode += 1;
				} else {
					nbPeriode += 0;
				}

				// Pour les heures de fin
				if (heureFin.isBefore(finPeriodeMidi)) {
					nbPeriode += 0;
				} else if (heureFin.isAfter(finPeriodeMidi)	&& heureFin.isBefore(finPeriodeSoir)) {
					nbPeriode += 1;
				} else {
					nbPeriode += 2;
				}

				nbPeriode += (2 * nbJour);
			}

			return nbPeriode;

		};

		// Permet de calculer les montants pour les hôtels
		ctrl.calculMontantHotel = function(detail) {
			var nbPeriode = ctrl.calculPeriodeHotel();

			var montantDetail = ctrl.getDetailMontantHotel(detail);

			return Number(nbPeriode * montantDetail);
		};

		// Permet de calculer le nombre de période pour l'hotel
		ctrl.calculPeriodeHotel = function() {
			var dateDebut = moment(ctrl.etape.dateDebut);
			var dateFin = moment(ctrl.etape.dateFin);
            // Permet de connaitre le nombre de jour entre la date de début
            // et date de fin ( fin : le 13 septembre, debut 10 septembre,
            // résultat 3 jours)
            var nbPeriode = dateFin.diff(dateDebut, 'days');

			var heureDebut = moment({
				hour : dateDebut.format('HH'),
				minute : dateDebut.format('mm')
			});

			var heureFin = moment({
				hour : dateFin.format('HH'),
				minute : dateFin.format('mm')
			});

			var debutPeriodeHotel = moment({
				h : 22
			});

			var finPeriodeHotel = moment({
				h : 6
			});

			if (nbPeriode === 0) {
				if ((heureDebut.isBefore(debutPeriodeHotel) || heureDebut
						.isSame(debutPeriodeHotel))	&& dateDebut.date() !== dateFin.date()) {
					if (heureFin.isSame(finPeriodeHotel)|| heureFin.isAfter(finPeriodeHotel)) {
						nbPeriode += 1;
					}
				}
			} else {
				var heureDeb = moment({
					h : heureDebut.format('HH'),
					s : heureDebut.format('mm')
				});

				var heureF = moment({
					h : heureFin.format('HH'),
					s : heureFin.format('mm')
				});

				if (heureF.isBefore(heureDeb)) {
					nbPeriode += 1;
				}

				// Cas où l'heure de début est avant ou égale à 22h et heure de
				// fin avant 6h. On enlève une période car le dernier jour
				// n'aura pas de nuité comprise
				if ((heureDebut.isBefore(debutPeriodeHotel) || heureDebut
						.isSame(debutPeriodeHotel)) && heureFin.isBefore(finPeriodeHotel)) {
					nbPeriode -= 1;
				}

				// Cas où l'heure de début est après 22h et heure de fin après
				// ou égale 6h. On enlève une période car le premier jour n'aura
				// pas de nuité comprise
				if (heureDebut.isAfter(debutPeriodeHotel) && (heureFin.isSame(finPeriodeHotel) || heureFin.isAfter(finPeriodeHotel))) {
					nbPeriode -= 1;
				}

				// Cas où l'heure de début est après 22h et heure de fin avant
				// 6h. On enlève deux périodes car le premier et le dernier jour
				// n'aura pas de nuité comprise
				if (heureDebut.isAfter(debutPeriodeHotel)&& heureFin.isBefore(finPeriodeHotel)) {
					nbPeriode -= 2;
				}
			}

			return nbPeriode;
		};

		// Permet de déterminer si on prend le montant du forfait ou du frais
		// réel pour les repas
		ctrl.getDetailMontantRepas = function(detail) {
			var montant;
			if (ctrl.fraisRepas) {
				montant = detail.reel;
			} else {
				montant = detail.forfait;
			}
			return montant;
		};

		// Permet de déterminé si on prend le montant du forfait ou du frais
		// réel pour les nuitées
		ctrl.getDetailMontantHotel = function(detail) {
			var montant;
			if (ctrl.fraisHotel) {
				montant = detail.reel;
			} else {
				montant = detail.forfait;
			}
			return montant;
		};
		
		ctrl.isFraisReel = function(detail){
			if(detail.typeFrais === 'HOTEL'){
				return ctrl.fraisHotel;
			} else if (detail.typeFrais === 'REPAS'){
				return ctrl.fraisRepas;
			} else{
				return false;
			}
		};

		ctrl.calculerPeriodes = function() {
			if (ctrl.etape.dateDebut !== undefined && ctrl.etape.dateFin !== undefined) {
				ctrl.nbRepas = ctrl.calculPeriodeRepas();
				ctrl.nbNuit = ctrl.calculPeriodeHotel();
			}
		};

		// Permet de rajouter un poste de dépense si l'utilisateur ajoute un
		// véhicule personnel pour faire le trajet
		ctrl.addVehicule = function() {
			if (ctrl.vehicule) {
				var montant;
				switch (ctrl.puissance) {
				case '3':
					montant = ctrl.vehicule3CV();
					break;
				case '4':
					montant = ctrl.vehicule4CV();
					break;
				case '5':
					montant = ctrl.vehicule5CV();
					break;
				case '6':
					montant = ctrl.vehicule6CV();
					break;
				case '7':
					montant = ctrl.vehicule7CV();
					break;
				default:
					break;
				}

				var vehiculePersonnel = {
					numeroEtape : ctrl.etape.numero,
					poste : 'Véhicule personnel',
					typeFrais : 'VEHICULE_PERSONNEL',
					montant : Number(Number(montant).toFixed(2)),
					selectionne : true,
					remboursement : true,
					quantite : ctrl.distance, 
					puissanceVehicule : ctrl.puissance
				};

				ctrl.demande.depenses.push(vehiculePersonnel);
			}
		};

		ctrl.vehicule3CV = function() {
			var montant;
			if (ctrl.distance > 0 && ctrl.distance <= 5000) {
				montant = ctrl.distance * 0.410;
			} else if (ctrl.distance > 5000 && ctrl.distance <= 20000) {
				montant = (ctrl.distance * 0.245) + 824;
			} else {
				montant = ctrl.distance * 0.286;
			}
			return montant;
		};

		ctrl.vehicule4CV = function() {
			var montant;
			if (ctrl.distance > 0 && ctrl.distance <= 5000) {
				montant = ctrl.distance * 0.493;
			} else if (ctrl.distance > 5000 && ctrl.distance <= 20000) {
				montant = (ctrl.distance * 0.277) + 1082;
			} else {
				montant = ctrl.distance * 0.332;
			}
			return montant;
		};

		ctrl.vehicule5CV = function() {
			var montant;
			if (ctrl.distance > 0 && ctrl.distance <= 5000) {
				montant = ctrl.distance * 0.543;
			} else if (ctrl.distance > 5000 && ctrl.distance <= 20000) {
				montant = (ctrl.distance * 0.305) + 1188;
			} else {
				montant = ctrl.distance * 0.364;
			}
			return montant;
		};

		ctrl.vehicule6CV = function() {
			var montant;
			if (ctrl.distance > 0 && ctrl.distance <= 5000) {
				montant = ctrl.distance * 0.568;
			} else if (ctrl.distance > 5000 && ctrl.distance <= 20000) {
				montant = (ctrl.distance * 0.320) + 1244;
			} else {
				montant = ctrl.distance * 0.382;
			}
			return montant;
		};

		ctrl.vehicule7CV = function() {
			var montant;
			if (ctrl.distance > 0 && ctrl.distance <= 5000) {
				montant = ctrl.distance * 0.595;
			} else if (ctrl.distance > 5000 && ctrl.distance <= 20000) {
				montant = (ctrl.distance * 0.337) + 1288;
			} else {
				montant = ctrl.distance * 0.401;
			}
			return montant;
		};

		ctrl.init();
	}
})();
(function() {
	'use strict';

	angular.module('app.operation').controller('DetailController',
			Controller);

	function Controller($stateParams, $state, CategoryWS) {
		var ctrl = this;
		
		ctrl.detail={};
		
		ctrl.idModified = $stateParams.id;
		
		// Initialisation de la demande avec celle passé en paramètre
		ctrl.init = function(){
			ctrl.demande = $stateParams.demande;
			ctrl.libelleObligatoire=true;
			ctrl.getListCategorie();
		};
		
		ctrl.getListCategorie = function(){
			return CategoryWS.getListCategories(ctrl.filtreActif, ctrl.searchText,ctrl.pagingOptions).then(onLoadSuccess.bind({search: ctrl.searchText}));
		};
		
		var onLoadSuccess = function (data) {
			ctrl.listeCategorie = data.data.content;
		};

		
		// Ajout un détail dans la liste des détail de la demande passé en paramètre
		ctrl.addDetail = function(){
			ctrl.demande.details.push(ctrl.detail);
		};
		
		ctrl.nextStepCategorie = function(){
			ctrl.libelleObligatoire = !ctrl.valideLibelle();
			if(!ctrl.libelleObligatoire){
				$state.go('operation.item_demande_mission.detail.information');
			}
		};
		
		// Permet de vérifier si le libelle est rempli pour valider le formulaire
		ctrl.valideLibelle = function(){
			var valide = true;
			if(ctrl.detail.libelle === undefined || ctrl.detail.libelle === null){
				valide = false;
			}
			return valide;
		};
		
		ctrl.updateTotal = function(){
			ctrl.detail.total = Number(ctrl.detail.quantite * ctrl.prixUnitaire); 
		};
		
		//Retour à la demande de mission
		ctrl.goToDemandeMission = function(){
			$state.go('operation.item_demande_mission', {id:ctrl.idModified, demande : ctrl.demande});
		};
		
		//Permet de setter le libellé à l'aide des boutons dans la première partie d'un détail
		ctrl.getLibelleCategorie=function(detail, categorie){
			ctrl.detail.libelle = detail.libelle;
			ctrl.getCategorie = categorie;
			ctrl.libelleObligatoire=false;
		};
		
		ctrl.init();
	}
})();
(function () {
	'use strict';

	angular
		.module('app.security', ['app'])
		.service('UtilisateurService', Service);

	/** @ngInject */
	function Service($http, _) {
		var service = this;
		service.findById = function (id) {
			return $http.get('/api/utilisateur/' + id).then(function (response) {
				return response.data;
			});
		};

		service.findAll = function () {
			return $http.get('/api/utilisateur/').then(function (response) {
				return response.data;
			});
		};

		service.save = function (user, password) {
			var params = {};

			if (password) {
				params = {password: password};
			}

			if (user.id) {
				return $http.put('/api/utilisateur/' + user.id, user, {params: params});
			} else {
				return $http.post('/api/utilisateur/', user, {params: params});
			}
		};


		service.createFromInvestigateur = function (user, idInvestigateur) {
			return $http.post('/api/utilisateur/fromInvestigateur/' + idInvestigateur, user);
		};
		
		service.createFromBeneficiaire = function (user, idBeneficiaire) {
			return $http.post('/api/utilisateur/fromBeneficiaire/' + idBeneficiaire, user);
		};


		service.delete = function (user) {
			return $http.delete('/api/utilisateur/' + user.id, user);
		};
		service.validateUsername = function (user, username) {
			if (user && user.id) {
				//TODO : refactorer pou ne plus construire l'URL par concaténation. Bug si le username contient certains caractères spéciaux
				return $http.get('/api/utilisateur/' + user.id + '/validate?username=' + username);
			} else {
				return $http.get('/api/utilisateur/validate?username=' + username);
			}
		};

		service.validateEmail = function (user, email) {
			if (user && user.id) {
				//TODO : refactorer pou ne plus construire l'URL par concaténation. Bug si l'email contient certains caractères spéciaux
				return $http.get('/api/utilisateur/' + user.id + '/validate?email=' + email);
			} else {
				return $http.get('/api/utilisateur/validate?email=' + email);
			}
		};

		service.loadUtilisateurs = function (searchText, paging) {
			var params = {
				'searchText': searchText
			};
			params = _.extend(params, paging);

			return $http.get('/api/utilisateur', {
				'params': params
			});
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('app.security')
		.controller('UtilisateurListController', Controller);

	/** @ngInject */
	function Controller(UtilisateurService, RoleWS, $q, toastr, $state, $log) {
		var ctrl = this;

		ctrl.searchText = '';
		ctrl.pageSize = 15;
		ctrl.pagingOptions = {};

		ctrl.viewMore = function () {
			ctrl.pageSize += 15;
		};

		ctrl.goTo = function (id) {
			$state.go('security.utilisateur', {id: id});
		};

		ctrl.toastDeleteFailure = function () {
			toastr.error('Echec de suppression');
			return $q.reject();
		};

		ctrl.delete = function (utilisateur) {
			UtilisateurService.delete(utilisateur).then(ctrl.loadUtilisateurs, ctrl.toastDeleteFailure);
		};

		var onLoadSuccess = function (response) {
			if (this.search === ctrl.searchText) {
				ctrl.page = response.data;
			} else {
				$log.debug('response is outdated => ignore');
			}
		};

		//Fonction permettant de récuperer la liste des utilisateurs
		ctrl.loadUtilisateurs = function () {
			return UtilisateurService.loadUtilisateurs(ctrl.searchText, ctrl.pagingOptions).then(onLoadSuccess.bind({search: ctrl.searchText}));
		};

		ctrl.onPagingOptionsChange = function (pagingOptions) {
			ctrl.pagingOptions = pagingOptions;
			ctrl.loadUtilisateurs();
		};

		ctrl.loadUtilisateurs();
	}
})();

(function () {
	'use strict';

	angular.module('app.security').controller('UtilisateurItemController',
		Controller);

	/** @ngInject */
	function Controller(UtilisateurService, $stateParams, $scope,RoleWS,
						EtablissementWS, $q, toastr, $state) {
		var ctrl = this;
		ctrl.disabled=true;
		ctrl.autocompleteEtablissement = EtablissementWS.autocomplete;

		ctrl.loadRoles = function(tousProfil) {			
			RoleWS.getRoles().then(function(data) {
				if (tousProfil){
				ctrl.roles = data;
				}else{
					ctrl.roles = data;	
					ctrl.roles.splice(4,5);
				}
			});
		};

		ctrl.loadUtilisateur = function (id) {
			UtilisateurService.findById(id).then(function (data) {
				ctrl.utilisateur = data;
			});
		};

		ctrl.save = function (utilisateur) {
			if (ctrl.createFromInvestigateur) {
				UtilisateurService.createFromInvestigateur(utilisateur,
					ctrl.investigateur.id).then(ctrl.backToList,
					ctrl.onSaveFailure);
			} else if (ctrl.createFromBeneficiaire) {
				UtilisateurService.createFromBeneficiaire(utilisateur,
					ctrl.beneficiaire.id).then(ctrl.backToList,
					ctrl.onSaveFailure);
			} else {
				var password = ctrl.editPassword ? utilisateur.password
					: undefined;
				
				UtilisateurService.save(utilisateur, password).then(
					ctrl.backToList, ctrl.onSaveFailure);
			}
		};

		ctrl.backToList = function () {
			$state.go('security.utilisateurs');
		};

		ctrl.onSaveFailure = function (response) {
			if (response.status === 400) {
				ctrl.serverErrors = response.data.errors;
			} else {
				toastr.error('Echec d\'enregistrement');
			}
			return $q.reject();
		};

		ctrl.validateUsername = function (value) {
			return UtilisateurService.validateUsername(ctrl.utilisateur, value);
		};

		ctrl.validateEmail = function (value) {
			return UtilisateurService.validateEmail(ctrl.utilisateur, value);
		};

		ctrl.removeAccents = function(input) {
			var output = '';
			var normalized = input.normalize('NFD');
			var i = 0;
			var j = 0;

			while (i < input.length) {
				output += normalized[j];

				j += (input[i] === normalized[j]) ? 1 : 2;
				i++;
			}
			
			return output;
		};

		ctrl.buildLogin = function (email) {
			return ctrl.removeAccents(email);
		};

		ctrl.init = function () {
			ctrl.isUpdate = $stateParams.id !== 'new';

			ctrl.utilisateur = {};
			ctrl.investigateur = null;
			ctrl.createFromInvestigateur = false;
			ctrl.beneficiaire = null;
			ctrl.createFromBeneficiaire = false;
			ctrl.roles = [];
			ctrl.editPassword = !ctrl.isUpdate;

			
			if ($stateParams.id === 'new'){
				//En mode nouvel utilisateur, il n'est pas possible de créer d'investiateur, ni de bénéficiaire
				//on charge donc les profils MEDES uniquement.
				ctrl.loadRoles(false);
				ctrl.utilisateur.enabled=true;
			}else{
				//on charge tous les rôles
				ctrl.loadRoles(true);
			}	
				

			if (ctrl.isUpdate) {
				ctrl.loadUtilisateur($stateParams.id);
			}

			if ($stateParams.investigateur !== undefined) {
				ctrl.investigateur = $stateParams.investigateur;
				ctrl.utilisateur.lastname = ctrl.investigateur.nom;
				ctrl.utilisateur.firstname = ctrl.investigateur.prenom;
				ctrl.utilisateur.email = ctrl.investigateur.email;
				ctrl.utilisateur.etablissement = ctrl.investigateur.etablissement;
				ctrl.utilisateur.role = 'INVESTIGATEUR';
				ctrl.utilisateur.username = ctrl.buildLogin(
					ctrl.investigateur.email);

				ctrl.createFromInvestigateur = true;
				ctrl.loadRoles(true);
			}

			if ($stateParams.beneficiaire !== undefined) {
				ctrl.beneficiaire = $stateParams.beneficiaire;
				ctrl.utilisateur.lastname = ctrl.beneficiaire.nom;
				ctrl.utilisateur.firstname = ctrl.beneficiaire.prenom;
				ctrl.utilisateur.email = ctrl.beneficiaire.email;
				ctrl.utilisateur.etablissement = ctrl.beneficiaire.etablissement;
				ctrl.utilisateur.role = 'BENEFICIAIRE';
				ctrl.utilisateur.username = ctrl.buildLogin(
					ctrl.beneficiaire.email);

				ctrl.createFromBeneficiaire = true;
				ctrl.loadRoles(true);
			}
			
			

		};

		ctrl.init();

		$scope.$watch('ctrl.utilisateur.email', function() {
			ctrl.utilisateur.username=ctrl.utilisateur.email;
		});
	
		
	}
})();

(function() {
	'use strict';

	angular.module('app.security').controller('ConfigurationBannerListController', Controller);

	/** @ngInject */
	function Controller(ConfigurationBannerService, $state) {
		var ctrl = this;
		ctrl.admin = {};
		
		//Charge list
		ctrl.getListBanner = function () {
			ConfigurationBannerService.getListBanner().then(
				function (response) {
				ctrl.list = response.data;
			});
		};

		//change page for update message
		ctrl.goTo = function (id) {
			$state.go('security.configurationBanner_item', {id: id});
		};
		
		// initialisation
		ctrl.init = function () {
			ctrl.list = [];
			ctrl.getListBanner();
		};

		ctrl.init();
		
	}

})();


(function() {
	'use strict';

	angular.module('app.security').controller('ConfigurationBannerItemController', Controller);

	/** @ngInject */
	function Controller(ConfigurationBannerService, $stateParams, $state) {
		var ctrl = this;
		
		ctrl.idBanner = $stateParams.id;
		
		// Charging information
		ctrl.getOne = function (id) {
			ConfigurationBannerService.getOne(id).then(function (response) {
				ctrl.admin = response.data;
			});
		};

		ctrl.backToList = function () {
			$state.go('security.configurationBanner');
		};
		
		// initialisation 
		ctrl.init = function () {
			ctrl.getOne($stateParams.id);
		};

		ctrl.init();

		// update data banner
		ctrl.saveOrUpdate = function (admin) {
            ConfigurationBannerService.saveOrUpdate(admin).then(ctrl.backToList, ctrl.onSaveFailure);
		};
		
	}

})();


(function () {
    'use strict';

    angular.module('app.projet', ['app']).service('ProjetWS', Service);

    /** @ngInject */
    function Service($http, $log, _) {
        var service = this;

        service.getList = function (actif, importEasy, searchText, paging) {
            var params = {
                'actif': actif,
                'searchText': searchText,
                'importEasy': importEasy
            };

            params = _.extend(params, paging);

            return $http.get('/api/projet', {
                'params': params
            });
        };

        service.getOne = function (id) {
            return $http.get('/api/projet/' + id);
        };

        service.saveOrUpdate = function (projet) {
            if (projet.id) {
                return $http.put('/api/projet', projet);
            } else {
                $log.debug('avant post');
                $log.debug(projet.fin);
                return $http.post('/api/projet', projet);
            }
        };

        //Permet l'autocompletion des projets
        service.autocompleteProjet = function (searchProjet, id) {
            return $http.get('/api/projet', {
                'params': {
                    'actif': true,
                    'searchText': searchProjet,
                    'importEasy': true
                }
            }).then(function (response) {
                if (id) {

                    response.data.content = _.reject(response.data.content, function (projet) {
                        return projet.etablissement.id !== id;
                    });
                    return response.data.content;
                } else {
                    return response.data.content;
                }
            });
        };

        //Permet de télécharger la convention
        service.download = function (fichier) {
            return $http.get('/api/projet/download/' + fichier, {responseType: 'arraybuffer'});
        };

        //Permet de supprimer la convention
        service.deleteFile = function (projet, fichier) {
            return $http.delete('/api/projet/' + projet + '/file/' + fichier);
        };

        service.updateProjetImport = function (id) {
			return $http.put('/api/projet/updateEasydore/' + id)
				.then(function (response) {
					return response.data.content;
				});
		};
    }
})();

(function() {
  'use strict';

  angular.module('app.projet').controller('ImportEasydoreListController', Controller);

  /** @ngInject */
  function Controller($state,$scope,$q, ImportEasydoreWS,toastr, $log) {
    var ctrl = this;
    var svc = ImportEasydoreWS;
    ctrl.filterActif = true;
	ctrl.importEasy=false;
	ctrl.pageSize = 15;
	ctrl.pagingOptions = {};
	ctrl.page=[];
	
	
    ctrl.init = function () {
        ctrl.searchText='';
        ctrl.getListProjetAImporte();
      
    };
    
    
    var onLoadSuccess = function (data) {
		if (this.search === ctrl.searchText) {
			ctrl.page = data.data;
				
		} else {
			$log.debug('response is outdated => ignore');
		}
	};
    // Permet d'initialiser les status pour les facturations de type facture
       
     
    ctrl.getListProjetAImporte = function () {
		var searchText = ctrl.searchText;
		if (searchText.length <= 2) {
			searchText = '';
		}
		
		return svc.getList(ctrl.filterActif,ctrl.importEasy, searchText,ctrl.pagingOptions).then(onLoadSuccess.bind({search: ctrl.searchText}));
	};
	
   	
	// Permet d'effectuer la recherche
	ctrl.onChangeSearchText = function(val){
		ctrl.searchText = val;
		ctrl.getListProjetAImporte();
	};	
	
	// Mise à jour des options de pagination (tri / paginataion)
	ctrl.onPagingOptionsChange = function (pagingOptions) {
		ctrl.pagingOptions = pagingOptions;
		ctrl.getListProjetAImporte();
	};

	// Augmente le nombre de résultats affichés
	ctrl.viewMore = function () {
		ctrl.pageSize += 15;
	};
	
	ctrl.backToList = function () {
		$state.go('projet.importEasydore');
	};

	ctrl.onSaveFailure = function (response) {
		if (response.status === 400) {
			$scope.serverErrors = response.data.errors;
		} else {
			toastr.error('Echec d\'enregistrement : ' + response.data.message);
		}
		return $q.reject();
	};
	
	ctrl.importProjet= function(projet){
		projet.importEasy=true;
		svc.update(projet).then(ctrl.init, ctrl.onSaveFailure);
		
	};
	//Permet l'affichage de l'investigateur principal dans le tableau
	ctrl.investigateurPrincipal = function (projet) {
		var retour = '';
		angular.forEach(projet.investigateurs, function (investigateur) {
			if (investigateur.investigateurPrincipal && investigateur.investigateur) {
				var investigateurSelected = investigateur.investigateur;
				retour = investigateurSelected.nom + ' ' + investigateurSelected.prenom;
				// Permet de sortir du forEach si un résultat a été trouvé
				return;
			}
		});
		return retour;
	};
	

     ctrl.init();
 }
})();

(function() {
  'use strict';

  angular.module('app.projet').controller('FacturationListController', Controller);

  /** @ngInject */
  function Controller($state, FacturationWS, _, SecurityService) {
    var ctrl = this;
    ctrl.sort='ref';
    ctrl.pageSize = 15;
    ctrl.pagingOptions = {};
	ctrl.read = false;

    ctrl.init = function () {
        ctrl.searchText='';
        ctrl.list=[];
            
        // Initialisation des filtres
        ctrl.filterFacture=true;
        ctrl.initFactureStatus();
		ctrl.getListFacture();
		
		if (SecurityService.anyRole('ETABLISSEMENT')) {
			ctrl.read = true;
		}
    };
    
    //Permet d'initialiser les status pour les facturations de type facture
    ctrl.initFactureStatus=function(){
    	 ctrl.statuts = ['BROUILLON', 'PAYE', 'EMISE'];
    	 ctrl.filterBrouillon=true;
         ctrl.filterEmise=true;
         ctrl.filterPaye=true;
    };
    
    ctrl.getListFacture=function(){
    	var searchText = ctrl.searchText;
		if (searchText.length <= 2) {
			searchText='';
		}
		
    	FacturationWS.getList(ctrl.filterFacture,ctrl.statuts,searchText,ctrl.pagingOptions).then(function(response) {
	        ctrl.list=response.data.content;
	        ctrl.page=response.data;
	    });
    };
    
    //Fonction permettant d'accéder au formulaire d'un projet
    ctrl.goTo = function(id){
		if (SecurityService.anyRole('ADMIN,INTERLOCUTEUR,FINANCIER')) {
			$state.go('projet.facturation_item', {id: id, edit: true}, {reload:true});
		} else {
			$state.go('projet.facturation_item', {id: id}, {reload:true});
		}
    };
    
	//Fonction permettant d'ajouter un nouveau projet
	ctrl.add = function(){
		$state.go('projet.facturation_item', {id : 'new', edit: true}, {reload:true});
	};
	
	//Permet d'effectuer la recherche
	ctrl.onChangeSearchText = function(val){
		ctrl.searchText = val;
		ctrl.getListFacture();
	};
	
	//Permet l'affichage des projet selon leur statut
	ctrl.onChangeFacture = function(val){
		ctrl.filterFacture = val;
		
		if(val){
			ctrl.initFactureStatus();
		} else{
			ctrl.statuts = ['ANNULE'];
		}
		
		ctrl.getListFacture();
	};
	
	ctrl.toggleStatut= function(statut){
		var found = _.contains(ctrl.statuts, statut);
		if(found) {
			ctrl.statuts = _.without(ctrl.statuts, statut);
		} else {
			ctrl.statuts.push(statut);
		}
 	};

      // Mise à jour des options de pagination (tri / paginataion)
      ctrl.onPagingOptionsChange = function (pagingOptions) {
          ctrl.pagingOptions = pagingOptions;
          ctrl.getListFacture();
      };

      // Augmente le nombre de résultats affichés
      ctrl.viewMore = function () {
          ctrl.pageSize += 15;
      };

     ctrl.init();
 }
})();

(function () {
	'use strict';

	angular.module('app.projet').controller('FacturationItemController', Controller);

	/** @ngInject */
	function Controller($stateParams, $state, $log, $q, toastr, FacturationWS, EtablissementWS, ProjetWS, InvestigateurWS, FinanceurWS) {
		var ctrl = this;

		ctrl.dateFormat = 'dd/MM/yyyy';

		ctrl.isUpdate = $stateParams.id !== 'new';

		ctrl.idModified = $stateParams.id;

		ctrl.facturation = {};

		ctrl.codeTVA = [];

		ctrl.autocompleteEtablissement = EtablissementWS.autocomplete;

		ctrl.autocompleteProjet = ProjetWS.autocompleteProjet;

		ctrl.autocompleteInvestigateur = InvestigateurWS.autocomplete;

		ctrl.autocompleteFinanceur = FinanceurWS.autocomplete;

		ctrl.statutsDatePaiementEnabled = ['EMISE'];

		ctrl.facturation.datePaiement = new Date();

		ctrl.isCreateFromProject = $stateParams.from === 'projet';
		//Permet de remplir les champs si un projet est passé en paramètre
		ctrl.createWithProject = ($stateParams.projet !== null ? $stateParams.projet : null);

		// Permet de mettre les champs en mode disable pour la simple
        // consultation de la page des facturations
        ctrl.disabled = !$stateParams.edit;

		//Fonction d'initialisation de la page
		ctrl.init = function () {
			ctrl.loadParams();
			ctrl.getCodeTVA();
			if (ctrl.isUpdate) {
				//on crée les droits pour les name importés à partir d'EasyDore
				var grant = FacturationWS.updateFacturationImport(ctrl.idModified);

				grant.then(function () {
					FacturationWS.getOne(ctrl.idModified).then(function (response) {
						ctrl.facturation = response.data;
						ctrl.statutActuel = ctrl.facturation.statut;
						ctrl.datePaiementDisabled = !_.contains(ctrl.statutsDatePaiementEnabled, ctrl.statutActuel);

					});
				});
			} else {
				$log.debug($stateParams.from);
				if (ctrl.isCreateFromProject && ctrl.createWithProject !== null) {
					var projet = ctrl.createWithProject;
					ctrl.facturation.financeur = projet.financeur;
					ctrl.facturation.referenceConvention = projet.reference;
					ctrl.facturation.projet = projet;
					ctrl.facturation.investigateur = ctrl.getInvestigateurPrincipalProjet(projet);
					ctrl.facturation.etablissement = projet.etablissement;
				}
				//initialisation du statut de facturation sur brouillon
				ctrl.facturation.statut = 'BROUILLON';
				ctrl.statutActuel = ctrl.facturation.statut;
				ctrl.datePaiementDisabled = !_.contains(ctrl.statutsDatePaiementEnabled, ctrl.statutActuel);
			}
		};

		//Permet de recharger la page après avoir enregistré, émis ou payer une facturation 
		ctrl.onSaveReload = function (response) {
			if (response.status === 201 || response.status === 200) {
				var idFacturation = response.data.id;
				toastr.success('Action effectuée avec succès');
				$state.go('projet.facturation_item', { id: idFacturation });
				ctrl.init();
			}
		};

		//Permet de revenir sur la liste des facturations
		ctrl.backToList = function () {
			localStorage.removeItem('projet');
			$state.go('projet.facturation');
		};

		// Fonction permettant de traiter les erreurs et de les afficher en cas
		// de non enregistrement de l'opération

		//TODO gerer tous les cas de null pointer et propager messages d'erreurs
		ctrl.onSaveFailure = function (response) {
			if (response.status === 400) {
				ctrl.serverErrors = response.data.errors;
			} else if (response.status === 500) {
				toastr.error(response.data.message);
			} else {
				toastr.error('Echec d\'enregistrement');
			}
		};

		// Fonction permettant de traiter les erreurs et de les afficher en cas de non suppresision de la facturation
		ctrl.onDeleteFailure = function (response) {
			if (response.status === 400) {
				ctrl.serverErrors = response.data.errors;
			} else {
				toastr.error('Echec de la suppression');
			}
			return $q.reject();
		};

		//Méthode appellée lors du clique sur le bouton "Enregistrer", "Emettre" et "Payer"
		ctrl.saveOrUpdate = function (facturation) {
			FacturationWS.saveOrUpdate(facturation).then(ctrl.onSaveReload, ctrl.onSaveFailure);
		};

		//Permet de sauvegarder une facturation et de revenir sur la liste des facturations
		ctrl.saveOrUpdateToList = function (facturation) {
			FacturationWS.saveOrUpdate(facturation).then(ctrl.backToList, ctrl.onSaveFailure);
		};

		//Permet de supprimer une facturation
		ctrl.delete = function (facturation) {
			FacturationWS.delete(facturation).then(ctrl.backToList, ctrl.onDeleteFailure);
		};

		// Permet d'aller sur l'écran des établissements
		ctrl.goEtablissement = function (etablissement) {
			if (etablissement !== null && etablissement !== undefined) {
				$state.go('referentiel.etablissement_item', { id: etablissement.id, disable: true });
			}
		};

		// Permet de récupérer tous les codes TVA présent dans la base de données
		ctrl.getCodeTVA = function () {
			FacturationWS.getCodeTVA().then(function (response) {
				ctrl.codeTVA = response.data.content;

				//Permet de données une valeur par défaut à la liste déroulante
				ctrl.facturation.codeTVA = ctrl.initCodeTVA(ctrl.codeTVA);
			});
		};

		//Permet de changer le statut d'une facturation
		ctrl.changeStatus = function (statut) {
			ctrl.facturation.statut = statut;
			ctrl.saveOrUpdate(ctrl.facturation);
		};

		//Permet d'effectuer les calculs de tous les montants présent dans le tableau
		ctrl.calculValue = function (montant) {
			// On vérifier que l'établissement, le code tva et le montant sont renseignés
			if (montant !== undefined && ctrl.facturation.etablissement !== undefined && ctrl.facturation.codeTVA !== undefined) {
				ctrl.facturation.fraisGestion = (montant * (ctrl.facturation.etablissement.pourcentageFrais / 100));
				ctrl.facturation.totalHT = montant;
				ctrl.facturation.tva = (montant * (ctrl.facturation.codeTVA.taux / 100));
				ctrl.facturation.totalCPHT = (montant - ctrl.facturation.fraisGestion);
				ctrl.facturation.totalTTC = (Number(montant) + Number(ctrl.facturation.tva));
			} else {
				ctrl.facturation.fraisGestion = 0;
				ctrl.facturation.totalHT = 0;
				ctrl.facturation.tva = 0;
				ctrl.facturation.totalCPHT = 0;
				ctrl.facturation.totalTTC = 0;
			}
		};

		//Permet d'initialiser la liste déroulante du code TVA sur 'TVA-FACTURE'
		ctrl.initCodeTVA = function (codes) {
			return _.findWhere(codes, { code: 'TVA-FACTURE' });
		};

		//Permet de changer le type de la facturation
		ctrl.creerAvoir = function (facturation) {
			facturation.statut = 'ANNULE';
			facturation.facture = false;
			ctrl.saveOrUpdateToList(facturation);
		};

		//Permet de visualiser le fichier téléchargé
		ctrl.successDownload = function (response) {
			var file = new Blob([response.data], { type: 'application/pdf' });
			var fileURL = URL.createObjectURL(file);
			window.open(fileURL);
		};

		//Permet de télécharger le fichier 
		ctrl.download = function (facture) {
			FacturationWS.download(facture).then(ctrl.successDownload);
		};

		//Permet de récupérer l'investigateur principal d'un projet
		ctrl.getInvestigateurPrincipalProjet = function (projet) {
			var retour = '';
			angular.forEach(projet.investigateurs, function (investigateur) {
				if (investigateur.investigateurPrincipal) {
					retour = investigateur.investigateur;
					return;
					// Permet de sortir du forEach si un résultat a été trouvé
				}
			});
			return retour;
		};

		//Permet de récupérer les paramètres passés dans la route si la page est raffraichie
		ctrl.loadParams = function () {
			if (ctrl.createWithProject !== null) {
				localStorage.setItem('projet', JSON.stringify(ctrl.createWithProject));
			} else {
				ctrl.createWithProject = JSON.parse(localStorage.getItem('projet'));
			}
		};

		//Permet d'afficher le bloc "Facture MEDES" s'il existe au moins une facture
		ctrl.showFacturesMedes = function () {
			if (ctrl.facturation.factures === undefined) {
				return true;
			}
			return Object.keys(ctrl.facturation.factures).length === 0;
		};

		ctrl.init();
	}
})();

(function () {
	'use strict';

	angular
		.module('app.referentiel', ['app'])
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		$stateProvider.state('referentiel', {
			abstract: true,
			parent: 'layout',
			url: '/referentiel',
			templateUrl: 'app/referentiel/referentiel.html'

		});
	}
})();

(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.controller('PromoteurListController', Controller);

	/** @ngInject */
	function Controller($state, PromoteurWS, $log, SecurityService) {
		var ctrl = this;

		ctrl.pageSize = 15;
		ctrl.pagingOptions = {};

		ctrl.filtreActif = true;
		ctrl.searchText = '';
		ctrl.read = false;

		//Fonction permettant d'accéder au formulaire d'un promoteur
		ctrl.goTo = function (id) {
			if (SecurityService.anyRole('ADMIN,INTERLOCUTEUR,FINANCIER')) {
				// reload to test active class on menu
				$state.go('referentiel.promoteur_item', {id: id, edit: true}, {reload:true});
			}else{
				$state.go('referentiel.promoteur_item', {id: id}, {reload:true});
			}
		};

		//Fonction permettant d'ajouter un nouveau promoteur
		ctrl.add = function () {
			$state.go('referentiel.promoteur_item', {id: 'new', edit: true}, {reload:true});
		};

		var onLoadSuccess = function (response) {
			if (this.search === ctrl.searchText) {
				ctrl.page = response.data;
			} else {
				$log.debug('response is outdated => ignore');
			}
		};

		//Fonction permettant d'afficher les promoteurs actifs ou clos
		ctrl.loadPromoteurs = function () {
			var searchText = ctrl.searchText;
			PromoteurWS.loadPromoteurs(ctrl.filtreActif, searchText, ctrl.pagingOptions).then(onLoadSuccess.bind({search: ctrl.searchText}));

			if (SecurityService.anyRole('ETABLISSEMENT')) {
				ctrl.read = true;
			}
		};

		ctrl.onChangeSearchText = function (val) {
			ctrl.searchText = val;
			ctrl.loadPromoteurs();
		};

		ctrl.onChangeActif = function (val) {
			ctrl.filtreActif = val;
			ctrl.loadPromoteurs();
		};

		// Mise à jour des options de pagination (tri / paginataion)
		ctrl.onPagingOptionsChange = function (pagingOptions) {
			ctrl.pagingOptions = pagingOptions;
			ctrl.loadPromoteurs();
		};

		// Augmente le nombre de résultats affichés
		ctrl.viewMore = function () {
			ctrl.pageSize += 15;
		};

		ctrl.loadPromoteurs();
	}
})();

(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.controller('PromoteurItemController', Controller);

	/** @ngInject */
	function Controller($stateParams, $state, PromoteurWS, EtablissementWS, $q, toastr, $rootScope) {
		var ctrl = this;

		// get current route to test active class on menuReferenciel
		$rootScope.currentStateName = $state.current.name;

		ctrl.isUpdate = $stateParams.id !== 'new';

		ctrl.idModified = $stateParams.id;

		ctrl.typologies = {};

		ctrl.promoteur = {};
		ctrl.promoteur.actif = true;

		//Permet l'autocompletion des etablissements
		ctrl.autocompleteEtablissement = EtablissementWS.autocomplete;

		//Permet de mettre les champs en mode disable pour la simple consultation de la page des promoteurs
		ctrl.disable = !$stateParams.edit;

		ctrl.init = function () {
			ctrl.loadTypologies();
			if (ctrl.isUpdate) {

				//on crée les droits pour les promoteurs importés à partir d'EasyDore
				var grant = PromoteurWS.updatePromoteurImport(ctrl.idModified);
				
				grant.then(function () {
					
					PromoteurWS.getOne(ctrl.idModified).then(function (response) {
						ctrl.promoteur = response.data;

					});

				});

			}
		};

		ctrl.loadTypologies = function () {
			PromoteurWS.getTypologies().then(function (response) {
				ctrl.typologies = response.data;
			});
		};

		ctrl.backToList = function () {
			$state.go('referentiel.promoteur');
		};

		ctrl.onSaveFailure = function (response) {
			if (response.status === 400) {
				$scope.serverErrors = response.data.errors;
			} else {
				toastr.error('Echec d\'enregistrement : ' + response.data.message);
			}
			return $q.reject();
		};

		ctrl.saveOrUpdate = function (promoteur) {
			PromoteurWS.saveOrUpdate(promoteur).then(ctrl.backToList, ctrl.onSaveFailure);
		};

		ctrl.validateCode = function (value) {
			return PromoteurWS.validateCode(ctrl.promoteur, value);
		};

		// Permet d'aller sur l'écran des établissements
		ctrl.goEtablissement = function (etablissement) {
			if (etablissement !== null && etablissement !== undefined) {
				$state.go('referentiel.etablissement_item', { id: etablissement.id, disable: true });
			}
		};

		ctrl.init();

	}
})();

(function () {
	'use strict';

	angular.module('app.referentiel')
		.service('InvestigateurListService', Service);

	/** @ngInject */
	//TODO Service utile ?
	function Service($http, InvestigateurWS) {
		var service = this;

		service.loadInvestigateurs = function (active, search, paging) {
			var searchText = search || '';

			if (searchText.length <= 2) {
				searchText = '';
			}

			return InvestigateurWS.loadInvestigateurs(active, searchText, paging).then(function (response) {
				return response.data;
			});
		};

		service.updateInvestigateurImport = function (id) {
			return $http.put('/api/investigateur/updateEasydore/' + id)
				.then(function (response) {
					return response.data.content;
				});
		};


	}

})();

(function() {
	'use strict';

	angular.module('app.referentiel').controller('InvestigateurListController',
			Controller);

	/** @ngInject */
	function Controller($state, InvestigateurListService, $log, SecurityService) {
		var ctrl = this;
		ctrl.read = false;

		ctrl.init = function() {
			ctrl.pagingOptions = {};
			ctrl.searchText = '';
			ctrl.filtreActif = true;
			ctrl.loadInvestigateurs();
			ctrl.pageSize = 15;

			if (SecurityService.anyRole('ETABLISSEMENT')) {
				ctrl.read = true;
			}
		};

		ctrl.goTo = function(id) {
			if (SecurityService.anyRole('ADMIN,INTERLOCUTEUR,FINANCIER')) {
				// reload to test active class on menu
				$state.go('referentiel.investigateur_item', {
					id : id,
					edit : true
				}, {reload:true});
			} else {
				$state.go('referentiel.investigateur_item', {
					id : id
				}, {reload:true});
			}
		};

		ctrl.add = function() {
			$state.go('referentiel.investigateur_item', {
				id : 'new',
				edit : true
			}, {reload:true});
		};

		ctrl.onChangeActif = function(val) {
			ctrl.filtreActif = val;
			ctrl.loadInvestigateurs();
		};

		ctrl.onChangeSearchText = function(val) {
			ctrl.searchText = val;
			ctrl.loadInvestigateurs();
		};

		// Mise à jour des options de pagination (tri / paginataion)
		ctrl.onPagingOptionsChange = function(pagingOptions) {
			ctrl.pagingOptions = pagingOptions;
			ctrl.loadInvestigateurs();
		};

		// Augmente le nombre de résultats affichés
		ctrl.viewMore = function() {
			ctrl.pageSize += 15;
		};

		// Fonction permettant d'afficher les investigateurs actifs ou clos
		ctrl.loadInvestigateurs = function() {
			
			var searchText = ctrl.searchText;
			if (searchText.length <= 2) {
				searchText = '';
			}

			InvestigateurListService.loadInvestigateurs(ctrl.filtreActif, searchText,ctrl.pagingOptions).then(function (data) {
				ctrl.list = data.content;
				ctrl.page = data;
			});
		};

		ctrl.init();

	}
})();

(function () {
  'use strict';

  angular
    .module('app.referentiel')
    .controller('FournisseurListController', Controller);

  /** @ngInject */
  function Controller($state, FournisseurWS, $log, SecurityService) {
    var ctrl = this;
    var svc = FournisseurWS;
    ctrl.pageSize = 15;
    ctrl.pagingOptions = {};
		ctrl.read = false;

    ctrl.init = function () {
      ctrl.filtreActif = true;
      ctrl.searchText = '';
      ctrl.list = [];

      ctrl.getListFournisseurs();

      if (SecurityService.anyRole('ETABLISSEMENT')) {
				ctrl.read = true;
			}
    };


    ctrl.goTo = function (id) {
			if (SecurityService.anyRole('ADMIN,INTERLOCUTEUR,FINANCIER')) {
        // reload to test active class on menu
        $state.go('referentiel.fournisseur_item', {id: id, edit: true}, {reload: true});
      } else {
        $state.go('referentiel.fournisseur_item', {id: id}, {reload: true});
      }
    };


    ctrl.add = function () {
      $state.go('referentiel.fournisseur_item', {id: 'new', edit: true}, {reload:true});
    };

    //Fonction permettant d'afficher les établissements actifs ou clos
    ctrl.getListFournisseurs = function () {

      var searchText = ctrl.searchText;
      if (searchText.length <= 2) {
        searchText = '';
      }

      return svc.getListFournisseurs(ctrl.filtreActif, searchText, ctrl.pagingOptions).then(function (response) {
        ctrl.list = response.data.content;
        ctrl.page = response.data;
      });
    };

    // Mise à jour des options de pagination (tri / paginataion)
    ctrl.onPagingOptionsChange = function (pagingOptions) {
      ctrl.pagingOptions = pagingOptions;
      ctrl.getListFournisseurs();
    };

    // Augmente le nombre de résultats affichés
    ctrl.viewMore = function () {
      ctrl.pageSize += 15;
    };

    ctrl.onChangeActif = function (val) {
      ctrl.filtreActif = val;
      ctrl.getListFournisseurs();
    };

    ctrl.onChangeSearchText = function (val) {
      ctrl.searchText = val;
      ctrl.getListFournisseurs();
    };


    ctrl.init();

  }
})();

(function () {
	'use strict';

	angular.module('app.referentiel').controller('InvestigateurItemController',
		Controller);
	/** @ngInject */
	function Controller($stateParams, $state, InvestigateurWS,
		UtilisateurService, EtablissementWS, InvestigateurListService, $q, $log, toastr, $scope, $rootScope) {
		var ctrl = this;
		var svc = InvestigateurWS;

		// get current route to test active class on menuReferenciel
		$rootScope.currentStateName = $state.current.name;

		ctrl.isUpdate = $stateParams.id !== 'new';
		ctrl.idModified = $stateParams.id;
		ctrl.investigateur = {};
		ctrl.utilisateur = {};
		ctrl.investigateur.actif = true;
		ctrl.disableConnexion = false;
		ctrl.titre = {};

		// Permet de mettre les champs en mode disable pour la simple
		// consultation de la page des établissements
		ctrl.disable = !$stateParams.edit;

		ctrl.init = function () {
			ctrl.loadTitres();
			if (ctrl.isUpdate) {
				//on crée les droits pour les investigateurs importés à partir d'EasyDore
				var grant = InvestigateurListService.updateInvestigateurImport(ctrl.idModified);
				
				grant.then(function () {
					
					InvestigateurWS.getOne(ctrl.idModified).then(function (data) {
						ctrl.investigateur = data.data;
						ctrl.verifyUser(ctrl.investigateur);
					});

				});

			}
		};

		ctrl.backToList = function () {
			$state.go('referentiel.investigateur');
		};

		ctrl.onSaveFailure = function (response) {
			$log.debug('ici');
			$log.debug(response);
			if (response.status === 400) {
				$scope.serverErrors = response.data.errors;
			} else if (response.status === 500) {
				toastr.error(response.data.message);
			} else {
				toastr.error('Echec d\'enregistrement : ' + response.data.message);
			}
			return $q.reject();
		};

		ctrl.saveOrUpdate = function (investigateur) {
			svc.saveOrUpdate(investigateur).then(ctrl.backToList,
				ctrl.onSaveFailure);
		};


		ctrl.saveAndCreateUser = function (investigateur) {
			svc.saveOrUpdate(investigateur).then(function (newInvestigateur) {
				if (ctrl.isUpdate) {
					ctrl.createUser(newInvestigateur.data);
				} else {
					ctrl.createUser(newInvestigateur);
				}
			}, ctrl.onSaveFailure);

		};

		ctrl.addContact = function () {
			var newContact = {};

			if (ctrl.investigateur.contacts === undefined) {
				ctrl.investigateur.contacts = [];
			}
			ctrl.investigateur.contacts.push(newContact);
		};

		ctrl.removeContact = function (index) {
			ctrl.investigateur.contacts.splice(index, 1);
		};

		// Permet l'autocompletion des etablissements;
		ctrl.autocompleteEtablissement = EtablissementWS.autocomplete;

		ctrl.validateCode = function (value) {
			return svc.validateCode(ctrl.investigateur, value);
		};
		ctrl.removeAccents = function (input) {
			var output = '';
			var normalized = input.normalize('NFD');
			var i = 0;
			var j = 0;

			while (i < input.length) {
				output += normalized[j];

				j += (input[i] === normalized[j]) ? 1 : 2;
				i++;
			}

			var outputWhithOutSpace = output.replace(/\s+/g, '');
			return outputWhithOutSpace;
		};

		ctrl.buildLogin = function (email) {
			return ctrl.removeAccents(email);
		};

		// Permet de recharger la page après avoir enregistré l'investigateur comme user
		ctrl.onSaveReload = function (response) {
			if (response.status === 201 || response.status === 200) {
				toastr.success('Utilisateur créé avec succès');
				ctrl.backToList();
			}
		};

		ctrl.createUser = function (investigateur) {

			ctrl.utilisateur.lastname = investigateur.nom;
			ctrl.utilisateur.firstname = investigateur.prenom;
			ctrl.utilisateur.email = investigateur.email;
			ctrl.utilisateur.etablissement = investigateur.etablissement;
			ctrl.utilisateur.role = 'INVESTIGATEUR';
			ctrl.utilisateur.username = ctrl.buildLogin(
				investigateur.email);
			UtilisateurService.createFromInvestigateur(ctrl.utilisateur,
				investigateur.id).then(ctrl.onSaveReload,
					ctrl.onSaveFailure);

		};

		ctrl.loadTitres = function () {
			svc.loadTitres().then(function (response) {
				ctrl.titres = response.data;
			});
		};


		ctrl.verifyUser = function (investigateur) {

			UtilisateurService.validateEmail(null, investigateur.email)
				.success(function () {
					ctrl.disableConnexion = false;
				}).error(function () {
					ctrl.disableConnexion = true;
				});

		};
		ctrl.init();

	}
})();

(function () {
  'use strict';

  angular
    .module('app.referentiel')
    .controller('FournisseurItemController', Controller);
  /** @ngInject */
  function Controller($stateParams, $state, FournisseurWS, FinanceurWS, $q, toastr, $log, $rootScope) {
    var ctrl = this;
    var svc = FournisseurWS;

    // get current route to test active class on menuReferenciel
    $rootScope.currentStateName = $state.current.name;

    ctrl.isUpdate = $stateParams.id !== 'new';
    ctrl.idModified = $stateParams.id;
    ctrl.fournisseur = {};
    ctrl.fournisseur.actif = true;
    ctrl.typologies = [];
    ctrl.compteGeneralFournisseur = [];
    ctrl.conditionPaiement = {};

    //Permet de mettre les champs en mode disable pour la simple consultation de la page des établissements
    ctrl.disable = !$stateParams.edit;

    ctrl.init = function () {
      ctrl.typologies = ctrl.getTypologies();
      ctrl.getCompteGeneralFournisseur();
      ctrl.conditionPaiement = ctrl.getConditionPaiement();

      if (ctrl.isUpdate) {
        //on crée les droits pour les fournisseurs importés à partir d'EasyDore
        var grant = FournisseurWS.updateFournisseurImport(ctrl.idModified);

        grant.then(function () {

          FournisseurWS.getOne(ctrl.idModified).then(function (response) {
            ctrl.fournisseur = response.data;
          });

        });

      }

    };

    ctrl.getTypologies = function () {
      FournisseurWS.getTypologies().then(function (response) {
        ctrl.typologies = response.data;
      });
    };

    ctrl.getCompteGeneralFournisseur = function () {
      FournisseurWS.getCompteGeneralFournisseur().then(function (response) {
        ctrl.compteGeneralFournisseur = response.data.content;
      });
    };

    ctrl.backToList = function () {
      $state.go('referentiel.fournisseur');
    };

    ctrl.onSaveFailure = function (response) {
      if (response.status === 400) {
        $scope.serverErrors = response.data.errors;
      } else {
        toastr.error('Echec d\'enregistrement : ' + response.data.message);
      }
      return $q.reject();
    };

    ctrl.saveOrUpdate = function (fournisseur) {
      return svc.saveOrUpdate(fournisseur).then(ctrl.backToList, ctrl.onSaveFailure);
    };

    ctrl.addContact = function () {
      $log.debug('Ajout d\'un contact');
      var newContact = {};

      if (ctrl.fournisseur.contacts === undefined) {
        ctrl.fournisseur.contacts = [];
      }
      ctrl.fournisseur.contacts.push(newContact);
    };

    ctrl.removeContact = function (index) {
      $log.debug('Retrait d\'un contact');
      ctrl.fournisseur.contacts.splice(index, 1);
    };

    ctrl.validateCode = function (value) {
      $log.debug('validationCode : ' + value);
      return svc.validateCode(ctrl.fournisseur, value);
    };

    //Récupération de la liste des conditions de paiement
    ctrl.getConditionPaiement = function () {
      FinanceurWS.getConditionPaiement().then(function (response) {
        ctrl.conditionPaiement = response.data;
      });
    };

    ctrl.init();
  }
})();

(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.controller('FinanceurListController', Controller);

	/** @ngInject */
	function Controller($state, FinanceurWS, $log, SecurityService) {
		var ctrl = this;
		var svc = FinanceurWS;
		ctrl.pageSize = 15;
		ctrl.pagingOptions = {};
		ctrl.read = false;


		ctrl.init = function () {
			ctrl.filtreActif = true;
			ctrl.searchText = '';
			ctrl.list = [];

			ctrl.getListFinanceurs();
		};


		ctrl.goTo = function (id) {
			if (SecurityService.anyRole('ADMIN,INTERLOCUTEUR,FINANCIER')) {
				// reload to test active class on menu
				$state.go('referentiel.financeur_item', {id: id, edit:true}, {reload:true});
			}else{
				$state.go('referentiel.financeur_item', {id: id}, {reload:true});
			}
		};


		ctrl.add = function () {
			$state.go('referentiel.financeur_item', {id: 'new', edit: true}, {reload:true});
		};

		//Fonction permettant d'afficher les financeurs actifs ou clos
		ctrl.getListFinanceurs = function () {

			var searchText = ctrl.searchText;
			if (searchText.length <= 2) {
				searchText = '';
			}

			return svc.getListFinanceurs(ctrl.filtreActif, searchText, ctrl.pagingOptions).then(function (response) {
				ctrl.list = response.data.content;
				ctrl.page = response.data;
			});
		};

		// Mise à jour des options de pagination (tri / paginataion)
		ctrl.onPagingOptionsChange = function (pagingOptions) {
			ctrl.pagingOptions = pagingOptions;
			ctrl.getListFinanceurs();
		};

		// Augmente le nombre de résultats affichés
		ctrl.viewMore = function () {
			ctrl.pageSize += 15;
		};

		ctrl.onChangeActif = function (val) {
			ctrl.filtreActif = val;
			ctrl.getListFinanceurs();
		};

		ctrl.onChangeSearchText = function (val) {
			ctrl.searchText = val;
			ctrl.getListFinanceurs();
		};


		ctrl.init();

	}
})();

(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.controller('FinanceurItemController', Controller);
	/** @ngInject */
	function Controller($stateParams, $state, FinanceurWS, $q, toastr, TvaWS, $log, $rootScope, SweetAlert) {
		var ctrl = this;
		var svc = FinanceurWS;

		// get current route to test active class on menuReferenciel
		$rootScope.currentStateName = $state.current.name;

		ctrl.isUpdate = $stateParams.id !== 'new';
		ctrl.idModified = $stateParams.id;
		ctrl.financeur = {};
		ctrl.financeur.actif = true;
		ctrl.conditionPaiement = {};
		ctrl.listTva = [];
		ctrl.compteGeneralFinanceur = [];

		//Permet de mettre les champs en mode disable pour la simple consultation de la page des établissements
		ctrl.disable = !$stateParams.edit;

		ctrl.init = function () {
			ctrl.getCompteGeneralFinanceur();
			ctrl.conditionPaiement = ctrl.getConditionPaiement();
			if (ctrl.isUpdate) {

				//on crée les droits pour les financeur importés à partir d'EasyDore
				var grant = FinanceurWS.updateFinanceurImport(ctrl.idModified);

				grant.then(function () {

					FinanceurWS.getOne(ctrl.idModified).then(function (response) {
						ctrl.financeur = response.data;

					});
				});
			}

			TvaWS.getListTva().then(function (response) {
				ctrl.listTva = response.data.content;
			});
		};

		ctrl.getCompteGeneralFinanceur = function () {
			FinanceurWS.getCompteGeneralFinanceur().then(function (response) {
				ctrl.compteGeneralFinanceur = response.data.content;
			});
		};

		ctrl.backToList = function () {
			$state.go('referentiel.financeur');
		};

		ctrl.onSaveFailure = function (response) {
			if (response.status === 400) {
				$scope.serverErrors = response.data.errors;
			} else {
				toastr.error('Echec d\'enregistrement : ' + response.data.message);
			}
			return $q.reject();
		};

		ctrl.saveOrUpdate = function (financeur) {
			$log.debug(financeur);
			return svc.saveOrUpdate(financeur).then(ctrl.backToList, ctrl.onSaveFailure);
		};

		ctrl.addContact = function () {
			$log.debug('Ajout d\'un contact');
			var newContact = {};

			if (ctrl.financeur.contacts === undefined) {
				ctrl.financeur.contacts = [];
			}
			ctrl.financeur.contacts.push(newContact);
		};

		ctrl.removeContact = function (index) {
			$log.debug('Retrait d\'un contact');
			ctrl.financeur.contacts.splice(index, 1);
		};

		ctrl.validateCode = function (value) {
			return svc.validateCode(ctrl.financeur, value);
		};

		//Récupération de la liste des conditions de paiement
		ctrl.getConditionPaiement = function () {
			FinanceurWS.getConditionPaiement().then(function (response) {
				ctrl.conditionPaiement = response.data;
			});
		};

		ctrl.confirmDelete = function (financeur) {
			SweetAlert.swal({
				title: 'Suppression de la demande',
				text: 'Êtes-vous sûr de vouloir supprimer ce financeur ?',
				type: 'warning',
				showCancelButton: true,
				cancelButtonText: 'Annuler',
				confirmButtonColor: '#DD6B55',
				confirmButtonText: 'Oui'
			},
				function (isConfirm) {
					if (isConfirm) {
						ctrl.delete(financeur);
					}
				});
		};

		// Permet de supprimer un financeur
		ctrl.delete = function (financeur) {
			FinanceurWS.deleteFinanceur(financeur).then(ctrl.backToList,
				function (response) {
					if (response.status === 403) {
						toastr.error('Suppression imposible, le financeur est référencé dans ' + response.data.reason);
					}
					else {
						toastr.error('Echec de la suppression');
					}
					return $q.reject();
				});
		};

		ctrl.init();
	}
})();

(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.controller('EtablissementListController', Controller);

	/** @ngInject */
	function Controller($state, EtablissementWS, $log, SecurityService) {
		var ctrl = this;
		var svc = EtablissementWS;
		ctrl.read = false;


		ctrl.init = function () {
			ctrl.filtreActif = true;
			ctrl.searchText = '';
			ctrl.list = [];

			ctrl.getListEtablissements();

			if (SecurityService.anyRole('ETABLISSEMENT')) {
				ctrl.read = true;
			}
		};



		//Fonction permettant d'accéder au formulaire d'un projet
		ctrl.goTo = function (id) {
			// reload to test active class on menu
			if (SecurityService.anyRole('ADMIN,INTERLOCUTEUR,FINANCIER')) {
				$state.go('referentiel.etablissement_item', { id: id, edit: true }, { reload: true });
			} else {
				$state.go('referentiel.etablissement_item', { id: id }, { reload: true });
			}
		};


		ctrl.add = function () {
			$state.go('referentiel.etablissement_item', { id: 'new', edit: true }, { reload: true });
		};

		//Fonction permettant d'afficher les établissements actifs ou clos
		ctrl.getListEtablissements = function () {
			$log.debug('ctrl.getListEtablissements : ' + ctrl.filtreActif + ' ' + ctrl.searchText);

			var searchText = ctrl.searchText;
			if (searchText.length <= 2) {
				searchText = '';
			}

			return svc.getListEtablissements(ctrl.filtreActif, searchText).then(function (response) {
				$log.debug('MAJ de la liste des etablissements');
				ctrl.list = response.data.content;
			});
		};


		ctrl.onChangeActif = function (val) {
			ctrl.filtreActif = val;
			ctrl.getListEtablissements();
		};

		ctrl.onChangeSearchText = function (val) {
			ctrl.searchText = val;
			ctrl.getListEtablissements();
		};


		ctrl.init();

	}
})();

(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.controller('EtablissementItemController', Controller);
	/** @ngInject */
	function Controller($stateParams, $state, EtablissementWS, $scope, $q, toastr, $log, $rootScope) {
		var ctrl = this;
		var svc = EtablissementWS;

		// get current route to test active class on menuReferenciel
		$rootScope.currentStateName = $state.current.name;

		ctrl.isUpdate = $stateParams.id !== 'new';
		ctrl.isNew = $stateParams.id === 'new';
		ctrl.idModified = $stateParams.id;

		ctrl.etablissement = {};

		//Permet de mettre les champs en mode disable pour la simple consultation de la page des établissements
		ctrl.disable = !$stateParams.edit;

		ctrl.init = function () {
			if (ctrl.isUpdate) {
				//on crée les droits pour les etablissement importés à partir d'EasyDore
				var grant = EtablissementWS.updateEtablissementImport(ctrl.idModified);
				
				grant.then(function () {
					
					EtablissementWS.getOne(ctrl.idModified).then(function (response) {
						ctrl.etablissement = response.data;

					});
					
				});
			}
			if (ctrl.isNew) {
				ctrl.etablissement.actif = true;
			}
		};

		ctrl.backToList = function () {
			$state.go('referentiel.etablissement');
		};

		ctrl.onSaveFailure = function (response) {
			if (response.status === 400) {
				$scope.serverErrors = response.data.errors;
			} else {
				toastr.error('Echec d\'enregistrement : ' + response.data.message);
			}
			return $q.reject();
		};



		ctrl.saveOrUpdate = function (etablissement) {

			return svc.saveOrUpdate(etablissement).then(ctrl.backToList, ctrl.onSaveFailure);
		};

		ctrl.addContact = function () {
			$log.debug('Ajout d\'un contact');
			var newContact = {};

			if (ctrl.etablissement.contacts === undefined) {
				ctrl.etablissement.contacts = [];
			}
			ctrl.etablissement.contacts.push(newContact);
		};

		ctrl.removeContact = function (index) {
			$log.debug('Retrait d\'un contact');
			ctrl.etablissement.contacts.splice(index, 1);
		};

		ctrl.validateCode = function (value) {
			return svc.validateCode(ctrl.etablissement, value);
		};

		ctrl.init();

	}
})();

(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.controller('CategoryListController', Controller);

	function Controller($state, CategoryWS, $log, SecurityService) {
		
		var ctrl = this;
		var svc = CategoryWS;
		ctrl.pageSize = 15;
		ctrl.pagingOptions = {};
		ctrl.read = false;


		ctrl.init = function () {
			ctrl.filtreActif = true;
			ctrl.searchText = '';
			ctrl.list = [];
			ctrl.getListCategories();

			if (SecurityService.anyRole('ETABLISSEMENT')) {
				ctrl.read = true;
			}
			
		};
		
		ctrl.goTo = function (id) {
			if (SecurityService.anyRole('ADMIN,INTERLOCUTEUR,FINANCIER')) {
				$state.go('referentiel.category_item', {id: id, edit: true}, {reload: true});
			}else{
				$state.go('referentiel.category_item', {id: id}, {reload: true});
			}
		};

		ctrl.add = function () {
			$state.go('referentiel.category_item', {id: 'new', edit: true}, {reload:true});
		};

		//Fonction permettant d'afficher les beneficiaires actifs ou clos
		
		ctrl.getListCategories = function () {
			var searchText = ctrl.searchText;
			if (searchText.length <= 2) {
				searchText = '';
			}
			
			return svc.getListCategories(ctrl.filtreActif, searchText, ctrl.pagingOptions).then(function (response) {
				ctrl.list = response.data.content;
				ctrl.page = response.data;
			});
		};
		

		
		ctrl.onChangeActif = function (val) {
			ctrl.filtreActif = val;
			ctrl.getListCategories();
		};

		ctrl.onChangeSearchText = function (val) {
			ctrl.searchText = val;
			ctrl.getListCategories();
		};

		// Mise à jour des options de pagination (tri / paginataion)
		ctrl.onPagingOptionsChange = function (pagingOptions) {
			ctrl.pagingOptions = pagingOptions;
			ctrl.getListCategories();
		};

		// Augmente le nombre de résultats affichés
		ctrl.viewMore = function () {
			ctrl.pageSize += 15;
		};

		ctrl.init();

	}
})();


(function () {
	'use strict';

	angular.module('app.referentiel').controller('CategoryItemController',
		Controller);
	/** @ngInject */
	function Controller($stateParams, $state, CategoryWS, EtablissementWS, $q,
		toastr, $scope, _, $rootScope) {
		var ctrl = this;

		// get current route to test active class on menuReferenciel
		$rootScope.currentStateName = $state.current.name;

		ctrl.isUpdate = $stateParams.id !== 'new';
		ctrl.idModified = $stateParams.id;
		ctrl.category = {
			actif: true
		};

		// Permet de mettre les champs en mode disable pour la simple
		// consultation de la page des Category
		ctrl.disable = !$stateParams.edit;
		ctrl.compteCharge = [];

		ctrl.init = function () {
			ctrl.loadTypesFrais();
			ctrl.loadCompteCharge();
			if (ctrl.isUpdate) {
				//on crée les droits pour les category importés à partir d'EasyDore
				var grant = CategoryWS.updateCategoryImport(ctrl.idModified);
				
				grant.then(function () {
					
					CategoryWS.getOne(ctrl.idModified).then(function (response) {
						ctrl.category = response.data;
					});

				});
				
			} else {
				ctrl.category.details = ctrl.category.details || [];
				ctrl.initialisationFrais();
			}
		};

		ctrl.loadTypesFrais = function () {
			CategoryWS.getTypesFrais().then(function (response) {
				ctrl.typesFrais = response.data;
			});
		};

		ctrl.loadCompteCharge = function () {
			CategoryWS.getCompteCharge().then(function (response) {
				ctrl.compteCharge = response.data.content;
			});
		};

		ctrl.returnCompteCharge = function () {
			CategoryWS.getCompteCharge().then(function (response) {
				return response.data.content;
			});
		};

		ctrl.backToList = function () {
			$state.go('referentiel.category');
		};

		ctrl.onSaveFailure = function (response) {
			if (response.status === 400) {
				$scope.serverErrors = response.data.errors;
			} else {
				toastr.error('Echec d\'enregistrement : ' + response.data.message);
			}
			return $q.reject();
		};

		ctrl.saveOrUpdate = function (category) {
			CategoryWS.saveOrUpdate(category).then(ctrl.backToList,
				ctrl.onSaveFailure);
		};

		ctrl.validateCode = function (value) {
			return CategoryWS.validateCode(ctrl.category, value);
		};

		// Gestion des frais
		ctrl.addFrais = function () {
			ctrl.category.details.push({});
		};

		ctrl.removeFrais = function (index) {
			ctrl.category.details.splice(index, 1);
		};

		//Initialise la liste des frais pour une nouvelle catégorie de dépense
		ctrl.initialisationFrais = function () {
			CategoryWS.getCompteCharge().then(function (response) {
				var comptes = response.data.content;

				var compte = _.find(comptes, function (compte) {
					return compte.numero === '62500000';
				});

				var transport1 = {
					libelle: 'Avion',
					typeFrais: 'TRANSPORT1',
					compteCharge: compte
				};

				var transport2 = {
					libelle: 'Train',
					typeFrais: 'TRANSPORT2',
					compteCharge: compte
				};

				var location = {
					libelle: 'Location de voiture',
					typeFrais: 'LOCATION',
					compteCharge: compte,
					reel: 150.0,
					forfait: 150.0
				};

				var taxi = {
					libelle: 'Taxi',
					typeFrais: 'TAXI',
					compteCharge: compte,
					reel: 100.0,
					forfait: 100.0
				};

				var parking = {
					libelle: 'Parking',
					typeFrais: 'PARKING',
					compteCharge: compte,
					reel: 100.0,
					forfait: 100.0
				};

				var peage = {
					libelle: 'Péage',
					typeFrais: 'PEAGE',
					compteCharge: compte,
					reel: 50.0,
					forfait: 50.0
				};

				var autre = {
					libelle: '',
					typeFrais: 'AUTRE',
					compteCharge: compte
				};

				ctrl.category.details.push(transport1);
				ctrl.category.details.push(transport2);
				ctrl.category.details.push(location);
				ctrl.category.details.push(taxi);
				ctrl.category.details.push(parking);
				ctrl.category.details.push(peage);
				ctrl.category.details.push(autre);

			});
		};

		ctrl.init();

	}
})();

(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.controller('BeneficiaireListController', Controller);

	/** @ngInject */
	function Controller($state, BeneficiaireWS, $log, SecurityService) {
		var ctrl = this;
		var svc = BeneficiaireWS;
		ctrl.read = false;


		ctrl.init = function () {
			ctrl.pageSize = 15;
			ctrl.pagingOptions = {};
			ctrl.filtreActif = true;
			ctrl.searchText = '';
			ctrl.list = [];
			ctrl.getListBeneficiaires();

			if (SecurityService.anyRole('ETABLISSEMENT')) {
				ctrl.read = true;
			}
		};

		ctrl.goTo = function (id) {
			if (SecurityService.anyRole('ADMIN,INTERLOCUTEUR,FINANCIER')) {
				// reload to test active class on menu
				$state.go('referentiel.beneficiaire_item', {id: id, edit: true}, {reload:true});
			}else{
				$state.go('referentiel.beneficiaire_item', {id: id}, {reload:true});
			}
		};

		ctrl.add = function () {
			$state.go('referentiel.beneficiaire_item', {id: 'new', edit: true}, {reload:true});
		};

		var onLoadSuccess = function (data) {
			if (this.search === ctrl.searchText) {
				ctrl.page = data.data;
								
			} else {
				$log.debug('response is outdated => ignore');
			}
		};

		//Fonction permettant d'afficher les beneficiaires actifs ou clos
		
		ctrl.getListBeneficiaires = function () {
			var searchText = ctrl.searchText;
			if (searchText.length <= 2) {
				searchText = '';
			}
			
			return svc.getListBeneficiaires(ctrl.filtreActif, searchText,ctrl.pagingOptions).then(onLoadSuccess.bind({search: ctrl.searchText}));
		};
		

		
		ctrl.onChangeActif = function (val) {
			ctrl.filtreActif = val;
			ctrl.getListBeneficiaires();
		};

		ctrl.onChangeSearchText = function (val) {
			ctrl.searchText = val;
			ctrl.getListBeneficiaires();
		};

		// Mise à jour des options de pagination (tri / paginataion)
		ctrl.onPagingOptionsChange = function (pagingOptions) {
			ctrl.pagingOptions = pagingOptions;
			ctrl.getListBeneficiaires();
		};

		// Augmente le nombre de résultats affichés
		ctrl.viewMore = function () {
			ctrl.pageSize += 15;
			
		};

		ctrl.init();

	}
})();

(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.controller('BeneficiaireItemController', Controller);
	/** @ngInject */
	function Controller($stateParams, $state, BeneficiaireWS, EtablissementWS, UtilisateurService, $q, toastr, $scope, $rootScope) {
		var ctrl = this;
		var svc = BeneficiaireWS;

		// get current route to test active class on menuReferenciel
		$rootScope.currentStateName = $state.current.name;

		ctrl.isUpdate = $stateParams.id !== 'new';
		ctrl.idModified = $stateParams.id;
		ctrl.beneficiaire = {};
		ctrl.beneficiaire.actif = true;
		ctrl.utilisateur = {};
		ctrl.disableConnexion = false;
		//Permet l'autocompletion des etablissements
		ctrl.autocompleteEtablissement = EtablissementWS.autocomplete;

		//Permet de mettre les champs en mode disable pour la simple consultation de la page des beneficaires
		ctrl.disable = !$stateParams.edit;

		ctrl.init = function () {
			if (ctrl.isUpdate) {
				//on crée les droits pour les beneficiaire importés à partir d'EasyDore
				var grant = BeneficiaireWS.updateBeneficiaireImport(ctrl.idModified);

				grant.then(function () {

					BeneficiaireWS.getOne(ctrl.idModified).then(function (response) {
						ctrl.beneficiaire = response.data;
						ctrl.verifyUser(ctrl.beneficiaire);
					});

				});
			}
		};


		ctrl.saveAndCreateUser = function (beneficiaire) {
			svc.saveOrUpdate(beneficiaire).then(function (newBen) {
				if (ctrl.isUpdate) {
					ctrl.createUser(newBen.data);
				} else {
					ctrl.createUser(newBen);
				}
			}, ctrl.onSaveFailure);

		};

		ctrl.removeAccents = function (input) {
			var output = '';
			var normalized = input.normalize('NFD');
			var i = 0;
			var j = 0;

			while (i < input.length) {
				output += normalized[j];

				j += (input[i] === normalized[j]) ? 1 : 2;
				i++;
			}

			var outputWhithOutSpace = output.replace(/\s+/g, '');

			return outputWhithOutSpace;
		};

		ctrl.buildLogin = function (email) {
			return ctrl.removeAccents(email);
		};

		// Permet de recharger la page après avoir enregistré, émis ou payer une
		// opération
		ctrl.onSaveReload = function (response) {
			if (response.status === 201 || response.status === 200) {
				toastr.success('Utilisateur créé avec succès');
				ctrl.backToList();
			}
		};

		ctrl.createUser = function (beneficiaire) {

			ctrl.utilisateur.lastname = beneficiaire.nom;
			ctrl.utilisateur.firstname = beneficiaire.prenom;
			ctrl.utilisateur.email = beneficiaire.email;
			ctrl.utilisateur.etablissement = beneficiaire.etablissement;
			ctrl.utilisateur.role = 'BENEFICIAIRE';
			ctrl.utilisateur.username = ctrl.buildLogin(
				beneficiaire.email);
			UtilisateurService.createFromBeneficiaire(ctrl.utilisateur,
				beneficiaire.id).then(ctrl.onSaveReload,
					ctrl.onSaveFailure);

		};

		ctrl.backToList = function () {
			$state.go('referentiel.beneficiaire');
		};

		ctrl.onSaveFailure = function (response) {
			if (response.status === 400) {
				$scope.serverErrors = response.data.errors;
			} else {
				toastr.error('Echec d\'enregistrement : ' + response.data.message);
			}
			return $q.reject();
		};

		ctrl.saveOrUpdate = function (beneficiaire) {
			svc.saveOrUpdate(beneficiaire).then(ctrl.backToList, ctrl.onSaveFailure);
		};




		ctrl.validateCode = function (value) {
			return svc.validateCode(ctrl.beneficiaire, value);
		};

		ctrl.verifyUser = function (beneficiaire) {

			UtilisateurService.validateEmail(null, beneficiaire.email)
				.success(function () {
					ctrl.disableConnexion = false;
				}).error(function () {
					ctrl.disableConnexion = true;
				});


		};

		ctrl.init();

	}
})();

(function () {
	'use strict';

	angular.module('app.operation').controller('DemandeRemboursementItemController',
		Controller);

	/** @ngInject */
	function Controller($stateParams, $q, $window, $log, $state, OperationWS, CategoryWS, $scope, toastr, FileUploader, CompteWS, InvestigateurWS, BeneficiaireWS, SecurityService, SweetAlert) {
		var ctrl = this;
		ctrl.isSaveOne = false;

		ctrl.dateFormat = 'dd/MM/yyyy';

		ctrl.isUpdate = $stateParams.id !== 'new';
		ctrl.idModified = $stateParams.id;

		ctrl.demande = {};

		ctrl.autocompleteCompte = CompteWS.autocomplete;

		ctrl.autocompleteInvestigateur = InvestigateurWS.autocomplete;

		ctrl.autocompleteBeneficiaire = BeneficiaireWS.autocomplete;
		ctrl.currentUser = {};
		ctrl.afficherSoumettre = false;
		ctrl.currentUser = SecurityService.getUserDetails();

		//Permet de mettre les champs en mode disable pour la simple consultation de la page des demandes de remboursement
		ctrl.disable = !$stateParams.edit;

		ctrl.init = function () {
			ctrl.loadCompteCharge();
			ctrl.afficherSoumettre = false;
			ctrl.afficherInputNumeroCheque = false;

			if (ctrl.currentUser && ctrl.currentUser.roles) {
				ctrl.role = ctrl.currentUser.roles[0];
			}


			if (ctrl.isUpdate) {
				//on crée les droits pour les remboursements importés à partir d'EasyDore
				var grant = OperationWS.updateDemandeRemboursementImport(ctrl.idModified);
				grant.then(function () {

					OperationWS.getOneDemandeRemboursement(ctrl.idModified).then(function (response) {

						// Permet de savoir si la demande à au moins était
						// sauvegardé une fois
						ctrl.isSaveOne = true;
						ctrl.demande = response.data;
						ctrl.statutActuel = ctrl.demande.statut;
						// Détermine le type du demandeur
						if (ctrl.demande.investigateur !== null) {
							ctrl.demande.demandeur = ctrl.demande.investigateur;
						} else {
							ctrl.demande.demandeur = ctrl.demande.beneficiaire;
						}
						ctrl.showInputNumeroCheque();
						ctrl.showButtonSoumettre();
					});
				});
			} else {
				// initialisation du statut de la demande de remboursement sur
				// brouillon
				ctrl.isSaveOne = false;
				ctrl.loadDemandeRemboursementLocal();
				ctrl.demande.statut = 'BROUILLON';
				ctrl.statutActuel = ctrl.demande.statut;
			}
		};

		// Permet de supprimer le compte si on change le demandeur
		ctrl.onChangeDemandeur = function ($item) {
			var demandeur = $item;
			var compte = ctrl.demande.compte;
			var deleteCompte = true;

			if (compte !== null && compte !== undefined) {
				_.forEach(compte.investigateurs, function (investigateur) {
					if (investigateur.investigateur.id === demandeur.id) {
						deleteCompte = false;
						return;
					}
				});

				if (deleteCompte) {
					_.forEach(compte.beneficiaires, function (beneficiaire) {
						if (beneficiaire.beneficiaire.id === demandeur.id) {
							deleteCompte = false;
							return;
						}
					});
				}

				if (deleteCompte && compte.titulaire.id === demandeur.id) {
					deleteCompte = false;
				}

				if (deleteCompte) {
					ctrl.demande.compte = null;
				}
			}
		};

		//Permet de détecter le changement du compte dans la liste déroulante
		ctrl.onChangeCompte = function () {
			$scope.form.montantTTC.$setValidity('server.solde_insuffisant', true);
		};

		// Permet de charger tous les comptes charges
		ctrl.loadCompteCharge = function () {
			CategoryWS.getCompteCharge().then(function (response) {
				ctrl.compteCharge = response.data.content;
			});
		};

		// Permet de recharger la page après avoir enregistré, émis ou payer une
		// opération
		ctrl.onSaveReload = function (response) {
			if (response.status === 201 || response.status === 200) {
				ctrl.idDemandeSave = response.data.id;

				if (ctrl.getFileUpload.queue.length !== 0) {
					ctrl.uploadFile();
				} else {
					ctrl.afterSave(ctrl.idDemandeSave);
				}
			}
		};

		//Permet d'ajouter des fichiers après l'enregistrement de la demande de remboursement
		ctrl.addFileToSave = function (idDemande) {
			OperationWS.uploadFilesRemboursement(idDemande).then(function () {
				ctrl.getFileUpload.clearQueue();
				ctrl.afterSave(idDemande);
			});
		};

		//Permet d'exécuter des actions après la sauvegarde de la demande et des pièces jointes
		ctrl.afterSave = function (idDemande) {
			if (localStorage.getItem('demandeRemboursement') !== null) {
				ctrl.isSaveOne = true;
				localStorage.removeItem('demandeRemboursement');
			}
			toastr.success('Action effectuée avec succès');
			$state.go('operation.item_demande_remboursement', {
				id: idDemande
			});
			ctrl.init();
		};


		// Permet de revenir sur la liste des opérations
		ctrl.backToList = function () {
			$state.go('operation.list');
		};
		// Fonction permettant de traiter les erreurs et de les afficher en cas
		// de non enregistrement de l'opération
		ctrl.onSaveFailure = function (response) {
			if (response.status === 400) {
				ctrl.serverErrors = response.data.errors;
			} else if (response.status === 500) {
				toastr.error(response.data.message);
			} else {
				toastr.error('Echec d\'enregistrement');
			}
		};

		// Fonction permettant de traiter les erreurs et de les afficher en cas
		// de non suppresision de la demande de remboursement
		ctrl.onDeleteFailure = function (response) {
			if (response.status === 400) {
				ctrl.serverErrors = response.data.errors;
			} else {
				toastr.error('Echec de la suppression');
			}
			return $q.reject();
		};

		// Permet d'enregistrer et de mettre à jour une demande sans quitter la
		// page
		ctrl.saveOrUpdate = function (demande) {
			// Si il y a des fichiers en attente d'upload, on exécute d'abord
			// l'upload avant l'enregistrement de la demande
			ctrl.saveOrUpdateWithoutUploadFile(demande);
		};

		// Permet l'enregistrement de la demande sans l'upload de fichier
		ctrl.saveOrUpdateWithoutUploadFile = function (demande) {
			if (ctrl.estSoumise) {
				demande.statut = 'SOUMISE';
			}

			// Permet de déterminer si le demandeur est un bénéficiaire ou un
			// investigateur
			if (ctrl.demande.demandeur.contacts !== undefined) {
				ctrl.demande.investigateur = ctrl.demande.demandeur;
				ctrl.demande.beneficiaire = null;
			} else {
				ctrl.demande.beneficiaire = ctrl.demande.demandeur;
				ctrl.demande.investigateur = null;
			}

			OperationWS.saveOrUpdateDemandeRemboursement(demande, ctrl.estSoumise).then(ctrl.onSaveReload, ctrl.onSaveFailure);

		};

		// Permet de supprimer une demande de remboursement
		ctrl.delete = function (demande) {
			OperationWS.deleteDemandeRemboursement(demande).then(ctrl.backToList, ctrl.onDeleteFailure);
		};


		// Permet de changer le statut d'une demande de remboursement
		ctrl.changeStatus = function (statut) {
			ctrl.demande.statut = statut;
			ctrl.saveOrUpdate(ctrl.demande);
		};

		// Permet de stocker le fichier passé en pièce jointe sur le serveur
		ctrl.getFileUpload = new FileUploader({
			url: '/api/demande/remboursement_fichier/upload',
			onSuccessItem: function () {
				$scope.form.pj.$setValidity('badFileRemove', true);
			},
			onErrorItem: function (item) {
				$scope.form.pj.$setValidity('badFileRemove', false);
				ctrl.getFileUpload.removeFromQueue(item);
			},
			onCompleteAll: function () {
				ctrl.addFileToSave(ctrl.idDemandeSave);
			}
		});

		// Permet de retirer un fichier de la liste d'attente pour l'upload des
		// pièces jointes
		ctrl.removeFile = function (index) {
			ctrl.getFileUpload.removeFromQueue(index);
		};

		// Permet de faire une recherche du demandeur sur l'investigateur ou sur
		// le bénéficiaire
		ctrl.autocompleteDemandeur = function (search, id) {
			var beneficiaires = ctrl.autocompleteBeneficiaire(search, id);
			var investigateurs = ctrl.autocompleteInvestigateur(search, id);
			return $q.all([beneficiaires, investigateurs]).then(function (results) {
				return results[0].concat(results[1]);
			});
		};

		//Permet de valider le montant de la demande de remboursement par rapport au montant total
		ctrl.validateMontantTVA = function () {
			var isValid = Number(ctrl.demande.montantTTC) - Number(ctrl.demande.montantTVA) >= 0;
			$scope.form.montantTVA.$setValidity('badMontant', isValid);
		};

		ctrl.confirmDelete = function (demande) {
			SweetAlert.swal({
				title: 'Suppression de la demande',
				text: 'Êtes-vous sûr de vouloir supprimer cette demande ?',
				type: 'warning',
				showCancelButton: true,
				cancelButtonText: 'Annuler',
				confirmButtonColor: '#DD6B55',
				confirmButtonText: 'Oui'
			},
				function (isConfirm) {
					if (isConfirm) {
						ctrl.delete(demande);
					}
				});
		};

		// Permet de définir si on a cliqué sur le bouton SOUMETTRE ou
		// ENREGISTRER lors de la première initialisation de la demande
		ctrl.changeActionSubmit = function (val) {
			$scope.form.pj.$setValidity('badFileRemove', true);
			ctrl.estSoumise = val;
		};

		// Gestion des détails
		ctrl.addDetail = function () {
			ctrl.demande.bonCommandes = ctrl.demande.bonCommandes || [];
			ctrl.demande.bonCommandes.push({});
		};

		ctrl.removeDetail = function (index) {
			ctrl.demande.bonCommandes.splice(index, 1);
			ctrl.updateMontantTTC();
		};

		// Permet de calculer le montant ttc selon les items renseignés dans la
		// partie détail de la demande
		ctrl.updateMontantTTC = function () {
			var montant = 0;
			_.forEach(ctrl.demande.bonCommandes, function (bon) {
				montant = montant + bon.total;
			});

			if (montant === 0) {
				ctrl.demande.montantTTC = null;
			} else {
				ctrl.demande.montantTTC = Number(montant);
			}

			$scope.form.montantTTC.$setValidity('server.solde_insuffisant', true);
		};

		ctrl.soumissionParBeneficiaire = function (demande, statut) {
			ctrl.demande.statut = statut;
			// Permet de déterminer si le demandeur est un bénéficiaire ou un
			// investigateur
			if (ctrl.demande.demandeur.contacts !== undefined) {
				ctrl.demande.investigateur = ctrl.demande.demandeur;
				ctrl.demande.beneficiaire = null;
			} else {
				ctrl.demande.beneficiaire = ctrl.demande.demandeur;
				ctrl.demande.investigateur = null;
			}
			OperationWS.saveOrUpdateDemandeRemboursement(ctrl.demande).then(ctrl.onSaveReload, ctrl.onSaveFailure);

		};

		//Permet d'uploader tous les fichiers en même temps
		ctrl.uploadFile = function () {
			if (ctrl.getFileUpload.queue.length !== 0) {
				ctrl.getFileUpload.uploadAll();
			}
		};

		ctrl.motifRefus = function () {
			swal({
				title: 'Demande de remboursement refusée',
				text: 'Saisissez le motif du refus',
				type: 'input',
				showCancelButton: true,
				closeOnConfirm: false,
				cancelButtonText: 'Annuler',
				confirmButtonText: 'Valider',
				confirmButtonColor: '#DD6B55',
				inputPlaceholder: 'Motif du refus'
			},
				function (inputValue) {
					if (inputValue === false) {
						return false;
					}
					if (inputValue === '') {
						swal.showInputError('Motif obligatoire');
						return false;
					}

					ctrl.demande.motif = inputValue;
					ctrl.changeStatus('REFUSE');
					swal.close();
				});
		};

		ctrl.soumissionParBeneficiaire = function (demande, statut) {
			ctrl.demande.statut = statut;
			// Permet de déterminer si le demandeur est un bénéficiaire ou un
			// investigateur
			if (ctrl.demande.demandeur.contacts !== undefined) {
				ctrl.demande.investigateur = ctrl.demande.demandeur;
				ctrl.demande.beneficiaire = null;
			} else {
				ctrl.demande.beneficiaire = ctrl.demande.demandeur;
				ctrl.demande.investigateur = null;
			}
			OperationWS.saveOrUpdateDemandeRemboursement(ctrl.demande).then(ctrl.onSaveReload, ctrl.onSaveFailure);
		};

		// Permet d'afficher le bouton soumettre pour le titulaire du compte
		ctrl.showButtonSoumettre = function () {

			if (ctrl.demande.compte !== undefined && ctrl.currentUser.investigateurId !== null && ctrl.demande.compte.titulaire.id === ctrl.currentUser.investigateurId) {
				ctrl.afficherSoumettre = true;

			}
			// au choix du compte, on définit si le user va être considéré comme
			// investigateur principale ou devenir beneficiaire

			if (ctrl.demande.compte !== undefined && ctrl.currentUser.investigateurId !== null && ctrl.demande.compte.titulaire.id !== ctrl.currentUser.investigateurId) {
				ctrl.role = 'BENEFICIAIRE';
				ctrl.afficherSoumettre = false;
			} else {
				ctrl.role = SecurityService.getRoles()[0];
			}


		};

		// Permet d'afficher le champ pour le numéro du chèque si le demandeur
		// de la demande ne possèdent pas d'IBAN
		ctrl.showInputNumeroCheque = function () {
			if (ctrl.demande.beneficiaire !== null && ctrl.demande.beneficiaire !== undefined) {
				if (ctrl.demande.beneficiaire.iban === null || ctrl.demande.beneficiaire.iban === '' || ctrl.demande.beneficiaire.iban === undefined) {
					ctrl.afficherInputNumeroCheque = true;
				}
			}

			if (ctrl.demande.investigateur !== null && ctrl.demande.investigateur !== undefined) {
				if (ctrl.demande.investigateur.iban === null || ctrl.demande.investigateur.iban === '' || ctrl.demande.investigateur.iban === undefined) {
					ctrl.afficherInputNumeroCheque = true;
				}
			}
		};


		// Permet de stocker des valeurs en local
		ctrl.loadDemandeRemboursementLocal = function () {
			if (localStorage.getItem('demandeRemboursement') !== null) {
				ctrl.demande = JSON.parse(localStorage.getItem('demandeRemboursement'));
			}
		};

		// Permet de détecter une changement de la route pour permettre la
		// sauvegarde de la demande
		$scope.$on('$stateChangeStart', function () {

			if (!ctrl.isSaveOne) {
				localStorage.setItem('demandeRemboursement', JSON.stringify(ctrl.demande));
			}

		});


		ctrl.init();
	}
})();

(function () {
	'use strict';

	angular.module('app.operation').controller('DemandeMissionItemController',
		Controller);

	/** @ngInject */
	function Controller($stateParams, $state, OperationWS, _, $scope, toastr, FileUploader, CompteWS, InvestigateurWS, BeneficiaireWS, $q, SweetAlert, SecurityService) {
		var ctrl = this;

		ctrl.dateFormat = 'dd/MM/yyyy';

		ctrl.isUpdate = $stateParams.id !== 'new';

		ctrl.idModified = $stateParams.id;

		ctrl.demandeStateParam = $stateParams.demande;

		ctrl.demande = {};
		ctrl.role = {};

		ctrl.autocompleteCompte = CompteWS.autocomplete;

		ctrl.autocompleteInvestigateur = InvestigateurWS.autocomplete;

		ctrl.autocompleteBeneficiaire = BeneficiaireWS.autocomplete;

		//Permet de mettre les champs en mode disable pour la simple consultation de la page des demandes de mission
		ctrl.disable = !$stateParams.edit;

		ctrl.currentUser = SecurityService.getUserDetails();
		if (ctrl.currentUser && ctrl.currentUser.roles) {
			ctrl.role = ctrl.currentUser.roles[0];
		}

		ctrl.init = function () {
			ctrl.demandeParam = ctrl.demandeStateParam;
			ctrl.afficherSoumettre = false;
			ctrl.afficherReceptionner = false;
			ctrl.afficherInputNumeroCheque = false;
			ctrl.remboursementBeneficiaire = false;
			ctrl.afficherTerminer = false;
			ctrl.afficherPaiementAmplitude = false;
			ctrl.afficherRemboursementBenenficiaire = false;
			ctrl.numeroChequeRequired = false;
			// Permet de savoir quand le paiement pour amplitude est fait (
			// permet de faire des paiements partiels )
			ctrl.typePaiement = null;
			ctrl.controleUser();
			if (ctrl.isUpdate) {

				// Permet de savoir si la demande a été sauvegardé une fois
				ctrl.isSaveOne = true;

				// Cas où l'on revient de l'ajout d'une étape dans la demande
				// de mission
				if (ctrl.demandeParam !== null && ctrl.demandeParam !== undefined) {
					ctrl.demande = ctrl.demandeParam;
					ctrl.initDemande();
					ctrl.updateMontantTTC();
					ctrl.showButtonSoumettre();
					// Cas Où l'on charge la demande de mission depuis la liste des
					// demandes
				} else {
					OperationWS.getOneDemandeMission(ctrl.idModified).then(
						function (response) {
							ctrl.demande = response.data;
							ctrl.initDemande();
							ctrl.showButtonSoumettre();
							ctrl.showButtonReceptionner();
							ctrl.showInputNumeroCheque();
							ctrl.showButtonTerminer();
							ctrl.showButtonPaiementAmplitude();
							ctrl.showButtonRemboursementBeneficiaire();
						});
				}
			} else {
				// initialisation du statut de la demande de mission sur
				// brouillon
				ctrl.isSaveOne = false;
				ctrl.loadDemandeMissionLocal();
				if (ctrl.demandeParam !== null && ctrl.demandeParam !== undefined) {
					ctrl.demande = ctrl.demandeParam;
					ctrl.showButtonSoumettre();
				}

				if (ctrl.demande.details === null || ctrl.demande.details === undefined) {
					ctrl.demande.details = [];
				}

				if (ctrl.demande.etapes === null || ctrl.demande.etapes === undefined) {
					ctrl.demande.etapes = [];
				}

				if (ctrl.demande.depenses === null || ctrl.demande.depenses === undefined) {
					ctrl.demande.depenses = [];
				}

				ctrl.demande.statut = 'BROUILLON';

				ctrl.initDemande();
				ctrl.updateMontantTTC();
			}
		};

		// Permet de supprimer le compte si on change le demandeur
		ctrl.onChangeDemandeur = function ($item) {
			var demandeur = $item;
			var compte = ctrl.demande.compte;
			var deleteCompte = true;

			if (compte !== null && compte !== undefined) {
				_.forEach(compte.investigateurs, function (investigateur) {
					if (investigateur.investigateur.id === demandeur.id) {
						deleteCompte = false;
						return;
					}
				});

				if (deleteCompte) {
					_.forEach(compte.beneficiaires, function (beneficiaire) {
						if (beneficiaire.beneficiaire.id === demandeur.id) {
							deleteCompte = false;
							return;
						}
					});
				}

				if (deleteCompte && compte.titulaire.id === demandeur.id) {
					deleteCompte = false;
				}

				if (deleteCompte) {
					ctrl.demande.compte = null;
				}
			}
		};

		// Permet de détecter le changement du compte dans la liste déroulante
		ctrl.onChangeCompte = function () {
			$scope.form.montantTTC.$setValidity('server.solde_insuffisant', true);
		};

		// Permet d'initialiser la demande qui a été récupérer (statut et le
		// demandeur)
		ctrl.initDemande = function () {
			ctrl.statutActuel = ctrl.demande.statut;
			ctrl.demande.montantPaiementPartiel = 0;

			// Permet d'éviter d'afficher 0 si vide et ainsi ne pas rendre les
			// pièces jointes obligatoires
			if (ctrl.demande.montantDevis === 0) {
				ctrl.demande.montantDevis = null;
			}

			// Détermine le type du demandeur
			if (ctrl.demande.investigateur !== null) {
				ctrl.demande.demandeur = ctrl.demande.investigateur;
			} else {
				ctrl.demande.demandeur = ctrl.demande.beneficiaire;
			}
		};

		ctrl.saveOrUpdate = function (demande) {
			ctrl.saveOrUpdateWithoutUploadFile(demande);
		};

		// Permet l'enregistrement de la demande sans l'upload de fichier
		ctrl.saveOrUpdateWithoutUploadFile = function (demande) {
			if (ctrl.estSoumise) {
				demande.statut = 'SOUMISE';
			}

			if (ctrl.demande.demandeur.contacts !== undefined) {
				ctrl.demande.investigateur = ctrl.demande.demandeur;
				ctrl.demande.beneficiaire = null;
			} else {
				ctrl.demande.beneficiaire = ctrl.demande.demandeur;
				ctrl.demande.investigateur = null;
			}

			OperationWS.saveOrUpdateDemandeMission(demande, ctrl.typePaiement).then(ctrl.onSaveReload, ctrl.onSaveFailure);
		};

		// Permet de faire un simple enregistrement
		ctrl.save = function (demande) {

			OperationWS.saveOrUpdateDemandeMission(demande, ctrl.typePaiement).then(ctrl.onSaveReload, ctrl.onSaveFailure);
		};



		// Permet de recharger la page après avoir enregistré, émis ou payer une
		// opération
		ctrl.onSaveReload = function (response) {
			if (response.status === 201 || response.status === 200) {
				ctrl.idDemandeSave = response.data.id;
				if (ctrl.getFileUpload.queue.length !== 0 || ctrl.getFileUploadDepense.queue.length !== 0) {
					if (ctrl.getFileUpload.queue.length !== 0) {
						ctrl.uploadFile();
					} else {
						ctrl.uploadFileDepense();
					}
				} else {
					ctrl.afterSave(ctrl.idDemandeSave);
				}
			}
		};

		// Permet d'ajouter des fichiers après l'enregistrement de la demande de
		// remboursement
		ctrl.addFileToSave = function (idDemande) {
			OperationWS.uploadFilesMission(idDemande).then(function () {
				ctrl.getFileUpload.clearQueue();
				ctrl.getFileUploadDepense.clearQueue();
				ctrl.afterSave(idDemande);
			});
		};

		// Permet d'exécuter des actions après la sauvegarde de la demande et
		// des pièces jointes
		ctrl.afterSave = function (idDemande) {
			if (localStorage.getItem('demandeMission') !== null) {
				ctrl.isSaveOne = true;
				localStorage.removeItem('demandeMission');
			}
			toastr.success('Action effectuée avec succès');
			$state.go('operation.item_demande_mission', {
				id: idDemande,
				demande: null
			});
			ctrl.init();
		};

		// Fonction permettant de traiter les erreurs et de les afficher en cas
		// de non enregistrement de l'opération
		ctrl.onSaveFailure = function (response) {
			if (response.status === 400) {
				ctrl.serverErrors = response.data.errors;
			} else if (response.status === 500) {
				toastr.error(response.data.message);
			} else {
				toastr.error('Echec d\'enregistrement');
			}
		};

		// Permet de stocker le fichier passé en pièce jointe sur le serveur
		ctrl.getFileUpload = new FileUploader({
			url: '/api/demande/mission_fichier/upload',
			onSuccessItem: function () {
				// Si la pièce jointe a été uploader avec succès, on la supprime
				// de la liste d'attente et on vérifie s'il n'y a pas d'autres
				// pièces jointes ensuite
				$scope.form.pj.$setValidity('badFileRemove', true);
			},
			onErrorItem: function (item) {
				$scope.form.pj.$setValidity('badFileRemove', false);
				ctrl.getFileUpload.removeFromQueue(item);
			},
			onCompleteAll: function () {
				ctrl.addFileToSave(ctrl.idDemandeSave);
			}
		});

		// Permet d'uploader les pièces jointes sur les postes de dépenses
		ctrl.getFileUploadDepense = new FileUploader({
			url: '/api/demande/mission_fichier/upload_depense',
			onAfterAddingFile: function (item) {
				item.formData.push({ id: item.idDepense });
			},
			onSuccessItem: function () {
				// Si la pièce jointe a été uploader avec succès, on la supprime
				// de la liste d'attente et on vérifie s'il n'y a pas d'autres
				// pièces jointes ensuite
				$scope.form.pj.$setValidity('badFileRemove', true);
			},
			onErrorItem: function (item) {
				$scope.form.pj.$setValidity('badFileRemove', false);
				ctrl.getFileUploadDepense.removeFromQueue(item);
			},
			onCompleteAll: function () {
				ctrl.addFileToSave(ctrl.idDemandeSave);
			}
		});

		// Permet de retirer un fichier de la liste d'attente pour l'upload des
		// pièces jointes
		ctrl.removeFile = function (index) {
			ctrl.getFileUpload.removeFromQueue(index);
		};

		// Permet de retirer un fichier de la liste d'attente pour l'upload des
		// pièces jointes d'une dépenses
		ctrl.removeFileDepense = function (index) {
			ctrl.getFileUploadDepense.removeFromQueue(index);
		};

		// Permet de supprimer une demande de remboursement
		ctrl.delete = function (demande) {
			OperationWS.deleteDemandeMission(demande).then(ctrl.backToList, ctrl.onDeleteFailure);
		};

		// Fonction permettant de traiter les erreurs et de les afficher en cas
		// de non suppresision de la demande de remboursement
		ctrl.onDeleteFailure = function (response) {
			if (response.status === 400) {
				ctrl.serverErrors = response.data.errors;
			} else {
				toastr.error('Echec de la suppression');
			}
			return $q.reject();
		};

		// Permet de revenir sur la liste des opérations
		ctrl.backToList = function () {
			$state.go('operation.list');
		};

		// Permet l'affichage d'une popup pour demander la confirmation de la
		// suppression de la demande
		ctrl.confirmDelete = function (demande) {
			SweetAlert.swal({
				title: 'Suppression de la demande',
				text: 'Êtes-vous sûr de vouloir supprimer cette demande ?',
				type: 'warning',
				showCancelButton: true,
				cancelButtonText: 'Annuler',
				confirmButtonColor: '#DD6B55',
				confirmButtonText: 'Oui'
			},
				function (isConfirm) {
					if (isConfirm) {
						ctrl.delete(demande);
					}
				});
		};

		// Gestion des étapes
		ctrl.addEtape = function () {
			if (ctrl.demande.demandeur !== undefined) {
				if (ctrl.demande.demandeur.contacts !== undefined) {
					ctrl.demande.investigateur = ctrl.demande.demandeur;
					ctrl.demande.beneficiaire = null;
				} else {
					ctrl.demande.beneficiaire = ctrl.demande.demandeur;
					ctrl.demande.investigateur = null;
				}
			}
			$state.go('operation.item_demande_mission.etape', { id: ctrl.idModified, demande: ctrl.demande });
		};

		ctrl.removeEtape = function (index) {
			var numEtape = index;

			ctrl.demande.etapes = _.reject(ctrl.demande.etapes, function (etape) {
				return etape.numero === numEtape;
			});

			// Permet de récupérer la liste des dépenses ne possédant pas le
			// numéro d'étape passé en paramètre
			ctrl.demande.depenses = _.reject(ctrl.demande.depenses, function (depense) {
				return depense.numeroEtape === numEtape;
			});

			_.forEach(ctrl.demande.etapes, function (etape) {
				if (etape.numero > numEtape) {
					etape.numero = etape.numero - 1;
				}
			});

			// Permet de diminuer le numéro de l'étape des dépense restantes si
			// la depense possède un numéro d'étape au dessus du numéro d'étape
			// supprimée
			_.forEach(ctrl.demande.depenses, function (depense) {
				if (depense.numeroEtape > numEtape) {
					depense.numeroEtape = depense.numeroEtape - 1;
				}
			});
			ctrl.updateMontantTTC();
		};

		// Permet de changer le statut d'une demande de mission
		ctrl.changeStatus = function (statut) {
			if ($scope.form.$valid) {
				ctrl.demande.statut = statut;
				ctrl.saveOrUpdate(ctrl.demande);
			}
		};

		// Permet de changer le statut d'une demande de mission sans le save
		ctrl.changeStatusWithoutSave = function (statut) {
			ctrl.demande.statut = statut;
			if (statut === 'PAYE') {
				ctrl.remboursementBeneficiaire = true;
			}
		};

		// Permet de calculer le montant ttc selon les items renseignés dans la
		// partie détail de la demande
		ctrl.updateMontantTTC = function () {
			var montant = 0;

			// Permet de déterminer si le montant du devis est obligatoire
			ctrl.montantDevisObligatoire = false;

			_.forEach(ctrl.demande.depenses, function (depense) {
				if (depense.selectionne && depense.remboursement) {
					montant = montant + depense.montant;
				} else if (depense.selectionne && !depense.remboursement) {
					ctrl.montantDevisObligatoire = true;
				}
			});

			if (ctrl.demande.montantDevis !== null && ctrl.demande.montantDevis !== undefined) {
				montant = montant + ctrl.demande.montantDevis;
			}

			if (montant === 0) {
				ctrl.demande.montantTTC = null;
			} else {
				ctrl.demande.montantTTC = Number(montant);
			}
		};

		// Permet de mettre à jour le montant TTC si les frais réels des
		// dépenses sont renseignés
		ctrl.updateMontantTTCDepense = function () {
			var difference = 0;
			var differenceMontantRestant = 0;
			ctrl.updateMontantTTC();
			// Mise à jour du montant restant
			_.forEach(ctrl.demande.paiements, function (paiement) {
				differenceMontantRestant += paiement.montant;
			});

			ctrl.demande.montantTTCRestant = Number(Number(ctrl.demande.montantTTC - differenceMontantRestant).toFixed(2));


			_.forEach(ctrl.demande.depenses, function (depense) {
				if (depense.selectionne && depense.montantReelTTC !== null && depense.montantReelTTC !== depense.montant) {
					if (depense.montantReelTTC !== null && depense.montantReelTTC !== depense.montant && ((depense.typeFrais !== 'HOTEL' && depense.typeFrais !== 'REPAS') || ((depense.typeFrais === 'HOTEL' || depense.typeFrais === 'REPAS') && depense.fraisReel) || depense.typeFrais !== 'VEHICULE_PERSONNEL')) {
						difference += depense.montantReelTTC - depense.montant;
					}

					if (((depense.typeFrais === 'HOTEL' || depense.typeFrais === 'REPAS') && !depense.fraisReel) || depense.typeFrais === 'VEHICULE_PERSONNEL') {
						difference += depense.montant - depense.montantReelTTC;
					}
				}
			});


			if (difference !== 0) {
				var nouveauMontant = ctrl.demande.montantTTC + difference;
				ctrl.demande.montantTTC = Number(Number(nouveauMontant).toFixed(2));

				var nouveauMontantRestant = ctrl.demande.montantTTCRestant + difference;
				ctrl.demande.montantTTCRestant = Number(Number(nouveauMontantRestant).toFixed(2));
			}
		};

		// Permet de définir si on a cliqué sur le bouton SOUMETTRE ou
		// ENREGISTRER lors de la première initialisation de la demande
		ctrl.changeActionSubmit = function (val) {
			$scope.form.pj.$setValidity('badFileRemove', true);
			ctrl.estSoumise = val;
		};

		//Permet de rendre le champ input numéroCheque obligatoire selon certains cas particulier
		//Par exemple, 
		ctrl.changeNumeroChequeRequired = function (value) {
			if (ctrl.afficherInputNumeroCheque) {
				ctrl.numeroChequeRequired = value;
			}
		};

		// Permet de faire une recherche du demandeur sur l'investigateur ou sur
		// le bénéficiaire
		ctrl.autocompleteDemandeur = function (search, id) {
			var beneficiaires = ctrl.autocompleteBeneficiaire(search, id);
			var investigateurs = ctrl.autocompleteInvestigateur(search, id);
			return $q.all([beneficiaires, investigateurs]).then(function (results) {
				return results[0].concat(results[1]);
			});
		};

		// Fonction d'upload de fichier 'à la chaîne' pour éviter d'enregistrer
		// la demande avant la fin de l'upload de toutes les pièces jointes
		ctrl.uploadFile = function () {
			if (ctrl.getFileUpload.queue.length !== 0) {
				ctrl.getFileUpload.uploadAll();
			}
		};

		ctrl.uploadFileDepense = function () {
			if (ctrl.getFileUploadDepense.queue.length !== 0) {
				ctrl.getFileUploadDepense.uploadAll();
			}
		};

		// Permet d'afficher le bouton soumettre pour le titulaire du compte
		ctrl.showButtonSoumettre = function () {

			if (ctrl.demande.compte !== undefined && ctrl.currentUser.investigateurId !== null && ctrl.demande.compte.titulaire.id === ctrl.currentUser.investigateurId) {
				ctrl.afficherSoumettre = true;

			}
			// au choix du compte, on définit si le user va être considéré comme
			// investigateur principale ou devenir beneficiaire
			if (ctrl.demande.compte !== undefined && ctrl.currentUser.investigateurId !== null && ctrl.demande.compte.titulaire.id !== ctrl.currentUser.investigateurId) {
				ctrl.role = 'BENEFICIAIRE';
				ctrl.afficherSoumettre = false;
			} else {
				ctrl.role = ctrl.currentUser.roles[0];
			}



		};

		ctrl.showButtonReceptionner = function () {
			if (ctrl.demande.beneficiaire !== null && ctrl.demande.beneficiaire !== undefined &&
				ctrl.demande.beneficiaire.id === ctrl.currentUser.beneficiaireId) {
				ctrl.afficherReceptionner = true;
			}


			if (ctrl.demande.investigateur !== null && ctrl.demande.investigateur !== undefined &&
				ctrl.demande.investigateur.id === ctrl.currentUser.investigateurId) {
				ctrl.afficherReceptionner = true;
			}
		};

		ctrl.showButtonTerminer = function () {
			if (ctrl.demande.statut === 'RECEPTIONNE') {

				if (ctrl.demande.beneficiaire !== null && ctrl.demande.beneficiaire !== undefined &&
					ctrl.demande.beneficiaire.id === ctrl.currentUser.beneficiaireId) {
					ctrl.afficherTerminer = true;

				}

				if (ctrl.demande.investigateur !== null && ctrl.demande.investigateur !== undefined &&
					ctrl.demande.investigateur.id === ctrl.currentUser.investigateurId) {
					ctrl.afficherTerminer = true;
				}

				if (ctrl.demande.soumissionJustificatifOver) {
					ctrl.afficherTerminer = false;
				}
			}
		};

		ctrl.showInputNumeroCheque = function () {
			if (ctrl.demande.beneficiaire !== null && ctrl.demande.beneficiaire !== undefined) {
				if (ctrl.demande.beneficiaire.iban === null || ctrl.demande.beneficiaire.iban === '' || ctrl.demande.beneficiaire.iban === undefined) {
					ctrl.afficherInputNumeroCheque = true;
				}
			}

			if (ctrl.demande.investigateur !== null && ctrl.demande.investigateur !== undefined) {
				if (ctrl.demande.investigateur.iban === null || ctrl.demande.investigateur.iban === '' || ctrl.demande.investigateur.iban === undefined) {
					ctrl.afficherInputNumeroCheque = true;
				}
			}
		};

		//Permet d'afficher l'option "Paiement Amplitude" au moment du paiement par l'admin 
		ctrl.showButtonPaiementAmplitude = function () {
			var paiementAmplitude = true;
			_.forEach(ctrl.demande.paiements, function (paiement) {
				if (paiement.typePaiement === 'PAIEMENT_AMPLITUDE') {
					paiementAmplitude = false;
					return;
				}
			});
			ctrl.afficherPaiementAmplitude = paiementAmplitude;
		};

		//Permet d'afficher l'option "Remboursement Bénéficiaire" et "Paiement partiel" au moment du paiement par l'admin 
		ctrl.showButtonRemboursementBeneficiaire = function () {
			var remboursementBeneficiaire = true;
			_.forEach(ctrl.demande.paiements, function (paiement) {
				if (paiement.typePaiement === 'REMBOURSEMENT_BENEFICIAIRE') {
					remboursementBeneficiaire = false;
					return;
				}
			});
			ctrl.afficherRemboursementBeneficiaire = remboursementBeneficiaire;
		};

		// TODO Fonction peut être plus utilisée
		ctrl.fonctionAfficherBoutonValider = function () {
			var investigateur = ctrl.demande.compte.titulaire;
			var afficher = false;
			if (investigateur !== null && investigateur.id === ctrl.currentUser.investigateurId) {
				afficher = true;
			}
			return afficher;
		};

		ctrl.soumissionParBeneficiaire = function (demande, statut) {
			ctrl.demande.statut = statut;
			// Permet de déterminer si le demandeur est un bénéficiaire ou un
			// investigateur
			if (ctrl.demande.demandeur.contacts !== undefined) {
				ctrl.demande.investigateur = ctrl.demande.demandeur;
				ctrl.demande.beneficiaire = null;
			} else {
				ctrl.demande.beneficiaire = ctrl.demande.demandeur;
				ctrl.demande.investigateur = null;
			}

			OperationWS.saveOrUpdateDemandeMission(ctrl.demande, ctrl.typePaiement).then(ctrl.onSaveReload, ctrl.onSaveFailure);

		};

		ctrl.motifRefus = function () {
			swal({
				title: 'Demande de mission refusée',
				text: 'Saisissez le motif du refus',
				type: 'input',
				showCancelButton: true,
				closeOnConfirm: false,
				cancelButtonText: 'Annuler',
				confirmButtonText: 'Valider',
				confirmButtonColor: '#DD6B55',
				inputPlaceholder: 'Motif du refus'
			},
				function (inputValue) {
					if (inputValue === false) {
						return false;
					}
					if (inputValue === '') {
						swal.showInputError('Motif obligatoire');
						return false;
					}

					ctrl.demande.motif = inputValue;
					ctrl.changeStatus('REFUSE');
					swal.close();
				});
		};

		// Permet de changer la valeur du du type de paiement partiel
		// (Enumération 'TypePaiementPartiel')
		ctrl.changeTypePaiement = function (val) {
			ctrl.typePaiement = val;
		};

		// Permet de stocker des valeurs en local
		ctrl.loadDemandeMissionLocal = function () {
			if (localStorage.getItem('demandeMission') !== null) {
				ctrl.demande = JSON.parse(localStorage.getItem('demandeMission'));
			}
		};

		ctrl.controleUser = function () {
			if (SecurityService.anyRole('BENEFICIAIRE')) {
				ctrl.role = 'BENEFICIAIRE';
			}
		};

		// Permet de mettre à jour le montant tva sur chaque poste de dépense
		ctrl.calculMontantTVA = function (depense) {
			switch (depense.tauxTVA) {
				case '0':
					depense.montantReelHT = depense.montantReelTTC;
					depense.montantTVA = 0;
					break;
				case '2':
					calculMontantTVAWithTaux(depense, 1.021);
					break;
				case '5':
					calculMontantTVAWithTaux(depense, 1.055);
					break;
				case '10':
					calculMontantTVAWithTaux(depense, 1.1);
					break;
				case '20':
					calculMontantTVAWithTaux(depense, 1.2);
					break;
				default:
					depense.montantReelHT = depense.montantReelTTC;
					depense.montantTVA = 0;
					break;
			}
		};

		// Permet de calculer le montant de la TVA et HT avec le taux et le
		// poste de dépense
		var calculMontantTVAWithTaux = function (depense, taux) {
			var montantReelHT = depense.montantReelTTC / taux;
			var montantTVA = depense.montantReelTTC - montantReelHT;
			depense.montantReelHT = Number(Number(montantReelHT).toFixed(2));
			depense.montantTVA = Number(Number(montantTVA).toFixed(2));
		};

		// Permet de calculer le montant réel HT quand le taux de tva est à
		// autre
		ctrl.calculMontantReelHT = function (depense) {
			if (depense.tauxTVA === 'Autre') {
				depense.montantReelHT = Number(depense.montantReelTTC - depense.montantTVA);
			}
		};

		// Permet de mettre à jour le montant prévue d'une poste de dépense
		// Hotel et Repas lorsque la quantité change
		ctrl.updateMontantRepasHotel = function (depense) {
			depense.montant = Number(depense.montantUnite * depense.quantite);
			ctrl.updateMontantTTCDepense();
		};

		ctrl.updateMontantVehiculePersonnel = function (depense) {
			depense.montant = ctrl.montantVehiculePersonne(depense.quantite, depense.puissanceVehicule);
			depense.montant = Number(Number(depense.montant).toFixed(2));
			ctrl.updateMontantTTCDepense();
		};

		//Permet de calculer le montant du véhicule personnel selon la puissance et la distance
		// Permet de rajouter un poste de dépense si l'utilisateur ajoute un
		// véhicule personnel pour faire le trajet
		ctrl.montantVehiculePersonne = function (distance, puissance) {
			var montant;
			switch (puissance) {
				case '3':
					montant = ctrl.vehicule3CV(distance);
					break;
				case '4':
					montant = ctrl.vehicule4CV(distance);
					break;
				case '5':
					montant = ctrl.vehicule5CV(distance);
					break;
				case '6':
					montant = ctrl.vehicule6CV(distance);
					break;
				case '7':
					montant = ctrl.vehicule7CV(distance);
					break;
				default:
					break;
			}
			return montant;
		};

		ctrl.vehicule3CV = function (distance) {
			var montant;
			if (distance > 0 && distance <= 5000) {
				montant = distance * 0.410;
			} else if (distance > 5000 && distance <= 20000) {
				montant = (distance * 0.245) + 824;
			} else {
				montant = distance * 0.286;
			}
			return montant;
		};

		ctrl.vehicule4CV = function (distance) {
			var montant;
			if (distance > 0 && distance <= 5000) {
				montant = distance * 0.493;
			} else if (distance > 5000 && distance <= 20000) {
				montant = (distance * 0.277) + 1082;
			} else {
				montant = distance * 0.332;
			}
			return montant;
		};

		ctrl.vehicule5CV = function (distance) {
			var montant;
			if (distance > 0 && distance <= 5000) {
				montant = distance * 0.543;
			} else if (distance > 5000 && distance <= 20000) {
				montant = (distance * 0.305) + 1188;
			} else {
				montant = distance * 0.364;
			}
			return montant;
		};

		ctrl.vehicule6CV = function (distance) {
			var montant;
			if (distance > 0 && distance <= 5000) {
				montant = distance * 0.568;
			} else if (distance > 5000 && distance <= 20000) {
				montant = (distance * 0.320) + 1244;
			} else {
				montant = distance * 0.382;
			}
			return montant;
		};

		ctrl.vehicule7CV = function (distance) {
			var montant;
			if (distance > 0 && distance <= 5000) {
				montant = distance * 0.595;
			} else if (distance > 5000 && distance <= 20000) {
				montant = (distance * 0.337) + 1288;
			} else {
				montant = distance * 0.401;
			}
			return montant;
		};

		// Permet de détecter une changement de la route pour permettre la
		// sauvegarde de la demande
		$scope.$on('$stateChangeStart', function () {
			if (!ctrl.isSaveOne) {
				localStorage.setItem('demandeMission', JSON.stringify(ctrl.demande));
			}
		});

		ctrl.init();
	}
})();
(function () {
	'use strict';

	angular.module('app.operation').controller('DemandeAchatItemController',
		Controller);

	/** @ngInject */
	function Controller($stateParams, $state, OperationWS, _, $scope, $log, toastr, FileUploader, FournisseurWS, CompteWS, CategoryWS, InvestigateurWS, BeneficiaireWS, $q, SweetAlert, SecurityService) {
		var ctrl = this;

		ctrl.dateFormat = 'dd/MM/yyyy';

		ctrl.isUpdate = $stateParams.id !== 'new';

		ctrl.idModified = $stateParams.id;

		ctrl.demande = {};
		ctrl.currentUser = {};
		ctrl.dateFichier = {};
		ctrl.activeUploadFacture = false;
		ctrl.autocompleteCompte = CompteWS.autocomplete;

		ctrl.autocompleteInvestigateur = InvestigateurWS.autocomplete;

		ctrl.autocompleteBeneficiaire = BeneficiaireWS.autocomplete;

		ctrl.autocompleteFournisseur = FournisseurWS.autocomplete;

		//Permet de mettre les champs en mode disable pour la simple consultation de la page des demandes d'achat
		ctrl.disable = !$stateParams.edit;

		ctrl.init = function () {
			ctrl.currentUser = SecurityService.getUserDetails();
			if (ctrl.currentUser && ctrl.currentUser.roles) {
				ctrl.role = ctrl.currentUser.roles[0];
			}
			ctrl.loadCompteCharge();
			ctrl.afficherSoumettre = false;
			ctrl.afficherReceptionner = false;
			ctrl.afficherInputNumeroCheque = false;
			ctrl.afficherEmettre = false;
			ctrl.afficherRefuser = false;
			ctrl.validerParEtablissement = false;

			//Variable qui permet de définir l'envoi à la fois des bons de livraison et factures ( pour le statut RECEPTIONNE)
			ctrl.fichierBonLivraisonEtFacture = false;

			// Permet de savoir quand le paiement pour amplitude est fait (
			// permet de faire des paiements partiels )
			ctrl.typePaiement = null;
			if (ctrl.isUpdate) {
				//on crée les droits pour les achats importés à partir d'EasyDore
				var grant = OperationWS.updateDemandeAchatImport(ctrl.idModified);
				grant.then(function () {

					OperationWS.getOneDemandeAchat(ctrl.idModified).then(function (response) {

						// Permet de savoir si la demande a été sauvegardé une
						// fois
						ctrl.isSaveOne = true;
						ctrl.demande = response.data;
						ctrl.statutActuel = ctrl.demande.statut;

						// Détermine le type du demandeur
						if (ctrl.demande.investigateur !== null) {
							ctrl.demande.demandeur = ctrl.demande.investigateur;
						} else {
							ctrl.demande.demandeur = ctrl.demande.beneficiaire;
						}

						if (ctrl.demande.statut === 'SOUMISE') {
							ctrl.afficherBoutonValider = ctrl.fonctionAfficherBoutonValider();
						}

						if (ctrl.demande.statut === 'RECEPTIONNE') {
							ctrl.demande.montantPaiementPartiel = 0;
						}

						ctrl.showButtonSoumettre();
						ctrl.showButtonReceptionner();
						ctrl.showInputNumeroCheque();
						ctrl.showButtonStatutValide();
					});
				});
			} else {
				// initialisation du statut de la demande de remboursement sur
				// brouillon
				ctrl.isSaveOne = false;
				ctrl.loadDemandeAchatLocal();
				ctrl.demande.statut = 'BROUILLON';
				ctrl.statutActuel = ctrl.demande.statut;
			}
		};

		// Permet de supprimer le compte si on change le demandeur
		ctrl.onChangeDemandeur = function ($item) {
			var demandeur = $item;
			var compte = ctrl.demande.compte;
			var deleteCompte = true;

			if (compte !== null && compte !== undefined) {
				_.forEach(compte.investigateurs, function (investigateur) {
					if (investigateur.investigateur !== null && investigateur.investigateur.id === demandeur.id) {
						deleteCompte = false;
						return;
					}
				});

				if (deleteCompte) {
					_.forEach(compte.beneficiaires, function (beneficiaire) {
						if (beneficiaire.beneficiaire !== null && beneficiaire.beneficiaire.id === demandeur.id) {
							deleteCompte = false;
							return;
						}
					});
				}

				if (deleteCompte && compte.titulaire.id === demandeur.id) {
					deleteCompte = false;
				}

				if (deleteCompte) {
					ctrl.demande.compte = null;
				}
			}
		};

		// Permet de détecter le changement du compte dans la liste déroulante
		ctrl.onChangeCompte = function () {
			$scope.form.montantTTC.$setValidity('server.solde_insuffisant', true);
		};

		ctrl.saveOrUpdate = function (demande) {
			ctrl.saveOrUpdateWithoutUploadFile(demande);
		};

		// Permet l'enregistrement de la demande sans l'upload de fichier
		ctrl.saveOrUpdateWithoutUploadFile = function (demande) {
			if (ctrl.estSoumise) {
				demande.statut = 'SOUMISE';
			}


			// Permet de déterminer si le demandeur est un bénéficiaire ou un
			// investigateur
			if (ctrl.demande.demandeur.contacts !== undefined) {
				ctrl.demande.investigateur = ctrl.demande.demandeur;
				ctrl.demande.beneficiaire = null;
			} else {
				ctrl.demande.beneficiaire = ctrl.demande.demandeur;
				ctrl.demande.investigateur = null;
			}

			OperationWS.saveOrUpdateDemandeAchat(demande, ctrl.typePaiement, ctrl.validerParEtablissement).then(ctrl.onSaveReload, ctrl.onSaveFailure);
		};

		// Permet de recharger la page après avoir enregistré, émis ou payer une
		// opération
		ctrl.onSaveReload = function (response) {
			if (response.status === 201 || response.status === 200) {
				ctrl.idDemandeSave = response.data.id;

				//Permet d'enregistrer les fichiers bon de livraison et facture en même temps sans faire deux sauvegardes
				if (ctrl.getFileUpload.queue.length !== 0 && ctrl.getFileUploadFacture.queue.length !== 0) {
					ctrl.fichierBonLivraisonEtFacture = true;
				}
				if (ctrl.getFileUpload.queue.length !== 0 || ctrl.getFileUploadFacture.queue.length !== 0) {
					ctrl.uploadFile();

					if (!ctrl.fichierBonLivraisonEtFacture) {
						ctrl.uploadFileFacture();
					}
				} else {
					ctrl.afterSave(ctrl.idDemandeSave);
				}
			}
		};

		// Fonction permettant de traiter les erreurs et de les afficher en cas
		// de non enregistrement de l'opération
		ctrl.onSaveFailure = function (response) {
			if (response.status === 400) {
				ctrl.serverErrors = response.data.errors;
			} else if (response.status === 500) {
				toastr.error(response.data.message);
			} else {
				toastr.error('Echec d\'enregistrement');
			}
		};

		ctrl.loadCompteCharge = function () {
			CategoryWS.getCompteCharge().then(function (response) {
				ctrl.compteCharge = response.data.content;
			});
		};

		// Permet d'ajouter des fichiers après l'enregistrement de la demande de
		// remboursement
		ctrl.addFileToSave = function (idDemande) {
			OperationWS.uploadFilesAchat(idDemande).then(function () {
				ctrl.getFileUpload.clearQueue();
				ctrl.getFileUploadFacture.clearQueue();
				ctrl.afterSave(idDemande);
			});
		};

		// Permet d'effectuer des actions après la sauvegarde et l'upload de
		// fichier
		ctrl.afterSave = function (idDemande) {
			if (localStorage.getItem('demandeAchat') !== null) {
				ctrl.isSaveOne = true;
				localStorage.removeItem('demandeAchat');
			}
			toastr.success('Action effectuée avec succès');
			$state.go('operation.item_demande_achat', {
				id: idDemande
			});
			ctrl.init();
		};

		// Permet de stocker le fichier passé en pièce jointe sur le serveur
		ctrl.getFileUpload = new FileUploader({
			url: '/api/demande/achat_fichier/upload',
			onSuccessItem: function () {
				// Si la pièce jointe a été uploader avec succès, on la supprime
				// de la liste d'attente et on vérifie s'il n'y a pas d'autres
				// pièces jointes ensuite
				$scope.form.pj.$setValidity('badFileRemove', true);
			},
			onErrorItem: function (item) {
				$scope.form.pj.$setValidity('badFileRemove', false);
				ctrl.getFileUpload.removeFromQueue(item);
			},
			onCompleteAll: function () {
				//Cas où l'on doit enregistrer à la fois les bons de livraison et les factures.
				if (ctrl.fichierBonLivraisonEtFacture) {
					ctrl.uploadFileFacture();
				} else {
					ctrl.addFileToSave(ctrl.idDemandeSave);
				}
			}
		});

		// Permet de stocker le fichier passé en pièce jointe sur le serveur
		ctrl.getFileUploadFacture =
			new FileUploader({
				url: '/api/demande/achat_fichier/uploadfacture',
				onAfterAddingFile: function (item) {
					item.formData.push({ dateFichier: moment(ctrl.demande.dateReceptionFacture).format() });
				},
				onSuccessItem: function () {
					// Si la pièce jointe a été uploader avec succès, on la supprime
					// de la liste d'attente et on vérifie s'il n'y a pas d'autres
					// pièces jointes ensuite
					$scope.form.pj.$setValidity('badFileRemove', true);

				},
				onErrorItem: function (item) {
					$scope.form.pj.$setValidity('badFileRemove', false);
					ctrl.getFileUploadFacture.removeFromQueue(item);
				},
				onCompleteAll: function () {
					ctrl.addFileToSave(ctrl.idDemandeSave);
				}
			});

		// Permet de retirer un fichier de la liste d'attente pour l'upload des
		// pièces jointes
		ctrl.removeFile = function (index) {
			ctrl.getFileUpload.removeFromQueue(index);
		};
		// Permet de retirer un fichier de la liste d'attente pour l'upload des
		// pièces jointes
		ctrl.removeFileFacture = function (index) {
			ctrl.getFileUploadFacture.removeFromQueue(index);
		};

		$scope.desactiveUpload = function () {
			ctrl.activeUploadFacture = false;
		};

		// Permet de supprimer une demande de remboursement
		ctrl.delete = function (demande) {
			OperationWS.deleteDemandeAchat(demande).then(ctrl.backToList, ctrl.onDeleteFailure);
		};

		// Fonction permettant de traiter les erreurs et de les afficher en cas
		// de non suppresision de la demande de remboursement
		ctrl.onDeleteFailure = function (response) {
			if (response.status === 400) {
				ctrl.serverErrors = response.data.errors;
			} else {
				toastr.error('Echec de la suppression');
			}
			return $q.reject();
		};

		// Permet de revenir sur la liste des opérations
		ctrl.backToList = function () {
			$state.go('operation.list');
		};

		// Permet l'affichage d'une popup pour demander la confirmation de la
		// suppression de la demande
		ctrl.confirmDelete = function (demande) {
			SweetAlert.swal({
				title: 'Suppression de la demande',
				text: 'Êtes-vous sûr de vouloir supprimer cette demande ?',
				type: 'warning',
				showCancelButton: true,
				cancelButtonText: 'Annuler',
				confirmButtonColor: '#DD6B55',
				confirmButtonText: 'Oui'
			},
				function (isConfirm) {
					if (isConfirm) {
						ctrl.delete(demande);
					}
				});
		};

		// Gestion des détails
		ctrl.addDetail = function () {
			ctrl.demande.bonCommandes = ctrl.demande.bonCommandes || [];
			ctrl.demande.bonCommandes.push({});
		};

		ctrl.removeDetail = function (index) {
			ctrl.demande.bonCommandes.splice(index, 1);
			ctrl.updateMontantTTC();
		};

		// Permet de changer le statut d'une demande d'achat
		ctrl.changeStatus = function (statut) {
			if ($scope.form.$valid) {
				ctrl.demande.statut = statut;
				ctrl.saveOrUpdate(ctrl.demande);
			}
		};

		// Permet de changer le statut d'une demande de mission sans de save
		ctrl.changeStatusWithoutSave = function (statut) {
			ctrl.demande.statut = statut;
			if (statut === 'PAYE') {
				ctrl.remboursementBeneficiaire = true;
			}
		};

		// Permet de calculer le montant ttc selon les items renseignés dans la
		// partie détail de la demande
		ctrl.updateMontantTTC = function () {
			var montant = 0;
			_.forEach(ctrl.demande.bonCommandes, function (bon) {
				montant = montant + bon.total;
			});

			if (montant === 0) {
				ctrl.demande.montantTTC = null;
			} else {
				ctrl.demande.montantTTC = Number(montant);
			}

			// on modifie la validité du montantTTC pour pouvoir resoumettre le
			// formulaire en cas d'échec serveur
			// échec serveur qui sera re-contrôler de toute manière à la
			// soumission du formulaire
			$scope.form.montantTTC.$setValidity('server.solde_insuffisant', true);

		};

		// Permet de définir si on a cliqué sur le bouton SOUMETTRE ou
		// ENREGISTRER lors de la première initialisation de la demande
		ctrl.changeActionSubmit = function (val) {
			$scope.form.pj.$setValidity('badFileRemove', true);
			ctrl.estSoumise = val;
		};

		// Permet de faire une recherche du demandeur sur l'investigateur ou sur
		// le bénéficiaire
		ctrl.autocompleteDemandeur = function (search, id) {
			var beneficiaires = ctrl.autocompleteBeneficiaire(search, id);
			var investigateurs = ctrl.autocompleteInvestigateur(search, id);
			return $q.all([beneficiaires, investigateurs]).then(function (results) {
				return results[0].concat(results[1]);
			});
		};

		// Permet d'uploader toutes les pièces jointes en même temps
		ctrl.uploadFile = function () {
			if (ctrl.getFileUpload.queue.length !== 0) {
				ctrl.getFileUpload.uploadAll();
			}
		};

		// Permet d'uploader toutes les factures en même temps
		ctrl.uploadFileFacture = function () {
			if (ctrl.getFileUploadFacture.queue.length !== 0) {
				ctrl.getFileUploadFacture.uploadAll();
			}
		};

		ctrl.fonctionAfficherBoutonValider = function () {
			var investigateur = ctrl.demande.compte.titulaire;
			var afficher = false;
			if (investigateur !== null && investigateur.id === ctrl.currentUser.investigateurId) {
				afficher = true;
			}
			return afficher;
		};

		ctrl.soumissionParBeneficiaire = function (demande, statut) {
			ctrl.demande.statut = statut;
			// Permet de déterminer si le demandeur est un bénéficiaire ou un
			// investigateur
			if (ctrl.demande.demandeur.contacts !== undefined) {
				ctrl.demande.investigateur = ctrl.demande.demandeur;
				ctrl.demande.beneficiaire = null;
			} else {
				ctrl.demande.beneficiaire = ctrl.demande.demandeur;
				ctrl.demande.investigateur = null;
			}

			OperationWS.saveOrUpdateDemandeAchat(ctrl.demande).then(ctrl.onSaveReload, ctrl.onSaveFailure);
		};

		ctrl.motifRefus = function () {
			swal({
				title: 'Demande d\'achat refusée',
				text: 'Saisissez le motif du refus',
				type: 'input',
				showCancelButton: true,
				closeOnConfirm: false,
				cancelButtonText: 'Annuler',
				confirmButtonText: 'Valider',
				confirmButtonColor: '#DD6B55',
				inputPlaceholder: 'Motif du refus'
			},
				function (inputValue) {
					if (inputValue === false) {
						return false;
					}
					if (inputValue === '') {
						swal.showInputError('Motif obligatoire');
						return false;
					}

					ctrl.demande.motif = inputValue;
					ctrl.changeStatus('REFUSE');
					swal.close();
				});
		};

		// Permet de stocker des valeurs en local
		ctrl.loadDemandeAchatLocal = function () {
			if (localStorage.getItem('demandeAchat') !== null) {
				ctrl.demande = JSON.parse(localStorage.getItem('demandeAchat'));
			}
		};

		// Permet d'afficher le bouton soumettre pour le titulaire du compte
		ctrl.showButtonSoumettre = function () {

			if (ctrl.demande.compte !== undefined && ctrl.currentUser.investigateurId !== null && ctrl.demande.compte.titulaire.id === ctrl.currentUser.investigateurId) {
				ctrl.afficherSoumettre = true;

			}
			// au choix du compte, on définit si le user va être considéré comme
			// investigateur principale ou devenir beneficiaire

			if (ctrl.demande.compte !== undefined && ctrl.currentUser.investigateurId !== null && ctrl.demande.compte.titulaire.id !== ctrl.currentUser.investigateurId) {
				ctrl.role = 'BENEFICIAIRE';
				ctrl.afficherSoumettre = false;
			} else {
				ctrl.role = SecurityService.getRoles()[0];
			}
		};

		// Permet d'afficher un champ pour la saisie du numéro de chèque si le
		// demandeur n'a pas renseigné son IBAN
		ctrl.showInputNumeroCheque = function () {
			if (ctrl.demande.beneficiaire !== null && ctrl.demande.beneficiaire !== undefined) {
				if (ctrl.demande.beneficiaire.iban === null || ctrl.demande.beneficiaire.iban === '' || ctrl.demande.beneficiaire.iban === undefined) {
					ctrl.afficherInputNumeroCheque = true;
				}
			}


			if (ctrl.demande.investigateur !== null && ctrl.demande.investigateur !== undefined) {
				if (ctrl.demande.investigateur.iban === null || ctrl.demande.investigateur.iban === '' || ctrl.demande.investigateur.iban === undefined) {
					ctrl.afficherInputNumeroCheque = true;
				}
			}

		};

		// Permet d'afficher le bouton "RECEPTIONNER"
		ctrl.showButtonReceptionner = function () {
			var userRole = SecurityService.getRoles()[0];
			if (userRole === 'ADMIN') {
				ctrl.afficherReceptionner = true;
			}

			if (ctrl.demande.beneficiaire !== null && ctrl.demande.beneficiaire !== undefined &&
				ctrl.demande.beneficiaire.id === ctrl.currentUser.beneficiaireId) {
				ctrl.afficherReceptionner = true;
			}


			if (ctrl.demande.investigateur !== null && ctrl.demande.investigateur !== undefined &&
				ctrl.demande.investigateur.id === ctrl.currentUser.investigateurId) {
				ctrl.afficherReceptionner = true;
			}

		};

		ctrl.showButtonStatutValide = function () {
			if (ctrl.statutActuel === 'SOUMISE') {
				if (ctrl.demande.validerParEtablissement && ctrl.demande.materielCHU || !ctrl.demande.materielCHU) {
					ctrl.afficherEmettre = true;
					ctrl.afficherRefuser = true;
				}
			}
		};

		ctrl.changeValiderParEtablissement = function (val) {
			ctrl.validerParEtablissement = val;
		};

		// Permet de détecter une changement de la route pour permettre la
		// sauvegarde de la demande
		$scope.$on('$stateChangeStart', function () {
			if (!ctrl.isSaveOne) {
				localStorage.setItem('demandeAchat', JSON.stringify(ctrl.demande));
			}
		});

		// Permet de changer la valeur du du type de paiement partiel
		// (Enumération 'TypePaiementPartiel')
		ctrl.changeTypePaiement = function (val) {
			ctrl.typePaiement = val;
		};

		ctrl.init();


	}
})();
(function () {
	'use strict';

	angular.module('app.compte', ['app']).config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {

		// State abstrait : Parent
		$stateProvider
			.state('compte', {
				abstract: true,
				parent: 'layout',
				url: '/compte',
				templateUrl: 'app/compte/compte.html'
			});

		// State concret
		$stateProvider
			.state('compte.list', {
				url: '/list',
				parent: 'compte',
				templateUrl: 'app/compte/list/CompteList.html',
				controller: 'CompteListController',
				controllerAs: 'ctrl'
			});

		//Route pour le détail d'un compte
		$stateProvider.state('compte.item', {
			url: '/:id?edit',
			parent: 'compte',
			templateUrl: 'app/compte/item/CompteItem.html',
			controller: 'CompteItemController',
			controllerAs: 'ctrl'
		});
	}

})();

(function() {
    'use strict';

    angular.module('app.compte').controller('VirementListController', Controller);

    /** @ngInject */
    function Controller($state, VirementWS, SecurityService) {
        var ctrl = this;
        ctrl.sort='ref';
        ctrl.pageSize = 15;
		ctrl.pagingOptions = {};
		ctrl.read = false;

        ctrl.init = function () {
            ctrl.searchText='';
            ctrl.list=[];
            ctrl.getList();

            if (SecurityService.anyRole('ETABLISSEMENT')) {
				ctrl.read = true;
			}
        };

        ctrl.getList=function(){
            var searchText = ctrl.searchText;
            if (searchText.length <= 2) {
                searchText='';
            }
            VirementWS.getList(searchText, ctrl.pagingOptions).then(function(response) {
                ctrl.list=response.data.content;
                ctrl.page=response.data;
            });
        };

        //Fonction permettant d'accéder au formulaire d'un virement
        ctrl.goTo = function(id){
			if (SecurityService.anyRole('ADMIN', 'INTERLOCUTEUR', 'FINANCIER')) {
				// reload to test active class on menu
				$state.go('compte.virement_item', {
					id: id,
					edit: true
				}, { reload: true });
			} else {
				$state.go('compte.virement_item', {
					id: id
				}, { reload: true });
			}
        };

        //Fonction permettant d'ajouter un nouveau virement
        ctrl.add = function(){
			$state.go('compte.virement_item', {
				id: 'new',
				edit: true
			}, { reload: true });
        };
        
        // Mise à jour des options de pagination (tri / paginataion)
		ctrl.onPagingOptionsChange = function (pagingOptions) {
			ctrl.pagingOptions = pagingOptions;
			ctrl.getList();
		};
        
     // Augmente le nombre de résultats affichés
		ctrl.viewMore = function () {
			ctrl.pageSize += 15;
		};


        //Permet d'effectuer la recherche
        ctrl.onChangeSearchText = function(val){
            ctrl.searchText = val;
            ctrl.getList();
        };

        ctrl.init();
    }
})();

(function () {
	'use strict';

	angular.module('app.compte').controller('VirementItemController', Controller);

	/** @ngInject */
	function Controller($stateParams, $state, $q, toastr, VirementWS, $log, CompteWS) {
		var ctrl = this;

		ctrl.dateFormat = 'dd/MM/yyyy';

		ctrl.isUpdate = $stateParams.id !== 'new';

		ctrl.idModified = $stateParams.id;

		ctrl.virement = {};

		ctrl.autocompleteCompte = CompteWS.autocomplete;
		ctrl.disabled = !$stateParams.edit;

		//Fonction d'initialisation de la page
		ctrl.init = function () {
			if (ctrl.isUpdate) {
				//on crée les droits pour les virements importés à partir d'EasyDore
				var grant = VirementWS.updateVirementImport(ctrl.idModified);

				grant.then(function () {

					VirementWS.getOne(ctrl.idModified).then(function (response) {
						ctrl.virement = response.data;
					});
				});
			}
		};

		//Permet de revenir sur la liste des facturations
		ctrl.backToList = function () {
			$state.go('compte.virement');
		};

		//Fonction permettant de traiter les erreurs et de les afficher en cas de non enregistrement de la facturation
		ctrl.onSaveFailure = function (response) {
			if (response.status === 400) {
				ctrl.serverErrors = response.data.errors;
			} else {
				toastr.error('Echec d\'enregistrement');
			}
			return $q.reject();
		};

		// Fonction permettant de traiter les erreurs et de les afficher en cas de non suppresision de la facturation
		ctrl.onDeleteFailure = function (response) {
			$log.debug(response);
			if (response.status === 400) {
				ctrl.serverErrors = response.data.errors;
				$log.debug(ctrl.serverErrors);
			} else {
				toastr.error('Echec de la suppression');
			}
			return $q.reject();
		};

		//Permet de sauvegarder une facturation
		ctrl.saveOrUpdate = function (virement) {
			VirementWS.saveOrUpdate(virement).then(ctrl.backToList, ctrl.onSaveFailure);
		};

		//Permet de supprimer une facturation
		ctrl.delete = function (virement) {
			VirementWS.delete(virement).then(ctrl.backToList, ctrl.onDeleteFailure);
		};


		ctrl.init();
	}
})();

/**
 * Created by PierreGOURET on 18/05/2016.
 */
(function () {
	'use strict';

	angular
		.module('app.security')
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		$stateProvider.state('security.utilisateurs', {
			url: '/utilisateur',
			parent: 'security',
			templateUrl: 'app/security/utilisateur/list/UtilisateurList.html',
			controller: 'UtilisateurListController',
			controllerAs: 'ctrl'
		});

		$stateProvider.state('security.utilisateur', {
			url: '/utilisateur/:id',
			parent: 'security',
			templateUrl: 'app/security/utilisateur/item/UtilisateurItem.html',
			controller: 'UtilisateurItemController',
			controllerAs: 'ctrl',
			params: {
				investigateur: undefined,
				beneficiaire:undefined
			}
		});

	}
})();

(function () {
	'use strict';

	angular
		.module('app.security')
		.controller('NouveauMotDePasseController', Controller);

	/** @ngInject */
	function Controller(UtilisateurWS, SecurityService, $stateParams, $q, toastr, $state, $log, $scope, SweetAlert) {
		var ctrl = this;

		ctrl.save = function (utilisateur) {
			return UtilisateurWS.resetPassword(utilisateur).then(ctrl.connectUser, ctrl.onSaveFailure);
		};

		ctrl.connectUser = function () {
			SecurityService.initUserSession(true);
		};

		ctrl.onSaveFailure = function (response) {
			if (response.status === 400) {
				$scope.serverErrors = response.data.errors;
			} else {
				toastr.error('Echec d\'enregistrement : ' + response.data.message);
			}
			return $q.reject();
		};

		ctrl.onLienInvalide = function () {
			SweetAlert.swal({
				title: 'Lien incorrect :(',
				text: 'Le lien utilisé est incorrect ou expiré. Faites une nouvelle demande de réinitialisation de mot de passe',
				type: 'error',
				confirmButtonColor: '#337ab7'
			}, function () {
				$state.go('mot-de-passe-oublie');
			});
			return $q.reject();
		};

		ctrl.init = function () {
			ctrl.utilisateur = {};
			ctrl.utilisateur.username = $stateParams.username;
			ctrl.utilisateur.token = $stateParams.token;

			UtilisateurWS.validateLienResetPassword(ctrl.utilisateur).catch(ctrl.onLienInvalide);
		};

		ctrl.init();
	}
})();

(function () {
	'use strict';

	angular
		.module('app.security')
		.controller('MotDePasseOublieController', Controller);

	/** @ngInject */
	function Controller(UtilisateurWS, $http, $location, $log, $state, $q, SweetAlert) {
		var ctrl = this;

		ctrl.badUsernameOrEmail = false;

		// handle authentication failure by resetting username and roles
		var sendPasswordResetMailFailure = function (response) {
			if (response.status === 400) {
				// Si l'erreur est de type 400, l'identifiant ou email est inconnu
				ctrl.badUsernameOrEmail = true;
			}
			return $q.reject();
		};

		var sendPasswordResetMailSuccess = function () {
			ctrl.badUsernameOrEmail = false;

			SweetAlert.swal({
				title: 'Email envoyé !',
				text: 'Pour réinitialiser votre mot de passe cliquez sur le lien qui vous a été envoyé par mail',
				confirmButtonColor: '#337ab7',
				type: 'success'
			}, function () {
				$state.go('connexion');
			});

		};

		ctrl.renewPassword = function () {
			UtilisateurWS.sendPasswordResetMail(ctrl.usernameOrEmail).then(sendPasswordResetMailSuccess, sendPasswordResetMailFailure);
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('app.security')
		.controller('ConnexionController', Controller);

	/** @ngInject */
	function Controller(UtilisateurWS, SecurityService, $log, $q, ConfigurationBannerService) {
		var ctrl = this;
		var message;
		ctrl.credentials = {};

		// Once authenticated, we must load user details to get username and roles
		var authenticateSuccess = function () {

			ctrl.badCredentialsError = false;
			$log.debug('Successfully authenticated => loading user details');
			SecurityService.initUserSession(true);

			//Load information banner
				ConfigurationBannerService.getListBanner().then(
					function (response) {
						ctrl.list = response.data;

						ConfigurationBannerService.getOne(ctrl.list[ctrl.list.length - 1].id).then(function (admin) {
							message = admin.data;

							if (message.activationPopUp === true && message.messageForAllUser !== null && message.messageForAllUser !== '') {

								ctrl.showPopUpInform(message.messageForAllUser);
							}
						});
				});

			};

			// handle authentication failure by resetting username and roles
			var authenticateFailure = function (response) {
				if (response.status === 401) {
					// Si l'erreur n'est pas de type 401, ce n'est pas un problème de login / mot de passe => on n'affiche pas le message
					ctrl.badCredentialsError = true;
				}
				return $q.reject();
			};

			ctrl.login = function () {
				UtilisateurWS.authenticate(ctrl.credentials).then(authenticateSuccess, authenticateFailure);
			};

			ctrl.showPopUpInform = function (message) {

				swal({
					title: 'Information utilisateurs !',
					text: message,
					type: 'warning',
					confirmButtonColor: '#337ab7'
				});

			};

		}
	})();

(function () {
	'use strict';

	angular
		.module('app.security')
		.service('ConfigurationBannerService', Service);

	/** @ngInject */
	function Service($http) {
        
		var service = this;

		service.saveOrUpdate = function(admin) {
			if(admin.id){
				return $http.put('/api/configurationBanner', admin);
			} else {
				return $http.post('/api/configurationBanner', admin);
			}
		};

		service.getListBanner = function() {
			return $http.get('/api/configurationBanner');
		};

		service.getOne = function(id) {
			return $http.get('/api/configurationBanner/'+ id);
		};

    }
})();
(function () {
	'use strict';

	angular
		.module('app.security')
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		$stateProvider.state('security.configurationBanner', {
			url: '/configurationBanner',
			parent: 'security',
			templateUrl: 'app/security/configuration-banner/list/ConfigurationBannerList.html',
			controller: 'ConfigurationBannerListController',
			controllerAs: 'ctrl'
		});

		$stateProvider.state('security.configurationBanner_item', {
			url: '/configurationBanner/:id',
			parent: 'security',
			templateUrl: 'app/security/configuration-banner/item/ConfigurationBannerItem.html',
			controller: 'ConfigurationBannerItemController',
			controllerAs: 'ctrl'
		});

	}
})();
(function () {
	'use strict';

	angular.module('app.projet').service('ProjetListService', Service);

	/** @ngInject */
	//TODO Service utile ?
	function Service(ProjetWS) {
		var service = this;

		service.getList = function (actif,importEasy, searchText, paging) {
			if (searchText === undefined || searchText.length <= 2) {
				searchText = '';
			}
			return ProjetWS.getList(actif, importEasy, searchText, paging).then(function (response) {
				return response.data;
			});
		};
	}

})();
	
(function () {
	'use strict';

	angular.module('app.projet').controller('ProjetListController', Controller);

	/** @ngInject */
	function Controller($state, ProjetListService, $log, SecurityService) {
		var ctrl = this;

		ctrl.searchText = '';
		ctrl.pageSize = 15;
		ctrl.pagingOptions = {};
		ctrl.filterActif = true;
		ctrl.importEasy = true;

		//Fonction permettant d'accéder au formulaire d'un projet
		ctrl.goTo = function (id) {
			if (SecurityService.anyRole('ADMIN,INTERLOCUTEUR,FINANCIER')) {
				$state.go('projet.item', { id: id, edit: true }, { reload: true });
			} else {
				$state.go('projet.item', { id: id }, { reload: true });
			}
		};

		//Fonction permettant d'ajouter un nouveau projet
		ctrl.add = function () {
			$state.go('projet.item', { id: 'new', edit: true });
		};

		//Permet d'effectuer la recherche
		ctrl.onChangeSearchText = function (val) {
			ctrl.searchText = val;
			ctrl.loadProjets();
		};

		//Permet l'affichage des projet selon leur statut
		ctrl.onChangeActif = function (val) {
			ctrl.filterActif = val;
			ctrl.loadProjets();
		};

		var onLoadSuccess = function (data) {
			if (this.search === ctrl.searchText) {
				ctrl.page = data;
			} else {
				$log.debug('response is outdated => ignore');
			}
		};

		//Fonction permettant de changer la page 
		ctrl.loadProjets = function () {
			ProjetListService.getList(ctrl.filterActif, ctrl.importEasy, ctrl.searchText, ctrl.pagingOptions)
				.then(onLoadSuccess.bind({ search: ctrl.searchText }));

			if (SecurityService.anyRole('ETABLISSEMENT')) {
				ctrl.read = true;
			}
		};

		// Mise à jour des options de pagination (tri / paginataion)
		ctrl.onPagingOptionsChange = function (pagingOptions) {
			ctrl.pagingOptions = pagingOptions;
			ctrl.loadProjets();
		};

		// Augmente le nombre de résultats affichés
		ctrl.viewMore = function () {
			ctrl.pageSize += 15;
		};

		//Permet l'affichage de l'investigateur principal dans le tableau
		ctrl.investigateurPrincipal = function (projet) {
			var retour = '';
			angular.forEach(projet.investigateurs, function (investigateur) {
				if (investigateur.investigateurPrincipal && investigateur.investigateur) {
					var investigateurSelected = investigateur.investigateur;
					retour = investigateurSelected.nom + ' ' + investigateurSelected.prenom;
					// Permet de sortir du forEach si un résultat a été trouvé
					return;
				}
			});
			return retour;
		};

		ctrl.loadProjets();

	}
})();

(function () {
    'use strict';

    angular.module('app.projet').controller('ProjetItemController', Controller);

    /** @ngInject */
    function Controller($stateParams, $state, $scope, $q, toastr, ProjetWS, FileUploader, EtablissementWS, PromoteurWS, FinanceurWS, InvestigateurWS, CompteWS, FacturationWS, SweetAlert) {
        var ctrl = this;

        ctrl.dateFormat = 'dd/MM/yyyy';

        ctrl.isUpdate = $stateParams.id !== 'new';
        ctrl.idModified = $stateParams.id;

        ctrl.projet = {};
        ctrl.isDesactivationImpossible = false;
        ctrl.isFacturationDesactive = false;
        ctrl.autocompleteEtablissement = EtablissementWS.autocomplete;

        ctrl.autocompletePromoteur = PromoteurWS.autocomplete;

        ctrl.autocompleteInvestigateur = InvestigateurWS.autocomplete;

        ctrl.autocompleteFinanceur = FinanceurWS.autocomplete;
        ctrl.autocompleteCompte = CompteWS.autocomplete;


        // Permet de mettre les champs en mode disable pour la simple
        // consultation de la page des projets
        ctrl.disabled = !$stateParams.edit;

        ctrl.init = function () {

            if (ctrl.isUpdate) {
                //on crée les droits pour les name importés à partir d'EasyDore
                var grant = ProjetWS.updateProjetImport(ctrl.idModified);

                grant.then(function () {
                    ProjetWS.getOne(ctrl.idModified).then(function (response) {
                        ctrl.projet = response.data;

                        //Vérifie si le compte du projet est actif
                        if (ctrl.projet.compte !== null && !ctrl.projet.compte.actif) {
                            ctrl.isFacturationDesactive = true;
                        }

                        //Permet de vérifier le nombre de facturation pour un projet
                        FacturationWS.countFacturationProjet(ctrl.projet.id).then(function (response) {
                            var nbFacturation = response.data;
                            if (nbFacturation !== null && nbFacturation > 0) {
                                ctrl.isDesactivationImpossible = true;
                            }
                        });
                    });
                });

            } else {

                ctrl.addInvestigateur();
                ctrl.addContact();
                ctrl.projet.actif = true;

            }
        };


        ctrl.validateDateDebut = function () {
            var isValid = true;

            if (ctrl.projet.debut && ctrl.projet.fin) {
                isValid = moment(ctrl.projet.debut).isSameOrBefore(moment(ctrl.projet.fin));
            }

            if (isValid) {
                $scope.form.debut.$setValidity('dateStartIsAfterDateEnd', true);
                $scope.form.fin.$setValidity('dateEndIsAfterDateStart', true);
            } else {
                $scope.form.debut.$setValidity('dateStartIsAfterDateEnd', false);
            }
        };

        ctrl.validateDateFin = function () {
            var isValid = true;

            if (ctrl.projet.debut && ctrl.projet.fin) {
                isValid = moment(ctrl.projet.debut).isBefore(moment(ctrl.projet.fin));
            }

            if (isValid) {
                $scope.form.debut.$setValidity('dateStartIsAfterDateEnd', true);
                $scope.form.fin.$setValidity('dateEndIsAfterDateStart', true);

            } else {
                $scope.form.fin.$setValidity('dateEndIsAfterDateStart', false);
            }
        };

        ctrl.backToList = function () {
            $state.go('projet.list');
        };

        ctrl.onSaveFailure = function (response) {
            if (response.status === 400) {
                ctrl.serverErrors = response.data.errors;
            } else {
                toastr.error('Echec d\'enregistrement');
            }
            return $q.reject();
        };

        ctrl.saveOrUpdate = function (projet) {
            ProjetWS.saveOrUpdate(projet).then(ctrl.backToList, ctrl.onSaveFailure);
        };

        // Gestion des contacts
        ctrl.addContact = function () {
            ctrl.projet.contacts = ctrl.projet.contacts || [];
            ctrl.projet.contacts.push({});
        };

        ctrl.removeContact = function (index) {
            ctrl.projet.contacts.splice(index, 1);
        };

        // Gestion des investigateurs
        ctrl.addInvestigateur = function () {
            ctrl.projet.investigateurs = ctrl.projet.investigateurs || [];
            ctrl.projet.investigateurs.push({});
        };

        ctrl.removeInvestigateur = function (index) {
            ctrl.projet.investigateurs.splice(index, 1);
        };

        ctrl.updateSelection = function (position, investigateurs) {
            angular.forEach(investigateurs, function (investigateur, index) {
                if (position !== index) {
                    investigateur.investigateurPrincipal = false;
                }
            });
        };

        // Création de la facturation à partir de l'écran projet
        ctrl.createFacturation = function (projet) {
            ProjetWS.saveOrUpdate(projet).then(function () {
                $state.go('projet.facturation_item', {
                    id: 'new', 
                    edit: true,
                    from: 'projet',
                    projet: projet
                });
            }, ctrl.onSaveFailure);
        };

        // Permet de stocker le fichier passé en pièce jointe sur le serveur
        ctrl.getFileUpload = new FileUploader({
            url: '/api/projet/upload',
            onSuccessItem: function () {
                $scope.form.pj.$setValidity('required', true);
                $scope.form.pj.$setValidity('badFile', true);
            },
            onErrorItem: function (item) {
                ctrl.getFileUpload.removeFromQueue(item);
                $scope.form.pj.$setValidity('required', true);
                $scope.form.pj.$setValidity('badFile', false);
            },
            autoUpload: true
        });

        // Permet l'affichage d'une popup pour demander la confirmation de la
        // suppression de la pièce jointe
        ctrl.confirmDelete = function (id) {
            SweetAlert.swal({
                title: 'Suppression de la pièce jointe',
                text: 'Êtes-vous sûr de vouloir supprimer cette pièce jointe ?',
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Annuler',
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Oui'
            },
                function (isConfirm) {
                    if (isConfirm) {
                        ctrl.removeFichier(id);
                    }
                });
        };

        // Permet de supprimer la pièce jointe choisie
        ctrl.removeFichier = function (id) {
            ProjetWS.deleteFile(ctrl.projet.id, id).then(function (response) {
                ctrl.projet = response.data;
            });
        };

        ctrl.init();

    }
})();

(function() {
	'use strict';

	angular.module('app.projet').service('ImportEasydoreWS', Service);

	/** @ngInject */
	function Service($http) {
		var service = this;

		service.getList = function(actif, importEasy, searchText, paging) {
			
			var params = {
				'actif' : actif,
				'searchText' : searchText,
				'importEasy' : importEasy
			};

			params = _.extend(params, paging);
			
			return $http.get('/api/projet', {
				'params' : params
			});
		};

		service.update = function(projet) {
				return $http.put('/api/projet/updateEasydore', projet)
				.then(function (response) {
				return response.data.content;
			});
			};

		// Permet l'autocompletion des imports
		service.autocompleteProjet = function(searchImport, importEasy) {
			return $http.get('/api/projet', {
				'params' : {
					'actif' : true,
					'searchText' : searchImport,
					'importEasy' : importEasy
				}
			}).then(function(response) {
				return response.data.content;
			});
		};

	}
})();

/**
 * Created by ACO on 09/08/2016.
 */
(function () {
	'use strict';

	angular
		.module('app.projet')
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		$stateProvider.state('projet.importEasydore', {
			url: '/importEasydore/list',
			parent: 'projet',
			templateUrl: 'app/projet/importEasydore/list/importEasydoreList.html',
			controller: 'ImportEasydoreListController',
			controllerAs: 'ctrl'
		});

	
	}
})();

(function () {
	'use strict';

	angular.module('app.projet')
		.service('FacturationWS', Service);

	/** @ngInject */
	function Service($http) {
		var service = this;

		service.getList = function (facture, statuts, searchText,paging) {
            var params = {
                'facture': facture,
                'statut': statuts,
                'searchText': searchText,
            };

            params = _.extend(params, paging);

			return $http.get('/api/facturation', {
                'params' : params
			});
		};

		service.getOne = function (id) {
			return $http.get('/api/facturation/' + id);
		};

		service.saveOrUpdate = function (facturation) {
			if (facturation.id) {
				return $http.put('/api/facturation', facturation);
			} else {
				return $http.post('/api/facturation', facturation);
			}
		};

		service.delete = function (facturation) {
			return $http.delete('/api/facturation/' + facturation.id);
		};

		//Permet de récupérer l'énumération sur les statuts de facturation
		service.getStatutFacturation = function () {
			return $http.get('/api/enum/statut_facturation');
		};

		service.getCodeTVA = function () {
			return $http.get('/api/tva');
		};

		service.download = function (facture) {
			return $http.get('/api/facturation/download/' + facture, {responseType: 'arraybuffer'});
		};
		
		//Permet de compter le nombre de facturation pour un projet
		service.countFacturationProjet = function(idProjet){
			return $http.get('/api/facturation/countProjet', {
				params: {
					'projet': idProjet
				}
			});
		};

		service.updateFacturationImport = function (id) {
			return $http.put('/api/facturation/updateEasydore/' + id)
				.then(function (response) {
					return response.data.content;
				});
		};

	}
})();

/**
 * Created by PierreGOURET on 18/05/2016.
 */
(function () {
	'use strict';

	angular
		.module('app.projet')
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		$stateProvider.state('projet.facturation', {
			url: '/facturation/list',
			parent: 'projet',
			templateUrl: 'app/projet/facturation/list/FacturationList.html',
			controller: 'FacturationListController',
			controllerAs: 'ctrl'
		});

		$stateProvider.state('projet.facturation_item', {
			url: '/facturation/:id?edit',
			parent: 'projet',
			templateUrl: 'app/projet/facturation/item/FacturationItem.html',
			controller: 'FacturationItemController',
			controllerAs: 'ctrl',
			params: {
				projet: {value : null},
				from :  {}
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('app.referentiel')
		.service('TvaWS', Service);

	/** @ngInject */
	function Service($http) {
		var service = this;

		service.getListTva = function () {
			return $http.get('/api/tva');
		};


		service.saveOrUpdate = function (listTvas) {
			return $http.put('/api/tva', listTvas);
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		$stateProvider.state('referentiel.tva', {
			url: '/tva',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/tva/tva.html',
			controller: 'TvaController',
			controllerAs: 'ctrl'
		});


	}
})();

(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.controller('TvaController', Controller);

	/** @ngInject */
	function Controller($stateParams, $state, TvaWS, $q, toastr, $scope) {
		var ctrl = this;
		var svc = TvaWS;

		ctrl.list = [];

		ctrl.init = function () {
			svc.getListTva().then(function (response) {
				ctrl.list = response.data.content;
			});
		};

		ctrl.addTva = function () {
			var newTva = {};

			if (ctrl.list === undefined) {
				ctrl.list = [];
			}
			ctrl.list.push(newTva);
		};

		ctrl.saveOrUpdate = function () {
			svc.saveOrUpdate(ctrl.list).then(ctrl.onSaveOk, ctrl.onSaveFailure);
		};

		ctrl.onSaveOk = function (response) {
			// on fait ça pour que les tva creees récuperent leur id
			ctrl.list = response.data;
		};

		ctrl.onSaveFailure = function (response) {
			if (response.status === 400) {
				$scope.serverErrors = response.data.errors;
			} else {
				toastr.error('Echec d\'enregistrement : ' + response.data.message);
			}
			return $q.reject();
		};

		ctrl.removeTva = function (index) {
			ctrl.list.splice(index, 1);
		};

		ctrl.validateCode = function (index, code) {

			var doublon = false;

			angular.forEach(ctrl.list, function (currentTva, currentIndex) {
				if (index !== currentIndex && code === currentTva.code) {
					doublon = true;
					return;
				}
			});

			if (doublon) {
				$scope.form['code' + index].$setValidity('codeUnique', false);
			} else {
				$scope.form['code' + index].$setValidity('codeUnique', true);
			}

		};
		
		ctrl.init();
	}
})();

(function() {
	'use strict';

	angular.module('app.referentiel').service('PromoteurWS', Service);

	/** @ngInject */
	function Service($http) {
		var service = this;

		service.loadPromoteurs = function(active, searchText, paging) {
			var params = {
				'actif' : active,
				'searchText' : searchText
			};

			params = _.extend(params, paging);

			return $http.get('/api/promoteur', {
				'params' : params
			});
		};

		service.getOne = function(id) {
			return $http.get('/api/promoteur/' + id);
		};

		service.saveOrUpdate = function(promoteur) {
			if (promoteur.id) {
				return $http.put('/api/promoteur', promoteur);
			} else {
				return $http.post('/api/promoteur', promoteur);
			}
		};

		service.getTypologies = function() {
			return $http.get('/api/enum/typologie');
		};

		service.validateCode = function(promoteur, value) {
			if (promoteur.id !== undefined) {
				return $http.get('/api/promoteur/validateCode?id=' + promoteur.id + '&code=' + value);
			} else {
				return $http.get('/api/promoteur/validateCode?code=' + value);
			}
		};

		// Permet l'autocompletion des promoteurs
		service.autocomplete = function(searchPromoteur, id) {
			return $http.get('/api/promoteur', {
				'params' : {
					'actif' : true,
					'searchText' : searchPromoteur
				}
			}).then(function(response) {
				if (id) {

					response.data.content = _.reject(response.data.content, function(promo) {
						return promo.etablissement.id !== id;
					});
					return response.data.content;
				} else {
					return response.data.content;
				}
			});
		};

		service.updatePromoteurImport = function(id) {
			return $http.put('/api/promoteur/updateEasydore/' + id).then(
				function(response) {
					return response.data.content;
			});
		};

	}
})();

/**
 * Created by PierreGOURET on 18/05/2016.
 */
(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		$stateProvider.state('referentiel.promoteur', {
			url: '/promoteur',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/promoteur/list/PromoteurList.html',
			controller: 'PromoteurListController',
			controllerAs: 'ctrl'
		});

		$stateProvider.state('referentiel.promoteur_item', {
			url: '/promoteur/:id?edit',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/promoteur/item/PromoteurItem.html',
			controller: 'PromoteurItemController',
			controllerAs: 'ctrl'
		});
	}
})();

(function () {
	'use strict';

	angular.module('app.referentiel')
		.service('InvestigateurWS', Service);

	/** @ngInject */
	function Service($http) {
		var service = this;

		service.loadInvestigateurs = function (active, searchText, paging) {
			var params = {
				'actif': active,
				'searchText': searchText
				
			};

			params = _.extend(params, paging);

			return $http.get('/api/investigateur', {
				'params': params
			});
		};

		service.getOne = function (id) {
			return $http.get('/api/investigateur/' + id);
		};

		service.saveOrUpdate = function (investigateur) {
			if (investigateur.id) {
				return $http.put('/api/investigateur', investigateur);
			} else {
				return $http.post('/api/investigateur', investigateur).then(function (response) {
					return response.data;
				});
			}
		};

		service.autocomplete = function (searchText,id) {
			return $http.get('/api/investigateur', {
				'params': {
					'actif': true,
					'searchText': searchText
					
				}
			}).then(function (response) {
				if (id) {

					response.data.content = _.reject(response.data.content, function(inves) {
						return inves.etablissement.id !== id;
					});
					return response.data.content;
				} else {
					return response.data.content;
				}
			});
		};

		service.validateCode = function (investigateur, value) {
			if (investigateur.id !== undefined) {
				return $http.get('/api/investigateur/validateCode?id=' + investigateur.id + '&code=' + value);
			} else {
				return $http.get('/api/investigateur/validateCode?code=' + value);
			}
		};

		service.loadTitres = function () {
			return $http.get('/api/enum/titre');
		};
	}
})();

/**
 * Created by PierreGOURET on 18/05/2016.
 */
(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		$stateProvider.state('referentiel.investigateur', {
			url: '/investigateur',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/investigateur/list/InvestigateurList.html',
			controller: 'InvestigateurListController',
			controllerAs: 'ctrl'
		});

		$stateProvider.state('referentiel.investigateur_item', {
			url: '/investigateur/:id?edit',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/investigateur/item/InvestigateurItem.html',
			controller: 'InvestigateurItemController',
			controllerAs: 'ctrl'
		});

	}
})();

(function() {
	'use strict';

	angular.module('app.referentiel').service('FournisseurWS', Service);

	/** @ngInject */
	function Service($http) {
		var service = this;

		service.getList = function() {
			return $http.get('/api/fournisseur');
		};

		service.getListFournisseurs = function(active, searchText, paging) {
			var params = {
				'actif' : active,
				'searchText' : searchText
			};

			params = _.extend(params, paging);

			return $http.get('/api/fournisseur', {
				'params' : params
			});
		};

		service.getOne = function(id) {
			return $http.get('/api/fournisseur/' + id);
		};

		service.saveOrUpdate = function(fournisseur) {
			if (fournisseur.id) {
				return $http.put('/api/fournisseur', fournisseur);
			} else {
				return $http.post('/api/fournisseur', fournisseur);
			}
		};

		service.validateCode = function(fournisseur, value) {
			if (fournisseur.id !== undefined) {
				return $http.get('/api/fournisseur/validateCode?id='+ fournisseur.id + '&code=' + value);
			} else {
				return $http.get('/api/fournisseur/validateCode?code=' + value);
			}
		};
		

		service.getTypologies = function() {
			return $http.get('/api/enum/typologie');
		};

		service.getCompteGeneralFournisseur = function() {
			return $http.get('/api/comptegeneralfournisseur');
		};

		service.autocomplete = function(searchText) {
			return $http.get('/api/fournisseur', {
				'params' : {
					'actif' : true,
					'searchText' : searchText
				}
			}).then(function(response) {
				return response.data.content;
			});
		};

		service.updateFournisseurImport = function(id) {
			return $http.put('/api/fournisseur/updateEasydore/' + id).then(function(response) {
				return response.data.content;
			});
		};
	}
})();

/**
 * Created by PierreGOURET on 18/05/2016.
 */
(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		$stateProvider.state('referentiel.fournisseur', {
			url: '/fournisseur',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/fournisseur/list/FournisseurList.html',
			controller: 'FournisseurListController',
			controllerAs: 'ctrl'
		});

		$stateProvider.state('referentiel.fournisseur_item', {
			url: '/fournisseur/:id?edit',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/fournisseur/item/FournisseurItem.html',
			controller: 'FournisseurItemController',
			controllerAs: 'ctrl'
		});
	}
})();

(function () {
	'use strict';

	angular.module('app.referentiel')
		.service('FinanceurWS', Service);

	/** @ngInject */
	function Service($http) {
		var service = this;

		service.getList = function () {
			return $http.get('/api/financeur');
		};

		service.getListFinanceurs = function (active, searchText, paging) {
			var params = {
				'actif': active,
				'searchText': searchText
			};
			
			params = _.extend(params, paging);

			return $http.get('/api/financeur', {
				'params' : params
			});
		};

		service.getOne = function (id) {
			return $http.get('/api/financeur/' + id);
		};

		service.saveOrUpdate = function (financeur) {
			if (financeur.id) {
				return $http.put('/api/financeur', financeur);
			} else {
				return $http.post('/api/financeur', financeur);
			}
		};

		service.validateCode = function (financeur, value) {
			if (financeur.id !== undefined) {
				return $http.get('/api/financeur/validateCode?id=' + financeur.id + '&code=' + value);
			} else {
				return $http.get('/api/financeur/validateCode?code=' + value);
			}
		};

		service.getConditionPaiement = function () {
			return $http.get('/api/enum/condition_paiement');
		};
		
		service.getCompteGeneralFinanceur = function () {
			return $http.get('/api/comptegeneralfinanceur');
		};

		service.autocomplete = function (searchText) {
			return $http.get('/api/financeur', {
				'params': {
					'actif': true,
					'searchText': searchText
				}
			}).then(function (response) {
				return response.data.content;
			});
		};
		
		service.updateFinanceurImport = function(id) {
			return $http.put('/api/financeur/updateEasydore/' + id)
			.then(function (response) {
			return response.data.content;
		});
		};

        service.deleteFinanceur = function (financeur) {
            return $http.delete('/api/financeur/' + financeur.id);
        };
	}
})();

/**
 * Created by PierreGOURET on 18/05/2016.
 */
(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		$stateProvider.state('referentiel.financeur', {
			url: '/financeur',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/financeur/list/FinanceurList.html',
			controller: 'FinanceurListController',
			controllerAs: 'ctrl'
		});

		$stateProvider.state('referentiel.financeur_item', {
			url: '/financeur/:id?edit',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/financeur/item/FinanceurItem.html',
			controller: 'FinanceurItemController',
			controllerAs: 'ctrl'
		});
	}
})();

(function () {
	'use strict';

	angular.module('app.referentiel')
		.service('EtablissementWS', Service);

	/** @ngInject */
	function Service($http, $log) {
		var service = this;

		service.getList = function () {
			return $http.get('/api/etablissement');
		};

		service.getListEtablissements = function (active, searchText) {
			var params = {
				'params': {
					'actif': active,
					'searchText': searchText
				}
			};

			$log.debug('WS.getListEtablissements : ');


			return $http.get('/api/etablissement', params);
		};

		service.getOne = function (id) {
			return $http.get('/api/etablissement/' + id);
		};

		service.saveOrUpdate = function (etablissement) {
			if (etablissement.id) {
				return $http.put('/api/etablissement', etablissement);
			} else {
				return $http.post('/api/etablissement', etablissement);
			}
		};

		service.validateCode = function (etablissement, value) {
			if (etablissement.id !== undefined) {
				return $http.get('/api/etablissement/validateCode?id=' + etablissement.id + '&code=' + value);
			} else {
				return $http.get('/api/etablissement/validateCode?code=' + value);
			}
		};

		//Permet l'autocompletion des établissements
		service.autocomplete = function (searchEtablissement) {
			return $http.get('/api/etablissement', {
				'params': {
					'actif': true,
					'searchText': searchEtablissement
				}
			}).then(function (response) {
				return response.data.content;
			});
		};

		service.updateEtablissementImport = function (id) {
			return $http.put('/api/etablissement/updateEasydore/' + id)
				.then(function (response) {
					return response.data.content;
				});
		};
	}
})();

/**
 * Created by PierreGOURET on 18/05/2016.
 */
(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		$stateProvider.state('referentiel.etablissement', {
			url: '/etablissement',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/etablissement/list/EtablissementList.html',
			controller: 'EtablissementListController',
			controllerAs: 'ctrl'
		});

		$stateProvider.state('referentiel.etablissement_item', {
			url: '/etablissement/:id?edit',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/etablissement/item/EtablissementItem.html',
			controller: 'EtablissementItemController',
			controllerAs: 'ctrl'
		});
	}
})();

(function() {
	'use strict';

	angular.module('app.referentiel').service('CategoryWS', Service);

	/** @ngInject */
	function Service($http) {
		var service = this;

		service.getList = function() {
			var params = {
					'params' : {
						'actif' : true,
						'searchText' : ''
					}
				};
			
			return $http.get('/api/category', params);
		};

		service.getListCategories = function(active, searchText, pagination) {

			var params = {
				'actif' : active,
				'searchText' : searchText
			};

			params = _.extend(params, pagination);
			return $http.get('/api/category', {
				'params' : params
			});
		};
		
		service.getTypes = function () {
			return $http.get('/api/enum/type_categorie');
		};
		
		service.getCompteCharge = function () {
			return $http.get('/api/comptecharge');
		};
		
		service.getTypesFrais = function () {
			return $http.get('/api/enum/type_frais');
		};

		service.getOne = function(id) {
			return $http.get('/api/category/' + id);
		};

		service.saveOrUpdate = function(category) {
			if (category.id) {
				return $http.put('/api/category', category);
			} else {
				return $http.post('/api/category', category);
			}
		};

		service.autocomplete = function(searchText, type) {
			return $http.get('/api/category', {
				'params' : {
					'actif' : true,
					'searchText' : searchText,
					'type': type
				}
			}).then(function(response) {
				return response.data.content;
			});
		};

		service.validateCode = function(category, value) {
			if (category.id !== undefined) {
				return $http.get('/api/category/validateCode?id=' + category.id	+ '&code=' + value);
			} else {
				return $http.get('/api/category/validateCode?code=' + value);
			}
		};

		service.updateCategoryImport = function (id) {
			return $http.put('/api/category/updateEasydore/' + id)
				.then(function (response) {
					return response.data.content;
				});
		};

	}
})();

/**
 * Created by PierreGOURET on 18/05/2016.
 */
(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		$stateProvider.state('referentiel.category', {
			url: '/category',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/category/list/CategoryList.html',
			controller: 'CategoryListController',
			controllerAs: 'ctrl'
		});
	
		$stateProvider.state('referentiel.category_item', {
			url: '/category/:id?edit',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/category/item/CategoryItem.html',
			controller: 'CategoryItemController',
			controllerAs: 'ctrl'
		});
		

	}
})();

(function () {
	'use strict';

	angular.module('app.referentiel')
		.service('BeneficiaireWS', Service);

	/** @ngInject */
	function Service($http) {
		var service = this;

		service.getList = function () {
			return $http.get('/api/beneficiaire');
		};

		service.getListBeneficiaires = function (active, searchText, pagination) {
			
			var params = {
				'params': {
					'actif': active,
					'searchText': searchText
				}
			};
			params = _.extend(params, pagination);
			return $http.get('/api/beneficiaire', params);
		};

		service.getOne = function (id) {
			return $http.get('/api/beneficiaire/' + id);
		};

		service.saveOrUpdate = function (beneficiaire) {
			if (beneficiaire.id) {
				return $http.put('/api/beneficiaire', beneficiaire);
			} else {
				return $http.post('/api/beneficiaire', beneficiaire).then(function (response) {
					return response.data;
				});
			}
		};
		
		service.autocomplete = function (searchText,id) {
			return $http.get('/api/beneficiaire', {
				'params': {
					'actif': true,
					'searchText': searchText
				}
			}).then(function (response) {
				if (id) {

					response.data.content = _.reject(response.data.content, function(ben) {
						return ben.etablissement.id !== id;
					});
					return response.data.content;
				} else {
					return response.data.content;
				}
			});
		};
		

		service.validateCode = function (beneficiaire, value) {
			if (beneficiaire.id !== undefined) {
				return $http.get('/api/beneficiaire/validateCode?id=' + beneficiaire.id + '&code=' + value);
			} else {
				return $http.get('/api/beneficiaire/validateCode?code=' + value);
			}
		};

		service.updateBeneficiaireImport = function (id) {
			return $http.put('/api/beneficiaire/updateEasydore/' + id)
				.then(function (response) {
					return response.data.content;
				});
		};
		
	}
})();

/**
 * Created by PierreGOURET on 18/05/2016.
 */
(function () {
	'use strict';

	angular
		.module('app.referentiel')
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		$stateProvider.state('referentiel.beneficiaire', {
			url: '/beneficiaire',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/beneficiaire/list/BeneficiaireList.html',
			controller: 'BeneficiaireListController',
			controllerAs: 'ctrl'
		});

		$stateProvider.state('referentiel.beneficiaire_item', {
			url: '/beneficiaire/:id?edit',
			parent: 'referentiel',
			templateUrl: 'app/referentiel/beneficiaire/item/BeneficiaireItem.html',
			controller: 'BeneficiaireItemController',
			controllerAs: 'ctrl'
		});

	}
})();

(function () {
	'use strict';

	angular.module('app.operation').controller('OperationListController', Controller);

	/** @ngInject */
	function Controller($state, OperationWS, UtilisateurWS, $stateParams, $log, SecurityService) {
		var ctrl = this;
		var utilisateur;
		ctrl.pageSize = 15;
		ctrl.pagingOptions = {};
		ctrl.filtreActif = true;
		ctrl.searchText = '';
		ctrl.utilisateur = {};
		ctrl.fromDashboard = $stateParams.id === 'graph';
		ctrl.read = false;

		ctrl.initUser = function () {

			UtilisateurWS.getCurrentUser().then(function (user) {
				utilisateur = user;
				if (!Array.isArray(user.roles)) {
					utilisateur.roles = [user.roles] || [];
				}
				ctrl.init();
			});
		};

		// INIT
		ctrl.init = function () {

			ctrl.etablissementId = $stateParams.etablissementId;
			ctrl.AValiderParEtablissement = $stateParams.AValiderParEtablissement;
			if (SecurityService.anyRole('ETABLISSEMENT')) {
				ctrl.read = true;
			}

			if (ctrl.fromDashboard) {

				switch ($stateParams.operation) {
					case 'REMBOURSEMENT':
						ctrl.filtreDemande = 'REMBOURSEMENT';
						switch ($stateParams.status) {
							case 'SOUMISE':
								ctrl.statutRemboursement = [$stateParams.status];
								ctrl.filterBrouillonRemboursement = false;
								ctrl.filterASoumettreRemboursement = false;
								ctrl.filterSoumiseRemboursement = true;
								ctrl.filterPayeRemboursement = false;
								ctrl.filterValideRemboursement = false;
								ctrl.filterRefuseRemboursement = false;
								break;
							case 'VALIDE':
								ctrl.statutRemboursement = [$stateParams.status];
								ctrl.filterBrouillonRemboursement = false;
								ctrl.filterASoumettreRemboursement = false;
								ctrl.filterSoumiseRemboursement = false;
								ctrl.filterPayeRemboursement = false;
								ctrl.filterValideRemboursement = true;
								ctrl.filterRefuseRemboursement = false;
								break;
							case 'ASOUMETTRE':
								ctrl.statutRemboursement = [$stateParams.status];
								ctrl.filterBrouillonRemboursement = false;
								ctrl.filterASoumettreRemboursement = true;
								ctrl.filterSoumiseRemboursement = false;
								ctrl.filterPayeRemboursement = false;
								ctrl.filterValideRemboursement = false;
								ctrl.filterRefuseRemboursement = false;
								break;
							default:
						}
						ctrl.getListOperationRemboursement();
						break;

					case 'ACHAT':
						ctrl.filtreDemande = 'ACHAT';
						switch ($stateParams.status) {
							case 'SOUMISE':
								ctrl.statutsAchat = [$stateParams.status];
								ctrl.filterBrouillonAchat = false;
								ctrl.filterASoumettreAchat = false;
								ctrl.filterSoumiseAchat = true;
								ctrl.filterPayeAchat = false;
								ctrl.filterReceptionneAchat = false;
								ctrl.filterValideAchat = false;
								break;
							case 'VALIDE':
								ctrl.statutsAchat = [$stateParams.status];
								ctrl.filterBrouillonAchat = false;
								ctrl.filterASoumettreAchat = false;
								ctrl.filterSoumiseAchat = false;
								ctrl.filterPayeAchat = false;
								ctrl.filterReceptionneAchat = false;
								ctrl.filterValideAchat = true;
								break;
							case 'RECEPTIONNE':
								ctrl.statutsAchat = [$stateParams.status];
								ctrl.filterBrouillonAchat = false;
								ctrl.filterSoumiseAchat = false;
								ctrl.filterPayeAchat = false;
								ctrl.filterReceptionneAchat = true;
								ctrl.filterValideAchat = false;
								break;
							case 'ASOUMETTRE':
								ctrl.statutsAchat = [$stateParams.status];
								ctrl.filterBrouillonAchat = false;
								ctrl.filterASoumettreAchat = true;
								ctrl.filterSoumiseAchat = false;
								ctrl.filterPayeAchat = false;
								ctrl.filterReceptionneAchat = false;
								ctrl.filterValideAchat = false;
								break;
							default:
						}
						ctrl.getListOperationAchat();
						break;

					case 'MISSION':
						ctrl.filtreDemande = 'MISSION';
						switch ($stateParams.status) {
							case 'SOUMISE':
								ctrl.statutsMission = [$stateParams.status];
								ctrl.filterBrouillonMission = false;
								ctrl.filterSoumiseMission = true;
								ctrl.filterPayeMission = false;
								ctrl.filterReceptionneMission = false;
								ctrl.filterValideMission = false;
								break;
							case 'VALIDE':
								ctrl.statutsMission = [$stateParams.status];
								ctrl.filterBrouillonMission = false;
								ctrl.filterSoumiseMission = false;
								ctrl.filterPayeMission = false;
								ctrl.filterReceptionneMission = false;
								ctrl.filterValideMission = true;
								break;
							case 'RECEPTIONNE':
								ctrl.statutsMission = [$stateParams.status];
								ctrl.filterBrouillonMission = false;
								ctrl.filterSoumiseMission = false;
								ctrl.filterPayeMission = false;
								ctrl.filterReceptionneMission = true;
								ctrl.filterValideMission = false;
								break;
							case 'ASOUMETTRE':
								ctrl.statutsMission = [$stateParams.status];
								ctrl.filterBrouillonMission = false;
								ctrl.filterASoumettreMission = true;
								ctrl.filterSoumiseMission = false;
								ctrl.filterPayeMission = false;
								ctrl.filterReceptionneMission = false;
								ctrl.filterValideMission = false;
								break;
							default:
						}
						ctrl.getListOperationMission();
						break;
					default:
				}
			} else {
				ctrl.initOperationStatus();
				ctrl.getListOperationRemboursement();
			}
		};

		var onLoadSuccess = function (response) {
			if (this.search === ctrl.searchText) {
				// L'investigateur ne doit voir que ces brouillons, pas ceux de
				// ses bénéficiaires
				if (utilisateur && utilisateur.roles && utilisateur.roles[0] === 'INVESTIGATEUR') {
					response.data.content = _.reject(response.data.content, function (operation) {
						switch (operation.statut) {
							case 'BROUILLON':
								if (operation.beneficiaire) {
									return operation.beneficiaire.id !== utilisateur.investigateurId;
								}
								if (operation.investigateur) {
									return operation.investigateur.id !== utilisateur.investigateurId;
								}
								break;
							default:
						}
					});
				}
				ctrl.page = response.data;
			} else {
				$log.debug('response is outdated => ignore');
			}
		};

		// Permet de récupérer les demandes de remboursement
		ctrl.getListOperationRemboursement = function () {
			OperationWS.getListRemboursement(ctrl.searchText, ctrl.statutRemboursement, ctrl.pagingOptions, ctrl.etablissementId).then(onLoadSuccess.bind({
				search: ctrl.searchText
			}));
		};

		// Permet de récupérer les demandes d'achats
		ctrl.getListOperationAchat = function () {
			OperationWS.getListAchat(ctrl.searchText, ctrl.statutsAchat, ctrl.AValiderParEtablissement, ctrl.pagingOptions).then(onLoadSuccess.bind({
				search: ctrl.searchText
			}));
		};

		ctrl.getListOperationMission = function () {
			OperationWS.getListMission(ctrl.searchText, ctrl.statutsMission, ctrl.pagingOptions, ctrl.etablissementId).then(onLoadSuccess.bind({
				search: ctrl.searchText
			}));
		};

		// Action pour les demandes de remboursement
		ctrl.goToDemandeRemboursement = function (id) {
			if (SecurityService.anyRole('ADMIN,INTERLOCUTEUR,FINANCIER,INVESTIGATEUR')) {
				$state.go('operation.item_demande_remboursement',
					{ id: id, edit: true }, { reload: true }
				);
			} else {
				$state.go('operation.item_demande_remboursement', { id: id }, { reload: true });
			}
		};

		ctrl.addDemandeRemboursement = function () {
			$state.go('operation.item_demande_remboursement',
				{ id: 'new', edit: true }, { reload: true }
			);
		};

		// Action pour les demandes d'achat
		ctrl.goToDemandeAchat = function (id) {
			if (SecurityService.anyRole('ADMIN,INTERLOCUTEUR,FINANCIER,INVESTIGATEUR')) {
				$state.go('operation.item_demande_achat',
					{ id: id, edit: true }, { reload: true }
				);
			} else {
				$state.go('operation.item_demande_achat', { id: id }, { reload: true });
			}
		};

		ctrl.addDemandeAchat = function () {
			$state.go('operation.item_demande_achat',
				{ id: 'new', edit: true }, { reload: true }
			);
		};

		// Action pour les demandes de mission
		ctrl.goToDemandeMission = function (id) {
			if (SecurityService.anyRole('ADMIN,INTERLOCUTEUR,FINANCIER,INVESTIGATEUR')) {
				$state.go('operation.item_demande_mission',
					{ id: id, edit: true }, { reload: true }
				);
			} else {
				$state.go('operation.item_demande_mission', { id: id }, { reload: true });
			}
		};

		ctrl.addDemandeMission = function () {
			$state.go('operation.item_demande_mission',
				{ id: 'new', edit: true }, { reload: true }
			);
		};

		// Permet d'effectuer la recherche
		ctrl.onChangeSearchText = function (val) {
			ctrl.searchText = val;
			switch (ctrl.filtreDemande) {
				case 'ACHAT':
					ctrl.getListOperationAchat();
					break;
				case 'REMBOURSEMENT':
					ctrl.getListOperationRemboursement();
					break;
				case 'MISSION':
					ctrl.getListOperationMission();
					break;
				default:
			}
		};

		// Permet d'initialiser les status pour les opérations
		ctrl.initOperationStatus = function () {
			// Selon les roles, tous les statuts ne sont pas chargés
			if (utilisateur && utilisateur.roles && utilisateur.roles[0] === 'INTERLOCUTEUR') {
				ctrl.statutRemboursement = ['SOUMISE', 'VALIDE', 'REFUSE', 'PAYE'];
				ctrl.statutsAchat = ['SOUMISE', 'VALIDE', 'RECEPTIONNE', 'PAYE', 'REFUSE'];
				ctrl.statutsMission = ['SOUMISE', 'VALIDE', 'RECEPTIONNE', 'APAYER', 'PAYE', 'REFUSE'];
			} else if (utilisateur && utilisateur.roles && utilisateur.roles[0] === 'ADMIN') {
				ctrl.statutRemboursement = ['BROUILLON', 'SOUMISE', 'VALIDE', 'REFUSE', 'PAYE'];
				ctrl.statutsAchat = ['BROUILLON', 'SOUMISE', 'VALIDE', 'RECEPTIONNE', 'PAYE', 'REFUSE'];
				ctrl.statutsMission = ['BROUILLON', 'SOUMISE', 'VALIDE', 'RECEPTIONNE', 'APAYER', 'PAYE', 'REFUSE'];
			} else {
				ctrl.statutRemboursement = ['BROUILLON', 'ASOUMETTRE', 'SOUMISE', 'VALIDE', 'REFUSE', 'PAYE'];
				ctrl.statutsAchat = ['BROUILLON', 'ASOUMETTRE', 'SOUMISE', 'VALIDE', 'RECEPTIONNE', 'PAYE', 'REFUSE'];
				ctrl.statutsMission = ['BROUILLON', 'ASOUMETTRE', 'SOUMISE', 'VALIDE', 'RECEPTIONNE', 'PAYE', 'REFUSE'];
			}

			// Partie demande de remboursement
			ctrl.filterBrouillonRemboursement = true;
			ctrl.filterASoumettreRemboursement = true;
			ctrl.filterSoumiseRemboursement = true;
			ctrl.filterPayeRemboursement = true;
			ctrl.filterValideRemboursement = true;
			ctrl.filterRefuseRemboursement = true;

			// Partie demande d'achat
			ctrl.filterBrouillonAchat = true;
			ctrl.filterASoumettreAchat = true;
			ctrl.filterSoumiseAchat = true;
			ctrl.filterPayeAchat = true;
			ctrl.filterReceptionneAchat = true;
			ctrl.filterValideAchat = true;

			// Partie demande de mission
			ctrl.filterBrouillonMission = true;
			ctrl.filterASoumettreMission = true;
			ctrl.filterSoumiseMission = true;
			ctrl.filterPayeMission = true;
			ctrl.filterReceptionneMission = true;
			ctrl.filterValideMission = true;

			// Partie commune
			ctrl.filtreDemande = 'REMBOURSEMENT';
		};

		ctrl.onChangeDemande = function (val) {
			ctrl.filtreDemande = val;
		};

		ctrl.toggleStatutRemboursement = function (statut) {
			var found = _.contains(ctrl.statutRemboursement, statut);
			if (found) {
				ctrl.statutRemboursement = _.without(ctrl.statutRemboursement, statut);
			} else {
				ctrl.statutRemboursement.push(statut);
			}
		};

		ctrl.toggleStatutAchat = function (statut) {
			var found = _.contains(ctrl.statutsAchat, statut);
			if (found) {
				ctrl.statutsAchat = _.without(ctrl.statutsAchat, statut);
			} else {
				ctrl.statutsAchat.push(statut);
			}
		};

		ctrl.toggleStatutMission = function (statut) {
			var found = _.contains(ctrl.statutsMission, statut);
			if (found) {
				ctrl.statutsMission = _.without(ctrl.statutsMission, statut);
			} else {
				ctrl.statutsMission.push(statut);
			}
		};

		// Mise à jour des options de pagination (tri / paginataion)
		ctrl.onPagingOptionsChange = function (pagingOptions) {
			ctrl.pagingOptions = pagingOptions;
			switch (ctrl.filtreDemande) {
				case 'ACHAT':
					ctrl.getListOperationAchat();
					break;
				case 'REMBOURSEMENT':
					ctrl.getListOperationRemboursement();
					break;
				case 'MISSION':
					ctrl.getListOperationMission();
					break;
				default:
			}

		};

		// Augmente le nombre de résultats affichés
		ctrl.viewMore = function () {
			ctrl.pageSize += 15;
		};

		/*
		 * ctrl.initOperationStatus(); ctrl.getListOperationRemboursement();
		 */
		ctrl.initUser();
	}
})();

(function () {
	'use strict';

	angular
		.module('app.dashboard', ['app'])
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		
		// State abstrait : Parent
		$stateProvider
			.state('dashboard', {
				abstract: true,
				parent: 'layout',
				url: '/dashboard',
				templateUrl: 'app/dashboard/dashboard.html'
			});

		// State concret
		$stateProvider
			.state('dashboard.dashboardGeneral', {
				url: '/dashboardGeneral',
				parent: 'dashboard',
				templateUrl: 'app/dashboard/dashboardGeneral/dashboardGeneral.html',
				controller: 'DashboardGeneralController',
				controllerAs: 'ctrl',
				params: {
					essai: ':test1'
					}
			});
		
		
	}
})();

(function() {
	'use strict';

	angular.module('app.dashboard').controller('DashboardGeneralController', Controller);

	/** @ngInject */
	function Controller($stateParams, $q, $log, $state, EtablissementWS, OperationWS, SecurityService, $scope) {

		var ctrl = this;

		// catégorie de statistique
		ctrl.rbt = {};
		ctrl.achat = {};
		ctrl.mission = {};
		ctrl.statistique = {};
		ctrl.total = 0;
		ctrl.user={};

		
		// Partie demande de remboursement
		ctrl.statutRemboursement = [ 'BROUILLON','ASOUMETTRE', 'SOUMISE', 'VALIDE', 'REFUSE', 'PAYE' ];
		// Partie demande d'achat
		ctrl.statutAchat = [ 'BROUILLON','ASOUMETTRE', 'SOUMISE', 'VALIDE', 'RECEPTIONNE', 'PAYE' ];
		// Partie demande de Mission
		ctrl.statutMission = [ 'BROUILLON', 'ASOUMETTRE', 'SOUMISE', 'VALIDE', 'RECEPTIONNE', 'PAYE' ];

		ctrl.pagination = {};

		ctrl.autocompleteEtablissement = EtablissementWS.autocomplete;

		ctrl.init = function() {
			//on récupère les identifications du user connecté
			ctrl.user=SecurityService.getUserDetails();
			ctrl.chargeRemboursement();
			ctrl.chargeAchat();
			ctrl.chargeMission();
		};

		ctrl.filtreEtablissement = function(etablissement) {
			ctrl.total = 0;
			ctrl.chargeRemboursement(etablissement);
			ctrl.chargeAchat(etablissement);
			ctrl.chargeMission(etablissement);
		};

		ctrl.chargeRemboursement = function(etablissement) {
			OperationWS.getListRemboursement('', ctrl.statutRemboursement, null).then(function(operation) {
				// On récupère toutes les opérations de remboursement
				ctrl.rbt = operation.data.content;
				if (etablissement) {
					// QD LA RECHERCHE EST FILTRE SUR UN ETABLISSEMENT
					// les demandes en status SOUMISE de l'établissement
					ctrl.rbt=_.reject(ctrl.rbt, function(rbt) {
						return rbt.compte.etablissement.id !== etablissement.id;
					});
				} 
				
				// on filtre par statut soumise
				ctrl.rbt.AV = ctrl.rbt.filter(function(rbt) {
					return rbt.statut === 'SOUMISE';
				});
				// jauge DR Soumise
				ctrl.rbt.statistiqueAV = ctrl.rbt.AV.length;
				// on filtre par statut a soumettre
				ctrl.rbt.AS = ctrl.rbt.filter(function(rbt) {
					return rbt.statut === 'ASOUMETTRE';
				});
				
				// la longueur de la liste est stocké pour le calcul de la
				// jauge DR A soumettre
				ctrl.rbt.statistiqueAS = ctrl.rbt.AS.length;
				ctrl.rbt.AP = ctrl.rbt.filter(function(rbt) {
					return rbt.statut === 'VALIDE';
				});
				ctrl.rbt.statistiqueAP = ctrl.rbt.AP.length;
				ctrl.rbt.total = operation.data.content.length;
				// incrémente de 1 lorsque la promise est réalisé
				ctrl.calculTotal(1);
			});
		};

		ctrl.chargeAchat = function(etablissement) {
				OperationWS.getListAchat('', ctrl.statutAchat, ctrl.pagination).then(function(operation) {
				ctrl.achat = operation.data.content;
				if (etablissement) {
					// QD LA RECHERCHE EST FILTRE SUR UN ETABLISSEMENT
					// les demandes en status SOUMISE de l'établissement
					ctrl.achat=_.reject(ctrl.achat, function(achat) {
							return achat.compte.etablissement.id !== etablissement.id;
						});
				}
				// chargement selon statut
				ctrl.achat.AV = ctrl.achat.filter(function(achat) {
					return achat.statut === 'SOUMISE';
				});
				
				//si le profil est interlocuteur,
				//seul les demandes de matériel biomedical et donné au CHU sont à valider
				
				if (ctrl.user && (ctrl.user.roles[0]==='INTERLOCUTEUR' || ctrl.user.roles[0]==='ETABLISSEMENT')){
						ctrl.achat.AV = ctrl.achat.filter(function(achat) {
							return achat.materielCHU === true && achat.statut ==='SOUMISE' && achat.validerParEtablissement === false;
						});	
				}					
				ctrl.achat.statistiqueAV = ctrl.achat.AV.length;
				
				// on filtre par statut a soumettre
				ctrl.achat.AS = ctrl.achat.filter(function(achat) {
					return achat.statut === 'ASOUMETTRE';
				});
				// la longueur de la liste est stocké pour le calcul de la
				// jauge DR A soumettre
				ctrl.achat.statistiqueAS = ctrl.achat.AS.length;
				
				ctrl.achat.AP = ctrl.achat.filter(function(achat) {
					return achat.statut === 'RECEPTIONNE';
				});
				ctrl.achat.statistiqueAP = ctrl.achat.AP.length;
				ctrl.achat.total = operation.data.content.length;
				ctrl.calculTotal(1);
			});
		};
		ctrl.chargeMission = function(etablissement) {
			OperationWS.getListMission('', ctrl.statutAchat, ctrl.pagination).then(function(operation) {
				ctrl.mission = operation.data.content;
				if (etablissement) {
					$log.debug('on passe ici');
					// QD LA RECHERCHE EST FILTRE SUR UN ETABLISSEMENT
					// les demandes en status SOUMISE de l'établissement
					ctrl.mission=_.reject(ctrl.mission, function(mission) {
							return mission.compte.etablissement.id !== etablissement.id;
						});
				}
				// chargement selon statut
				
				
				ctrl.mission.AV = ctrl.mission.filter(function(mission) {
					return mission.statut === 'SOUMISE';
				});
				ctrl.mission.statistiqueAV = ctrl.mission.AV.length;
				
				// on filtre par statut a soumettre
				ctrl.mission.AS = ctrl.mission.filter(function(mission) {
					return mission.statut === 'ASOUMETTRE';
				});
				// la longueur de la liste est stocké pour le calcul de la
				// jauge DR A soumettre
				ctrl.mission.statistiqueAS = ctrl.mission.AS.length;
				
				ctrl.mission.AP = ctrl.mission.filter(function(mission) {
					return mission.statut === 'RECEPTIONNE';
				});
				ctrl.mission.statistiqueAP = ctrl.mission.AP.length;
				ctrl.mission.total = operation.data.content.length;
				ctrl.calculTotal(1);
			});
		};

		ctrl.goToDemandeRemboursement = function(etablissementId, status) {
			if (etablissementId) {
				$state.go('operation.list', {
					id : 'graph',
					operation : 'REMBOURSEMENT',
					etablissementId : etablissementId,
					status : status
				});
			} else {
				$state.go('operation.list', {
					id : 'graph',
					operation : 'REMBOURSEMENT',
					status : status
				});
			}
		};

		ctrl.goToDemandeAchat = function(etablissementId, status, AValiderParEtablissement) {
			if (etablissementId) {
				$state.go('operation.list', {
					id : 'graph',
					operation : 'ACHAT',
					etablissementId : etablissementId,
					status : status,
					AValiderParEtablissement : AValiderParEtablissement
				});
			} else {
				$state.go('operation.list', {
					id : 'graph',
					operation : 'ACHAT',
					status : status,
					AValiderParEtablissement : AValiderParEtablissement
				});
			}
		};

		ctrl.goToDemandeMission = function(etablissementId, status) {
			if (etablissementId) {
				$state.go('operation.list', {
					id : 'graph',
					operation : 'MISSION',
					etablissementId : etablissementId,
					status : status
				});
			} else {
				$state.go('operation.list', {
					id : 'graph',
					operation : 'MISSION',
					status : status
				});
			}
		};

		ctrl.calculTotal = function(value) {
			// variable watché par le controlleur
			// incrémenté à chaque promise réalisé
			ctrl.total += Number(value);
		};

		function numSort(arr) {
			return arr.sort(function(a, b) {
				return +a - +b;
			});
		}

		ctrl.calculTauxRemplissage = function() {
			// creation de la liste des statistiques
			var listeAtrier = [];
			var nbElement=0;
			if(ctrl.user && ctrl.user.roles && ctrl.user.roles[0]==='ADMIN'){
				listeAtrier.push(ctrl.rbt.statistiqueAV);
				listeAtrier.push(ctrl.rbt.statistiqueAP);
				listeAtrier.push(ctrl.achat.statistiqueAV);
				listeAtrier.push(ctrl.achat.statistiqueAP);
				listeAtrier.push(ctrl.mission.statistiqueAV);
				listeAtrier.push(ctrl.mission.statistiqueAP);	
				nbElement=listeAtrier.length-1;
			}
			if(ctrl.user && ctrl.user.roles && ctrl.user.roles[0]==='INVESTIGATEUR'){
				listeAtrier.push(ctrl.rbt.statistiqueAS);
				listeAtrier.push(ctrl.achat.statistiqueAS);
				listeAtrier.push(ctrl.mission.statistiqueAS);
				nbElement=listeAtrier.length-1;
			}
			
			if(ctrl.user && ctrl.user.roles && (ctrl.user.roles[0]==='INTERLOCUTEUR' || ctrl.user.roles[0]==='ETABLISSEMENT')){
				listeAtrier.push(ctrl.achat.statistiqueAV);
				nbElement=listeAtrier.length-1;
			}
			
			// tri croissant
			numSort(listeAtrier);
			
			// l'échelle maximum des jauges doit être la valeur la plus élevée
			ctrl.total = listeAtrier[nbElement];
			// calcul de chaque jauge
			ctrl.rbt.tauxRemplissageAV = (100 * Number(ctrl.rbt.statistiqueAV)) / Number(ctrl.total);
			ctrl.rbt.tauxRemplissageAP = (100 * Number(ctrl.rbt.statistiqueAP)) / Number(ctrl.total);
			ctrl.rbt.tauxRemplissageAS= (100 * Number(ctrl.rbt.statistiqueAS)) / Number(ctrl.total);
			ctrl.achat.tauxRemplissageAV = (100 * Number(ctrl.achat.statistiqueAV)) / Number(ctrl.total);
			ctrl.achat.tauxRemplissageAP = (100 * Number(ctrl.achat.statistiqueAP)) / Number(ctrl.total);
			ctrl.achat.tauxRemplissageAS= (100 * Number(ctrl.achat.statistiqueAS)) / Number(ctrl.total);
			ctrl.mission.tauxRemplissageAV = (100 * Number(ctrl.mission.statistiqueAV)) / Number(ctrl.total);
			ctrl.mission.tauxRemplissageAP = (100 * Number(ctrl.mission.statistiqueAP)) / Number(ctrl.total);
			ctrl.mission.tauxRemplissageAS= (100 * Number(ctrl.mission.statistiqueAS)) / Number(ctrl.total);
		};

		ctrl.init();

		$scope.$watch('ctrl.statistique.etablissement', function() {
			if (ctrl.statistique.etablissement) {
				ctrl.filtreEtablissement(ctrl.statistique.etablissement);
			}
		});

		$scope.$watch('ctrl.total', function() {
			// valide que l'on a bien recu les promesses des 3 types (DR,DA,DM),
			// on peut alors calculer les taux de remplissage des jauges
			if (ctrl.total && ctrl.total === 3) {
				ctrl.calculTauxRemplissage();
			}
		});

	}

})();

(function () {
    'use strict';

    angular.module('app.compte')
        .service('VirementWS', Service);

    /** @ngInject */
    function Service($http) {
        var service = this;

        service.getList = function (searchText, paging) {
            var params = {
            		'searchText': searchText
            };
            
            params = _.extend(params, paging);
            return $http.get('/api/virement', {
            	'params' : params
            });
        };

        service.getOne = function (id) {
            return $http.get('/api/virement/' + id);
        };

        service.saveOrUpdate = function (virement) {
            if (virement.id) {
                return $http.put('/api/virement', virement);
            } else {
                return $http.post('/api/virement', virement);
            }
        };

        service.updateVirementImport = function (id) {
			return $http.put('/api/virement/updateEasydore/' + id)
				.then(function (response) {
					return response.data.content;
				});
		};

    }
})();

/**
 * Created by cedric.guegan on 17/07/2016.
 */
(function () {
    'use strict';

    angular
        .module('app.compte')
        .config(stateConfig);

    /** @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('compte.virement', {
            url: '/virement/list',
            parent: 'compte',
            templateUrl: 'app/compte/virement/list/VirementList.html',
            controller: 'VirementListController',
            controllerAs: 'ctrl'
        });

        $stateProvider.state('compte.virement_item', {
            url: '/virement/:id?edit',
            parent: 'compte',
            templateUrl: 'app/compte/virement/item/VirementItem.html',
            controller: 'VirementItemController',
            controllerAs: 'ctrl'
        });

    }
})();

(function () {
	'use strict';

	angular.module('app.compte').controller('CompteListController', Controller);

	/** @ngInject */
	function Controller($state, CompteWS, SecurityService) {
		var ctrl = this;
		ctrl.sort = 'ref';
		ctrl.pageSize = 15;
		ctrl.pagingOptions = {};
		
		ctrl.read = false;

		ctrl.init = function () {
			ctrl.searchText = '';
			ctrl.list = [];
			ctrl.filterActif = true;
			ctrl.typologies = [];

			ctrl.getListCompte();

			if (SecurityService.anyRole('ETABLISSEMENT')) {
				ctrl.read = true;
			}
		};

		ctrl.getListCompte = function () {
			var searchText = ctrl.searchText;
			if (searchText.length <= 2) {
				searchText = '';
			}

			CompteWS.getListCompte(ctrl.filterActif, searchText, ctrl.pagingOptions).then(function (response) {
				ctrl.list = response.data.content;
				ctrl.page = response.data;
			});
		};

		//Fonction permettant d'accéder au formulaire d'un projet
		ctrl.goTo = function (id) {
			if (SecurityService.anyRole('ADMIN,INTERLOCUTEUR,FINANCIER,INVESTIGATEUR')) {
				// reload to test active class on menu
				$state.go('compte.item', {
					id: id,
					edit: true
				}, { reload: true });
			} else {
				$state.go('compte.item', {
					id: id
				}, { reload: true });
			}
		};

		//Fonction permettant d'ajouter un nouveau projet
		ctrl.add = function () {
			$state.go('compte.item', {
				id: 'new',
				edit: true
			}, { reload: true });
		};

		// Mise à jour des options de pagination (tri / paginataion)
		ctrl.onPagingOptionsChange = function (pagingOptions) {
			ctrl.pagingOptions = pagingOptions;
			ctrl.getListCompte();
		};

		// Augmente le nombre de résultats affichés
		ctrl.viewMore = function () {
			ctrl.pageSize += 15;
		};


		//Permet d'effectuer la recherche
		ctrl.onChangeSearchText = function (val) {
			ctrl.searchText = val;
			ctrl.getListCompte();
		};

		//Permet l'affichage des projet selon leur statut
		ctrl.onChangeActif = function (val) {
			ctrl.filterActif = val;
			ctrl.getListCompte();
		};

		ctrl.init();
	}
})();

(function () {
	'use strict';

	angular.module('app.compte').controller('CompteItemController', Controller);
	/** @ngInject */
	function Controller($stateParams, $state, $scope, CompteWS, SecurityService, $q, toastr, BeneficiaireWS, InvestigateurWS) {
		var ctrl = this;
		var utilisateur;


		ctrl.pageSize = Number(10);
		$scope.limit = 10;
		ctrl.pagingOptions = {};
		ctrl.isUpdate = $stateParams.id !== 'new';
		ctrl.idModified = $stateParams.id;
		ctrl.compte = {};
		ctrl.typologies = {};
		ctrl.listeBeneficiaireFiltre = [];
		ctrl.investigateurCompte = {};
		ctrl.isDesactivationImpossible = false;
		ctrl.invest = {};

		ctrl.autocompleteBeneficiaire = BeneficiaireWS.autocomplete;
		ctrl.autocompleteInvestigateur = InvestigateurWS.autocomplete;

		// Permet de mettre les champs en mode disable pour la simple
		// consultation de la page des établissements
		ctrl.disable = ($stateParams.disable !== undefined ? $stateParams.disable : false);
		ctrl.consultation = !$stateParams.edit;

		ctrl.init = function () {
			ctrl.loadTypologiesCompte();
			utilisateur = SecurityService.getUserDetails();

			if (ctrl.isUpdate) {
				//on crée les droits pour les compte importés à partir d'EasyDore
				var grant = CompteWS.updateCompteImport(ctrl.idModified);
				grant.then(function () {

					CompteWS.getOne(ctrl.idModified).then(function (response) {
						ctrl.compte = response.data;

						angular.forEach(ctrl.compte.operations, function (operation) {
							if (operation.statut !== 'PAYE' && operation.statut !== 'REFUSE') {
								ctrl.isDesactivationImpossible = true;
							}
							ctrl.affichageStatutOperation(operation);
						});

						ctrl.invest = ctrl.compte.titulaire.nom + ' ' + ctrl.compte.titulaire.prenom;
					});
				});
			} else {
				ctrl.addBeneficiaire();
				ctrl.addInvestigateur();
				ctrl.addUserConnected();
				//par défaut le compte est actif
				ctrl.compte.actif = true;
			}

		};

		ctrl.backToList = function () {
			$state.go('compte.list');
		};

		ctrl.affichageStatutOperation = function (operation) {
			switch (operation.statut) {
				case 'SOUMISE':
				case 'VALIDE':
					operation.statut = 'Engagé';
					break;
				case 'PAYE':
					operation.statut = 'Payé';
					break;
				case 'REFUSE':
					operation.statut = 'Refusé';
					break;
				case 'ANNULE':
					operation.statut = 'Annulé';
					break;
				default:
					operation.statut = '-';
			}
		};

		//Fonction permettant d'accéder au item
		ctrl.goTo = function (operation) {
			switch (operation.typologie) {
				case 'Facture':
					$state.go('projet.facturation_item', { id: operation.idDemande });
					break;
				case 'Virement':
					$state.go('compte.virement_item', { id: operation.idDemande });
					break;
				case 'Demande de remboursement':
					$state.go('operation.item_demande_remboursement', { id: operation.idDemande });
					break;
				case 'Demande de mission':
					$state.go('operation.item_demande_mission', { id: operation.idDemande });
					break;
				case 'Demande d\'achat':
					$state.go('operation.item_demande_achat', { id: operation.idDemande });
					break;
				default:
					$state.go('compte.list');
			}
		};

		ctrl.onSaveFailure = function (response) {
			if (response.status === 400) {
				$scope.serverErrors = response.data.errors;
			} else {
				toastr.error('Echec d\'enregistrement : ' + response.data.message);
			}
			return $q.reject();
		};

		ctrl.saveOrUpdate = function (compte) {

			return CompteWS.saveOrUpdate(compte).then(ctrl.backToList, ctrl.onSaveFailure);

		};

		ctrl.validateCode = function (value) {
			return CompteWS.validateCode(ctrl.compte, value);
		};

		ctrl.loadTypologiesCompte = function () {
			return CompteWS.loadTypologiesCompte().then(function (response) {
				ctrl.typologies = response.data;

			});
		};


		// Permet d'aller sur l'écran des établissements
		ctrl.goEtablissement = function (etablissement) {
			if (etablissement !== null && etablissement !== undefined) {
				$state.go('referentiel.etablissement_item', {
					id: etablissement.id,
					disable: true
				});
			}
		};

		// Permet d'attribuer l'établissement automatiquement à l'aide du
		// titulaire
		ctrl.onChangeTitulaire = function (titulaire) {
			if (titulaire !== undefined) {
				ctrl.compte.etablissement = titulaire.etablissement;
			} else {
				ctrl.compte.etablissement = null;
			}
		};

		// Gestion des beneficaiires
		ctrl.addBeneficiaire = function () {
			ctrl.compte.beneficiaires = ctrl.compte.beneficiaires || [];
			ctrl.compte.beneficiaires.push({});
		};

		ctrl.removeBeneficiaire = function (index) {
			ctrl.compte.beneficiaires.splice(index, 1);
		};

		// Gestion des inbestigateurs
		ctrl.addInvestigateur = function () {
			ctrl.compte.investigateurs = ctrl.compte.investigateurs || [];
			ctrl.compte.investigateurs.push({});
		};

		// Gestion du titulaire par défaut (Si création du compte par un investigateur)
		ctrl.addUserConnected = function () {
			if (utilisateur && utilisateur.roles && utilisateur.roles[0] === 'INVESTIGATEUR') {
				InvestigateurWS.getOne(utilisateur.investigateurId).then(function (response) {
					ctrl.compte.titulaire = response.data;
					ctrl.invest = ctrl.compte.titulaire.nom + ' ' + ctrl.compte.titulaire.prenom;
					ctrl.compte.etablissement = ctrl.compte.titulaire.etablissement;
				});
			}


		};

		ctrl.removeInvestigateur = function (index) {
			ctrl.compte.investigateurs.splice(index, 1);
		};

		ctrl.updateSelection = function (position, investigateurs) {
			angular.forEach(investigateurs, function (investigateur, index) {
				if (position !== index) {
					investigateur.investigateurPrincipal = false;
				}
			});
		};

		// Augmente le nombre de résultats affichés
		ctrl.viewMore = function () {
			$scope.limit += 15;
			$state.go('compte.item', {
				id: ctrl.compte.id
			});
		};

		ctrl.init();

	}
})();

(function () {
    'use strict';
    angular.module('app', [
        'app.lib',
        'app.security',
        'app.projet',
        'app.referentiel',
        'app.compte',
        'app.operation',
        'app.dashboard'
    ]);
    angular
        .module('app.lib', [
            'ngAnimate',
            'ngCookies',
            'ngSanitize',
            'ngMessages',
            'ngRoute',
            'ngAria',
            'ngResource',
            'ui.bootstrap',
            'nya.bootstrap.select',
            'ui.router',
            'angular-loading-bar',
            'scrollToFixed',
            'underscore',
            'toastr',
            'angular.filter',
            'validation.match',
            'pascalprecht.translate',
            // Alertes JS de ce type http://oitozero.github.io/ngSweetAlert/#/home
            'oitozero.ngSweetAlert',
            'mm.iban',
            'angularFileUpload',
            // Boutons switch on/off Cf. http://jumplink.github.io/angular-toggle-switch/
            'toggle-switch',
            'swaggerUi']);
})();

(function () {
	'use strict';

	angular.module('app')
		.service('SecurityService', SecurityService);

	/** @ngInject */
	function SecurityService(_, $http, $state, $stateParams, $location, UtilisateurWS) {
		var service = this;

		this.userDetails = {};

		service.setAuthenticated = function (username, fullname, investigateurId, beneficiaireId, roles, id) {
			service.userDetails.isAuthenticated = true;
			service.userDetails.username = username;
			service.userDetails.fullname = fullname;
			service.userDetails.investigateurId = investigateurId;
			service.userDetails.beneficiaireId = beneficiaireId;
			service.userDetails.id = id;
			if (Array.isArray(roles)) {
				service.userDetails.roles = roles;
			} else {
				service.userDetails.roles = [roles] || [];
			}
		};
		
		service.setRoles= function (roles) {
			if (Array.isArray(roles)) {
				service.userDetails.roles = roles;
			} else {
				service.userDetails.roles = [roles] || [];
			}
		};

		service.setNotAuthenticated = function () {
			service.userDetails = {};
		};

		service.getUserDetails = function () {
			return service.userDetails;
		};

		service.getRoles = function () {
			return service.userDetails.roles;
		};

		service.getUsername = function () {
			return service.userDetails.username;
		};

		service.getFullname = function () {
			return service.userDetails.fullname;
		};
		
		service.getInvestigateurId = function () {
			return service.userDetails.investigateurId;
		};
		
		service.getBeneficiaireId = function () {
			return service.userDetails.beneficiaireId;
		};

		service.isAuthenticated = function () {
			return service.userDetails.isAuthenticated || false;
		};

		service.isAnonymous = function () {
			return !service.isAuthenticated();
		};

		var hasRole = function (grant) {
			if (grant === undefined) {
				return false;
			}
			return _.contains(service.userDetails.roles, grant.trim());
		};

		// Verification des droits.
		service.anyRole = function (roles) {

			if (roles.indexOf('!') === 0) {
				// strip first "!" char and invert anyRole evaluation
				return !service.anyRole(roles.substring(1));
			}

			var rolesArray = roles.split(',');
			var roleFound = (_.find(rolesArray, hasRole) !== undefined);
			return roleFound;
		};

		service.initUserSession = function (gotoLandingPageOnSuccess) {
			return UtilisateurWS.getCurrentUser().then(getCurrentUserSuccess.bind({gotoLandingPage: gotoLandingPageOnSuccess}));
		};

		service.logout = function () {
			return UtilisateurWS.logout().then(service.setNotAuthenticated);
		};

		// Store user details and redirect to appropriate view
		var getCurrentUserSuccess = function (userDetails) {
			service.setAuthenticated(userDetails.username, userDetails.fullname, userDetails.investigateurId, userDetails.beneficiaireId, userDetails.roles, userDetails.id);

			if ($stateParams.redirectTo) {
				$location.path($stateParams.redirectTo);
			} else if (this.gotoLandingPage) {
				if (userDetails.roles==='BENEFICIAIRE'){
					$state.go('operation.list');
				}else{
					$state.go('projet.list');
				}
			}
		};

		// this.initUserSession(false);

		return service;
	}
})();

/**
 * Setup a global HTTP response interceptor which pop up message when HTTP 403 (Forbidden) occurs.
 * Largely inspired by this article : http://blog.thesparktree.com/post/75952317665/angularjs-interceptors-globally-handle-401-and
 */
(function () {
	var module = angular.module('app');

	/** @ngInject */
	module.factory('http403ResponseInterceptor', function ($q, SweetAlert) {
		return {
			responseError: function (error) {
				if (error.status === 403) {
					SweetAlert.swal({
						title: 'Droits insuffisants',
						text: 'Vous n\'êtes pas autorisé à poursuivre l\'opération.',
						type: 'error',
						confirmButtonColor: '#337ab7'
					});
				}
				return $q.reject(error);
			}
		};
	});

	module.config(['$httpProvider', function ($httpProvider) {
		$httpProvider.interceptors.push('http403ResponseInterceptor');
	}]);

})();

/**
 * Setup a global HTTP response interceptor which redirect to login page when HTTP 401 (Unauthorized) occurs.
 * Largely inspired by this article : http://blog.thesparktree.com/post/75952317665/angularjs-interceptors-globally-handle-401-and
 */
(function () {
	var NO_REDIRECT_FOR_PATHS = ['/connexion', '/nouveau-mot-de-passe', '/mot-de-passe-oublie'];

	var module = angular.module('app');

	/** @ngInject */
	module.factory('http401ResponseInterceptor', function ($q, $location, $log, _) {
		return {
			responseError: function (error) {
				if (error.status === 401) {
					var currentPath = $location.path();

					// avoid infinite redirection loop
					if (!_.contains(NO_REDIRECT_FOR_PATHS, currentPath)) {
						$log.debug('Got an HTTP 401 error => redirect to login page');

						// add current location to query string to redirect after login success
						$location.path('/connexion').search({redirectTo: currentPath});
					} else {
						$log.debug('Got an HTTP 401 error => no redirect for this page');
					}
				}
				return $q.reject(error);
			}
		};
	});

	module.config(['$httpProvider', function ($httpProvider) {
		$httpProvider.interceptors.push('http401ResponseInterceptor');
	}]);

})();

(function() {
	'use strict';

	angular.module('app').filter('categorieSorter', function(){

	/** @ngInject */
		function categorieOrder(item) {
			switch (item) {
			case 'REPAS':
				return 1;
			case 'HOTEL':
				return 2;
			case 'TRANSPORT1':
			case 'TRANSPORT2':
				return 3;
			case 'LOCATION':
				return 4;
			default:
				return 5;
			}
		}

		return function(items, field) {
			var filtered = [];
			angular.forEach(items, function(item) {
				filtered.push(item);
			});
			filtered.sort(function(a, b) {
				return (categorieOrder(a[field]) > categorieOrder(b[field]) ? 1 : -1);
			});

			return filtered;

		};
	});
})();
(function () {
	'use strict';

	angular
		.module('app').directive('gifValidateAsync', function () {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, elem, attr, ngModelController) {
				var moreValidators = scope.$eval(attr.gifValidateAsync);
				angular.extend(ngModelController.$asyncValidators, moreValidators);
			}
		};
	});

})();

/**
 * Permet de lire / enregistrer les dates du modèle métier au format UTC et donc
 * d'éviter les soucis de timezone non gérés (ou mal gérés?) par la librairie Angular UI Bootstrap
 * notamment par le composant uibDatepickerPopup.
 *
 * Concrètement, sans cette directive, lorsque l'on choisi la date du 16/09/2016 via le date picker uib
 * la date settée au niveau du modèle est "2016-09-15T22:00:00.000Z" ce qui est incorrect dans le sens ou il manque le timezone.
 * Avec cette directive on a bien "2016-09-16T00:00:00.000Z"
 *
 * Cf. http://www.ericluwj.com/2015/11/06/angularui-ui-bootstrap-datepicker-and-timepicker-neutral-timezone.htm
 */
angular.module('app')
	.directive('gifUtcDate', function () {
		return {
			restrict: 'A',
			priority: 1,
			require: 'ngModel',
			link: function (scope, element, attrs, ctrl) {
				ctrl.$formatters.push(function (value) {
					var date = new Date(Date.parse(value));
					date = new Date(date.getTime() + (60000 * date.getTimezoneOffset()));
					return date;
				});

				ctrl.$parsers.push(function (value) {
					if(value === null){
						return null;
					}
					var date = new Date(value.getTime() - (60000 * value.getTimezoneOffset()));
					return date;
				});
			}
		};
	});

(function () {
	'use strict';

	angular.module('app')
		.directive('gifServerValidate', gifServerValidate);

	/** @ngInject */
	function gifServerValidate(SecurityService, _, $log) {
		var directive = {
			restrict: 'A',
			require: 'form',
			link: function ($scope, $elem, $attrs, form) {
				var invalidateField = function (field, errorType) {
					var changeListener = function () {

						field.$setValidity(errorType, true);

						var index = field.$viewChangeListeners.indexOf(changeListener);
						if (index > -1) {
							field.$viewChangeListeners.splice(index, 1);
						}
					};

					field.$setDirty();
					field.$setTouched();
					field.$setValidity(errorType, false);
					field.$viewChangeListeners.push(changeListener);
				};

				var invalidateForm = function (form, errorType) {
					form.$setDirty();
					form.$setValidity(errorType, false);
				};
				
				$scope.$watch($attrs.gifServerValidate, function (errors) {
					// retire toues les erreurs de type 'form.$error.server.xxx'


					if (errors) {

						angular.forEach(errors, function (error) {

							if (error.field) {
								if (error.field in form) {
									invalidateField(form[error.field], 'server.' + error.code);
								} else {
									$log.warn('Erreur de validation serveur détectée pour le champ \'' + error.field + '\' mais il n\'existe pas de champ de formulaire de même nom.');
									invalidateForm(form, 'server.other');
								}
							} else {
								invalidateForm(form, 'server.' + error.code);
							}
						});
					}
				});
			}
		};

		return directive;
	}
})();

/**
 * Directive permettant d'ajouter / retirer un élément au DOM selon les rôles de la personne connectée.
 * Exemple : <div gif-role="ADMIN">visible uniquement si la personne possède le rôle ADMIN</div>
 * Exemple : <div gif-role="ADMIN, USER">visible si la personne possède le rôle ADMIN ou USER</div>
 * Exemple : <div gif-role="!ADMIN">visible si la personne ne possède pas le rôle ADMIN ou USER</div>
 *
 * Utilise la fonction SecurityService.anyRole(roles).
 */
(function () {
	'use strict';

	angular.module('app').directive('gifRole', gifRole);

	/** @ngInject */
	function gifRole(SecurityService, $rootScope, ngIfDirective) {
		var ngIf = ngIfDirective[0];
		return {
			transclude: ngIf.transclude,
			priority: 1000,
			terminal: ngIf.terminal,
			restrict: ngIf.restrict,
			link: function ($scope, $element, $attr) {

				$attr.ngIf = function () {
					return SecurityService.anyRole($attr.gifRole);
				};
				ngIf.link.apply(ngIf, arguments);
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('app').directive('gifPagedData', gifPagedData);

	/** @ngInject */
	function gifPagedData($compile, _, $log) {


		var directive = {
			restrict: 'EA',
			scope: {gifPagedData: '&'},
			link: function ($scope, $element, attrs) {
				var directiveElement = $element.parent();
				$scope.paging = {};

				var initialPageSize = parseInt(attrs.gifPageSize, 10) || 15;
				$scope.paging.size = initialPageSize;
				/**
				 *  retourne 'asc' si l'élément est trié de manière ascendante
				 *  'desc' si l'élément est trié de manière descendante
				 *  null si l'élement n'est pas trié.
				 */
				var sortDirection = function (column) {
					var sortItem = _.find($scope.paging.sort, function (value) {
						return value.startsWith(column + ',');
					});

					if (sortItem && sortItem === (column + ',asc')) {
						return 'asc';
					}
					if (sortItem && sortItem === (column + ',desc')) {
						return 'desc';
					} else {
						return null;
					}
				};

				var handleSortable = function (sortable) {
					var element = angular.element(sortable);
					var sortValue = element.attr('gif-sortable');

					if (sortValue) {
						element.attr('ng-click', 'gifPagedDataToggleSort(\'' + sortValue + '\')');
						$compile(element)($scope);
					} else {
						$log.warn('gif-sortable attribute must not be empty');
					}
				};

				angular.forEach(angular.element(directiveElement[0].querySelectorAll('[gif-sortable]')), handleSortable);


				attrs.$observe('gifPageSize', function (value) {
					$scope.paging.size = parseInt(value, 10);
					$scope.gifPagedData({pagingOptions: $scope.paging});
				});


				$scope.gifPagedDataToggleSort = function (column) {

					$scope.paging = $scope.paging || {};
					$scope.paging.sort = $scope.paging.sort || [];

					var actualSortDirection = sortDirection(column);

					if (actualSortDirection !== null) {
						$scope.paging.sort = _.reject($scope.paging.sort, function (value) {
							return value.startsWith(column + ',');
						});
					}

					var newSortDirection = 'asc';

					if (actualSortDirection === 'asc') {
						newSortDirection = 'desc';
					} else if (actualSortDirection === 'desc') {
						newSortDirection = 'asc';
					}


					$scope.paging.sort.unshift(column + ',' + newSortDirection);
					$scope.gifPagedData({pagingOptions: $scope.paging});
				};


			}
		};

		return directive;
	}
})();

(function () {
	'use strict';

	angular.module('app').directive('gifHasError', gifHasError);

	/** @ngInject */
	function gifHasError($log) {
		var directive = {
			restrict: 'A',
			require: '^form',
			link: function (scope, el, attrs, formCtrl) {
				//TODO : gérer le cas de n input trouvés
				// find the text box element, which has the 'name' attribute
				var inputEl = el[0].querySelector('[name]');


				// convert the native text box element to an angular element
				var inputNgEl = angular.element(inputEl);
				// get the name on the text box so we know the property to
				// check
				// on the form controller
				var inputName = inputNgEl.attr('name');

				if (inputName === undefined) {
					$log.warn('No input with attribute \'name\' found as child of gif-has-Error. Remove this useless directive definition.');
					return;
				}
				scope.$watch(function () {
					var formSubmitted = formCtrl.$submitted;
					var input = formCtrl[inputName];
					if (input === undefined) {
						$log.warn('Input ' + inputName + ' not found in submitted form');
					} else {
						var inputInvalid = input.$invalid;
						var inputDirty = input.$dirty;
						var inputPending = input.$pending;
						if (inputPending) {
							// ne modifie pas le style pendant une validation asynchrone.
						} else {
							el.toggleClass('has-error', inputInvalid && (formSubmitted || inputDirty));
						}
					}
				});
			}
		};

		return directive;
	}
})();

/**
 * Permet d'initialiser les datetimepicker et les rendre compatible avec Angular
 */
angular.module('app').directive('gifDatetimepicker', function() {
	return {
		restrict : 'A',
		require : 'ngModel',
		link : function(scope, element, attrs, ngModelCtrl) {
			var parent = $(element).parent();
			var dtp = parent.datetimepicker({
				format : 'DD/MM/YYYY HH:mm',
				locale : 'fr',
				useCurrent : false,
				sideBySide : true
			});
			dtp.on('dp.change', function(e) {
				ngModelCtrl.$setViewValue(e.date.toDate());
				scope.$apply();
			});
		}
	};
});

/**
 * Directive permettant d'ajouter / retirer un élément au DOM selon que la personne est connectée ou non.
 * Exemple : <div gif-authenticated>visible uniquement si la personne est connectée</div>
 *
 * Utilise la fonction SecurityService.isAuthenticated().
 */
(function () {
	'use strict';

	angular.module('app')
		.directive('gifAuthenticated', gifAuthenticated);

	/** @ngInject */
	function gifAuthenticated(SecurityService, $rootScope, ngIfDirective) {
		var ngIf = ngIfDirective[0];
		return {
			transclude: ngIf.transclude,
			priority: ngIf.priority,
			terminal: ngIf.terminal,
			restrict: ngIf.restrict,
			link: function ($scope, $element, $attr) {

				$attr.ngIf = function () {
					return SecurityService.isAuthenticated();
				};
				ngIf.link.apply(ngIf, arguments);
			}
		};
	}
})();

/**
 * Directive permettant d'ajouter / retirer un élément au DOM selon que la personne est connectée ou non.
 * Exemple : <div gif-anonymous>visible uniquement si la personne n'est pas connectée</div>
 *
 * Utilise la fonction SecurityService.isAnonymous().
 */
(function () {
	'use strict';

	angular.module('app')
		.directive('gifAnonymous', gifAnonymous);

	/** @ngInject */
	function gifAnonymous(SecurityService, $rootScope, ngIfDirective) {
		var ngIf = ngIfDirective[0];
		return {
			transclude: ngIf.transclude,
			priority: ngIf.priority,
			terminal: ngIf.terminal,
			restrict: ngIf.restrict,
			link: function ($scope, $element, $attr) {

				$attr.ngIf = function () {
					return SecurityService.isAnonymous();
				};
				ngIf.link.apply(ngIf, arguments);
			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('app.security')
		.service('UtilisateurWS', Service);

	/** @ngInject */
	function Service($http) {
		var service = this;

		service.validateLienResetPassword = function (user) {
				return $http.get('/api/utilisateur/renew/validate', {
						params: {
							'token':user.token,
							'username': user.username
						}
				});
		};

		service.resetPassword = function (user) {
			return $http.put('/api/utilisateur/renew?token=' + user.token + '&username=' + user.username + '&password=' + user.password);
			//return $http.put('/api/utilisateur/renew', {
			//	params: {
			//		'token':user.token,
			//		'username': user.username,
			//		'password': user.password
			//	}
			//});
		};

		service.sendPasswordResetMail = function (usernameOrEmail) {
			// Performs an XHR form authentication
			return $http.post('api/utilisateur/renew-password', $.param({'usernameOrEmail': usernameOrEmail}), {
				headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
			});
		};

		service.getCurrentUser = function () {
			return $http.get('api/utilisateur/current').then(function (response) {
				var data = response.data;
				return {
					id: data.id,
					username: data.username,
					fullname: data.firstname + ' ' + data.lastname,
					roles: data.role,
					investigateurId : data.investigateur !== null ? data.investigateur.id : null,
					beneficiaireId : data.beneficiaire !== null ? data.beneficiaire.id : null
				};
			});
		};

		service.logout = function () {
			return $http.get('api/logout');
		};

		service.authenticate = function (credentials) {
			var params = {
				'username': credentials.username,
				'password': credentials.password
			};

			if (credentials.rememberMe) {
				params['remember-me'] = 'true';
			}

			// Performs an XHR form authentication
			return $http.post('api/login', params, {
				headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
				transformRequest: function (data) {
					return $.param(data);
				}
			});
		};

	}
})();

(function () {
	'use strict';

	angular
		.module('app.security')
		.config(stateConfig);

	/** @ngInject */
	function stateConfig($stateProvider) {
		$stateProvider.state('security', {
			abstract: true,
			parent: 'layout',
			url: '/security',
			templateUrl: 'app/security/security.html'
		});

		$stateProvider.state('connexion', {
			url: '/connexion?redirectTo',
			templateUrl: 'app/security/connexion/Connexion.html',
			controller: 'ConnexionController',
			controllerAs: 'controller',
			params: {
				credentials: undefined
			}
		});

		$stateProvider.state('mot-de-passe-oublie', {
			url: '/mot-de-passe-oublie',
			templateUrl: 'app/security/mot-de-passe-oublie/MotDePasseOublie.html',
			controller: 'MotDePasseOublieController',
			controllerAs: 'ctrl'
		});

		$stateProvider.state('nouveau-mot-de-passe', {
			url: '/nouveau-mot-de-passe?username&token',
			templateUrl: 'app/security/nouveau-mot-de-passe/NouveauMotDePasse.html',
			controller: 'NouveauMotDePasseController',
			controllerAs: 'ctrl'
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('app.security')
		.service('RoleWS', Service);

	/** @ngInject */
	function Service($http) {
		var service = this;

		service.getRoles = function () {
			return $http.get('/api/enum/role').then(function (response) {
				return response.data;
			});
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.projet').config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {

		// State abstrait : Parent
		$stateProvider
			.state('projet', {
				abstract: true,
				parent: 'layout',
				url: '/projet',
				templateUrl: 'app/projet/projet.html'
			});

		// State concret
		$stateProvider
			.state('projet.list', {
				url: '/list',
				parent: 'projet',
				templateUrl: 'app/projet/list/projetList.html',
				controller: 'ProjetListController',
				controllerAs: 'ctrl'
			});

		//Route pour le détail d'un projet
		$stateProvider.state('projet.item', {
			url: '/:id?edit',
			parent: 'projet',
			templateUrl: 'app/projet/item/ProjetItem.html',
			controller: 'ProjetItemController',
			controllerAs: 'ctrl'
		});
	}

})();

(function () {
	'use strict';

	angular
		.module('app')
		.controller('LayoutController', Controller);

	/** @ngInject */
	function Controller($rootScope, $state, SecurityService,$log) {
		var layoutCtrl = this;
		$rootScope.currentState = $state.current.name;

		layoutCtrl.goToProfil = function (id) {
			$state.go('security.utilisateur', {id: id});
		};

		var initUserSessionSuccess = function () {
			layoutCtrl.userDetails = SecurityService.getUserDetails();
		};

		var logoutFailure = function () {
			$log.error('Logout fails.');
		};

		var logoutSuccess = function () {
			$state.go('connexion');
		};

		layoutCtrl.logout = function () {
			localStorage.clear();
			SecurityService.logout().then(logoutSuccess, logoutFailure);
		};

		SecurityService.initUserSession(false).then(initUserSessionSuccess);

		$rootScope.$on('$stateChangeStart',
			function (event, toState) {
				$log.debug(toState.name);
				$rootScope.currentState = toState.name;
			});
	}
})();

(function () {
	'use strict';

	angular.module('app.operation').config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {

		// State abstrait : Parent
		$stateProvider
			.state('operation', {
				abstract: true,
				parent: 'layout',
				url: '/operation',
				templateUrl: 'app/operation/operation.html'
			});

		// State concret
		$stateProvider
			.state('operation.list', {
				url: '/list',
				parent: 'operation',
				templateUrl: 'app/operation/list/OperationList.html',
				controller: 'OperationListController',
				controllerAs: 'ctrl',
				params: {
					id : ':id',
					operation : ':operation',
					etablissementId: ':etablissementId',
					status : ':status',
					AValiderParEtablissement : ':AValiderParEtablissement'
					}
			});

		// Route pour le détail d'une demande de remboursement
		$stateProvider.state('operation.item_demande_remboursement', {
			url: '/demande/remboursement/:id?edit',
			parent: 'operation',
			templateUrl: 'app/operation/item/demande_remboursement/DemandeRemboursementItem.html',
			controller: 'DemandeRemboursementItemController',
			controllerAs: 'ctrl'
		});
		
		// Route pour le détail d'une demande d'achat
		$stateProvider.state('operation.item_demande_achat', {
			url: '/demande/achat/:id?edit',
			parent: 'operation',
			templateUrl: 'app/operation/item/demande_achat/DemandeAchatItem.html',
			controller: 'DemandeAchatItemController',
			controllerAs: 'ctrl'
		});
		
		// Route pour le détail d'une demande de mission
		$stateProvider.state('operation.item_demande_mission', {
			url: '/demande/mission/:id?edit',
			parent: 'operation',
			templateUrl: 'app/operation/item/demande_mission/DemandeMissionItem.html',
			controller: 'DemandeMissionItemController',
			controllerAs: 'ctrl',
			params: {
				id:null,
				demande: null
			}
		});
		
		// Partie detail pour la demande de mission
		$stateProvider.state('operation.item_demande_mission.etape', {
			url: '/demande/mission/etape/new',
			parent: 'operation',
			templateUrl: 'app/operation/item/demande_mission/detail/Etape.html',
			controller: 'EtapeController',
			controllerAs: 'ctrl',
			params: {
				id:null,
				demande: null
			}
		});
		
		// Partie detail pour la demande de mission
		$stateProvider.state('operation.item_demande_mission.detail', {
			url: '/demande/mission/detail',
			parent: 'operation',
			templateUrl: 'app/operation/item/demande_mission/detail/Detail.html',
			controller: 'DetailController',
			controllerAs: 'ctrl',
			params: {
				id:null,
				demande: null
			}
		});
		
		$stateProvider.state('operation.item_demande_mission.detail.categorie', {
			url: '/categorie',
			parent: 'operation.item_demande_mission.detail',
			templateUrl: 'app/operation/item/demande_mission/detail/DetailCategorie.html'
		});
		
		$stateProvider.state('operation.item_demande_mission.detail.information', {
			url: '/information',
			parent: 'operation.item_demande_mission.detail',
			templateUrl: 'app/operation/item/demande_mission/detail/DetailInformation.html'
		});
		
		$stateProvider.state('operation.item_demande_mission.detail.estimation', {
			url: '/estimation',
			parent: 'operation.item_demande_mission.detail',
			templateUrl: 'app/operation/item/demande_mission/detail/DetailEstimation.html'
		});
	}

})();

(function () {
	'use strict';

	angular.module('app.dashboardGeneral', ['app']).service('dashboardGeneralWS', Service);

	/** @ngInject */
	function Service() {
		//var service = this;
	
	}
})();

(function() {
	'use strict';

	angular.module('app.compte').service('CompteWS', Service);

	/** @ngInject */
		function Service($http) {
		var service = this;

		service.getListCompte = function(active, searchText, paging) {
			var params = {
				'actif' : active,
				'searchText' : searchText
			};

			params = _.extend(params, paging);

			return $http.get('/api/compte', {
				'params' : params
			});
		};

		service.loadTypologiesCompte = function() {
			return $http.get('/api/enum/typologie_compte');
		};

		service.getOne = function(id) {
			return $http.get('/api/compte/' + id);
		};

		service.saveOrUpdate = function(compte) {

			if (compte.id) {

				return $http.put('/api/compte', compte);
			} else {
				return $http.post('/api/compte', compte);
			}
		};

		service.validateCode = function(compte, value) {
			if (compte.id !== undefined) {
				return $http.get('/api/compte/validateCode?id=' + compte.id + '&code=' + value);
			} else {
				return $http.get('/api/compte/validateCode?code=' + value);
			}
		};

		service.autocomplete = function(searchText, id) {
			return $http.get('/api/compte', {
				'params' : {
					'actif' : true,
					'searchText' : searchText
				}
			}).then(
					function(response) {
						if (id) {

							response.data.content = _.reject(
									response.data.content, function(compte) {
										return compte.etablissement.id !== id;
									});
							return response.data.content;
						} else {
							return response.data.content;
						}
					});
		};

		service.updateCompteImport = function (id) {
			return $http.put('/api/compte/updateEasydore/' + id)
				.then(function (response) {
					return response.data.content;
				});
		};

	}
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ApiController', Controller);

    /** @ngInject */
    function Controller($rootScope, $state, $log, SecurityService) {
        var apiCtrl = this;
        $rootScope.currentState = $state.current.name;

        apiCtrl.isLoading = false;
        apiCtrl.url = '/v2/api-docs';

        apiCtrl.goToProfil = function (id) {
            $state.go('security.utilisateur', {id: id});
        };

        var initUserSessionSuccess = function () {
            apiCtrl.userDetails = SecurityService.getUserDetails();
        };

        var logoutFailure = function () {
            $log.error('Logout fails.');
        };

        var logoutSuccess = function () {
            $state.go('connexion');
        };

        apiCtrl.logout = function () {
            localStorage.clear();
            SecurityService.logout().then(logoutSuccess, logoutFailure);
        };

        SecurityService.initUserSession(false).then(initUserSessionSuccess);

        $rootScope.$on('$stateChangeStart',
            function (event, toState) {
                $log.debug(toState.name);
                $rootScope.currentState = toState.name;
            });
    }
})();

(function () {
    'use strict';

    angular.module('app').config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider.state('layout', {
            abstract: true,
            templateUrl: 'app/app.html',
            controller: 'LayoutController',
            controllerAs: 'layoutCtrl'
        }).state('api',{
            url : '^/api',
            templateUrl: 'app/api/api.html',
            controller: 'ApiController',
            controllerAs: 'apiCtrl'
        });

        $urlRouterProvider.otherwise('/connexion');
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .constant('constant', {
            'baseURI': '/api'
        });
})();

(function () {
	'use strict';

	angular
		.module('app')
		.config(mainConfig)
		.config(toastr)
		.config(i18n)
		.config(transformIso8601StringsToDates)
		.config(uibDatepickerDefaultConfiguration)
		.config(uibDatepickerPopupDefaultConfiguration);

	/** @ngInject */
	function mainConfig($logProvider, cfpLoadingBarProvider) {
		// Enable log
		$logProvider.debugEnabled(true);
		// Suppression du spinner lors des chargement XHR
		cfpLoadingBarProvider.includeSpinner = false;
	}


	/** @ngInject */
	function toastr(toastrConfig) {
		angular.extend(toastrConfig, {
			'closeButton': true,
			'debug': false,
			'newestOnTop': true,
			'progressBar': false,
			'positionClass': 'toast-top-right',
			'preventDuplicates': false,
			'showDuration': '200',
			'hideDuration': '200',
			'timeOut': '2000',
			'extendedTimeOut': '1000',
			'showEasing': 'easeOutBounce',
			'hideEasing': 'easeInBack',
			'showMethod': 'fadeIn',
			'hideMethod': 'fadeOut'
		});
	}

	/** @ngInject */
	function i18n($translateProvider) {
		$translateProvider.useStaticFilesLoader({
			prefix: 'resources/locale-',// path to translations files
			suffix: '.json'// suffix, currently- extension of the translations
		});
		$translateProvider.preferredLanguage('fr_FR');// is applied on first load
		$translateProvider.useSanitizeValueStrategy('escape');
		$translateProvider.useMissingTranslationHandlerLog();
	}


	var regexIso8601 = /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})\.?(\d{0,})(Z|([\-+])(\d{2}):(\d{2}))?)?)?)+$/;

	/**
	 * Fonction qui parcours les propriétés d'un objet JS récursivement et convertir
	 * tous les attributs de type string qui matchent le format Iso8601 en objet Date.
	 *
	 * Adaptation de cet article : http://aboutcode.net/2013/07/27/json-date-parsing-angularjs.html (regex affinée)
	 *
	 * @param un objets dont on souhaite convertir les propriétés
	 * @returns l'objet convertir
	 */
	function convertDateStringsToDates(input) {
		// Ignore things that aren't objects.
		if (typeof input !== 'object') {
			return input;
		}

		for (var key in input) {
			if (!input.hasOwnProperty(key)) {
				continue;
			}

			var value = input[key];
			var match;
			// Check for string properties which look like dates.
			if (typeof value === 'string' && (match = value.match(regexIso8601))) {
				// Assume that Date.parse can parse ISO 8601 strings, or has been shimmed in older browsers to do so.
				var milliseconds = Date.parse(match[0]);
				if (!isNaN(milliseconds)) {
					input[key] = new Date(milliseconds);
				}
			} else if (typeof value === 'object') {
				// Recurse into object
				convertDateStringsToDates(value);
			}
		}
	}

	/** @ngInject */
	function transformIso8601StringsToDates($httpProvider) {
		$httpProvider.defaults.transformResponse.push(function (responseData) {
			convertDateStringsToDates(responseData);
			return responseData;
		});
	}

	/** @ngInject */
	function uibDatepickerDefaultConfiguration(uibDatepickerConfig) {
		uibDatepickerConfig.startingDay = 1;
		uibDatepickerConfig.showWeeks = false;
	}

	/** @ngInject */
	function uibDatepickerPopupDefaultConfiguration(uibDatepickerPopupConfig) {
		uibDatepickerPopupConfig.showButtonBar = false;
		uibDatepickerPopupConfig.onOpenFocus = false;
	}


})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/app.html","<ng-include src=\"\'app/layout/header.html\'\"></ng-include> <div class=col-md-2> <div ng-if=\"layoutCtrl.currentState != \'security.renew\'\"> <div id=menuLeftUp ng-include=\"\'app/layout/menu.html\'\"></div> <div id=menuBorder> <span class=border></span> </div> <div id=menuLeftDown> <span class=border></span> <div ng-if=\"currentState.indexOf(\'projet\') !== -1\" ng-include=\"\'app/layout/menuProjet.html\'\"></div> <div ng-if=\"currentState.indexOf(\'compte\') !== -1\" ng-include=\"\'app/layout/menuCompte.html\'\"></div> <div ng-if=\"currentState.indexOf(\'operation\') !== -1\" ng-include=\"\'app/layout/menuOperation.html\'\"></div> <div ng-if=\"currentState.indexOf(\'security\') != -1\" ng-include=\"\'app/layout/menuSecurity.html\'\"></div> <div ng-if=\"currentState.indexOf(\'referentiel\') != -1\" ng-include=\"\'app/layout/menuReferentiel.html\'\"></div> <div ng-if=\"currentState.indexOf(\'dashboard\') !== -1\" ng-include=\"\'app/layout/menuDashBoard.html\'\"></div> </div> </div> </div> <div class=\"container-fluid col-md-10\" ui-view> </div>");
$templateCache.put("app/default-messages.html","<small ng-message=badFile>Fichier trop volumineux (au dessus de 20Mo).</small> <small ng-message=badFileRemove>Fichier trop volumineux (au dessus de 20Mo). Le ou les fichiers concernés ont été supprimés de la liste</small> <small ng-message=required>Obligatoire</small> <small ng-message=date>Format incorrect</small> <small ng-message=dateEndIsAfterDateStart>Antérieure à la date de début</small> <small ng-message=dateStartIsAfterDateEnd>Postérieure à la date de fin</small> <small ng-message=editable>Sélectionnez une valeur dans la liste</small> <small ng-message=badMontant>Mauvaise valeur</small> <small ng-message=number>Format non valide</small> <small ng-message=min>Format non valide</small> <small ng-message=max>Format non valide</small> <small ng-message=server.solde_insuffisant>Montant supérieur au solde disponible</small> <small ng-message=unique>Ce code est déjà utilisé.</small> <small ng-message=ngIban>Format IBAN incorrect</small> <small ng-message=pattern>Format incorrect</small> <small ng-message=badMontantPartiel>Supérieur au montant</small> <small ng-message=codeUnique>Code déjà utilisé</small> <small ng-message=maxlength>Nombre de caractère trop important (Max: 255)</small> <small ng-message=tel>Format du numéro de téléphone est incorrect</small>");
$templateCache.put("app/api/api.html","<ng-include ng-controller=\"ApiController as layoutCtrl\" src=\"\'app/layout/header.html\'\"></ng-include> <div ng-controller=ApiController class=\"container my-ctrl\"> <h3 ng-show=isLoading swagger-translate=loading></h3> <div swagger-ui apissorter=\"\'alpha\'\" url=apiCtrl.url api-explorer=true></div> </div>");
$templateCache.put("app/compte/compte.html","<div class=row> <div class=col-md-12> <div ui-view></div> </div> </div>");
$templateCache.put("app/dashboard/dashboard.html","<ui-view>");
$templateCache.put("app/layout/header.html","<div id=navbar class=\"navbar navbar navbar-default navbar-static-top\"> <ul class=\"nav navbar-nav navbar-right\"> <li gif-authenticated> <div class=\"btn-group navbar-text\" uib-dropdown is-open=status.isopen> <button id=single-button type=button class=\"btn btn-link\" uib-dropdown-toggle ng-disabled=disabled> <span class=\"glyphicon glyphicon-user\" aria-hidden=true></span> {{layoutCtrl.userDetails.fullname}} <span class=caret></span> </button> <ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button> <li role=menuitem><a ng-click=layoutCtrl.goToProfil(layoutCtrl.userDetails.id)>Profil</a></li> <li role=menuitem><a ng-click=layoutCtrl.logout()>Déconnexion</a></li> </ul> </div> </li> </ul> </div>");
$templateCache.put("app/layout/menu.html","<ul id=menu class=\"nav nav-pills nav-stacked\" gif-role=\"ADMIN, FINANCIER, INTERLOCUTEUR\"><!-- Menu Utilisateurs MEDES --> <li ui-sref-active=\"{\'active\': \'projet.*\'}\"> <a ui-sref=projet.list>Projet</a> </li> <li ui-sref-active=\"{\'active\': \'compte.*\'}\"> <a ui-sref=compte.list>Compte</a> </li> <li ui-sref-active=\"{\'active\': \'operation.*\'}\"> <a ui-sref=operation.list>Opération</a> </li> <li ui-sref-active=\"{\'active\': \'security.*\'}\" gif-role=ADMIN> <a ui-sref=security.utilisateurs>Sécurité</a> </li> <li ui-sref-active=\"{\'active\': \'referentiel.*\'}\"> <a ui-sref=referentiel.etablissement>Réferentiel</a> </li> <li ui-sref-active=\"{\'active\': \'dashboard.*\'}\"> <a ui-sref=dashboard.dashboardGeneral>Tableau de Bord</a> </li> </ul> <ul id=menu class=\"nav nav-pills nav-stacked\" gif-role=ETABLISSEMENT><!-- Menu Utilisateurs ayant le rôle ETABLISSEMENT --> <li ui-sref-active=\"{\'active\': \'projet.*\'}\"> <a ui-sref=projet.list>Projet</a> </li> <li ui-sref-active=\"{\'active\': \'compte.*\'}\"> <a ui-sref=compte.list>Compte</a> </li> <li ui-sref-active=\"{\'active\': \'operation.*\'}\"> <a ui-sref=operation.list>Opération</a> </li> <li ui-sref-active=\"{\'active\': \'referentiel.*\'}\"> <a ui-sref=referentiel.etablissement>Réferentiel</a> </li> <li ui-sref-active=\"{\'active\': \'dashboard.*\'}\"> <a ui-sref=dashboard.dashboardGeneral>Tableau de Bord</a> </li> </ul> <ul id=menu class=\"nav nav-pills nav-stacked\" gif-role=INVESTIGATEUR><!-- Menu utilisateurs ayant le rôle INVESTIGATEUR --> <li ui-sref-active=\"{\'active\': \'projet.*\'}\"> <a ui-sref=projet.list>Projet</a> </li> <li ui-sref-active=\"{\'active\': \'compte.*\'}\"> <a ui-sref=compte.list>Compte</a> </li> <li ui-sref-active=\"{\'active\': \'operation.*\'}\"> <a ui-sref=operation.list>Opération</a> </li> <li ui-sref-active=\"{\'active\': \'referentiel.*\'}\"> <a ui-sref=referentiel.beneficiaire>Réferentiel</a> </li> <li ui-sref-active=\"{\'active\': \'dashboard.*\'}\"> <a ui-sref=dashboard.dashboardGeneral>Tableau de Bord</a> </li> </ul> <ul id=menu class=\"nav nav-pills nav-stacked\" gif-role=BENEFICIAIRE><!-- Menu utilisateurs ayant le rôle BENEFICIAIRE --> <li ui-sref-active=\"{\'active\': \'operation.*\'}\"> <a ui-sref=operation.list>Opération</a> </li> </ul>");
$templateCache.put("app/layout/menuCompte.html","<span gif-role=!BENEFICIAIRE> <a class=\"btn-submenu btn-block\" ng-class=\"{\'active\': currentState == \'compte.list\' || currentState == \'compte.item\'}\" ui-sref=compte.list>Comptes</a> <hr> <a class=\"btn-submenu btn-block\" ng-class=\"{\'active\': currentState.indexOf(\'virement\') != -1}\" ui-sref=compte.virement>Virements</a> </span>");
$templateCache.put("app/layout/menuDashBoard.html","<a class=\"btn-submenu btn-block\" ui-sref-active=active ui-sref=dashboard.dashboardGeneral>Tableau de Bord</a>");
$templateCache.put("app/layout/menuOperation.html","<a class=\"btn-submenu btn-block\" ui-sref-active=\"{\'active\': \'operation.*\'}\" ui-sref=operation.list>Opérations</a>");
$templateCache.put("app/layout/menuProjet.html","<span gif-role=!BENEFICIAIRE> <a class=\"btn-submenu btn-block\" ng-class=\"{\'active\': currentState == \'projet.list\' || currentState == \'projet.item\'}\" ui-sref=projet.list>Projets</a> <hr> <span gif-role=!INVESTIGATEUR><a class=\"btn-submenu btn-block\" ng-class=\"{\'active\': currentState.indexOf(\'facturation\') != -1}\" ui-sref=projet.facturation>Facturations</a></span> <span gif-role=!INVESTIGATEUR><a class=\"btn-submenu btn-block\" ui-sref-active=active ui-sref=projet.importEasydore>Import EASY</a></span> </span>");
$templateCache.put("app/layout/menuReferentiel.html","<span gif-role=\"!BENEFICIAIRE, !INVESTIGATEUR\"> <a gif-role=!INVESTIGATEUR class=\"btn-submenu btn-block\" ui-sref-active=active ui-sref=referentiel.etablissement ng-class=\"{\'active\': currentState == \'referentiel.etablissement_item\'}\">Etablissements</a> <a gif-role=!INVESTIGATEUR class=\"btn-submenu btn-block\" ui-sref-active=active ui-sref=referentiel.investigateur ng-class=\"{\'active\': currentState == \'referentiel.investigateur_item\'}\">Investigateurs</a> <a class=\"btn-submenu btn-block\" ui-sref-active=active ui-sref=referentiel.beneficiaire ng-class=\"{\'active\': currentState == \'referentiel.beneficiaire_item\'}\">Bénéficiaires</a> <a gif-role=!INVESTIGATEUR class=\"btn-submenu btn-block\" ui-sref-active=active ui-sref=referentiel.financeur ng-class=\"{\'active\':currentState == \'referentiel.financeur_item\'}\">Financeurs</a> <a gif-role=ADMIN class=\"btn-submenu btn-block\" ui-sref-active=active ui-sref=referentiel.tva>TVA</a> <a gif-role=!INVESTIGATEUR class=\"btn-submenu btn-block\" ui-sref-active=active ui-sref=referentiel.promoteur ng-class=\"{\'active\': currentState == \'referentiel.promoteur_item\'}\">Promoteurs</a> <a gif-role=!INVESTIGATEUR class=\"btn-submenu btn-block\" ui-sref-active=active ui-sref=referentiel.fournisseur ng-class=\"{\'active\': currentState == \'referentiel.fournisseur_item\'}\">Fournisseurs</a> <a gif-role=!INVESTIGATEUR class=\"btn-submenu btn-block\" ui-sref-active=active ui-sref=referentiel.category ng-class=\"{\'active\': currentState == \'referentiel.category_item\'}\">Cat. dépenses</a> </span>");
$templateCache.put("app/layout/menuSecurity.html","<span gif-role=ADMIN> <a class=\"btn-submenu btn-block\" ui-sref-active=\"{\'active\': \'security.utilisateurs\'}\" ui-sref=security.utilisateurs>Utilisateurs</a> <a class=\"btn-submenu btn-block\" ng-class=\"{\'active\': currentState == \'security.configurationBanner\' || currentState == \'security.configurationBanner_item\'}\" ui-sref=security.configurationBanner>Bandeau d\'information</a> </span>");
$templateCache.put("app/projet/projet.html","<ui-view>");
$templateCache.put("app/operation/operation.html","<ui-view>");
$templateCache.put("app/referentiel/referentiel.html","<div class=row> <div class=col-md-12> <div ui-view></div> </div> </div>");
$templateCache.put("app/security/security.html","<div class=row> <div class=col-md-12> <div ui-view></div> </div> </div>");
$templateCache.put("app/compte/item/CompteItem.html","<div class=header> <h1 ng-if=ctrl.isUpdate>Compte - {{ctrl.compte.libelle}}</h1> <h1 ng-if=!ctrl.isUpdate>Ajout d\'un compte</h1> <hr> </div> <div class=main><!-- Le ng-class permet de mettre les bordure en rouge pour les champ obligatoire --> <form name=form ng-class=\"{\'submitted\': submitted}\" ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.compte)\" novalidate> <div class=form-group> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <label class=control-label> Code </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.code.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=id_code name=code ng-disabled=true ng-model=ctrl.compte.code type=text class=form-control gif-validate-async=\"{unique: ctrl.validateCode}\"> </div> </div> <div class=col-md-6> <div class=form-group> <label> Statut </label> <div ng-if=ctrl.isDesactivationImpossible> <toggle-switch uib-tooltip=\"ce compte possède des opérations en cours. Il ne peut être désactivé\" is-disabled=ctrl.isDesactivationImpossible id=enabledInput ng-model=ctrl.compte.actif on-label=Actif off-label=Inactif> </toggle-switch> </div> <div ng-if=!ctrl.isDesactivationImpossible> <toggle-switch is-disabled=\"ctrl.isDesactivationImpossible || ctrl.consultation\" id=enabledInput ng-model=ctrl.compte.actif on-label=Actif off-label=Inactif> </toggle-switch> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Libellé </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.libelle.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=id_libelle name=libelle ng-disabled=\"ctrl.disable || ctrl.consultation\" ng-model=ctrl.compte.libelle type=text class=form-control ng-maxlength=255 required> </div> </div> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label for=titulaire> Titulaire </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.titulaire.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=custom-typeahead> <div class=\"input-group col-md-12\" gif-role=INVESTIGATEUR> <input ng-disabled=true name=titulaire ng-model=ctrl.invest typeahead-editable=false type=text class=form-control required> </div> <div class=\"input-group col-md-12\" gif-role=\"ADMIN, ETABLISSEMENT\"> <input ng-selected=ctrl.onChangeTitulaire(ctrl.compte.titulaire) name=titulaire ng-model=ctrl.compte.titulaire uib-typeahead=\"titulaire as (titulaire.nom +\' \'+ titulaire.prenom + \' (\' + titulaire.etablissement.code + \')\' ) for titulaire in ctrl.autocompleteInvestigateur($viewValue)\" typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher... ng-disabled=ctrl.consultation required> <span ng-show=ctrl.compte.titulaire class=input-group-btn> <a href=/#/referentiel/investigateur/{{ctrl.compte.titulaire.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Typologie</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.typologie.$error ng-if=form.typologie.$touched> <ng-messages-include src=app/default-messages.html> </ng-messages> <select name=typologie class=form-control ng-disabled=\"ctrl.disable || ctrl.consultation\" ng-model=ctrl.compte.typologie ng-init=\"ctrl.compte.typologie=\'INDIVIDUEL\'\" ng-options=\"typologie as typologie  | translate for typologie in ctrl.typologies\" required><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> </div> </div> <div class=col-md-6> <div class=form-group gif-has-error> <label class=control-label> Etablissement</label> <div class=form-group> <input ng-disabled=true name=etablissement ng-model=ctrl.compte.etablissement.libelle class=form-control> <span ng-show=ctrl.compte.etablissement class=input-group-btn gif-role=ADMIN> <a href=/#/referentiel/etablissement/{{ctrl.compte.etablissement.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </div> </div> <div class=row> <div> <label class=col-md-2>Solde disponible : </label> <div class=text-primary> <strong>{{ctrl.compte.solde | number:2}} €</strong> </div> </div> </div> <uib-tabset active=active> <uib-tab index=0 heading=Opération> <div class=row> <div class=col-md-12> <div ng-if=ctrl.compte.operations> <div class=table-responsive> <table class=\"table table-striped table-condensed\"> <thead> <th class=text-primary>Date</th> <th class=text-primary>Opération</th> <th class=text-primary>Typologie</th> <th class=text-primary>Débit</th> <th class=text-primary>Crédit</th> <th class=text-primary>Statut</th> </thead> <tbody> <tr class=table_row ng-click=ctrl.goTo(operation) ng-repeat=\"operation in ctrl.compte.operations | orderBy:\'-id\' | limitTo:limit\"> <td>{{operation.date | date:\'dd/MM/yyyy\'}}</td> <td>{{operation.operation}}</td> <td>{{operation.typologie}}</td> <td class=text-danger> <strong ng-show=\"operation.debit != 0\">{{operation.debit | number:2}}</strong> </td> <td class=text-success> <strong ng-show=\"operation.credit != 0\">{{operation.credit | number:2}}</strong> </td> <td>{{operation.statut}}</td> </tr> </tbody> </table> <div class=\"col-md-2 col-md-offset-5\"> <button type=button ng-click=ctrl.viewMore(); class=\"btn btn-default btn-sm\">Afficher davantage</button> </div> </div> </div> </div> </div> </uib-tab> <uib-tab index=1 heading=Investigateur> <div class=row> <div class=col-md-12> <h3> Investigateurs <button ng-hide=\"ctrl.disable || ctrl.consultation\" ng-click=ctrl.addInvestigateur() type=button class=\"btn btn-link btn-sm\"> <span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span> Ajouter </button> </h3> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-10\">Nom</th> <th ng-hide=ctrl.disable></th> </thead> <tbody> <tr> <input ng-show=false ng-disabled=true ng-model=ctrl.investigateurCompte.compte type=text class=form-control> </tr> <tr class=table_row ng-repeat=\"i in ctrl.compte.investigateurs\"> <td> <div class=custom-typeahead> <div ng-class=\"{\'input-group\': i.investigateur}\"> <input ng-disabled=\"ctrl.disable || ctrl.consultation\" name=investigateur ng-model=i.investigateur uib-typeahead=\"investigateur as (investigateur.nom +\' \'+ investigateur.prenom) for investigateur in ctrl.autocompleteInvestigateur($viewValue,ctrl.compte.etablissement.id)\" typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher...> <span ng-show=i.investigateur class=input-group-btn> <a href=/#/referentiel/investigateur/{{i.investigateur.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </td> <td ng-hide=\"ctrl.disable || ctrl.consultation\" style=\"vertical-align: middle; text-align: center\"> <a ng-click=ctrl.removeInvestigateur($index)> <span title=\"Retirer un contact\" class=\"glyphicon glyphicon-trash\" aria-hidden=true></span> </a> </td> </tr> </tbody> </table> </div> </div> </uib-tab> <uib-tab index=2 heading=Bénéficiaire> <div class=row> <div class=col-md-12> <h3> Bénéficiaires <button ng-hide=\"ctrl.disable || ctrl.consultation\" ng-click=ctrl.addBeneficiaire() type=button class=\"btn btn-link btn-sm\"> <span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span> Ajouter </button> </h3> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-10\">Nom</th> <th ng-hide=ctrl.disable></th> </thead> <tbody> <tr class=table_row ng-repeat=\"b in ctrl.compte.beneficiaires\"> <td> <div class=custom-typeahead> <div ng-class=\"{\'input-group\': b.beneficiaire}\"> <input ng-disabled=\"ctrl.disable || ctrl.consultation\" name=beneficiaire ng-model=b.beneficiaire uib-typeahead=\"beneficiaire as (beneficiaire.nom +\' \'+ beneficiaire.prenom +\' - \'+ beneficiaire.etablissement.libelle) for beneficiaire in ctrl.autocompleteBeneficiaire($viewValue,ctrl.compte.etablissement.id)\" typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher...> <span ng-show=b.beneficiaire class=input-group-btn> <a href=/#/referentiel/beneficiaire/{{b.beneficiaire.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </td> <td ng-hide=\"ctrl.disable || ctrl.consultation\" style=\"vertical-align: middle; text-align: center\"> <a ng-click=ctrl.removeBeneficiaire($index)> <span title=\"Retirer un contact\" class=\"glyphicon glyphicon-trash\" aria-hidden=true></span> </a> </td> </tr> </tbody> </table> </div> </div> </uib-tab> </uib-tabset> </div> <div class=row> <div class=form-group> <div class=col-md-12> <div class=footer> <div class=pull-right> <a class=\"btn btn-link\" href=/#/compte/list>Annuler</a> <button ng-hide=\"ctrl.disable || ctrl.consultation\" type=submit ng-click=\"submitted = true; \" class=\"btn btn-primary\">Enregistrer</button> </div> </div> </div> </div> </div> </form> </div>");
$templateCache.put("app/compte/list/CompteList.html","<div class=header> <h1>Compte</h1> <hr> <div class=row> <div class=col-md-2> <div class=\"btn-group btn-group-justified\"> <div class=btn-group> <button ng-class=\"{\'active\': ctrl.filterActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(true)>Actif</button> </div> <div class=btn-group> <button ng-class=\"{\'active\': !ctrl.filterActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(false)>Clos</button> </div> </div> </div> <div class=\"col-md-offset-5 col-md-4\"> <input id=searchCompte type=text class=form-control placeholder=Rechercher ng-model=ctrl.searchText ng-change=ctrl.onChangeSearchText(ctrl.searchText)> </div> <div class=col-md-1 ng-hide=ctrl.read> <button ng-click=ctrl.add() type=button class=\"pull-right btn btn-primary\">Ajouter</button> </div> </div> </div> <div ng-if=ctrl.page gif-paged-data=ctrl.onPagingOptionsChange(pagingOptions) gif-page-size={{ctrl.pageSize}}> <small class=text-muted> <span><strong>{{ctrl.page.number+1 * ctrl.page.size}}</strong> premiers comptes parmi <strong>{{ctrl.page.totalElements}}</strong> {{ctrl.page.totalElements > 1 ? \'résultats\' : \'résultat\'}}</span> </small> <table class=\"table table-striped table-condensed\"> <thead> <th class=text-primary>Intitulé</th> <th class=text-primary>Titulaire</th> <th class=text-primary>Typologie</th> <th class=text-primary>Solde disponible</th> </thead> <tbody> <tr ng-click=ctrl.goTo(compte.id) class=table_row ng-repeat=\"compte in ctrl.list\"> <td>{{compte.libelle}}</td> <td>{{compte.titulaire.nom}} {{compte.titulaire.prenom}}</td> <td>{{compte.typologie | translate}}</td> <td>{{compte.solde | number:2}} €</td> </tr> </tbody> </table> <div class=\"col-md-2 col-md-offset-5\"> <button ng-click=ctrl.viewMore() class=\"btn btn-default btn-sm\" ng-hide=ctrl.page.last> Afficher davantage </button> </div> </div>");
$templateCache.put("app/dashboard/dashboardGeneral/dashboardGeneral.html","<form id=graphForm name=form ng-class=\"{\'submitted\': submitted}\" ng-submit=form.$valid novalidate> <div class=header> <h1 ng-if=ctrl.statistique.etablissement>Tableau de bord - {{ctrl.statistique.etablissement.libelle}}</h1> <h1 ng-if=!ctrl.statistique.etablissement>Tableau de bord général</h1> <hr> <div class=row> <div class=\"col-md-offset-0 col-md-3\" gif-has-error> <label class=control-label>Etablissement</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.etablissement.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div ng-class=\"{\'input-group\': ctrl.statistique.etablissement}\"> <input ng-disabled=ctrl.disabled name=etablissement ng-model=ctrl.statistique.etablissement uib-typeahead=\"etablissement as (etablissement.code +\' - \'+ etablissement.libelle) for etablissement in ctrl.autocompleteEtablissement($viewValue)\" typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher... ng-change=ctrl.filtreEtablissement(ctrl.statistique.etablissement)> <span ng-show=ctrl.statistique.etablissement class=input-group-btn> <a href=/#/referentiel/etablissement/{{ctrl.statistique.etablissement.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </div> </div> <div class=body><!-- TABLEAU DE BORD ADMIN --> <div gif-role=ADMIN> <div class=row></div> <div class=row> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-2 align\"> <h4> <label class=\"control-label align\"> Remboursements </label> </h4> </div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-2 align\"> <h4> <label class=\"control-label align\"> Achats </label> </h4> </div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-2 align\"> <h4> <label class=\"control-label align\"> Missions </label> </h4> </div> <div class=\"text-primary col-md-1\"></div> </div> <div class=row> <div class=col-md-1></div> <div class=col-md-1> <div class=\"progress vertical\"> <a ng-click=\"ctrl.goToDemandeRemboursement(ctrl.statistique.etablissement.id,\'SOUMISE\')\"> <div class=\"progress-bar progress-bar-striped\" role=progressbar aria-valuenow=90 aria-valuemin=0 aria-valuemax=100 ng-style=\"{ width:ctrl.rbt.tauxRemplissageAV + \'%\' }\"></div> </a> </div> </div> <div class=col-md-1> <div class=\"progress vertical\"> <a ng-click=\"ctrl.goToDemandeRemboursement(ctrl.statistique.etablissement.id,\'VALIDE\')\"> <div class=\"progress-bar progress-bar-success progress-bar-striped\" role=progressbar aria-valuenow=90 aria-valuemin=0 type=warning aria-valuemax=100 ng-style=\"{ width: ctrl.rbt.tauxRemplissageAP + \'%\' }\"></div> </a> </div> </div> <div class=\"col-md-1 colonne2\"></div> <div class=col-md-1></div> <div class=col-md-1> <div class=\"progress vertical\"> <a ng-click=\"ctrl.goToDemandeAchat(ctrl.statistique.etablissement.id,\'SOUMISE\')\"> <div class=\"progress-bar progress-bar-striped\" role=progressbar aria-valuenow=90 aria-valuemin=0 aria-valuemax=100 ng-style=\"{ width: ctrl.achat.tauxRemplissageAV + \'%\' }\"></div> </a> </div> </div> <div class=\"text-primary col-md-1\"> <div class=\"progress vertical\"> <a ng-click=\"ctrl.goToDemandeAchat(ctrl.statistique.etablissement.id,\'RECEPTIONNE\')\"> <div class=\"progress-bar progress-bar-success progress-bar-striped\" role=progressbar aria-valuenow=90 aria-valuemin=0 type=warning aria-valuemax=100 ng-style=\"{ width: ctrl.achat.tauxRemplissageAP + \'%\' }\"></div> </a> </div> </div> <div class=\"col-md-1 colonne2\"></div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1\"> <div class=\"progress vertical\"> <a ng-click=\"ctrl.goToDemandeMission(ctrl.statistique.etablissement.id,\'SOUMISE\')\"> <div class=\"progress-bar progress-bar-striped\" role=progressbar aria-valuenow=90 aria-valuemin=0 aria-valuemax=100 ng-style=\"{ width: ctrl.mission.tauxRemplissageAV + \'%\' }\"></div> </a> </div> </div> <div class=\"text-primary col-md-1\"> <div class=progress_container> <div class=\"progress vertical\"> <a ng-click=\"ctrl.goToDemandeMission(ctrl.statistique.etablissement.id,\'RECEPTIONNE\')\"> <div class=\"progress-bar progress-bar-success progress-bar-striped\" role=progressbar aria-valuenow=90 aria-valuemin=0 type=warning aria-valuemax=100 ng-style=\"{ width: ctrl.mission.tauxRemplissageAP + \'%\' }\"></div> </a> </div> </div> </div> <div class=col-md-1></div> </div> <div class=row> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1 align\"> <label class=control-label> {{ctrl.rbt.statistiqueAV}} &agrave valider </label> </div> <div class=\"text-primary col-md-1 align\"> <label class=control-label> {{ctrl.rbt.statistiqueAP}} &agrave payer </label> </div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1 align\"> <label class=control-label> {{ctrl.achat.statistiqueAV}} &agrave valider </label> </div> <div class=\"text-primary col-md-1 align\"> <label class=control-label> {{ctrl.achat.statistiqueAP}} &agrave payer </label> </div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1 align\"> <label class=control-label> {{ctrl.mission.statistiqueAV}} &agrave valider </label> </div> <div class=\"text-primary col-md-1 align\"> <label class=control-label> {{ctrl.mission.statistiqueAP}} &agrave payer </label> </div> <div class=\"text-primary col-md-1\"></div> </div> </div><!-- TABLEAU DE BORD INTERLOCUTEUR / ETABLISSEMENT --> <div gif-role=\"INTERLOCUTEUR, ETABLISSEMENT\"> <div class=row></div> <div class=row> <div class=\"text-primary col-md-3 align\"> <h4> <label class=\"control-label align\"> Achats </label> </h4> </div> </div> <div class=row> <div class=\"text-primary col-md-1\"></div> <div class=col-md-1> <div class=\"progress vertical\"> <a ng-click=\"ctrl.goToDemandeAchat(ctrl.statistique.etablissement.id,\'SOUMISE\', true)\"> <div class=\"progress-bar progress-bar-striped\" role=progressbar aria-valuenow=90 aria-valuemin=0 aria-valuemax=100 ng-style=\"{ width: ctrl.achat.tauxRemplissageAV + \'%\' }\"></div> </a> </div> </div> </div> <div class=row> <div class=\"text-primary col-md-3 align\"> <label class=control-label> {{ctrl.achat.statistiqueAV}} &agrave valider</label> </div> </div> </div><!-- TABLEAU DE BORD INVESTIGATEUR --> <div gif-role=INVESTIGATEUR> <div class=row></div> <div class=row> <div class=\"text-primary col-md-3 align\"> <h4> <label class=\"control-label align\"> Remboursements </label> </h4> </div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1 align\"> <h4> <label class=\"control-label align\"> Achats </label> </h4> </div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-3 align\"> <h4> <label class=\"control-label align\"> Missions </label> </h4> </div> <div class=\"text-primary col-md-1\"></div> </div> <div class=row> <div class=col-md-1></div> <div class=col-md-1> <div class=\"progress vertical\"> <a ng-click=\"ctrl.goToDemandeRemboursement(ctrl.statistique.etablissement.id,\'ASOUMETTRE\')\"> <div class=\"progress-bar progress-bar-striped\" role=progressbar aria-valuenow=90 aria-valuemin=0 aria-valuemax=100 ng-style=\"{ width: ctrl.rbt.tauxRemplissageAS + \'%\' }\"></div> </a> </div> </div> <div class=\"col-md-1 colonne2\"></div> <div class=col-md-1></div> <div class=col-md-1> <div class=\"progress vertical\"> <a ng-click=\"ctrl.goToDemandeAchat(ctrl.statistique.etablissement.id,\'ASOUMETTRE\')\"> <div class=\"progress-bar progress-bar-striped\" role=progressbar aria-valuenow=90 aria-valuemin=0 aria-valuemax=100 ng-style=\"{ width: ctrl.achat.tauxRemplissageAS + \'%\' }\"></div> </a> </div> </div> <div class=\"col-md-1 colonne2\"></div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1\"> <div class=\"progress vertical\"> <a ng-click=\"ctrl.goToDemandeMission(ctrl.statistique.etablissement.id,\'ASOUMETTRE\')\"> <div class=\"progress-bar progress-bar-striped\" role=progressbar aria-valuenow=90 aria-valuemin=0 aria-valuemax=100 ng-style=\"{ width: ctrl.mission.tauxRemplissageAS + \'%\' }\"></div> </a> </div> </div> <div class=col-md-1></div> </div> <div class=row> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1 align\"> <label class=control-label> {{ctrl.rbt.statistiqueAS}} &agrave soumettre </label> </div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1 align\"> <label class=control-label> {{ctrl.achat.statistiqueAS}} &agrave soumettre </label> </div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1\"></div> <div class=\"text-primary col-md-1 align\"> <label class=control-label> {{ctrl.mission.statistiqueAS}} &agrave soumettre </label> </div> <div class=\"text-primary col-md-1\"></div> </div> </div> </div> </form>");
$templateCache.put("app/projet/item/ProjetItem.html","<div class=header> <h1 ng-if=ctrl.isUpdate>Projet - {{ctrl.projet.libelleAbrege}}</h1> <h1 ng-if=!ctrl.isUpdate>Nouveau projet</h1> <hr> </div> <form id=projetForm name=form ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.projet)\" gif-server-validate=ctrl.serverErrors novalidate> <div class=row> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=reference class=control-label>Référence</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.reference.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=reference ng-disabled=ctrl.disabled name=reference ng-model=ctrl.projet.reference type=text class=form-control ng-maxlength=255 required> </div> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=libelleAbrege class=control-label>Libellé abrégé</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.libelleAbrege.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=libelleAbrege ng-disabled=ctrl.disabled name=libelleAbrege ng-model=ctrl.projet.libelleAbrege type=text class=form-control ng-maxlength=255 required> </div> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=debut class=control-label>Date prévisionnelle de début</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.debut.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=input-group> <input id=debut ng-disabled=ctrl.disabled name=debut type=text class=form-control gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-model=ctrl.projet.debut is-open=dateDebutPopup.opened placeholder=jj/mm/aaaa ng-change=ctrl.validateDateDebut() required> <span class=input-group-btn> <button ng-disabled=ctrl.disabled type=button class=\"btn btn-default\" ng-click=\"dateDebutPopup.opened=true\"> <span class=\"glyphicon glyphicon-calendar text-primary\"></span> </button> </span> </div> </div> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=fin class=control-label>Date prévisionnelle de fin</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.fin.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=input-group> <input id=fin ng-disabled=ctrl.disabled name=fin type=text class=form-control gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-model=ctrl.projet.fin is-open=dateFinPopup.opened placeholder=jj/mm/aaaa ng-change=ctrl.validateDateFin() required> <span class=input-group-btn> <button ng-disabled=ctrl.disabled type=button class=\"btn btn-default\" ng-click=\"dateFinPopup.opened=true\"> <span class=\"glyphicon glyphicon-calendar text-primary\"></span> </button> </span> </div> </div> </div> <div class=row> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=etablissement class=control-label>Etablissement</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.etablissement.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div ng-class=\"{\'input-group\': ctrl.projet.etablissement}\"> <input id=etablissement ng-disabled=ctrl.disabled name=etablissement ng-model=ctrl.projet.etablissement uib-typeahead=\"etablissement as (etablissement.code +\' - \'+ etablissement.libelle) for etablissement in ctrl.autocompleteEtablissement($viewValue)\" typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher... required> <span ng-show=ctrl.projet.etablissement class=input-group-btn> <a href=/#/referentiel/etablissement/{{ctrl.projet.etablissement.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=compteAssocie class=control-label>Compte associé</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.compte.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div ng-class=\"{\'input-group\': ctrl.projet.compte}\"> <input id=compteAssocie ng-disabled=ctrl.disabled name=compte ng-model=ctrl.projet.compte uib-typeahead=\"compte as (compte.code +\' - \'+ compte.libelle) for compte in ctrl.autocompleteCompte($viewValue,ctrl.projet.etablissement.id)\" typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher... required> <span ng-show=ctrl.projet.compte class=input-group-btn> <a href=/#/compte/{{ctrl.projet.compte.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> <div class=\"form-group col-md-3\"> <label class=control-label>Pièce jointe</label> <div ng-hide=ctrl.disabled> <input name=pj type=file ng-model=pj nv-file-select uploader=ctrl.getFileUpload> </div> </div> <div class=\"form-group col-md-3\"> <div ng-show=\"ctrl.projet.conventionFichier.length!=0\" ng-repeat=\"fichier in ctrl.projet.conventionFichier\"> <a class=\"btn btn-link\" ng-href=/api/projet/download/{{fichier.nomFichier}} title={{fichier.libelle}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{fichier.libelle | limitTo:10}}<span ng-if=\"fichier.libelle.length > 10\">&hellip;</span></a> <a ng-click=ctrl.confirmDelete(fichier.id)> <span title=\"Retirer une pièce jointe\" class=\"glyphicon glyphicon-trash\" aria-hidden=true></span> </a> </div> </div> </div> <div class=row> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=promoteur class=control-label>Promoteur</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.promoteur.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div ng-class=\"{\'input-group\': ctrl.projet.promoteur}\"> <input id=promoteur ng-disabled=ctrl.disabled name=promoteur ng-model=ctrl.projet.promoteur uib-typeahead=\"promoteur as (promoteur.code +\' - \'+ promoteur.libelle) for promoteur in ctrl.autocompletePromoteur($viewValue,ctrl.projet.etablissement.id)\" typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher... required> <span ng-show=ctrl.projet.promoteur class=input-group-btn> <a href=/#/referentiel/promoteur/{{ctrl.projet.promoteur.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=financeur class=control-label>Financeur</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.financeur.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div ng-class=\"{\'input-group\': ctrl.projet.financeur}\"> <input id=financeur ng-disabled=ctrl.disabled name=financeur ng-model=ctrl.projet.financeur uib-typeahead=\"financeur as (financeur.code +\' - \'+ financeur.libelle) for financeur in ctrl.autocompleteFinanceur($viewValue)\" typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher... required> <span ng-show=ctrl.projet.financeur class=input-group-btn> <a href=/#/referentiel/financeur/{{ctrl.projet.financeur.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=dateConvention class=control-label>Date de la convention</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.signature.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=input-group> <input id=dateConvention ng-disabled=ctrl.disabled name=signature type=text class=form-control gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-model=ctrl.projet.dateSignature is-open=dateSignaturePopup.opened placeholder=jj/mm/aaaa required> <span class=input-group-btn> <button ng-disabled=ctrl.disabled type=button class=\"btn btn-default\" ng-click=\"dateSignaturePopup.opened=true\"> <span class=\"glyphicon glyphicon-calendar text-primary\"></span> </button> </span> </div> </div> </div> <div class=row> <div class=\"form-group col-md-6\"> <label for=referenceExterne> Référence externe </label> <input id=referenceExterne ng-model=ctrl.projet.referenceExterne type=text class=form-control disabled> </div> <div class=col-md-6> <label for=synchronise> Synchronisé depuis EASYDORE</label> <div> <toggle-switch id=synchronise ng-model=ctrl.projet.synchronise on-label=Oui off-label=Non is-disabled=true> </toggle-switch> </div> </div> </div> <div class=row> <div class=\"form-group col-md-6\" gif-has-error> <label for=libelle> Libellé </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.libelleEasydore.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <textarea id=libelleEasydore name=libelleEasydore ng-disabled=ctrl.disabled ng-model=ctrl.projet.libelleEasydore class=form-control rows=3 maxlength=255>\n            </textarea> <small> Il vous reste <span>{{255 - ctrl.projet.libelleEasydore.length}}</span> <span ng-if=\"255 - ctrl.projet.libelleEasydore.length != 1 && 255 - ctrl.projet.libelleEasydore.length != 0\">caractères</span> <span ng-if=\"255 - ctrl.projet.libelleEasydore.length == 1 || 255 - ctrl.projet.libelleEasydore.length == 0\">caractère</span>  </small> </div> <div class=\"form-group col-md-6\"> <div ng-if=ctrl.isDesactivationImpossible> <label for=statutNonModifiable> Statut </label> <div> <toggle-switch uib-tooltip=\"Ce projet possède des facturations en cours. Il ne peut être clôturé\" is-disabled=ctrl.isDesactivationImpossible id=statutNonModifiable ng-model=ctrl.projet.actif on-label=Actif off-label=Clos> </toggle-switch> </div> </div> <div ng-if=!ctrl.isDesactivationImpossible> <label for=statutModifiable> Statut </label> <div> <toggle-switch is-disabled=\"ctrl.isDesactivationImpossible || ctrl.disabled\" id=statutModifiable on-change=\"ctrl.isFacturationDesactive=!ctrl.projet.actif\" ng-model=ctrl.projet.actif on-label=Actif off-label=Clos> </toggle-switch> </div> </div> </div> </div><!--  Tableau des investigateurs --> <div class=row> <div class=col-md-12> <h3> Investigateurs <button ng-hide=ctrl.disabled ng-click=ctrl.addInvestigateur() type=button class=\"btn btn-link btn-sm\"> <span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span> Ajouter </button> </h3> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-10\">Nom</th> <th class=\"text-primary col-md-2\">Investigateur principal</th> <th ng-hide=ctrl.disabled></th> </thead> <tbody> <tr class=table_row ng-repeat=\"i in ctrl.projet.investigateurs\"> <td> <div ng-class=\"{\'input-group\': i.investigateur}\"> <input ng-disabled=ctrl.disabled name=investigateur ng-model=i.investigateur uib-typeahead=\"investigateur as (investigateur.nom +\' \'+ investigateur.prenom) for investigateur in ctrl.autocompleteInvestigateur($viewValue,ctrl.projet.etablissement.id)\" typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher...> <span ng-show=i.investigateur class=input-group-btn> <a href=/#/referentiel/investigateur/{{i.investigateur.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </td> <td> <input ng-disabled=ctrl.disabled type=checkbox ng-model=i.investigateurPrincipal ng-click=ctrl.updateSelection($index,ctrl.projet.investigateurs)> </td> <td ng-hide=ctrl.disabled style=\"vertical-align: middle\"> <a ng-click=ctrl.removeInvestigateur($index)> <span title=\"Retirer un contact\" class=\"glyphicon glyphicon-trash\" aria-hidden=true></span> </a> </td> </tr> </tbody> </table> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.investigateur.$error> <small ng-message=InvestigateurLength>Il faut au moins un investigateur </small> </ng-messages> </div> </div><!--  Tableau des contacts --> <div class=row> <div class=col-md-12> <h3> Contacts <button ng-hide=ctrl.disabled ng-click=ctrl.addContact() type=button class=\"btn btn-link btn-sm\"> <span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span> Ajouter </button> </h3> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-2\">Nom</th> <th class=\"text-primary col-md-2\">Prénom</th> <th class=\"text-primary col-md-2\">Téléphone</th> <th class=\"text-primary col-md-3\">Email</th> <th class=\"text-primary col-md-3\">Information</th> <th class=col-md-1></th> </thead> <tbody> <tr ng-repeat=\"contact in ctrl.projet.contacts\"> <td> <input ng-disabled=ctrl.disabled ng-model=contact.nom type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disabled ng-model=contact.prenom type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disabled ng-model=contact.telephone type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disabled ng-model=contact.email type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disabled ng-model=contact.information type=text class=form-control> </td> <td> <a ng-click=ctrl.removeContact($index) ng-hide=ctrl.disabled class=\"btn btn-link pull-right\"> <span title=\"Retirer un contact\" class=\"glyphicon glyphicon-trash\" aria-hidden=true></span> </a> </td> </tr> </tbody> </table> </div> </div> <div class=row> <div class=col-md-12> <div class=pull-left> <button ng-hide=ctrl.disabled type=button uib-tooltip=\"{{ctrl.isFacturationDesactive ? \'Le compte de ce projet n\\\'est pas actif\' : \'\'}}\" ng-show=ctrl.projet.id ng-disabled=\"ctrl.isFacturationDesactive || form.$invalid\" ng-click=ctrl.createFacturation(ctrl.projet) class=\"btn btn-default\">Facturer</button> </div> <div class=pull-right> <a class=\"btn btn-link\" href=/#/projet/list>Annuler</a> <button ng-hide=ctrl.disabled type=submit class=\"btn btn-primary\">Enregistrer</button> </div> </div> </div> </form>");
$templateCache.put("app/projet/list/projetList.html","<div class=header> <h1>Projet</h1> <hr> <div class=row> <div class=col-md-2> <div class=\"btn-group btn-group-justified\"> <div class=btn-group> <button ng-class=\"{\'active\': ctrl.filterActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(true)>Actif</button> </div> <div class=btn-group> <button ng-class=\"{\'active\': !ctrl.filterActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(false)>Clos</button> </div> </div> </div> <div class=\"col-md-offset-5 col-md-4\"> <input id=searchProjet type=text class=form-control placeholder=Rechercher ng-model=ctrl.searchText ng-change=ctrl.onChangeSearchText(ctrl.searchText)> </div> <div class=col-md-1 gif-role=ADMIN> <button ng-click=ctrl.add() type=button class=\"pull-right btn btn-primary\">Ajouter</button> </div> </div> </div> <div ng-if=ctrl.page gif-paged-data=ctrl.onPagingOptionsChange(pagingOptions) gif-page-size={{ctrl.pageSize}}> <small class=text-muted> <span><strong>{{ctrl.page.number+1 * ctrl.page.size}}</strong> premiers projets parmi <strong>{{ctrl.page.totalElements}}</strong> {{ctrl.page.totalElements > 1 ? \'résultats\' : \'résultat\'}}</span> </small> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-1\" gif-sortable=reference>Réference</th> <th class=\"text-primary col-md-4\" gif-sortable=libelleAbrege>Libellé</th> <th class=col-md-3>Investigateur</th> <th class=\"text-primary col-md-3\" gif-sortable=promoteur.libelle>Promoteur</th> <th class=\"text-primary col-md-1\" gif-sortable=debut>Date début</th> </thead> <tbody> <tr ng-click=ctrl.goTo(projet.id) class=table_row ng-repeat=\"projet in ctrl.page.content\"> <td>{{projet.reference}}</td> <td>{{projet.libelleAbrege}}</td> <td>{{ctrl.investigateurPrincipal(projet)}}</td> <td>{{projet.promoteur.libelle}}</td> <td>{{projet.debut | date:\'dd/MM/yyyy\'}}</td> </tr> </tbody> </table> <div class=\"col-md-2 col-md-offset-5\"> <button ng-click=ctrl.viewMore() class=\"btn btn-default btn-sm\" ng-hide=ctrl.page.last> Afficher davantage </button> </div> </div>");
$templateCache.put("app/operation/list/OperationList.html","<div class=header> <h1>Opération</h1> <hr> <div class=row> <div class=col-md-2> <div class=\"btn-group btn-group-justified\"> <div class=btn-group> <button tooltip-placement=bottom uib-tooltip=\"Demande de remboursement\" ng-class=\"{\'active\': ctrl.filtreDemande==\'REMBOURSEMENT\'}\" type=button class=\"btn btn-default\" ng-click=\"ctrl.onChangeDemande(\'REMBOURSEMENT\');ctrl.getListOperationRemboursement()\">DR</button> </div> <div class=btn-group> <button tooltip-placement=bottom uib-tooltip=\"Demande d\'achat\" ng-class=\"{\'active\': ctrl.filtreDemande==\'ACHAT\'}\" type=button class=\"btn btn-default\" ng-click=\"ctrl.onChangeDemande(\'ACHAT\');ctrl.getListOperationAchat()\">DA</button> </div> <div class=btn-group> <button tooltip-placement=bottom uib-tooltip=\"Demande de mission\" ng-class=\"{\'active\': ctrl.filtreDemande==\'MISSION\'}\" type=button class=\"btn btn-default\" ng-click=\"ctrl.onChangeDemande(\'MISSION\');ctrl.getListOperationMission()\">DM</button> </div> </div> </div> <div class=col-md-6> <div ng-show=\"ctrl.filtreDemande==\'REMBOURSEMENT\'\" class=\"btn-group btn-group-justified\"> <div class=btn-group gif-role=INVESTIGATEUR,BENEFICIAIRE,ADMIN> <label ng-model=ctrl.filterBrouillonRemboursement uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutRemboursement(\'BROUILLON\');ctrl.getListOperationRemboursement()\">Brouillon</label> </div> <div class=btn-group gif-role=INVESTIGATEUR> <label ng-model=ctrl.filterASoumettreRemboursement uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutRemboursement(\'ASOUMETTRE\');ctrl.getListOperationRemboursement()\">A soumettre</label> </div> <div class=btn-group gif-role=!BENEFICIAIRE> <label ng-model=ctrl.filterSoumiseRemboursement uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutRemboursement(\'SOUMISE\');ctrl.getListOperationRemboursement()\">Soumise</label> </div> <div class=btn-group gif-role=BENEFICIAIRE> <label ng-model=ctrl.filterASoumettreRemboursement uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutRemboursement(\'ASOUMETTRE\');ctrl.getListOperationRemboursement()\">Soumise</label> </div> <div class=btn-group> <label ng-model=ctrl.filterRefuseRemboursement uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutRemboursement(\'REFUSE\');ctrl.getListOperationRemboursement()\">Refusée</label> </div> <div class=btn-group> <label ng-model=ctrl.filterValideRemboursement uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutRemboursement(\'VALIDE\');ctrl.getListOperationRemboursement()\">Validée</label> </div> <div class=btn-group> <label ng-model=ctrl.filterPayeRemboursement uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutRemboursement(\'PAYE\');ctrl.getListOperationRemboursement()\">Payée</label> </div> </div> <div ng-show=\"ctrl.filtreDemande==\'ACHAT\'\" class=\"btn-group btn-group-justified\"> <div class=btn-group gif-role=INVESTIGATEUR,BENEFICIAIRE,ADMIN> <label ng-model=ctrl.filterBrouillonAchat uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutAchat(\'BROUILLON\');ctrl.getListOperationAchat()\">Brouillon</label> </div> <div class=btn-group gif-role=INVESTIGATEUR> <label ng-model=ctrl.filterASoumettreAchat uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutAchat(\'ASOUMETTRE\');ctrl.getListOperationAchat()\">A soumettre</label> </div> <div class=btn-group gif-role=!BENEFICIAIRE> <label ng-model=ctrl.filterSoumiseAchat uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutAchat(\'SOUMISE\');ctrl.getListOperationAchat()\">Soumise</label> </div> <div class=btn-group gif-role=BENEFICIAIRE> <label ng-model=ctrl.filterASoumettreAchat uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutAchat(\'ASOUMETTRE\');ctrl.getListOperationAchat()\">Soumise</label> </div> <div class=btn-group> <label ng-model=ctrl.filterValideAchat uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutAchat(\'VALIDE\');ctrl.getListOperationAchat()\">Validée</label> </div> <div class=btn-group> <label ng-model=ctrl.filterReceptionneAchat uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutAchat(\'RECEPTIONNE\');ctrl.getListOperationAchat()\">Receptionnée</label> </div> <div class=btn-group> <label ng-model=ctrl.filterPayeAchat uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutAchat(\'PAYE\');ctrl.getListOperationAchat()\">Payée</label> </div> </div> <div ng-show=\"ctrl.filtreDemande==\'MISSION\'\" class=\"btn-group btn-group-justified\"> <div class=btn-group gif-role=INVESTIGATEUR,BENEFICIAIRE,ADMIN> <label ng-model=ctrl.filterBrouillonMission uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutMission(\'BROUILLON\');ctrl.getListOperationMission()\">Brouillon</label> </div> <div class=btn-group gif-role=INVESTIGATEUR> <label ng-model=ctrl.filterASoumettreMission uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutMission(\'ASOUMETTRE\');ctrl.getListOperationMission()\">A soumettre</label> </div> <div class=btn-group gif-role=!BENEFICIAIRE> <label ng-model=ctrl.filterSoumiseMission uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutMission(\'SOUMISE\');ctrl.getListOperationMission()\">Soumise</label> </div> <div class=btn-group gif-role=BENEFICIAIRE> <label ng-model=ctrl.filterASoumettreMission uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutMission(\'ASOUMETTRE\');ctrl.getListOperationMission()\">Soumise</label> </div> <div class=btn-group> <label ng-model=ctrl.filterValideMission uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutMission(\'VALIDE\');ctrl.getListOperationMission()\">Validée</label> </div> <div class=btn-group> <label ng-model=ctrl.filterReceptionneMission uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutMission(\'RECEPTIONNE\');ctrl.getListOperationMission()\">Receptionnée</label> </div> <div class=btn-group> <label ng-model=ctrl.filterPayeMission uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatutMission(\'PAYE\');ctrl.getListOperationMission()\">Payée</label> </div> </div> </div> <div class=col-md-3> <input id=searchOpération type=text class=form-control placeholder=Rechercher ng-model=ctrl.searchText ng-change=ctrl.onChangeSearchText(ctrl.searchText)> </div> <div class=\"dropdown open col-md-1\" uib-dropdown ng-hide=ctrl.read> <button id=single-button type=button class=\"btn btn-primary pull-right\" uib-dropdown-toggle> Ajouter <span class=caret></span> </button> <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=single-button> <li> <a ng-click=ctrl.addDemandeRemboursement()>Demande de remboursement</a> </li> <li> <a ng-click=ctrl.addDemandeAchat()>Demande d\'achat</a> </li> <li class=desactive> <a tooltip-placement=left uib-tooltip=\"Bouton désactivé, merci de faire une demande remboursement\">Demande de mission</a><!-- <a ng-click=\"ctrl.addDemandeMission()\">Demande de mission</a> --> </li> </ul> </div> </div> </div> <div ng-if=ctrl.page gif-paged-data=ctrl.onPagingOptionsChange(pagingOptions) gif-page-size={{ctrl.pageSize}}> <small class=text-muted> <strong>{{ctrl.page.number+1 * ctrl.page.size | number}}</strong> premières opérations parmi <strong>{{ctrl.page.content.length | number}}</strong> {{ctrl.page.totalElements > 1 ? \'résultats\' : \'résultat\'}} </small> <table ng-show=\"ctrl.filtreDemande===\'REMBOURSEMENT\'\" class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-1\" gif-sortable=dateCreation>Date</th> <th class=\"text-primary col-md-1\" gif-sortable=objet>Référence</th> <th class=\"text-primary col-md-3\" gif-sortable=objet>Libellé de l\'opération</th> <th class=\"text-primary col-md-3\">Demandeur</th> <th class=\"text-primary col-md-2\" gif-sortable=compte.libelle>Intitulé du compte</th> <th class=\"text-primary col-md-2\" gif-sortable=montantTTC>Montant TTC</th> </thead> <tbody><!-- track by operation.id | orderBy:\'-dateCreation\'\" --> <tr ng-repeat=\"operation in ctrl.page.content\" ng-click=ctrl.goToDemandeRemboursement(operation.id)> <td>{{operation.dateCreation | date:\'dd/MM/yyyy\'}}</td> <td>{{operation.numero}}</td> <td>{{operation.objet}}</td> <td ng-if=operation.investigateur>{{operation.investigateur.nom}} {{operation.investigateur.prenom}} </td> <td ng-if=operation.beneficiaire>{{operation.beneficiaire.nom}} {{operation.beneficiaire.prenom}}</td> <td>{{operation.compte.libelle}}</td> <td> {{operation.montantTTC | number:2}} </td> </tr> </tbody> </table> <table ng-show=\"ctrl.filtreDemande===\'ACHAT\'\" class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-1\" gif-sortable=dateCreation>Date</th> <th class=\"text-primary col-md-1\" gif-sortable=objet>Référence</th> <th class=\"text-primary col-md-2\" gif-sortable=objet>Libellé de l\'opération</th> <th class=\"text-primary col-md-2\">Demandeur</th> <th class=\"text-primary col-md-2\" gif-sortable=compte.libelle>Intitulé du compte</th> <th class=\"text-primary col-md-2\" gif-sortable=fournisseur.libelle>Libellé du fournisseur</th> <th class=\"text-primary col-md-2\" gif-sortable=montantTTC>Montant TTC</th> </thead> <tbody> <tr ng-repeat=\"operation in ctrl.page.content\" ng-click=ctrl.goToDemandeAchat(operation.id)> <td>{{operation.dateCreation | date:\'dd/MM/yyyy\'}}</td> <td>{{operation.numero}}</td> <td>{{operation.objet}}</td> <td ng-show=operation.investigateur>{{operation.investigateur.nom}} {{operation.investigateur.prenom}} </td> <td ng-show=operation.beneficiaire>{{operation.beneficiaire.nom}} {{operation.beneficiaire.prenom}} </td> <td>{{operation.compte.libelle}}</td> <td>{{operation.fournisseur.libelle}}</td> <td>{{operation.montantTTC | number:2}}</td> </tr> </tbody> </table> <table ng-show=\"ctrl.filtreDemande===\'MISSION\'\" class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-1\" gif-sortable=dateCreation>Date</th> <th class=\"text-primary col-md-1\" gif-sortable=objet>Référence</th> <th class=\"text-primary col-md-2\" gif-sortable=objet>Libellé de l\'opération</th> <th class=\"text-primary col-md-3\">Demandeur</th> <th class=\"text-primary col-md-2\" gif-sortable=compte.libelle>Intitulé du compte</th> <th class=\"text-primary col-md-2\" gif-sortable=montantTTC>Montant TTC</th> </thead> <tbody> <tr ng-repeat=\"operation in ctrl.page.content\" ng-click=ctrl.goToDemandeMission(operation.id)> <td>{{operation.dateCreation | date:\'dd/MM/yyyy\'}}</td> <td>{{operation.numero}}</td> <td>{{operation.objet}}</td> <td ng-show=operation.investigateur>{{operation.investigateur.nom}} {{operation.investigateur.prenom}} </td> <td ng-show=operation.beneficiaire>{{operation.beneficiaire.nom}} {{operation.beneficiaire.prenom}} </td> <td>{{operation.compte.libelle}}</td> <td>{{operation.montantTTC | number:2}}</td> </tr> </tbody> </table> <div class=\"col-md-2 col-md-offset-5\"> <button ng-click=ctrl.viewMore() class=\"btn btn-default btn-sm\" ng-hide=ctrl.page.last> Afficher davantage </button> </div> </div>");
$templateCache.put("app/referentiel/tva/tva.html","<div class=header> <h1>TVA</h1> <hr> </div> <form name=form ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.tva)\" novalidate> <div class=row> <div class=col-md-12> <h3> Elements <button ng-hide=ctrl.disable ng-click=ctrl.addTva() type=button class=\"btn btn-link btn-sm\"> <span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span> Ajouter </button> </h3> <table class=\"table table-striped table-condensed\"> <thead> <th class=text-primary>Code *</th> <th class=text-primary>Taux *</th> <th class=text-primary>Statut</th> <th></th> </thead> <tbody> <tr class=table_row ng-repeat=\"tva in ctrl.list\"> <td ng-class=\"{\'has-error\': (form[\'code{{$index}}\'].$invalid && ( form.$submitted || form[\'code{{$index}}\'].$touched))}\"> <input name=code{{$index}} ng-model=tva.code type=text class=form-control required ng-change=\"ctrl.validateCode($index, tva.code)\"> <ng-messages class=\"pull-right text-danger has-error-messages\" for=\"form[\'code\' + $index].$error\"> <ng-messages-include src=app/default-messages.html> </ng-messages> </td> <td ng-class=\"{\'has-error\': (form[\'taux{{$index}}\'].$invalid && ( form.$submitted || form[\'taux{{$index}}\'].$touched))}\"> <input name=taux{{$index}} ng-model=tva.taux type=number class=form-control required> <ng-messages class=\"pull-right text-danger has-error-messages\" for=\"form[\'taux\' + $index].$error\"> <ng-messages-include src=app/default-messages.html> </ng-messages> </td> <td> <div> <toggle-switch id=enabledInput ng-model=tva.actif on-label=Actif off-label=Inactif is-disabled=ctrl.disable> </toggle-switch> </div> </td> <td style=\"vertical-align: middle\"> <a ng-click=ctrl.removeTva($index)> <span title=\"Supprimer TVA\" class=\"glyphicon glyphicon-trash\" aria-hidden=true></span> </a> </td> </tr> </tbody> </table> </div> </div> <div class=row> <div class=form-group> <div class=col-md-12> <div class=footer> <button type=submit class=\"pull-right btn btn-primary\">Enregistrer</button> </div> </div> </div> </div> </form>");
$templateCache.put("app/security/connexion/Connexion.html","<div class=accueil> <div class=\"simple-form-panel col-md-offset-5 col-md-2 cadre\" ng-submit=controller.login()> <h1>Bienvenue sur ASTRAM</h1> <div class=\"alert alert-danger\" ng-show=controller.badCredentialsError>Identifiant ou mot de passe incorrect. </div> <form class=form-signin novalidate> <span id=reauth-email class=reauth-email></span> <input type=text id=username name=username ng-model=controller.credentials.username class=form-control placeholder=Identifiant autofocus> <input type=password id=password name=password ng-model=controller.credentials.password class=form-control placeholder=\"Mot de passe\" autocomplete=off> <button class=\"btn btn-lg btn-primary btn-block btn-signin\" type=submit>Se connecter</button> </form> <a href=/#/mot-de-passe-oublie class=forgot-password> Mot de passe oublié ? </a> </div> </div>");
$templateCache.put("app/security/mot-de-passe-oublie/MotDePasseOublie.html","<div class=accueil> <div class=\"simple-form-panel col-md-offset-5 col-md-2 cadre\" ng-submit=ctrl.renewPassword()> <h1>Mot de passe oublié</h1> <div class=\"alert alert-danger\" ng-if=ctrl.badUsernameOrEmail> <strong>Identifiant ou email inconnu</strong> </div> <form class=form-signin name=form novalidate> <input type=text id=email name=email ng-model=ctrl.usernameOrEmail class=form-control placeholder=\"identifiant ou email\" autofocus autocomplete=off required> <button class=\"btn btn-lg btn-primary btn-block btn-signin\" type=submit>Réinitialiser mon mot de passe</button> </form> <a href=/#> Annuler </a> </div> </div>");
$templateCache.put("app/security/nouveau-mot-de-passe/NouveauMotDePasse.html","<div class=accueil> <div class=\"simple-form-panel col-md-offset-5 col-md-2 cadre\" ng-submit=ctrl.renewPassword()> <h1>Nouveau mot de passe</h1> <form name=form ng-class=\"{\'submitted\': submitted}\" ng-submit=\"form.$valid && ctrl.save(ctrl.utilisateur)\" novalidate> <div ng-if=\"form.$invalid && form.$submitted\" class=\"alert alert-danger\"> <strong>Certaines informations sont incorrectes.</strong><br> </div> <ng-messages class=\"pull-right text-danger\" for=form.password.$error ng-if=form.password.$touched> <ng-messages-include src=app/default-messages.html> </ng-messages><!-- **************************** Mot de passe **************************** --> <input id=paswordInput name=password ng-model=ctrl.utilisateur.password placeholder=\"Nouveau mot de passe\" class=form-control type=password required ng-pattern=\"/^(?=.*[A-Za-z])(?=.*\\d).{6,}$/\" autocomplete=off> <ng-messages class=text-danger for=form.password.$error ng-if=form.password.$touched> <small ng-message=pattern>Votre mot de passe doit être constitué d\'au moins 6 caractères dont au moins une lettre et un chiffre.</small> </ng-messages><!-- **************************** Confirmation mot de passe **************************** --> <ng-messages class=\"pull-right text-danger\" for=form.passwordConfirmation.$error ng-if=form.passwordConfirmation.$touched> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=confirmPaswordInput name=passwordConfirmation class=form-control type=password ng-model=ctrl.utilisateur.passwordConfirmation placeholder=Confirmation required match=form.password autocomplete=off> <ng-messages class=text-danger for=form.passwordConfirmation.$error ng-if=form.passwordConfirmation.$touched> <small ng-message=match> Les deux mot de passe saisis ne coïncident pas<br> <br> </small> </ng-messages> <button ng-hide=ctrl.disable type=submit ng-click=\"submitted = true;\" class=\"btn btn-primary\">Enregistrer</button> </form> </div> </div>");
$templateCache.put("app/compte/virement/list/VirementList.html","<div class=header> <h1>Virement</h1> <hr> <div class=row> <div class=\"col-md-offset-7 col-md-4\"> <input id=searchVirement type=text class=form-control placeholder=Rechercher ng-model=ctrl.searchText ng-change=ctrl.onChangeSearchText(ctrl.searchText)> </div> <div class=col-md-1 ng-hide=ctrl.read> <button ng-click=ctrl.add() type=button class=\"pull-right btn btn-primary\">Ajouter</button> </div> </div> </div> <div ng-if=ctrl.page gif-paged-data=ctrl.onPagingOptionsChange(pagingOptions) gif-page-size={{ctrl.pageSize}}> <small class=text-muted> <span><strong>{{ctrl.page.number+1 * ctrl.page.size}}</strong> premiers virements parmi <strong>{{ctrl.page.totalElements}}</strong> {{ctrl.page.totalElements > 1 ? \'résultats\' : \'résultat\'}}</span> </small> <table class=\"table table-striped table-condensed\"> <thead> <th class=text-primary ng-click=\"ctrl.sort=\'code\'\">Compte Source</th> <th class=text-primary ng-click=\"ctrl.sort=\'code\'\">Compte Destination</th> <th class=text-primary ng-click=\"ctrl.sort=\'motif\'\">Motif</th> <th class=text-primary ng-click=\"ctrl.sort=\'montant\'\">Montant crédité</th> <th class=text-primary ng-click=\"ctrl.sort=\'date\'\">Date</th> </thead> <tbody> <tr ng-click=ctrl.goTo(virement.id) class=table_row ng-repeat=\"virement in ctrl.list | orderBy:ctrl.sort\"> <td>{{virement.compteSource.code}}</td> <td>{{virement.compteDestination.code}}</td> <td>{{virement.motif}}</td> <td>{{virement.montant | number:2}}</td> <td>{{virement.date | date:\'dd/MM/yyyy\'}}</td> </tr> </tbody> </table> <div class=\"col-md-2 col-md-offset-5\"> <button ng-click=ctrl.viewMore() class=\"btn btn-default btn-sm\" ng-hide=ctrl.page.last> Afficher davantage </button> </div> </div>");
$templateCache.put("app/compte/virement/item/VirementItem.html","<div class=header> <h1 ng-if=ctrl.isUpdate>Virement - {{ctrl.virement.date | date:\'dd/MM/yyyy\'}} </h1> <h1 ng-if=!ctrl.isUpdate>Ajout d\'un virement</h1> <hr> </div> <div class=main><!-- Le ng-class permet de mettre les bordure en rouge pour les champ obligatoire --> <form name=form ng-class=\"{\'submitted\': submitted}\" ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.virement)\" novalidate gif-server-validate=ctrl.serverErrors> <div class=form-group> <div class=\"row ng-scope\"> <div class=\"form-group col-md-3 boiteCompteSource required\" gif-has-error> <label class=control-label for=compteSource> Compte source </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.compteSource.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div ng-class=\"{\'input-group\': ctrl.virement.compteSource}\"> <input ng-disabled=ctrl.isUpdate id=compteSource name=compteSource ng-model=ctrl.virement.compteSource uib-typeahead=\"compte as (compte.code +\' - \'+ compte.libelle) for compte in ctrl.autocompleteCompte($viewValue)\" typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher... required> <span ng-show=ctrl.virement.compteSource class=input-group-btn> <a href=/#/compte/{{ctrl.virement.compteSource.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> <div class=\"col-md-1 iconPlaySource\"> <span class=\"glyphicon glyphicon-play\" aria-hidden=true></span> </div> <div class=\"col-md-3 boiteCompteDestination\"> <div class=\"form-group required\" gif-has-error> <label class=control-label for=montant>Montant </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.montant.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input ng-disabled=ctrl.isUpdate id=montant name=montant ng-model=ctrl.virement.montant type=number class=form-control min=0 step=1 required> </div> <div class=\"form-group required\" gif-has-error> <label class=control-label for=motif> Motif </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.motif.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input ng-disabled=ctrl.isUpdate id=motif name=motif ng-model=ctrl.virement.motif type=text class=form-control ng-maxlength=255 required> </div> </div> <div class=\"col-md-1 iconPlayDestination\"> <span class=\"glyphicon glyphicon-play pull-right\" aria-hidden=true></span> </div> <div class=\"form-group col-md-3 boiteCompteDestination required\" gif-has-error> <label class=control-label for=compteDestination> Compte destination </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.compteDestination.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div ng-class=\"{\'input-group\': ctrl.virement.compteDestination}\"> <input ng-disabled=ctrl.isUpdate id=compteDestination name=compteDestination ng-model=ctrl.virement.compteDestination uib-typeahead=\"compte as (compte.code +\' - \'+ compte.libelle) for compte in ctrl.autocompleteCompte($viewValue)\" typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher... required> <span ng-show=ctrl.virement.compteDestination class=input-group-btn> <a href=/#/compte/{{ctrl.virement.compteDestination.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </div> </div> <div class=form-group> <div class=col-md-12> <div class=footer> <div class=pull-right> <a ng-if=ctrl.isUpdate class=\"btn btn-link\" href=/#/compte/virement/list>Retour</a> <a ng-if=!ctrl.isUpdate class=\"btn btn-link\" href=/#/compte/virement/list>Annuler</a> <button ng-hide=ctrl.isUpdate type=submit ng-click=\"submitted = true;\" class=\"btn btn-primary\">Enregistrer</button> </div> </div> </div> </div> </form> </div>");
$templateCache.put("app/projet/importEasydore/list/importEasydoreList.html","<div class=header> <h1>Import EASYDORE</h1> <hr> <div class=row> <div class=\"col-md-offset-8 col-md-4\"> <input id=searchImport type=text class=form-control placeholder=Rechercher ng-model=ctrl.searchText ng-change=ctrl.onChangeSearchText(ctrl.searchText)> </div> </div> </div> <div class=main> <form name=form> <div ng-if=ctrl.page gif-paged-data=ctrl.onPagingOptionsChange(pagingOptions) gif-page-size={{ctrl.pageSize}}> <small class=text-muted> <span> <strong>{{ctrl.page.number+1 * ctrl.page.size}}</strong> premiers projets à importer parmi <strong>{{ctrl.page.totalElements}}</strong> {{ctrl.page.totalElements > 1 ? \'résultats\' : \'résultat\'}} </span> </small> <table class=\"table table-striped table-condensed fixed-table\"> <thead> <th style=\"width: 3%\" class=\"text-primary col-md-1\"></th> <th class=\"text-primary col-md-2\">Code établissement</th> <th class=\"text-primary col-md-1\">Référence</th> <th class=\"text-primary col-md-2\">Libellé court</th> <th class=\"text-primary col-md-2\">Promoteur</th> <th class=\"text-primary col-md-2\">Investigateur principal</th> <th class=\"text-primary col-md-1\">Date de signature</th> <th class=\"text-primary col-md-1\"></th> </thead> <tbody> <tr class=table_row ng-repeat=\"import in ctrl.page.content\"> <td style=\"vertical-align: middle\" ng-if=!import.informationImport> <div class=\"alert alert-success\" style=\"margin-bottom: 0px\" tooltip-placement=bottom uib-tooltip=\"Projet Complet\"></div> </td> <td style=\"vertical-align: middle\" ng-if=import.informationImport> <div class=\"alert alert-danger\" style=\"margin-bottom: 0px\" tooltip-placement=bottom uib-tooltip=\"Information(s) manquante(s) : {{import.informationImport}}\"></div> </td> <td style=\"vertical-align: middle\">{{import.etablissement.code}}</td> <td style=\"vertical-align: middle\">{{import.reference}}</td> <td style=\"vertical-align: middle\">{{import.libelleAbrege}}</td> <td style=\"vertical-align: middle\"><span style=\"display: block\" tooltip-placement=bottom uib-tooltip={{import.promoteur.libelle}}>{{import.promoteur.libelle}}</span></td> <td style=\"vertical-align: middle\">{{ctrl.investigateurPrincipal(import)}}</td> <td>{{import.dateSignature| date:\'dd/MM/yyyy\'}}</td> <td style=\"vertical-align: middle; text-align: center\"> <button type=button class=\"pull-right btn btn-default\" ng-click=\"submitted = true; ctrl.importProjet(import)\"> <span title=\"Importer le projet\" class=\"glyphicon glyphicon-download-alt\"></span> Importer </button> </td> </tr> </tbody> </table> <div class=\"col-md-2 col-md-offset-5\"> <button ng-click=ctrl.viewMore() class=\"btn btn-default btn-sm\" ng-hide=ctrl.page.last>Afficher davantage</button> </div> </div> </form> </div>");
$templateCache.put("app/projet/facturation/item/FacturationItem.html","<div class=header> <div class=row> <div class=col-md-6> <h1 ng-if=ctrl.isUpdate>Facture - {{ctrl.facturation.financeur.libelle}}</h1> <h1 ng-if=!ctrl.isUpdate>Ajout d\'une facturation</h1> </div> <div class=col-md-6 ng-show=\"ctrl.facturation.facture || ctrl.facturation.facture==null\"> <div class=stepwizard> <div class=\"stepwizard-row setup-panel\"> <div class=\"stepwizard-step stepwizard-step-3\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'BROUILLON\'}\"> <strong>Brouillon</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-3\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'EMISE\'}\"> <strong>Emise</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-3\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'PAYE\'}\"> <strong>Payé</strong> </span> </div> </div> </div> </div> </div> <hr> </div> <div class=main><!-- Le ng-class permet de mettre les bordure en rouge pour les champ obligatoire --> <form name=form ng-class=\"{\'submitted\': submitted}\" ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.facturation)\" novalidate> <div ng-if=\"form.$invalid && form.$submitted\" class=\"alert alert-danger\"> <strong>Certaines informations sont incorrectes.</strong><br> </div> <div class=row> <div class=\"form-group col-md-6 required\" gif-has-error> <label class=control-label> Objet </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.objet.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input ng-disabled=\"ctrl.statutActuel != \'BROUILLON\' || ctrl.disabled\" id=codeInput name=objet ng-model=ctrl.facturation.objet type=text class=form-control ng-maxlength=255 required> </div> <div class=\"form-group col-md-3\"> <label> Date de création</label> <input type=text class=form-control gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-model=ctrl.facturation.dateCreation ng-disabled=true show-button-bar=false> </div> <div class=\"form-group col-md-3\"> <label> Date d\'émission </label> <input type=text class=form-control gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-model=ctrl.facturation.dateEmission ng-disabled=true show-button-bar=false> </div> </div> <div class=row> <div class=\"form-group col-md-6\"> <label> Numéro de pièce</label> <input ng-model=ctrl.facturation.numero type=text class=form-control ng-disabled=true> </div> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=paiement class=control-label>Date de paiement</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.paiement.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=input-group> <input id=paiement ng-disabled=ctrl.datePaiementDisabled name=paiement type=text class=form-control gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-model=ctrl.facturation.datePaiement is-open=dateDebutPopup.opened ng-required=!ctrl.datePaiementDisabled> <span class=input-group-btn> <button ng-disabled=ctrl.datePaiementDisabled type=button class=\"btn btn-default\" ng-click=\"dateDebutPopup.opened=true\"> <span class=\"glyphicon glyphicon-calendar text-primary\"></span> </button> </span> </div> </div> </div> <div class=row> <div class=\"form-group col-md-6 required\" gif-has-error> <label class=control-label> Référence convention</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.reference_convention.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input ng-disabled=\"ctrl.statutActuel != \'BROUILLON\' || ctrl.disabled\" name=reference_convention ng-model=ctrl.facturation.referenceConvention type=text class=form-control ng-maxlength=255 required> </div> <div class=\"form-group col-md-6 required\" gif-has-error> <label class=control-label> Code TVA</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.codeTVA.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <select name=codeTVA class=form-control ng-disabled=\"ctrl.statutActuel != \'BROUILLON\' || ctrl.disabled\" ng-model=ctrl.facturation.codeTVA ng-change=ctrl.calculValue(ctrl.facturation.montantHT) ng-options=\"tva as tva.code for tva in ctrl.codeTVA track by tva.id\" required><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> </div> </div> <div class=row> <div class=\"form-group col-md-6 required\" gif-has-error> <label class=control-label> Code Etablissement </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.code.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=custom-typeahead> <div class=\"input-group col-md-12\"> <input name=code ng-model=ctrl.facturation.etablissement ng-disabled=\"ctrl.statutActuel != \'BROUILLON\' || ctrl.disabled\" placeholder=Rechercher... uib-typeahead=\"etablissement as (etablissement.code +\' - \'+ etablissement.libelle) for etablissement in ctrl.autocompleteEtablissement($viewValue)\" type=text class=form-control typeahead-editable=false autocomplete=off typeahead-on-select=ctrl.calculValue(ctrl.facturation.montantHT) required> <span ng-show=ctrl.facturation.etablissement class=input-group-btn> <button type=button class=\"btn btn-default\" ng-click=ctrl.goEtablissement(ctrl.facturation.etablissement)> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </button> </span> </div> </div> </div> <div class=\"form-group col-md-6 required\" gif-has-error> <label class=control-label>Financeur </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.financeur.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=custom-typeahead> <div class=\"input-group col-md-12\"> <input ng-disabled=\"ctrl.statutActuel != \'BROUILLON\' || ctrl.disabled\" name=financeur ng-model=ctrl.facturation.financeur placeholder=Rechercher... uib-typeahead=\"financeur as (financeur.code +\' - \'+ financeur.libelle) for financeur in ctrl.autocompleteFinanceur($viewValue)\" type=text class=form-control typeahead-editable=false autocomplete=off required> <span ng-show=ctrl.facturation.financeur class=input-group-btn> <a href=/#/referentiel/financeur/{{ctrl.facturation.financeur.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </div> </div> <div class=row> <div class=\"form-group col-md-6 required\" gif-has-error> <label class=control-label> Référence projet </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.projet.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=custom-typeahead> <div class=\"input-group col-md-12\"> <input name=projet ng-model=ctrl.facturation.projet ng-disabled=\"ctrl.statutActuel != \'BROUILLON\' || ctrl.disabled\" placeholder=Rechercher... uib-typeahead=\"projet as (projet.reference +\' - \'+ projet.libelleAbrege) for projet in ctrl.autocompleteProjet($viewValue,ctrl.facturation.etablissement.id)\" type=text class=form-control typeahead-editable=false autocomplete=off required> <span ng-show=ctrl.facturation.projet class=input-group-btn> <a href=/#/projet/{{ctrl.facturation.projet.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </div> <div class=\"form-group col-md-6 required\" gif-has-error> <label class=control-label> Investigateur </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.investigateur.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=custom-typeahead> <div class=\"input-group col-md-12\"> <input name=investigateur ng-model=ctrl.facturation.investigateur ng-disabled=\"ctrl.statutActuel != \'BROUILLON\' || ctrl.disabled\" placeholder=Rechercher... uib-typeahead=\"investigateur as (investigateur.nom +\' \'+ investigateur.prenom) for investigateur in ctrl.autocompleteInvestigateur($viewValue, ctrl.facturation.etablissement.id)\" type=text class=form-control typeahead-editable=false autocomplete=off required> <span ng-show=ctrl.facturation.investigateur class=input-group-btn> <a href=/#/referentiel/investigateur/{{ctrl.facturation.investigateur.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </div> </div> <div class=row> <div class=\"form-group col-md-6\"> <label> Commentaire </label> <textarea ng-disabled=\"ctrl.statutActuel != \'BROUILLON\' || ctrl.disabled\" ng-model=ctrl.facturation.commentaire class=form-control rows=4 maxlength=255>\n				</textarea> <small> Il vous reste <span>{{255 - ctrl.projet.libelleEasydore.length}}</span> <span ng-if=\"255 - ctrl.projet.libelleEasydore.length != 1 && 255 - ctrl.projet.libelleEasydore.length != 0\">caractères</span> <span ng-if=\"255 - ctrl.projet.libelleEasydore.length == 1 || 255 - ctrl.projet.libelleEasydore.length == 0\">caractère</span>  </small> </div> </div> <div class=row> <div class=col-md-12> <table class=\"table table-striped table-condensed\"> <thead> <th ng-class=\"{\'has-error\': (form.montant.$invalid && (form.montant.$dirty || form.$submitted))}\" class=text-primary> Montant HT <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.montant.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> </th> <th class=text-primary>Frais de Gestion HT</th> <th class=text-primary>Total HT</th> <th class=text-primary>TVA</th> <th class=text-primary>Total CP HT</th> <th class=text-primary>Total TTC</th> </thead> <tbody> <tr class=table_row> <td> <div ng-show=\"ctrl.statutActuel == \'BROUILLON\'\"> <div gif-has-error> <input type=number name=montant ng-model=ctrl.facturation.montantHT type=text class=form-control ng-disabled=ctrl.disabled ng-keyup=ctrl.calculValue(ctrl.facturation.montantHT) min=0 step=0.01 required> </div> </div> <div ng-show=\"ctrl.statutActuel != \'BROUILLON\'\"> <span>{{ctrl.facturation.montantHT | number:2}}</span> </div> </td> <td> <span>{{ctrl.facturation.fraisGestion | number:2}}</span> </td> <td> <span>{{ctrl.facturation.totalHT | number:2}}</span> </td> <td> <span>{{ctrl.facturation.tva | number:2}}</span> </td> <td> <span>{{ctrl.facturation.totalCPHT | number:2}}</span> </td> <td> <span>{{ctrl.facturation.totalTTC | number:2}}</span> </td> </tr> </tbody> </table> </div> </div> <div class=clearfix> <div class=row ng-hide=ctrl.showFacturesMedes()> <div class=\"form-group col-md-6\"> <h2>Facture MEDES</h2> <hr> <div ng-repeat=\"(libelle, nom) in ctrl.facturation.factures\"> <a class=\"btn btn-link\" ng-href=/api/facturation/download/{{nom}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{libelle}} </a> </div> </div> </div> <div class=clearfix> <div class=form-group> <div class=col-md-12> <div ng-hide=ctrl.disabled> <div class=pull-left> <button ng-show=\"ctrl.isUpdate && ctrl.statutActuel == \'BROUILLON\'\" type=button ng-click=ctrl.delete(ctrl.facturation) class=\"btn btn-default\">Supprimer</button> </div> <div class=\"pull-right col-offset-md-9\"> <button ng-show=\"ctrl.statutActuel == \'EMISE\'\" type=button ng-click=ctrl.creerAvoir(ctrl.facturation) class=\"btn btn-default\">Créer un avoir</button> <button ng-show=\"ctrl.isUpdate && ctrl.statutActuel == \'BROUILLON\'\" ng-click=\"submitted = true;ctrl.changeStatus(\'EMISE\');\" type=button class=\"btn btn-primary\">Emettre</button> <button ng-show=\"ctrl.statutActuel == \'EMISE\'\" type=button ng-click=\"submitted = true;ctrl.changeStatus(\'PAYE\');\" class=\"btn btn-primary\">Payer</button> <button ng-show=\"ctrl.statutActuel == \'BROUILLON\'\" type=submit ng-click=\"submitted = true;\" class=\"btn btn-default\">Enregistrer</button> </div> </div> </div> </div> </div></div></form> </div>");
$templateCache.put("app/projet/facturation/list/FacturationList.html","<div class=header> <h1>Facturation</h1> <hr> <div class=row> <div class=col-md-2> <div class=\"btn-group btn-group-justified\"> <div class=btn-group> <button ng-class=\"{\'active\': ctrl.filterFacture}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeFacture(true)>Facture</button> </div> <div class=btn-group> <button ng-class=\"{\'active\': !ctrl.filterFacture}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeFacture(false)>Avoir</button> </div> </div> </div> <div class=col-md-3> <div ng-show=ctrl.filterFacture class=\"btn-group btn-group-justified\"> <div class=btn-group> <label ng-model=ctrl.filterBrouillon uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatut(\'BROUILLON\');ctrl.getListFacture()\">Brouillon </label> </div> <div class=btn-group> <label ng-model=ctrl.filterEmise uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatut(\'EMISE\');ctrl.getListFacture()\">Emise </label> </div> <div class=btn-group> <label ng-model=ctrl.filterPaye uib-btn-checkbox class=\"btn btn-default btn-sm-1\" ng-change=\"ctrl.toggleStatut(\'PAYE\');ctrl.getListFacture()\">Payé </label> </div> </div> </div> <div class=\"col-md-offset-2 col-md-4\"> <input id=searchProjet type=text class=form-control placeholder=Rechercher ng-model=ctrl.searchText ng-change=ctrl.onChangeSearchText(ctrl.searchText)> </div> <div class=col-md-1 ng-hide=ctrl.read> <button ng-click=ctrl.add() type=button class=\"pull-right btn btn-primary\">Ajouter</button> </div> </div> </div> <div class=noData ng-if=\"ctrl.list.length === 0 \"> Aucune facturation trouvée </div> <div ng-if=ctrl.page gif-paged-data=ctrl.onPagingOptionsChange(pagingOptions) gif-page-size={{ctrl.pageSize}}> <small class=text-muted> <span><strong>{{ctrl.page.number+1 * ctrl.page.size}}</strong> Premières facturations parmi <strong>{{ctrl.page.totalElements}}</strong> {{ctrl.page.totalElements > 1 ? \'résultats\' : \'résultat\'}}</span> </small> <table class=\"table table-striped table-condensed\"> <thead> <th class=text-primary ng-click=\"ctrl.sort=\'code\'\">Code établissement <span class=\"pull-right glyphicon glyphicon-chevron-down\" ng-show=\"ctrl.sort==\'code\'\"></span></th> <th class=text-primary ng-click=\"ctrl.sort=\'reference\'\">Référence <span class=\"pull-right glyphicon glyphicon-chevron-down\" ng-show=\"ctrl.sort==\'reference\'\"></span></th> <th class=text-primary ng-click=\"ctrl.sort=\'libelle\'\">Libellé court <span class=\"pull-right glyphicon glyphicon-chevron-down\" ng-show=\"ctrl.sort==\'libelle\'\"></span></th> <th class=text-primary ng-click=\"ctrl.sort=\'financeur\'\">Financeur <span class=\"pull-right glyphicon glyphicon-chevron-down\" ng-show=\"ctrl.sort==\'financeur\'\"></span></th> <th class=text-primary ng-click=\"ctrl.sort=\'investigateur\'\"> Investigateur principal <span class=\"pull-right glyphicon glyphicon-chevron-down\" ng-show=\"ctrl.sort==\'investigateur\'\"></span> </th> <th class=text-primary ng-click=\"ctrl.sort=\'reference_facturation\'\"> Référence facturation <span class=\"pull-right glyphicon glyphicon-chevron-down\" ng-show=\"ctrl.sort==\'reference_facturation\'\"></span></th> <th class=text-primary ng-click=\"ctrl.sort=\'totalHT\'\"> Total HT <span class=\"pull-right glyphicon glyphicon-chevron-down\" ng-show=\"ctrl.sort==\'totalHT\'\"></span></th> <th class=text-primary ng-click=\"ctrl.sort=\'statut\'\"> Statut <span class=\"pull-right glyphicon glyphicon-chevron-down\" ng-show=\"ctrl.sort==\'statut\'\"></span></th> </thead> <tbody> <tr ng-click=ctrl.goTo(facturation.id) class=table_row ng-repeat=\"facturation in ctrl.list | orderBy:ctrl.sorts\"> <td>{{facturation.etablissement.code}}</td> <td>{{facturation.projet.reference}}</td> <td>{{facturation.objet}}</td> <td>{{facturation.financeur.libelle}}</td> <td>{{facturation.investigateur.nom}} {{facturation.investigateur.prenom}}</td> <td>{{facturation.numero}}</td> <td>{{facturation.montantHT | number:2}} €</td> <td>{{facturation.statut | translate}}</td> </tr> </tbody> </table> <div class=\"col-md-2 col-md-offset-5\"> <button ng-click=ctrl.viewMore() class=\"btn btn-default btn-sm\" ng-hide=ctrl.page.last> Afficher davantage </button> </div> </div>");
$templateCache.put("app/operation/item/demande_achat/DemandeAchatItem.html","<div class=header> <div class=row> <div class=col-md-6> <h1 ng-if=ctrl.isUpdate>Demande d\'achat - {{ctrl.demande.objet}}</h1> <h1 ng-if=!ctrl.isUpdate>Nouvelle demande d\'achat</h1> </div><!-- WIZARD ADMIN --> <span gif-role=!BENEFICIAIRE> <div class=col-md-6 ng-if=\"ctrl.statutActuel !== \'REFUSE\'\"> <div class=stepwizard> <div class=\"stepwizard-row setup-panel\"> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'BROUILLON\' || ctrl.statutActuel==\'ASOUMETTRE\'}\"> <strong>Brouillon</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'SOUMISE\'}\"> <strong>Soumise</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'VALIDE\'}\"> <strong>Validée</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'RECEPTIONNE\'}\"> <strong>Receptionnée</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'PAYE\'}\"> <strong>Payée</strong> </span> </div> </div> </div> </div> </span><!-- WIZARD ADMIN --> <span gif-role=BENEFICIAIRE> <div class=col-md-6 ng-if=\"ctrl.statutActuel !== \'REFUSE\'\"> <div class=stepwizard> <div class=\"stepwizard-row setup-panel\"> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'BROUILLON\'}\"> <strong>Brouillon</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'ASOUMETTRE\'}\"> <strong>Soumise</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'VALIDE\'}\"> <strong>Validée</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'RECEPTIONNE\'}\"> <strong>Receptionnée</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'PAYE\'}\"> <strong>Payée</strong> </span> </div> </div> </div> </div> </span> </div> <div class=row> <div class=col-md-12 ng-if=\"ctrl.statutActuel === \'REFUSE\'\"> <h3 class=text-danger>Motif de refus : {{ctrl.demande.motif}}</h3> </div> </div> <hr> </div><!-- Le ng-class permet de mettre les bordure en rouge pour les champ obligatoire --> <form id=demandeAchatForm name=form ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.demande)\" novalidate gif-server-validate=ctrl.serverErrors> <div class=row> <div class=\"form-group col-md-6 required\" gif-has-error> <label for=objet class=control-label> Objet </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.objet.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=objet name=objet ng-model=ctrl.demande.objet type=text class=form-control required ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" ng-maxlength=255> </div> <div class=\"form-group col-md-3\"> <label for=dateCreation> Date de création</label> <input id=dateCreation type=text class=form-control ng-model=ctrl.demande.dateCreation gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-disabled=true show-button-bar=false> </div> <div class=\"form-group col-md-3\"> <label for=dateSoumission> Date de soumission</label> <input id=dateSoumission type=text class=form-control ng-model=ctrl.demande.dateSoumission gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-disabled=true show-button-bar=false> </div> </div> <div class=row> <div class=\"form-group col-md-6\"> <label for=numeroPiece class=control-label> Numéro de pièce</label> <input id=numeroPiece name=numero ng-model=ctrl.demande.numero ng-disabled=true type=text class=form-control> </div> <div class=\"form-group col-md-3\"> <label for=dateValidation> Date de validation </label> <input id=dateValidation type=text class=form-control ng-model=ctrl.demande.dateValidation gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-disabled=true show-button-bar=false> </div> <div class=\"form-group col-md-3\"> <label for=datePaiement> Date de paiement </label> <input id=datePaiement type=text class=form-control ng-model=ctrl.demande.datePaiement gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-disabled=true show-button-bar=false> </div> </div> <div class=row> <div class=\"form-group col-md-6 required\" gif-has-error> <label for=demandeur class=control-label> Demandeur</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.demandeur.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div ng-class=\"{\'input-group\': ctrl.demande.demandeur}\"> <input id=demandeur name=demandeur ng-model=ctrl.demande.demandeur uib-typeahead=\"demandeur as (demandeur.nom +\' \'+ demandeur.prenom) for demandeur in ctrl.autocompleteDemandeur($viewValue,ctrl.demande.compte.etablissement.id)\" typeahead-on-select=ctrl.showButtonSoumettre();ctrl.onChangeDemandeur($item); typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher... ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" required> <span ng-if=ctrl.demande.demandeur class=input-group-btn> <a ng-href=\"{{ctrl.demande.demandeur.contacts !== undefined ? \'/#/referentiel/investigateur/\'+ctrl.demande.demandeur.id : \'/#/referentiel/beneficiaire/\'+ctrl.demande.demandeur.id}}\" target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> <div class=\"form-group col-md-6 required\" gif-has-error> <label for=compte class=control-label> Compte</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.compte.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div ng-class=\"{\'input-group\': ctrl.demande.compte}\"> <input id=compte name=compte ng-model=ctrl.demande.compte uib-typeahead=\"compte as (compte.code +\' - \'+ compte.libelle) for compte in ctrl.autocompleteCompte($viewValue)\" typeahead-on-select=ctrl.showButtonSoumettre();ctrl.onChangeCompte(); typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher... ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" required> <span ng-if=ctrl.demande.compte class=input-group-btn> <a href=/#/compte/{{ctrl.demande.compte.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </div> <div class=row> <div class=\"form-group col-md-6\" gif-has-error> <label for=rue class=control-label> Adresse de livraison</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.rue.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=rue ng-model=ctrl.demande.adresseLivraison.rue ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" type=text class=form-control ng-maxlength=255> </div> <div class=\"form-group col-md-3\" gif-has-error> <label for=codePostal class=control-label> Code Postal</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.codePostal.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=codePostal ng-model=ctrl.demande.adresseLivraison.codePostal ng-maxlength=255 ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" type=text class=form-control> </div> <div class=\"form-group col-md-3\" gif-has-error> <label for=ville class=control-label> Ville</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.ville.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=ville ng-model=ctrl.demande.adresseLivraison.ville ng-maxlength=255 ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" type=text class=form-control> </div> </div> <div class=row> <div class=\"form-group col-md-6 required\" gif-has-error> <label for=fournisseur class=control-label> Fournisseur</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.fournisseur.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div ng-class=\"{\'input-group\': ctrl.demande.fournisseur}\"> <input id=fournisseur name=fournisseur ng-model=ctrl.demande.fournisseur uib-typeahead=\"fournisseur as (fournisseur.code +\' - \'+ fournisseur.libelle) for fournisseur in ctrl.autocompleteFournisseur($viewValue)\" typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher... ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" required> <span ng-if=ctrl.demande.fournisseur class=input-group-btn> <a href=/#/referentiel/fournisseur/{{ctrl.demande.fournisseur.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> <div class=col-md-2> <div class=form-group> <label for=materielBiomedical>Matériel Biomédical ?</label> <div> <toggle-switch is-disabled=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" id=materielBiomedical ng-model=ctrl.demande.materielBiomedical on-label=Oui off-label=Non on-change=\"ctrl.demande.materielCHU = ctrl.demande.materielBiomedical\"> </toggle-switch> </div> </div> </div> <div class=col-md-2> <div class=form-group> <label for=materielCHU>Matériel dans le parc du CHU ?</label> <div> <toggle-switch is-disabled=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.demande.materielBiomedical || ctrl.disable\" id=materielCHU ng-model=ctrl.demande.materielCHU on-label=Oui off-label=Non> </toggle-switch> </div> </div> </div> </div> <div class=row> <div class=\"form-group col-md-6\"> <label for=description class=control-label> Description </label> <textarea id=description name=description ng-model=ctrl.demande.description class=form-control rows=4 ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" maxlength=255>\n            </textarea> <small> Il vous reste <span>{{255 - ctrl.demande.description.length}}</span> <span ng-if=\"255 - ctrl.demande.description.length != 1 && 255 - ctrl.demande.description.length != 0\">caractères</span> <span ng-if=\"255 - ctrl.demande.description.length == 1 || 255 - ctrl.demande.description.length == 0\">caractère</span>  </small> </div> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=montantTTC class=control-label> Montant total TTC</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.montantTTC.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=montantTTC name=montantTTC type=text class=form-control ng-model=ctrl.demande.montantTTC ng-disabled=true required> </div> <div class=\"form-group col-md-3 required\" ng-if=\"ctrl.statutActuel !== \'BROUILLON\'\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER gif-has-error> <label for=montantTVA class=control-label>Montant TVA</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.montantTVA.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=montantTVA name=montantTVA type=number class=form-control ng-model=ctrl.demande.montantTVA ng-disabled=\"ctrl.statutActuel === \'PAYE\'\" ng-init=0 min=0 step=1 max={{ctrl.demande.montantTTC}} required> </div> <div class=\"form-group col-md-3 required\" ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\'\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER gif-has-error> <label for=montantPartiel class=control-label>Montant paiement partiel</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.montantPartiel.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=montantPartiel name=montantPartiel type=number class=form-control ng-model=ctrl.demande.montantPaiementPartiel ng-init=0 ng-required=\"ctrl.statutActuel === \'RECEPTIONNE\'\" min=0 step=1 max={{ctrl.demande.montantTTCRestant}}> </div> <div class=\"form-group col-md-3 required\" ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' && ctrl.afficherInputNumeroCheque\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER gif-has-error> <label for=numeroCheque class=control-label>Numéro du chèque</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.numeroCheque.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=numeroCheque name=numeroCheque class=form-control ng-model=ctrl.demande.numeroPaiement ng-required=\"(ctrl.demande.montantPaiementPartiel !== 0 && (ctrl.statutActuel === \'VALIDE\' || ctrl.statutActuel === \'RECEPTIONNE\') \n					&& ctrl.afficherInputNumeroCheque) || (ctrl.remboursementBeneficiaire && ctrl.afficherInputNumeroCheque)\"> </div> <div class=\"form-group col-md-3\" ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' && ctrl.demande.paiements.length != 0 && ctrl.demande.paiements != null\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER> <label for=montantTTCRestant class=control-label>Montant restant à payer</label> <input id=montantTTCRestant name=montantTTCRestant type=number class=form-control ng-model=ctrl.demande.montantTTCRestant disabled> </div> </div> <div class=row> <div class=\"form-group col-md-6\" ng-if=\"ctrl.afficherSoumettre || ctrl.demande.certifie\"> <input type=checkbox id=certifie ng-model=ctrl.demande.certifie ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' && ctrl.statutActuel !=\'ASOUMETTRE\'\"> <label for=certifie> Je certifie que cette demande d\'achat rentre dans le cadre de la recherche clinique</label> </div> <div class=\"form-group col-md-6\"></div> </div> <uib-tabset active=active> <uib-tab index=0 heading=Détails><!--  Tableau des bons de commandes --> <div class=row> <div class=col-md-12> <br> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-1\">Numéro</th> <th class=\"text-primary col-md-6\">Libelle</th> <th gif-role=ADMIN ng-if=\"ctrl.statutActuel===\'RECEPTIONNE\' || ctrl.statutActuel===\'PAYE\'\" class=\"text-primary col-md-2\">Compte charge</th> <th class=\"text-primary col-md-3\">Montant TTC</th> <th ng-if=\"ctrl.statutActuel===\'BROUILLON\'\" class=col-md-1></th> </thead> <tbody> <tr ng-repeat=\"bonCommande in ctrl.demande.bonCommandes\"> <td>{{$index + 1}}</td> <td> <input ng-model=bonCommande.libelle type=text class=form-control ng-if=\"ctrl.statutActuel===\'BROUILLON\'\" ng-disabled=ctrl.disable> <span ng-if=\"ctrl.statutActuel!==\'BROUILLON\'\">{{bonCommande.libelle}}</span> </td> <td gif-role=ADMIN ng-if=\"ctrl.statutActuel===\'RECEPTIONNE\' || ctrl.statutActuel===\'PAYE\'\"> <select name=compte_charge class=form-control ng-model=bonCommande.compteCharge ng-if=\"ctrl.statutActuel===\'RECEPTIONNE\'\" ng-options=\"compte as (compte.numero + \' - \'+ compte.libelle) for compte in ctrl.compteCharge track by compte.id\" ng-required=\"ctrl.statutActuel===\'RECEPTIONNE\'\"><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> <span ng-if=\"ctrl.statutActuel===\'PAYE\'\">{{bonCommande.compteCharge.numero}} - {{bonCommande.compteCharge.libelle}}</span> </td> <td> <div ng-class=\"{\'has-error\': (form[\'total{{$index}}\'].$invalid && form[\'total{{$index}}\'].$touched)}\"><!-- Partie non admin --> <input gif-role=!ADMIN name=total{{$index}} ng-model=bonCommande.total type=number min=0 ng-init=\"bonCommande.total==null ? bonCommande.total=0 : bonCommande.total\" class=form-control ng-if=\"ctrl.statutActuel===\'BROUILLON\'\" ng-change=ctrl.updateMontantTTC() ng-disabled=ctrl.disable required> <span gif-role=!ADMIN class=pull-right ng-if=\"ctrl.statutActuel!==\'BROUILLON\'\">{{bonCommande.total | number:2}}</span><!-- Partie admin --> <input gif-role=ADMIN name=total{{$index}} ng-model=bonCommande.total type=number min={{ctrl.demande.montantTVA}} ng-init=\"bonCommande.total==null ? bonCommande.total=0 : bonCommande.total\" class=form-control ng-if=\"ctrl.statutActuel!==\'PAYE\'\" ng-change=ctrl.updateMontantTTC() required> <span gif-role=ADMIN class=pull-right ng-if=\"ctrl.statutActuel===\'PAYE\'\">{{bonCommande.total | number:2}}</span> <ng-messages class=help-block for=\"form[\'total\' + $index].$error\" ng-if=\"form[\'total\' + $index].$touched\"> <ng-messages-include src=app/default-messages.html> </ng-messages> </div> </td> <td ng-if=\"ctrl.statutActuel===\'BROUILLON\'\" ng-hide=ctrl.disable> <a ng-click=ctrl.removeDetail($index) class=\"btn btn-link pull-right\"> <span title=\"Retirer un détail\" class=\"glyphicon glyphicon-trash\" aria-hidden=true></span> </a> </td> </tr> </tbody> </table> <button ng-hide=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" ng-click=ctrl.addDetail() type=button class=\"btn btn-link btn-sm\"> <span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span> Ajouter </button> </div> </div> </uib-tab> <uib-tab index=1 heading=\"Paiements partiels\" ng-if=\"ctrl.demande.paiements.length != 0 && ctrl.demande.paiements != null\"><!--  Tableau des paiements partiels --> <div class=row> <div class=col-md-12> <br> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-2\">N° paiement</th> <th class=\"text-primary col-md-2\">Date</th> <th class=\"text-primary col-md-2\">Type de paiement</th> <th class=\"text-primary col-md-2\">Montant</th> <th class=\"text-primary col-md-2\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER>Choix du paiement </th> <th class=\"text-primary col-md-2\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER>Numéro</th> </thead> <tbody> <tr ng-repeat=\"paiement in ctrl.demande.paiements | filter:-date\"> <td>{{paiement.numero}}</td> <td>{{paiement.date | date:\'dd/MM/yyyy\'}}</td> <td>{{paiement.typePaiement | translate}}</td> <td>{{paiement.montant | number:2}}</td> <td gif-role=ADMIN,INTERLOCUTEUR,FINANCIER> {{paiement.choixPaiementPartiel | translate}}</td> <td gif-role=ADMIN,INTERLOCUTEUR,FINANCIER>{{paiement.numeroPaiement}}</td> </tr> </tbody> </table> </div> </div> </uib-tab> <uib-tab index=3 heading=\"Justificatifs des Achats\" ng-if=\"ctrl.statutActuel !== \'BROUILLON\'\"> <div class=row> <div class=col-md-6 ng-if=\"ctrl.statutActuel !== \'BROUILLON\'\"> <h2>Pièce jointe</h2> <hr> <div ng-repeat=\"pj in ctrl.demande.fichiers | filter:{ type: \'PIECEJOINTE\'}\"> <a class=\"btn btn-link\" ng-href=/api/demande/achat_fichier/download/{{pj.nomFichier}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{pj.libelle}} </a> </div> </div> <div class=\"form-group col-md-6\" ng-if=\"ctrl.statutActuel != \'BROUILLON\' && ctrl.statutActuel != \'SOUMISE\' && ctrl.statutActuel != \'ASOUMETTRE\'\"> <h2>Bon de commande</h2> <hr> <div ng-repeat=\"pj in ctrl.demande.fichiers | filter:{ type: \'BONCOMMANDE\'}\"> <a class=\"btn btn-link\" ng-href=/api/demande/achat_fichier/download/{{pj.nomFichier}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{pj.libelle}} </a> </div> </div> </div> <div class=row> <div class=col-md-6 ng-if=\"ctrl.statutActuel == \'VALIDE\' || ctrl.statutActuel == \'RECEPTIONNE\' || ctrl.statutActuel == \'PAYE\'\"> <div ng-if=\"ctrl.statutActuel == \'VALIDE\' || ctrl.statutActuel == \'RECEPTIONNE\' || ctrl.statutActuel == \'PAYE\'\"> <h2>Bon de Livraison</h2> <hr> <div> <div ng-repeat=\"pj in ctrl.demande.fichiers | filter:{ type: \'BONLIVRAISON\'}\"> <a class=\"btn btn-link\" ng-href=/api/demande/achat_fichier/download/{{pj.nomFichier}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{pj.libelle}} </a> </div> </div> </div> </div> <div class=col-md-6 ng-if=\"ctrl.statutActuel == \'RECEPTIONNE\' || ctrl.statutActuel == \'PAYE\'\"> <h2>Facture</h2> <hr> <div ng-if=\"ctrl.statutActuel == \'RECEPTIONNE\' || ctrl.statutActuel == \'PAYE\'\"> <div ng-repeat=\"pj in ctrl.demande.fichiers | filter:{ type: \'FACTURE\'}\"> <a class=\"btn btn-link\" ng-href=/api/demande/achat_fichier/download/{{pj.nomFichier}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{pj.libelle}} réceptionné le {{pj.dateFichier | date : \'dd/MM/yyyy\'}} </a> </div> </div> </div> </div> <div class=row> <div class=col-md-6 ng-if=\"ctrl.statutActuel == \'PAYE\'\"> <h2>Bilan Financier</h2> <hr> <div ng-if=\"ctrl.statutActuel == \'PAYE\'\"> <div ng-repeat=\"pj in ctrl.demande.fichiers | filter:{ type: \'BILANFINANCIER\'}\"> <a class=\"btn btn-link\" ng-href=/api/demande/achat_fichier/download/{{pj.nomFichier}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{pj.libelle}} </a> </div> </div> </div> </div> <div class=row> <div class=col-md-12></div> </div> </uib-tab> </uib-tabset> <div class=row> <div class=\"form-group col-md-6\" ng-if=\"ctrl.statutActuel == \'BROUILLON\'\"> <h2>Pièce jointe</h2> <hr> <div> <div class=\"row col-md-6\" ng-hide=ctrl.disable> <div gif-has-error> <input id=id_pj name=pj type=file ng-model=pj nv-file-select uploader=ctrl.getFileUpload ng-required=\"!ctrl.demande.id && ctrl.getFileUpload.queue.length == 0\" multiple> <ng-messages class=\"pull-left text-danger has-error-messages\" for=form.pj.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> </div> <div ng-repeat=\"item in ctrl.getFileUpload.queue\" ng-if=\"ctrl.getFileUpload.queue.length != 0\"> <span> {{item.file.name}} <a class=\"btn btn-link\"> <span ng-click=ctrl.removeFile($index) class=\"glyphicon glyphicon-remove\"></span> </a> </span> </div> </div> <div class=col-md-6> <div ng-repeat=\"pj in ctrl.demande.fichiers | filter:{ type: \'PIECEJOINTE\'}\"> <a class=\"btn btn-link\" ng-href=/api/demande/achat_fichier/download/{{pj.nomFichier}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{pj.libelle}} </a> </div> </div> </div> </div> </div> <div class=row> <div ng-if=\"ctrl.statutActuel === \'VALIDE\' || ctrl.statutActuel === \'RECEPTIONNE\' || ctrl.statutActuel === \'PAYE\'\"> <div class=col-md-6 gif-role=!ETABLISSEMENT ng-if=\"ctrl.statutActuel === \'VALIDE\' || ctrl.statutActuel === \'RECEPTIONNE\'\"> <h2>Bon de Livraison</h2> <hr> <div ng-if=\"ctrl.statutActuel === \'VALIDE\' || ctrl.statutActuel === \'RECEPTIONNE\'\" class=col-md-6> <div gif-has-error> <input id=id_pjbl name=pj type=file ng-model=pj nv-file-select uploader=ctrl.getFileUpload ng-required=\"!ctrl.demande.id && ctrl.getFileUpload.queue.length == 0\" multiple> <ng-messages class=\"pull-left text-danger has-error-messages\" for=form.pj.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> </div> <div ng-repeat=\"item in ctrl.getFileUpload.queue\" ng-if=\"ctrl.getFileUpload.queue.length != 0\"> <span> {{item.file.name}} <a class=\"btn btn-link\"> <span ng-click=ctrl.removeFile($index) class=\"glyphicon glyphicon-remove\"></span> </a> </span> </div> </div> </div> <div class=col-md-6 gif-role=ADMIN ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\'\"> <h2>Facture</h2> <hr> <div ng-if=\"ctrl.statutActuel == \'RECEPTIONNE\'\"> <div class=col-md-6 gif-has-error ng-required=\"!ctrl.demande.id && ctrl.getFileUploadFacture.queue.length == 0\"> <input id=id_pjfacture name=pj type=file ng-model=pj nv-file-select uploader=ctrl.getFileUploadFacture options=\"{dateFichier: ctrl.dateFichier}\" ng-disabled=!ctrl.demande.dateReceptionFacture ng-required=\"!ctrl.demande.id && ctrl.getFileUploadFacture.queue.length == 0 \" ng-disabled=!ctrl.activeUploadFacture multiple> <div ng-repeat=\"item in ctrl.getFileUploadFacture.queue\" ng-if=\"ctrl.getFileUploadFacture.queue.length != 0\"> <span> {{item.file.name}} <a class=\"btn btn-link\"> <span ng-click=ctrl.removeFileFacture($index) class=\"glyphicon glyphicon-remove\"></span> </a> </span> </div> </div> <div class=col-md-6> <label for=datePicker>Date de réception</label> <div class=input-group> <input id=datePicker ng-disabled=ctrl.disabled name=debut type=text class=form-control uib-datepicker-popup={{ctrl.dateFormat}} ng-model=ctrl.demande.dateReceptionFacture is-open=dateDebutPopup.opened placeholder=jj/mm/aaaa ng-change=\"ctrl.activeUploadFacture=true;\" ng-required=\"!ctrl.demande.id && ctrl.getFileUploadFacture.queue.length == 0 \"> <span class=input-group-btn> <button ng-disabled=ctrl.disabled type=button class=\"btn btn-default\" ng-click=\"dateDebutPopup.opened=true\"> <span class=\"glyphicon glyphicon-calendar text-primary\"></span> </button> </span> </div> <ng-messages class=\"pull-left text-danger has-error-messages\" for=form.pj.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> </div> </div> </div> </div> <br> </div> <div class=row> <div class=col-md-12> <div class=pull-left ng-hide=ctrl.disable> <button ng-if=\"ctrl.isUpdate && ctrl.statutActuel == \'BROUILLON\'\" type=button ng-click=ctrl.confirmDelete(ctrl.demande) class=\"btn btn-default\">Supprimer</button> </div> <div class=pull-right> <a class=\"btn btn-link\" href=/#/operation/list>Annuler</a><!-- uniquement pour les b�n�ficiaires --> <button type=button ng-disabled=!form.$valid ng-if=\"!ctrl.isUpdate && ctrl.statutActuel == \'BROUILLON\' && ctrl.role===\'BENEFICIAIRE\'\" ng-click=\"ctrl.soumissionParBeneficiaire(ctrl.demande,\'ASOUMETTRE\');\" class=\"btn btn-primary\">Soumettre</button> <button type=button ng-disabled=!form.$valid ng-if=\"ctrl.isUpdate && ctrl.statutActuel == \'BROUILLON\' && ctrl.role===\'BENEFICIAIRE\'\" ng-click=\"ctrl.soumissionParBeneficiaire(ctrl.demande,\'ASOUMETTRE\');\" class=\"btn btn-primary\">Soumettre</button> <button type=submit gif-role=!BENEFICIAIRE ng-if=\"!ctrl.isUpdate && ctrl.statutActuel == \'BROUILLON\' && ctrl.afficherSoumettre\" ng-disabled=!ctrl.demande.certifie ng-click=ctrl.changeActionSubmit(true); class=\"btn btn-primary\">Soumettre</button> <button type=button gif-role=!BENEFICIAIRE ng-if=\"ctrl.isUpdate && (ctrl.statutActuel == \'BROUILLON\' || ctrl.statutActuel == \'ASOUMETTRE\')  && ctrl.afficherSoumettre\" ng-disabled=!ctrl.demande.certifie ng-click=\"ctrl.changeStatus(\'SOUMISE\');ctrl.changeActionSubmit(true);\" class=\"btn btn-primary\">Soumettre</button> <button type=button ng-if=\"ctrl.statutActuel === \'SOUMISE\' && !ctrl.demande.validerParEtablissement && ctrl.demande.materielCHU\" gif-role=ETABLISSEMENT ng-click=ctrl.motifRefus(); class=\"btn btn-default\">Refuser</button> <button type=button ng-if=ctrl.afficherRefuser gif-role=ADMIN,INTERLOCUTEUR,FINANCIER ng-click=ctrl.motifRefus(); class=\"btn btn-default\">Refuser</button> <button type=submit ng-click=ctrl.changeValiderParEtablissement(true); class=\"btn btn-primary\" ng-if=\"ctrl.statutActuel === \'SOUMISE\' && !ctrl.demande.validerParEtablissement && ctrl.demande.materielCHU\" gif-role=ETABLISSEMENT>Valider</button><!-- Permet de gérer les différents cas de l\'enregistrement d\'une DA. Si on accepte les pièces jointes \n					sans vérification du formulaire ( évite les required)  --> <button gif-role=ADMIN ng-if=\"ctrl.statutActuel !== \'RECEPTIONNE\' && ctrl.statutActuel !== \'PAYE\'\" type=submit class=\"btn btn-default\">Enregistrer</button> <button gif-role=ADMIN ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\'\" type=button ng-click=ctrl.saveOrUpdateWithoutUploadFile(ctrl.demande) class=\"btn btn-default\">Enregistrer</button> <button ng-disabled=form.$invalid type=button ng-if=ctrl.afficherEmettre ng-click=\"ctrl.changeStatus(\'VALIDE\');\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER class=\"btn btn-primary\">Emettre le bon de commande</button> <button type=button ng-if=\"ctrl.statutActuel === \'VALIDE\' && ctrl.afficherReceptionner\" ng-click=\"ctrl.changeStatus(\'RECEPTIONNE\');\" class=\"btn btn-primary\">Réceptionner</button> <div ng-if=\"ctrl.statutActuel == \'RECEPTIONNE\'\" class=\"btn-group dropup\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER uib-dropdown> <button ng-disabled=form.$invalid id=bouton_payer type=button class=\"btn btn-primary\" uib-dropdown-toggle> Payer <span class=caret></span> </button> <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=bouton_payer> <li> <button type=submit class=\"form-control btn btn-link\" ng-click=\"ctrl.changeStatusWithoutSave(\'PAYE\')\">Payer</button> </li> <li> <button type=submit class=\"form-control btn btn-link\" ng-disabled=\"ctrl.demande.montantPaiementPartiel === 0\" ng-click=\"ctrl.changeTypePaiement(\'PAIEMENT_PARTIEL\')\">Paiement partiel</button> </li> </ul> </div> <button ng-hide=ctrl.disable gif-role=!ADMIN ng-if=\"ctrl.statutActuel == \'BROUILLON\'\" type=submit ng-click=ctrl.changeActionSubmit(false); class=\"btn btn-default\">Enregistrer</button> </div> </div> </div> </form>");
$templateCache.put("app/operation/item/demande_mission/DemandeMissionItem.html","<div class=header> <div class=row> <div class=col-md-6> <h1 ng-if=ctrl.isUpdate>Demande de mission - {{ctrl.demande.objet}}</h1> <h1 ng-if=!ctrl.isUpdate>Nouvelle demande de mission</h1> </div><!-- WIZARD ADMIN --> <span gif-role=!BENEFICIAIRE> <div class=col-md-6 ng-if=\"ctrl.statutActuel !== \'REFUSE\'\"> <div class=stepwizard> <div class=\"stepwizard-row setup-panel\"> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'BROUILLON\'}\"> <strong>Brouillon</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'SOUMISE\'}\"> <strong>Soumise</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'VALIDE\'}\"> <strong>Validée</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'RECEPTIONNE\'}\"> <strong>Réceptionnée</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'PAYE\'}\"> <strong>Payée</strong> </span> </div> </div> </div> </div> </span><!-- WIZARD BENEFICIAIRE --> <span gif-role=BENEFICIAIRE> <div class=col-md-6 ng-if=\"ctrl.statutActuel !== \'REFUSE\'\"> <div class=stepwizard> <div class=\"stepwizard-row setup-panel\"> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'BROUILLON\'}\"> <strong>Brouillon</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'ASOUMETTRE\'}\"> <strong>Soumise</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'VALIDE\'}\"> <strong>Validée</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'RECEPTIONNE\'}\"> <strong>Réceptionnée</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-5\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'PAYE\'}\"> <strong>Payée</strong> </span> </div> </div> </div> </div> </span> </div> <div class=row> <div class=col-md-12 ng-if=\"ctrl.statutActuel === \'REFUSE\'\"> <h3 class=text-danger>Motif de refus : {{ctrl.demande.motif}}</h3> </div> </div> <hr> </div><!-- Le ng-class permet de mettre les bordure en rouge pour les champ obligatoire --> <form id=demandeMissionForm name=form ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.demande)\" novalidate gif-server-validate=ctrl.serverErrors> <div class=row> <div class=\"form-group col-md-6 required\" gif-has-error> <label for=object class=control-label> Objet </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.objet.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=object name=objet ng-model=ctrl.demande.objet type=text class=form-control required ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\'\" ng-maxlength=255> </div> <div class=\"form-group col-md-3\"> <label for=dateCreation> Date de création</label> <input id=dateCreation type=text class=form-control ng-model=ctrl.demande.dateCreation gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-disabled=true show-button-bar=false> </div> <div class=\"form-group col-md-3\"> <label for=dateSoumission> Date de soumission</label> <input id=dateSoumission type=text class=form-control ng-model=ctrl.demande.dateSoumission gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-disabled=true show-button-bar=false> </div> </div> <div class=row> <div class=\"form-group col-md-6\"> <label for=numeroPiece class=control-label> Numéro de pièce</label> <input id=numeroPiece name=numero ng-model=ctrl.demande.numero ng-disabled=true type=text class=form-control> </div> <div class=\"form-group col-md-3\"> <label for=dateValidation> Date de validation </label> <input id=dateValidation type=text class=form-control ng-model=ctrl.demande.dateValidation gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-disabled=true show-button-bar=false> </div> <div class=\"form-group col-md-3\"> <label for=datePaiement> Date de paiement </label> <input id=datePaiement type=text class=form-control ng-model=ctrl.demande.datePaiement gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-disabled=true show-button-bar=false> </div> </div> <div class=row> <div class=\"form-group col-md-6 required\" gif-has-error> <label for=demandeur class=control-label> Demandeur</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.demandeur.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div ng-class=\"{\'input-group\': ctrl.demande.demandeur}\"> <input id=demandeur name=demandeur ng-model=ctrl.demande.demandeur uib-typeahead=\"demandeur as (demandeur.nom +\' \'+ demandeur.prenom) for demandeur in ctrl.autocompleteDemandeur($viewValue,ctrl.demande.compte.etablissement.id)\" typeahead-editable=false typeahead-on-select=ctrl.onChangeDemandeur($item) type=text class=form-control autocomplete=off placeholder=Rechercher... ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\'\" required> <span ng-if=ctrl.demande.demandeur class=input-group-btn> <a ng-href=\"{{ctrl.demande.demandeur.contacts !== undefined ? \'/#/referentiel/investigateur/\'+ctrl.demande.demandeur.id : \'/#/referentiel/beneficiaire/\'+ctrl.demande.demandeur.id}}\" target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> <div class=\"form-group col-md-6 required\" gif-has-error> <label for=compte class=control-label> Compte</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.compte.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div ng-class=\"{\'input-group\': ctrl.demande.compte}\"> <input id=compte name=compte ng-model=ctrl.demande.compte uib-typeahead=\"compte as (compte.code +\' - \'+ compte.libelle) for compte in ctrl.autocompleteCompte($viewValue)\" typeahead-on-select=ctrl.showButtonSoumettre();ctrl.onChangeCompte(); typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher... ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\'\" required> <span ng-if=ctrl.demande.compte class=input-group-btn> <a href=/#/compte/{{ctrl.demande.compte.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </div> <div class=row> <div class=\"form-group col-md-6\"> <label for=description> Description </label> <textarea id=description name=description ng-model=ctrl.demande.description class=form-control rows=4 ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\'\" maxlength=255 required>\n        </textarea> <small> Il vous reste <span>{{255 - ctrl.demande.description.length}}</span> <span ng-if=\"255 - ctrl.demande.description.length != 1 && 255 - ctrl.demande.description.length != 0\">caractères</span> <span ng-if=\"255 - ctrl.demande.description.length == 1 || 255 - ctrl.demande.description.length == 0\">caractère</span>  </small> </div> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=montantTotalTTC class=control-label> Montant total TTC</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.montantTTC.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=montantTotalTTC tooltip-placement=bottom uib-tooltip=\"Budget maximum sollicité pour cette mission\" name=montantTTC type=number class=form-control ng-model=ctrl.demande.montantTTC disabled required> </div> <div class=\"form-group col-md-3\" ng-if=\"ctrl.statutActuel === \'BROUILLON\' || ctrl.statutActuel === \'ASOUMETTRE\' || ctrl.statutActuel === \'SOUMISE\' || ctrl.statutActuel === \'VALIDE\'\"> <label for=avance>Demander une avance ?</label> <div> <toggle-switch id=avance ng-model=ctrl.demande.demanderAvance on-label=Oui off-label=Non is-disabled=\"(ctrl.statutActuel === \'ASOUMETTRE\' && ctrl.role===\'BENEFICIAIRE\') || ctrl.statutActuel === \'SOUMISE\' || ctrl.statutActuel === \'VALIDE\'\"> </toggle-switch> </div> </div> <div class=\"form-group col-md-3\" ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\'\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER> <label for=montantRestantTTC>Montant TTC Restant</label> <input id=montantRestantTTC name=montantTTCRestant type=number class=form-control ng-model=ctrl.demande.montantTTCRestant disabled> </div> <div class=\"form-group col-md-3\" ng-if=\"ctrl.demande.demanderAvance && ctrl.statutActuel == \'VALIDE\' && ctrl.demande.paiements.length === 0\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER gif-has-error> <label for=montantPatielValide class=control-label>Avance</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.montantPartiel.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=montantPatielValide name=montantPartiel type=number class=form-control ng-model=ctrl.demande.montantPaiementPartiel ng-init=0 ng-required=\"ctrl.statutActuel === \'RECEPTIONNE\'\" min=0 step=1 max={{ctrl.demande.montantTTC}}> </div> <div class=\"form-group col-md-3\" ng-if=\"ctrl.statutActuel == \'RECEPTIONNE\'\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER gif-has-error> <label for=montantPartielReceptionne class=control-label>Montant paiement partiel</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.montantPartiel.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=montantPartielReceptionne name=montantPartiel type=number class=form-control ng-model=ctrl.demande.montantPaiementPartiel ng-init=0 ng-required=\"ctrl.statutActuel == \'RECEPTIONNE\'\" min=0 step=1 max={{ctrl.demande.montantTTCRestant}}> </div> <div class=\"form-group col-md-3 required\" ng-if=\"(ctrl.demande.demanderAvance && ctrl.statutActuel == \'VALIDE\' && ctrl.demande.paiements.length === 0|| ctrl.statutActuel == \'RECEPTIONNE\') \n                && ctrl.afficherInputNumeroCheque\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER gif-has-error> <label for=numeroCheque class=control-label>Numéro du chèque</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.numeroCheque.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=numeroCheque name=numeroCheque class=form-control ng-model=ctrl.demande.numeroPaiement ng-required=\"((((ctrl.demande.paiementAmplitude || ctrl.demande.montantPaiementPartiel !== 0) \n                            && (ctrl.statutActuel === \'VALIDE\' || ctrl.statutActuel === \'RECEPTIONNE\') \n                            && ctrl.afficherInputNumeroCheque) || (ctrl.remboursementBeneficiaire && ctrl.afficherInputNumeroCheque) \n                            || (ctrl.afficherRemboursementBeneficiaire && ctrl.afficherInputNumeroCheque)) && ctrl.numeroChequeRequired)\"> </div> </div> <div class=row ng-if=ctrl.afficherSoumettre> <div class=\"form-group col-md-6\"> <input type=checkbox id=certifie ng-model=ctrl.demande.certifie ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' && ctrl.statutActuel !=\'ASOUMETTRE\'\"> <label for=certifie> Je certifie que cette demande de mission rentre dans le cadre de la recherche clinique</label> </div> </div> <uib-tabset active=active> <uib-tab index=0 heading=\"Etape Mission\"><!--  Tableau des détails --> <div class=row> <div class=col-md-12> <br> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-1\">Numéro</th> <th class=\"text-primary col-md-3\">Destination</th> <th class=\"text-primary col-md-2\">Début</th> <th class=\"text-primary col-md-2\">Fin</th> <th class=col-md-1></th> </thead> <tbody> <tr ng-repeat=\"etape in ctrl.demande.etapes\"> <td>{{etape.numero}}</td> <td>{{etape.lieu}}</td> <td>{{etape.dateDebut | date:\"dd/MM/yyyy HH:mm\"}}</td> <td>{{etape.dateFin | date:\"dd/MM/yyyy HH:mm\"}}</td> <td> <a ng-click=ctrl.removeEtape(etape.numero) ng-hide=\"ctrl.statutActuel!==\'BROUILLON\'\" class=\"btn btn-link pull-right\"> <span title=\"Retirer une étape\" class=\"glyphicon glyphicon-trash\" aria-hidden=true></span> </a> </td> </tr> </tbody> </table> <button ng-hide=\"ctrl.statutActuel!=\'BROUILLON\'\" ng-click=ctrl.addEtape() type=button class=\"btn btn-link btn-sm\"> <span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span> Ajouter </button> </div> </div> </uib-tab> <uib-tab index=1 heading=\"Poste de dépense\"> <div class=row> <div class=col-md-12> <br> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-1\">N° étape</th> <th class=\"text-primary col-md-2\">Poste</th> <th class=\"text-primary col-md-2\">Montant prévu</th> <th class=\"text-primary col-md-1\">Quantité</th> <th class=\"text-primary col-md-1\">Sélectionner</th> <th class=\"text-primary col-md-1\" ng-hide=\"ctrl.statutActuel === \'RECEPTIONNE\' || ctrl.statutActuel === \'PAYE\' \">Type </th> <th class=\"text-primary col-md-1\" ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' || ctrl.statutActuel === \'PAYE\' \">Montant réel TTC </th> <th class=\"text-primary col-md-1\" ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' || ctrl.statutActuel === \'PAYE\' \" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER>Taux TVA </th> <th class=\"text-primary col-md-1\" ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' || ctrl.statutActuel === \'PAYE\' \" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER>Montant réel HT </th> <th class=\"text-primary col-md-1\" ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' || ctrl.statutActuel === \'PAYE\' \" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER>Montant TVA </th> <th class=\"text-primary col-md-2\" ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' && !ctrl.demande.soumissionJustificatifOver && (ctrl.demande.paiements.length === 0 || (ctrl.demande.paiements.length === 1 && ctrl.demande.paiements[0].typePaiement === \'AVANCE\'))\"> Pièce jointe </th> </thead> <tbody> <tr ng-repeat=\"depense in ctrl.demande.depenses | categorieSorter : \'typeFrais\'\"> <td>{{depense.numeroEtape}}</td> <td>{{depense.poste}}</td> <td ng-if=\"depense.typeFrais !== \'TRANSPORT1\' && depense.typeFrais !== \'TRANSPORT2\' && depense.typeFrais !== \'AUTRE\'\"> <span class=pull-right>{{depense.montant | number:2}}</span></td> <td ng-if=\"depense.typeFrais === \'TRANSPORT1\' || depense.typeFrais === \'TRANSPORT2\' || depense.typeFrais === \'AUTRE\'\"> <input id=id_montantPrevue ng-if=\"ctrl.statutActuel === \'BROUILLON\'\" name=montantPrevue type=number class=\"form-control align-chiffre\" ng-model=depense.montant min=0 step=1 ng-change=ctrl.updateMontantTTC() ng-disabled=\"ctrl.statutActuel !== \'BROUILLON\' || !depense.selectionne || !depense.remboursement\"> <span class=pull-right ng-if=\"ctrl.statutActuel !== \'BROUILLON\'\">{{depense.montant | number:2}}</span> </td> <td> <input id=id_quantiteVP name=quantite type=number class=form-control ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' && depense.typeFrais === \'VEHICULE_PERSONNEL\' && depense.selectionne \n                                                && !depense.fraisReel\" ng-model=depense.quantite min=0 step=1 ng-change=ctrl.updateMontantVehiculePersonnel(depense) ng-disabled=\"ctrl.statutActuel !== \'RECEPTIONNE\' || (ctrl.demande.soumissionJustificatifOver \n                                                    && (ctrl.role === \'BENEFICIAIRE\' || ctrl.role === \'INVESTIGATEUR\')) || (ctrl.demande.paiements.length > 1 \n                                                    || ( ctrl.demande.paiements.length === 1 && ctrl.demande.paiements[0].typePaiement !== \'AVANCE\'))\" required> <input id=id_quantite name=quantite type=number class=form-control ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' && (depense.typeFrais === \'REPAS\' || depense.typeFrais === \'HOTEL\') \n                                                && depense.selectionne && !depense.fraisReel\" ng-model=depense.quantite min=0 step=1 ng-change=ctrl.updateMontantRepasHotel(depense) ng-disabled=\"ctrl.statutActuel !== \'RECEPTIONNE\' || (ctrl.demande.soumissionJustificatifOver \n                                                    && (ctrl.role === \'BENEFICIAIRE\' || ctrl.role === \'INVESTIGATEUR\')) || (ctrl.demande.paiements.length > 1 \n                                                    || ( ctrl.demande.paiements.length === 1 && ctrl.demande.paiements[0].typePaiement !== \'AVANCE\'))\" required> <span class=pull-right ng-if=\"ctrl.statutActuel !== \'RECEPTIONNE\' || ((depense.typeFrais === \'REPAS\' || depense.typeFrais === \'HOTEL\') \n                                      && depense.fraisReel)\">{{depense.quantite}}</span> </td> <td> <toggle-switch id=selectionne is-disabled=\"ctrl.statutActuel !== \'BROUILLON\'\" ng-model=depense.selectionne on-label=Oui off-label=Non ng-change=ctrl.updateMontantTTC()></toggle-switch> </td> <td ng-hide=\"ctrl.statutActuel === \'RECEPTIONNE\' || ctrl.statutActuel === \'PAYE\' \"> <toggle-switch tooltip-placement=bottom uib-tooltip=\"{{depense.remboursement ? \'Remboursement\' : \'Agence de voyage\'}}\" class=ats-switch-large id=type is-disabled=\"ctrl.statutActuel !== \'BROUILLON\' || !depense.selectionne\" ng-model=depense.remboursement ng-if=\"depense.typeFrais === \'TRANSPORT1\' || depense.typeFrais === \'TRANSPORT2\' || depense.typeFrais === \'LOCATION\' \n                                                        || (depense.typeFrais === \'HOTEL\' && depense.fraisReel)\" on-label=Remb. off-label=AV ng-change=ctrl.updateMontantTTC()> </toggle-switch> </td> <td ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' || ctrl.statutActuel === \'PAYE\'\" ng-class=\"{\'has-error\': (form[\'montantReelTTC{{$index}}\'].$invalid && form[\'montantReelTTC{{$index}}\'].$touched)}\"> <input id=id_montantReelTTC name=montantReelTTC{{$index}} type=number class=form-control ng-model=depense.montantReelTTC min=0 step=1 ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' && ((depense.remboursement && depense.selectionne\n                                             && depense.typeFrais !== \'REPAS\' && depense.typeFrais !== \'HOTEL\' && depense.typeFrais !== \'VEHICULE_PERSONNEL\') \n                                             || ((depense.typeFrais === \'REPAS\' || depense.typeFrais === \'HOTEL\') && depense.fraisReel && depense.selectionne))\" ng-change=ctrl.updateMontantTTCDepense();ctrl.calculMontantTVA(depense);ctrl.calculMontantReelHT(depense); ng-disabled=\"ctrl.statutActuel === \'PAYE\' || (ctrl.demande.soumissionJustificatifOver && (ctrl.role===\'BENEFICIAIRE\' \n                                                    || ctrl.role === \'INVESTIGATEUR\')) || (ctrl.demande.paiements.length > 1 \n                                                    || ( ctrl.demande.paiements.length === 1 && ctrl.demande.paiements[0].typePaiement !== \'AVANCE\'))\" ng-required=\"ctrl.statutActuel === \'RECEPTIONNE\'\"> <ng-messages class=\"pull-left text-danger has-error-messages\" for=\"form[\'montantReelTTC\' + $index].$error\" ng-if=\"form[\'montantReelTTC\' + $index].$touched\"> <ng-messages-include src=app/default-messages.html> </ng-messages> <span class=pull-right ng-if=\"ctrl.statutActuel === \'PAYE\'\">{{depense.montantReelTTC | number:2}}</span> </td> <td gif-role=ADMIN,INTERLOCUTEUR,FINANCIER> <select name=taux class=form-control ng-init=\"depense.tauxTVA === null ? depense.tauxTVA = \'0\' : depense.tauxTVA\" ng-model=depense.tauxTVA ng-change=ctrl.calculMontantTVA(depense) ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' && (depense.remboursement && depense.selectionne \n                                                && depense.typeFrais !== \'REPAS\' && depense.typeFrais !== \'HOTEL\')\" ng-disabled=\"ctrl.demande.paiements.length > 1 || ( ctrl.demande.paiements.length === 1 \n                                                    && ctrl.demande.paiements[0].typePaiement !== \'AVANCE\')\"> <option value=0>0 %</option> <option value=2>2,1 %</option> <option value=5>5,5 %</option> <option value=10>10 %</option> <option value=20>20 %</option> <option value=Autre>Autre</option> </select> <span class=pull-right ng-if=\"ctrl.statutActuel === \'PAYE\' && depense.tauxTVA \"> {{depense.tauxTVA === \'Autre\' ? \'Autre\' : depense.tauxTVA + \' %\'}}</span> </td> <td ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' || ctrl.statutActuel === \'PAYE\'\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER> <span class=pull-right name=montantReelHT class=pull-right ng-if=\"depense.remboursement && depense.selectionne && depense.typeFrais !== \'REPAS\' && depense.typeFrais !== \'HOTEL\'\"> {{depense.montantReelHT | number:2}} </span> </td> <td gif-role=ADMIN,INTERLOCUTEUR,FINANCIER ng-class=\"{\'has-error\': (form[\'montantTVA{{$index}}\'].$invalid && form[\'montantTVA{{$index}}\'].$touched)} \"> <input id=id_montantTVA name=montantTVA{{$index}} type=number min=0 max={{depense.montantReelTTC}} class=form-control ng-model=depense.montantTVA ng-change=ctrl.calculMontantReelHT(depense); ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' && (depense.remboursement && depense.selectionne \n                                                && depense.typeFrais !== \'REPAS\' && depense.typeFrais !== \'HOTEL\')\" ng-disabled=\"ctrl.statutActuel === \'PAYE\' || depense.tauxTVA !== \'Autre\'\"> <ng-messages class=\"pull-right text-danger has-error-messages\" for=\"form[\'montantTVA\' + $index].$error\" ng-if=\"form[\'montantTVA\' + $index].$touched\"> <ng-messages-include src=app/default-messages.html> </ng-messages> <span ng-if=\"ctrl.statutActuel === \'PAYE\'\" class=pull-right>{{depense.montantTVA | number:2}}</span> </td> <td ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' && !ctrl.demande.soumissionJustificatifOver && (ctrl.demande.paiements.length === 0 \n                                        || (ctrl.demande.paiements.length === 1 && ctrl.demande.paiements[0].typePaiement === \'AVANCE\'))\" ng-class=\"{\'has-error\': (form[\'pjDepense{{$index}}\'].$invalid)} \"> <div ng-show=\"(depense.montantReelTTC !== 0 && depense.montantReelTTC !== null && depense.selectionne) \n                                                && ((((depense.typeFrais === \'HOTEL\' || depense.typeFrais === \'REPAS\') && depense.fraisReel) \n                                                || depense.typeFrais === \'AUTRE\' || ((depense.typeFrais === \'TRANSPORT1\' || depense.typeFrais === \'TRANSPORT2\') \n                                                && depense.remboursement)) || (depense.typeFrais !== \'HOTEL\' && depense.typeFrais !== \'REPAS\' \n                                                && depense.typeFrais !== \'AUTRE\' && depense.typeFrais !== \'TRANSPORT1\' && depense.typeFrais !== \'TRANSPORT2\' \n                                                && depense.montantReelTTC !== depense.montant))\"> <input id=id_pjDepense name=pjDepense{{$index}} type=file title=\"Ajouter les cartes d\'embarquements et la facture\" ng-model=depense.pj nv-file-select uploader=ctrl.getFileUploadDepense options=\"{idDepense: depense.id}\" ng-required=\"(ctrl.statutActuel === \'RECEPTIONNE\' && (depense.montantReelTTC !== 0 && depense.montantReelTTC !== null \n                                                        && depense.selectionne) && ((((depense.typeFrais === \'HOTEL\' || depense.typeFrais === \'REPAS\') \n                                                        && depense.fraisReel) || depense.typeFrais === \'AUTRE\' || ((depense.typeFrais === \'TRANSPORT1\' \n                                                        || depense.typeFrais === \'TRANSPORT2\') && depense.remboursement)) || (depense.typeFrais !== \'HOTEL\' \n                                                        && depense.typeFrais !== \'REPAS\' && depense.typeFrais !== \'AUTRE\' && depense.typeFrais !== \'TRANSPORT1\' \n                                                        && depense.typeFrais !== \'TRANSPORT2\' && depense.montantReelTTC !== depense.montant)) && results.length === 0 \n                                                        && (depense.fichiers === undefined || depense.fichiers.length === 0))\" multiple> <ng-messages class=\"pull-left text-danger has-error-messages\" for=\"form[\'pjDepense\' + $index].$error\"> <ng-messages-include src=app/default-messages.html> </ng-messages> </div> <div ng-repeat=\"item in ctrl.getFileUploadDepense.queue | filter : {idDepense : depense.id} as results\"> <span> {{item.file.name}} <a class=\"btn btn-link\"> <span ng-click=ctrl.removeFileDepense($index) class=\"glyphicon glyphicon-remove\"></span> </a> </span> </div> </td> </tr> </tbody> </table> </div> </div> </uib-tab> <uib-tab index=2 heading=\"Conversion des dépenses\" ng-if=false> <div class=row> <div class=col-md-12> <br> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-1\">N° etape</th> <th class=\"text-primary col-md-3\">Poste</th> <th class=\"text-primary col-md-1\">Montant réel</th> <th class=\"text-primary col-md-1\">Taux</th> <th class=\"text-primary col-md-1\">Nouveau montant</th> </thead> <tbody> <tr ng-repeat=\"depense in ctrl.demande.depenses | orderBy : \'id\'\"> <td>{{depense.numeroEtape}}</td> <td>{{depense.poste}}</td> <td>{{depense.montantReelTTC}}</td> <td> <input id=id_taux name=taux type=number class=form-control ng-model=depense.taux ng-init=\"depense.taux === undefined ? depense.taux = 1.0 : depense.taux\" min=0 step=0.1 ng-change=ctrl.updateMontantTTCDepense() ng-disabled=\"ctrl.statutActuel === \'PAYE\' || depense.valide || ctrl.demande.paiements.length !== 0\"> </td> <td>{{depense.montantReelTTC * depense.taux}}</td> </tr> </tbody> </table> </div> </div> </uib-tab> <uib-tab index=3 heading=\"Justificatifs des dépenses\" ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' || ctrl.statutActuel === \'PAYE\'\"> <div class=row> <div class=col-md-12> <br> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-1\">N° etape</th> <th class=\"text-primary col-md-3\">Poste</th> <th class=\"text-primary col-md-8\">Pièces jointes</th> </thead> <tbody> <tr ng-repeat=\"depense in ctrl.demande.depenses | orderBy : \'id\'\"> <td>{{depense.numeroEtape}}</td> <td>{{depense.poste}}</td> <td> <div ng-repeat=\"pj in depense.fichiers\"> <div class=\"row col-md-4\"> <a class=\"btn btn-link pull-left\" ng-href=/api/demande/mission_fichier/download_depense/{{pj.nomFichier}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{pj.libelle}} </a> </div> </div> </td> </tr> </tbody> </table> </div> </div> </uib-tab> <uib-tab ng-if=\"ctrl.demande.paiements.length!= 0 && ctrl.demande.paiements != null\" index=4 heading=Paiements> <div class=row> <div class=col-md-12> <br> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-2\">N° paiement</th> <th class=\"text-primary col-md-2\">Date</th> <th class=\"text-primary col-md-2\">Type de paiement</th> <th class=\"text-primary col-md-2\">Montant</th> <th class=\"text-primary col-md-2\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER>Choix du paiement </th> <th class=\"text-primary col-md-2\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER>Numéro</th> </thead> <tbody> <tr ng-repeat=\"paiement in ctrl.demande.paiements\"> <td>{{paiement.numero}}</td> <td>{{paiement.date | date:\'dd/MM/yyyy\'}}</td> <td>{{paiement.typePaiement | translate}}</td> <td>{{paiement.montant | number:2}}</td> <td gif-role=ADMIN,INTERLOCUTEUR,FINANCIER> {{paiement.choixPaiementPartiel | translate}} </td> <td gif-role=ADMIN,INTERLOCUTEUR,FINANCIER>{{paiement.numeroPaiement}}</td> </tr> </tbody> </table> </div> </div> </uib-tab> <uib-tab ng-if=\"ctrl.demande.paiements.length!= 0 && ctrl.demande.paiements != null\" index=5 heading=Documents> <div class=row> <div class=col-md-12> <div class=col-md-6> <h2>Note de frais</h2> <div ng-repeat=\"pj in ctrl.demande.fichiers | filter:{ type: \'NOTE\'}\"> <a class=\"btn btn-link\" ng-href=/api/demande/mission_fichier/download/{{pj.nomFichier}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{pj.libelle}} </a> </div> </div> <div class=col-md-6> <h2>Bilan Financier</h2> <div ng-repeat=\"pj in ctrl.demande.fichiers | filter:{ type: \'BILANFINANCIER\'}\"> <a class=\"btn btn-link\" ng-href=/api/demande/mission_fichier/download/{{pj.nomFichier}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{pj.libelle}} </a> </div> </div> </div> </div> </uib-tab> </uib-tabset> <div class=row ng-hide=\"ctrl.statutActuel !== \'BROUILLON\' && ctrl.demande.montantDevis === null\"> <div class=col-md-6> <h2>Devis</h2> <hr> <div class=\"row form-group col-md-6\" gif-has-error> <label for=montantTotalDevis class=control-label>Montant total devis</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.montantDevis.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=montantTotalDevis name=montantDevis type=number class=form-control ng-model=ctrl.demande.montantDevis ng-change=ctrl.updateMontantTTC() ng-disabled=\"ctrl.statutActuel !== \'BROUILLON\'\" min=0 step=1 ng-required=\"(ctrl.statutActuel === \'BROUILLON\' && !(ctrl.getFileUpload.queue.length ===0 && (ctrl.demande.fichiers.length === 0 \n                                || ctrl.demande.fichiers === undefined))) || ctrl.montantDevisObligatoire\"> </div> <div ng-hide=\"ctrl.statutActuel != \'BROUILLON\'\" class=col-md-6> <div gif-has-error> <input id=id_pjDevis name=pj type=file ng-model=pj nv-file-select uploader=ctrl.getFileUpload ng-required=\"ctrl.statutActuel === \'BROUILLON\' && ctrl.demande.montantDevis !== null \n                            && ctrl.demande.montantDevis !== undefined && ctrl.getFileUpload.queue.length === 0 \n                            && (ctrl.demande.fichiers === undefined || ctrl.demande.fichiers.length === 0)\" multiple> <ng-messages class=\"pull-left text-danger has-error-messages\" for=form.pj.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> </div> <div ng-repeat=\"item in ctrl.getFileUpload.queue\" ng-if=\"ctrl.getFileUpload.queue.length != 0\"> <span> {{item.file.name}} <a class=\"btn btn-link\"> <span ng-click=ctrl.removeFile($index) class=\"glyphicon glyphicon-remove\"></span> </a> </span> </div> </div> <div class=col-md-6> <div ng-repeat=\"pj in ctrl.demande.fichiers | filter:{ type: \'PIECEJOINTE\'}\"> <a class=\"btn btn-link\" ng-href=/api/demande/mission_fichier/download/{{pj.nomFichier}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{pj.libelle}} </a> </div> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=pull-left> <button ng-if=\"ctrl.isUpdate && ctrl.statutActuel == \'BROUILLON\'\" type=button ng-click=ctrl.confirmDelete(ctrl.demande) class=\"btn btn-default\"> Supprimer </button> </div> <div class=pull-right> <a class=\"btn btn-link\" href=/#/operation/list>Annuler</a> <button type=button ng-disabled=!form.$valid ng-if=\"!ctrl.isUpdate && ctrl.statutActuel === \'BROUILLON\' && ctrl.role === \'BENEFICIAIRE\'\" ng-click=\"ctrl.soumissionParBeneficiaire(ctrl.demande,\'ASOUMETTRE\');\" class=\"btn btn-primary\">Soumettre</button> <button type=button ng-disabled=!form.$valid ng-if=\"ctrl.isUpdate && ctrl.statutActuel === \'BROUILLON\' && ctrl.role === \'BENEFICIAIRE\'\" ng-click=\"ctrl.soumissionParBeneficiaire(ctrl.demande,\'ASOUMETTRE\');\" class=\"btn btn-primary\">Soumettre</button><!-- Cas  où la soumission est faite sans avoir enregistré la demande de mission au préalable--> <button type=submit gif-role=!BENEFICIAIRE ng-if=\"!ctrl.isUpdate && ctrl.statutActuel == \'BROUILLON\' && ctrl.afficherSoumettre\" ng-disabled=!ctrl.demande.certifie ng-click=ctrl.changeActionSubmit(true); class=\"btn btn-primary\">Soumettre</button><!-- Cas  où la soumission est faite après avoir enregistré au moins une fois la demande de mission--> <button type=button gif-role=!BENEFICIAIRE ng-if=\"ctrl.isUpdate && (ctrl.statutActuel == \'BROUILLON\' || ctrl.statutActuel == \'ASOUMETTRE\') && ctrl.afficherSoumettre\" ng-disabled=!ctrl.demande.certifie ng-click=\"ctrl.changeStatus(\'SOUMISE\');\" class=\"btn btn-primary\">Soumettre</button> <button type=button ng-if=\"ctrl.statutActuel === \'SOUMISE\'\" ng-click=ctrl.motifRefus() gif-role=ADMIN,INTERLOCUTEUR,FINANCIER class=\"btn btn-default\">Refuser</button> <button type=button ng-if=\"ctrl.statutActuel === \'SOUMISE\'\" ng-click=\"ctrl.changeStatus(\'VALIDE\');\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER class=\"btn btn-primary\">Valider</button> <button type=submit ng-if=\"ctrl.statutActuel === \'VALIDE\' && ctrl.demande.paiements.length === 0 && ctrl.demande.demanderAvance\" ng-disabled=\"ctrl.demande.montantPaiementPartiel === 0 || ctrl.demande.montantPaiementPartiel === null\" ng-click=\"ctrl.changeTypePaiement(\'AVANCE\');ctrl.changeNumeroChequeRequired(true);\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER class=\"btn btn-default\">Faire une avance</button> <button type=button ng-if=\"ctrl.statutActuel == \'VALIDE\' && ctrl.afficherReceptionner\" ng-click=\"ctrl.changeStatus(\'RECEPTIONNE\'); ctrl.changeActionSubmit(false);\" class=\"btn btn-primary\">Réceptionner</button> <button type=submit ng-disabled=form.$invalid ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' && ctrl.afficherTerminer\" ng-click=\"ctrl.demande.soumissionJustificatifOver=true;\" class=\"btn btn-primary\">Terminer</button> <div ng-if=\"ctrl.statutActuel === \'RECEPTIONNE\' && ctrl.demande.soumissionJustificatifOver\" class=\"btn-group dropup\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER uib-dropdown> <button id=bouton_payer type=button class=\"btn btn-primary\" uib-dropdown-toggle> Payer <span class=caret></span> </button> <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu aria-labelledby=bouton_payer> <li> <button type=submit class=\"form-control btn btn-link\" ng-if=ctrl.afficherRemboursementBeneficiaire ng-click=\"ctrl.changeTypePaiement(\'REMBOURSEMENT_BENEFICIAIRE\');ctrl.changeNumeroChequeRequired(true)\">Remboursement bénéficiaire</button> </li> <li> <button type=submit class=\"form-control btn btn-link\" ng_if=ctrl.afficherRemboursementBeneficiaire ng-disabled=\"ctrl.demande.montantPaiementPartiel === 0\" ng-click=\"ctrl.changeTypePaiement(\'PAIEMENT_PARTIEL\');ctrl.changeNumeroChequeRequired(true);\">Paiement partiel</button> </li> <li> <button type=button class=\"form-control btn btn-link\" ng-if=\"ctrl.demande.paiementAmplitude && ctrl.afficherPaiementAmplitude\" ng-click=\"ctrl.changeTypePaiement(\'PAIEMENT_AMPLITUDE\');ctrl.saveOrUpdateWithoutUploadFile(ctrl.demande);\">Paiement Amplitude</button> </li> </ul> </div> <button gif-role=!ADMIN,INTERLOCUTEUR,FINANCIER ng-disabled=\"ctrl.demande.etapes.length === 0\" ng-if=\"ctrl.statutActuel === \'BROUILLON\' || (ctrl.statutActuel === \'RECEPTIONNE\' && !ctrl.demande.soumissionJustificatifOver)\" type=submit ng-click=ctrl.changeActionSubmit(false); class=\"btn btn-default\">Enregistrer</button><!-- Bouton pour l\'enregistrement des différents montant pour les postes de dépenses pour le MEDES --> <button gif-role=ADMIN,INTERLOCUTEUR,FINANCIER ng-disabled=\"ctrl.demande.etapes.length === 0\" ng-if=\"ctrl.statutActuel === \'BROUILLON\' || (ctrl.statutActuel === \'RECEPTIONNE\' && (ctrl.demande.paiements.length === 0 \n                        || ctrl.demande.paiements.length === 1 && ctrl.demande.paiements[0].typePaiement === \'AVANCE\'))\" type=submit ng-click=ctrl.changeActionSubmit(false);ctrl.changeNumeroChequeRequired(false) class=\"btn btn-default\">Enregistrer</button> </div> </div> </div> </form>");
$templateCache.put("app/operation/item/demande_remboursement/DemandeRemboursementItem.html","<div class=header> <div class=row> <div class=col-md-6> <h1 ng-if=ctrl.isUpdate>Demande de remboursement - {{ctrl.demande.objet}}</h1> <h1 ng-if=!ctrl.isUpdate>Nouvelle demande de remboursement</h1> </div><!-- WIZARD POUR ADMIN ET INVES --> <span gif-role=!BENEFICIAIRE> <div class=col-md-6 ng-hide=\"ctrl.statutActuel==\'REFUSE\'\"> <div class=stepwizard> <div class=\"stepwizard-row setup-panel\"> <div class=\"stepwizard-step stepwizard-step-4\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel===\'BROUILLON\' || ctrl.statutActuel===\'ASOUMETTRE\'}\"> <strong>Brouillon</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-4\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel===\'SOUMISE\'}\"> <strong>Soumise</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-4\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel===\'VALIDE\'}\"> <strong>Validée</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-4\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel===\'PAYE\'}\"> <strong>Payée</strong> </span> </div> </div> </div> </div> </span><!-- WIZARD POUR ROLE BENEFICIAIRE --> <span gif-role=BENEFICIAIRE> <div class=col-md-6 ng-hide=\"ctrl.statutActuel==\'REFUSE\'\"> <div class=stepwizard> <div class=\"stepwizard-row setup-panel\"> <div class=\"stepwizard-step stepwizard-step-4\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'BROUILLON\'}\"> <strong>Brouillon</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-4\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'ASOUMETTRE\'}\"> <strong>Soumise</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-4\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'VALIDE\'}\"> <strong>Validée</strong> </span> </div> <div class=\"stepwizard-step stepwizard-step-4\"> <span type=text class=btn-step ng-class=\"{\'select\':ctrl.statutActuel==\'PAYE\'}\"> <strong>Payée</strong> </span> </div> </div> </div> </div> </span> </div> <div class=row> <div class=col-md-12 ng-show=\"ctrl.statutActuel === \'REFUSE\'\"> <h3 class=text-danger>Motif de refus : {{ctrl.demande.motif}}</h3> </div> </div> <hr> </div><!-- Le ng-class permet de mettre les bordure en rouge pour les champ obligatoire --> <form id=demandeRemboursementForm name=form ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.demande)\" novalidate gif-server-validate=ctrl.serverErrors> <div class=row> <div class=\"form-group col-md-6 required\" gif-has-error> <label class=control-label> Objet </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.objet.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=objet ng-model=ctrl.demande.objet type=text class=form-control required ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" ng-maxlength=255> </div> <div class=\"form-group col-md-3\"> <label> Date de création</label> <input type=text class=form-control ng-model=ctrl.demande.dateCreation gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-disabled=true show-button-bar=false> </div> <div class=\"form-group col-md-3\"> <label> Date de soumission</label> <input type=text class=form-control ng-model=ctrl.demande.dateSoumission gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-disabled=true show-button-bar=false> </div> </div> <div class=row> <div class=\"form-group col-md-6\"> <label class=control-label> Numéro de pièce</label> <input name=numero ng-model=ctrl.demande.numero ng-disabled=true type=text class=form-control> </div> <div class=\"form-group col-md-3\"> <label> Date de validation </label> <input type=text class=form-control ng-model=ctrl.demande.dateValidation gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-disabled=true show-button-bar=false> </div> <div class=\"form-group col-md-3\"> <label> Date de paiement </label> <input type=text class=form-control ng-model=ctrl.demande.datePaiement gif-utc-date uib-datepicker-popup={{ctrl.dateFormat}} ng-disabled=true show-button-bar=false> </div> </div> <div class=row> <div class=\"form-group col-md-6 required\" gif-has-error> <label class=control-label> Demandeur</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.demandeur.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=custom-typeahead> <div ng-class=\"{\'input-group\': ctrl.demande.demandeur}\"> <input name=demandeur ng-model=ctrl.demande.demandeur uib-typeahead=\"demandeur as (demandeur.nom +\' \'+ demandeur.prenom) for demandeur in ctrl.autocompleteDemandeur($viewValue,ctrl.demande.compte.etablissement.id)\" typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher... ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" typeahead-on-select=ctrl.onChangeDemandeur($item) required> <span ng-show=ctrl.demande.demandeur class=input-group-btn> <a href=/#/referentiel/investigateur/{{ctrl.demande.demandeur.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </div> <div class=\"form-group col-md-6 required\" gif-has-error> <label class=control-label> Compte</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.compte.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=custom-typeahead> <div ng-class=\"{\'input-group\': ctrl.demande.compte}\"> <input name=compte ng-model=ctrl.demande.compte uib-typeahead=\"compte as (compte.code +\' - \'+ compte.libelle) for compte in ctrl.autocompleteCompte($viewValue)\" typeahead-on-select=ctrl.showButtonSoumettre();ctrl.onChangeCompte(); typeahead-editable=false type=text class=form-control autocomplete=off placeholder=Rechercher... ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" required> <span ng-show=ctrl.demande.compte class=input-group-btn> <a href=/#/compte/{{ctrl.demande.compte.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </div> </div> <div class=row> <div class=\"form-group col-md-6 required\" gif-has-error> <label class=control-label> Description </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.description.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <textarea name=description ng-model=ctrl.demande.description class=form-control rows=3 ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" maxlength=255 required>\n            </textarea> <small> Il vous reste <span>{{255 - ctrl.demande.description.length}}</span> <span ng-if=\"255 - ctrl.demande.description.length != 1 && 255 - ctrl.demande.description.length != 0\">caractères</span> <span ng-if=\"255 - ctrl.demande.description.length == 1 || 255 - ctrl.demande.description.length == 0\">caractère</span>  </small> </div> <div class=\"form-group col-md-3 required\" gif-has-error> <label class=control-label> Montant total TTC</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.montantTTC.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=montantTTC type=number class=form-control ng-model=ctrl.demande.montantTTC min=0 step=1 ng-disabled=true required> </div> <div class=\"form-group col-md-3 required\" ng-show=\"ctrl.statutActuel == \'VALIDE\' || ctrl.statutActuel == \'PAYE\'\" gif-has-error> <label class=control-label>Montant TVA</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.montantTVA.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=montantTVA type=number class=form-control ng-model=ctrl.demande.montantTVA ng-init=0 ng-change=ctrl.validateMontantTVA() ng-required=\"ctrl.statutActuel == \'VALIDE\'\" ng-disabled=\"ctrl.statutActuel==\'PAYE\'\" min=0 step=1> </div> <div class=\"form-group col-md-3 required\" ng-show=\"ctrl.statutActuel == \'VALIDE\' && ctrl.afficherInputNumeroCheque\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER gif-has-error> <label class=control-label>Numéro du chèque</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.numeroCheque.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=numeroCheque class=form-control ng-model=ctrl.demande.numeroPaiement ng-required=\"ctrl.statutActuel === \'VALIDE\' && ctrl.afficherInputNumeroCheque\"> </div> <div class=\"form-group col-md-6\" ng-show=ctrl.afficherSoumettre> <input type=checkbox id=certifie ng-model=ctrl.demande.certifie ng-disabled=\"ctrl.statutActuel!=\'BROUILLON\' && ctrl.statutActuel !=\'ASOUMETTRE\'\"> <label for=certifie> Je certifie que cette demande de remboursement rentre dans le cadre de la recherche clinique</label> </div> </div> <uib-tabset active=active> <uib-tab index=0 heading=Détails><!--  Tableau des bons de commandes --> <div class=row> <div class=col-md-12> <br> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-1\">Numéro</th> <th class=\"text-primary col-md-6\">Libelle</th> <th gif-role=ADMIN ng-show=\"ctrl.statutActuel==\'VALIDE\' || ctrl.statutActuel==\'PAYE\'\" class=\"text-primary col-md-2\">Compte charge</th> <th class=\"text-primary col-md-3\">Montant TTC</th> <th ng-if=\"ctrl.statutActuel === \'BROUILLON\'\" class=col-md-1></th> </thead> <tbody> <tr ng-repeat=\"bonCommande in ctrl.demande.bonCommandes\"> <td>{{$index + 1}}</td> <td> <input ng-if=\"ctrl.statutActuel===\'BROUILLON\'\" ng-disabled=ctrl.disable ng-model=bonCommande.libelle type=text class=form-control> <span ng-if=\"ctrl.statutActuel!==\'BROUILLON\'\">{{bonCommande.libelle}}</span> </td> <td gif-role=ADMIN ng-show=\"ctrl.statutActuel===\'VALIDE\' || ctrl.statutActuel===\'PAYE\'\"> <select name=compte_charge ng-if=\"ctrl.statutActuel===\'VALIDE\'\" class=form-control ng-model=bonCommande.compteCharge ng-disabled=ctrl.disable ng-options=\"compte as (compte.numero + \' - \'+ compte.libelle) for compte in ctrl.compteCharge track by compte.id\" ng-required=\"ctrl.statutActuel==\'VALIDE\'\"><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> <span ng-if=\"ctrl.statutActuel===\'PAYE\'\">{{bonCommande.compteCharge.numero}} - {{bonCommande.compteCharge.libelle}}</span> </td> <td> <div ng-class=\"{\'has-error\': (form[\'total{{$index}}\'].$invalid && form[\'total{{$index}}\'].$touched)}\"> <input name=total{{$index}} ng-model=bonCommande.total type=number min=0 ng-init=\"bonCommande.total==null ? bonCommande.total=0 : bonCommande.total\" class=form-control ng-if=\"ctrl.statutActuel===\'BROUILLON\'\" ng-change=ctrl.updateMontantTTC() ng-disabled=ctrl.disable required> <ng-messages class=help-block for=\"form[\'total\' + $index].$error\" ng-if=\"form[\'total\' + $index].$touched\"> <ng-messages-include src=app/default-messages.html> </ng-messages> <span class=pull-right ng-if=\"ctrl.statutActuel!==\'BROUILLON\'\">{{bonCommande.total | number:2}}</span> </div> </td> <td ng-if=\"ctrl.statutActuel === \'BROUILLON\'\" ng-hide=ctrl.disable> <a ng-click=ctrl.removeDetail($index) class=\"btn btn-link pull-right\"> <span title=\"Retirer un détail\" class=\"glyphicon glyphicon-trash\" aria-hidden=true></span> </a> </td> </tr> </tbody> </table> <button ng-hide=\"ctrl.statutActuel!=\'BROUILLON\' || ctrl.disable\" ng-click=ctrl.addDetail() type=button class=\"btn btn-link btn-sm\"> <span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span> Ajouter </button> </div> </div> </uib-tab> </uib-tabset> <div class=row> <div class=\"form-group col-md-6\"> <h2>Pièce jointe</h2> <hr> <div ng-hide=\"ctrl.statutActuel != \'BROUILLON\' || ctrl.disable\" class=col-md-6> <div class=row gif-has-error> <input name=pj type=file ng-model=pj nv-file-select uploader=ctrl.getFileUpload ng-required=\"!ctrl.demande.id && ctrl.getFileUpload.queue.length == 0\" multiple> </div> <div ng-repeat=\"item in ctrl.getFileUpload.queue\" ng-show=\"ctrl.getFileUpload.queue.length != 0\"> <span> {{item.file.name}} <a class=\"btn btn-link\"> <span ng-click=ctrl.removeFile($index) class=\"glyphicon glyphicon-remove\"></span> </a> </span> </div> </div> <div class=col-md-6> <div ng-repeat=\"pj in ctrl.demande.fichiers | filter:{ type: \'PIECEJOINTE\'}\"> <a class=\"btn btn-link\" ng-href=/api/demande/remboursement_fichier/download/{{pj.nomFichier}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{pj.libelle}} </a> </div> </div> </div> <div class=\"form-group col-md-6\" ng-show=\"ctrl.statutActuel==\'PAYE\'\"> <h2>Note de frais</h2> <hr> <div ng-show=\"ctrl.statutActuel=\'PAYE\'\" ng-repeat=\"fichier in ctrl.demande.fichiers | filter:{ type: \'NOTE\'}\"> <a class=\"btn btn-link\" ng-href=/api/demande/remboursement_fichier/download/{{fichier.nomFichier}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{fichier.libelle}} </a> </div> </div> </div> <div class=row> <div class=\"form-group col-md-6\" ng-show=\"ctrl.statutActuel==\'PAYE\'\"> <h2>Bilan financier</h2> <hr> <div ng-show=\"ctrl.statutActuel=\'PAYE\'\" ng-repeat=\"fichier in ctrl.demande.fichiers | filter:{ type: \'BILANFINANCIER\'}\"> <a class=\"btn btn-link\" ng-href=/api/demande/remboursement_fichier/download/{{fichier.nomFichier}} target=_blank> <span class=\"glyphicon glyphicon-paperclip\"></span> {{fichier.libelle}} </a> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=pull-left ng-hide=ctrl.disable> <button ng-show=\"ctrl.isUpdate && ctrl.statutActuel == \'BROUILLON\'\" type=button ng-click=ctrl.confirmDelete(ctrl.demande) class=\"btn btn-default\">Supprimer</button> </div> <div class=pull-right> <a class=\"btn btn-link\" href=/#/operation/list>Annuler</a><!-- uniquement pour les b�n�ficiaires --> <button type=button ng-disabled=!form.$valid ng-if=\"!ctrl.isUpdate && ctrl.statutActuel == \'BROUILLON\' && ctrl.role===\'BENEFICIAIRE\'\" ng-click=\"ctrl.soumissionParBeneficiaire(ctrl.demande,\'ASOUMETTRE\');\" class=\"btn btn-primary\">Soumettre</button> <button type=button ng-disabled=!form.$valid ng-if=\"ctrl.isUpdate && ctrl.statutActuel == \'BROUILLON\' && ctrl.role===\'BENEFICIAIRE\'\" ng-click=\"ctrl.soumissionParBeneficiaire(ctrl.demande,\'ASOUMETTRE\');\" class=\"btn btn-primary\">Soumettre</button> <button type=submit gif-role=!BENEFICIAIRE ng-if=\"!ctrl.isUpdate && ctrl.statutActuel == \'BROUILLON\'  && ctrl.afficherSoumettre\" ng-disabled=!ctrl.demande.certifie ng-click=ctrl.changeActionSubmit(true); class=\"btn btn-primary\">Soumettre</button> <button type=button gif-role=!BENEFICIAIRE ng-if=\"ctrl.isUpdate && (ctrl.statutActuel == \'BROUILLON\' || ctrl.statutActuel == \'ASOUMETTRE\') && ctrl.afficherSoumettre \" ng-disabled=!ctrl.demande.certifie ng-click=\"ctrl.changeStatus(\'SOUMISE\');ctrl.changeActionSubmit(true);\" class=\"btn btn-primary\">Soumettre</button> <button type=button ng-show=\"ctrl.statutActuel == \'SOUMISE\'\" ng-click=ctrl.motifRefus(); class=\"btn btn-default\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER>Refuser</button> <button type=button ng-show=\"ctrl.statutActuel == \'SOUMISE\'\" ng-click=\"ctrl.changeStatus(\'VALIDE\');\" class=\"btn btn-primary\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER>Valider</button> <button ng-disabled=form.$invalid type=button ng-show=\"ctrl.statutActuel == \'VALIDE\'\" ng-click=\"ctrl.changeStatus(\'PAYE\');\" class=\"btn btn-primary\" gif-role=ADMIN,INTERLOCUTEUR,FINANCIER>Payer</button> <button ng-hide=\"ctrl.statutActuel != \'BROUILLON\' || ctrl.disable\" type=submit ng-click=ctrl.changeActionSubmit(false); class=\"btn btn-default\">Enregistrer</button> </div> </div> </div> </form>");
$templateCache.put("app/referentiel/beneficiaire/item/BeneficiaireItem.html","<div class=header> <h1 ng-if=ctrl.isUpdate>Bénéficiaire - {{ctrl.beneficiaire.prenom}} {{ctrl.beneficiaire.nom}}</h1> <h1 ng-if=!ctrl.isUpdate>Ajout d\'un bénéficiaire</h1> <hr> </div> <div class=main> <form name=form ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.beneficiaire)\" novalidate> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <label class=control-label> Code </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.code.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=codeInput name=code ng-disabled=true ng-model=ctrl.beneficiaire.code type=text class=form-control gif-validate-async=\"{unique: ctrl.validateCode}\"> </div> </div> <div class=col-md-6> <div class=form-group> <label for=typologie>Statut</label> <div> <toggle-switch id=enabledInput ng-model=ctrl.beneficiaire.actif on-label=Actif off-label=Inactif is-disabled=ctrl.disable> </toggle-switch> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Nom </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.nom.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=nom ng-disabled=ctrl.disable ng-model=ctrl.beneficiaire.nom type=text class=form-control ng-maxlength=255 required> </div> </div> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Etablissement</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.etablissement.$error> <ng-messages-include src=app/default-messages.html> </ng-messages><!-- TODO : retirer tous les custom-typeahead si la solution css actuelle convient --> <div class=custom-typeahead> <div class=\"input-group col-md-12\"> <input name=etablissement ng-disabled=ctrl.disable ng-model=ctrl.beneficiaire.etablissement uib-typeahead=\"etablissement as (etablissement.code +\' - \'+ etablissement.libelle) for etablissement in ctrl.autocompleteEtablissement($viewValue)\" typeahead-loading=etablissements type=text class=form-control typeahead-editable=false autocomplete=off placeholder=Rechercher... required> <span ng-show=ctrl.beneficiaire.etablissement class=input-group-btn> <a href=/#/referentiel/etablissement/{{ctrl.beneficiaire.etablissement.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Prénom </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.prenom.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=prenom ng-disabled=ctrl.disable ng-model=ctrl.beneficiaire.prenom type=text class=form-control ng-maxlength=255 required> </div> </div> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.telephone.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label class=control-label> Téléphone </label> <input name=telephone ng-disabled=ctrl.disable ng-model=ctrl.beneficiaire.telephone type=tel pattern=^((\\+)33|0)[1-9](\\d{2}){4}$ class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.rue.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label> Adresse</label> <input name=rue ng-disabled=ctrl.disable ng-model=ctrl.beneficiaire.adresse.rue type=text ng-maxlength=255 class=form-control> </div> </div> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Adresse email </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.email.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=email ng-disabled=ctrl.disable ng-model=ctrl.beneficiaire.email type=email class=form-control ng-change=ctrl.verifyUser(ctrl.beneficiaire) required> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <label> Complément </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.complement.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=complement ng-disabled=ctrl.disable ng-model=ctrl.beneficiaire.adresse.complement type=text class=form-control ng-maxlength=255> </div> </div> <div class=col-md-6 ng-show=!ctrl.disable> <div class=form-group gif-has-error> <label class=control-label>IBAN</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.iban.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=iban ng-disabled=ctrl.disable ng-model=ctrl.beneficiaire.iban ng-iban type=text class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.codePostal.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.ville.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label> Code Postal / Ville</label> <div class=row> <div class=col-md-4> <input name=codePostal ng-disabled=ctrl.disable ng-model=ctrl.beneficiaire.adresse.codePostal ng-maxlength=255 type=text class=form-control> </div> <div class=col-md-8> <input name=ville ng-disabled=ctrl.disable ng-model=ctrl.beneficiaire.adresse.ville ng-maxlength=255 type=text class=form-control> </div> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label class=control-label>Code comptable</label> <input name=code_comptable ng-model=ctrl.beneficiaire.codeComptable type=text class=form-control disabled> </div> </div> </div> <div class=row> <div class=form-group> <div class=col-md-12> <div class=footer> <div class=pull-left> <button ng-hide=ctrl.disableConnexion ng-disabled=form.$invalid type=button ng-click=ctrl.saveAndCreateUser(ctrl.beneficiaire) class=\"btn btn-default\">Ouvrir la connexion</button> </div> <div class=pull-right> <a class=\"btn btn-link\" href=/#/referentiel/beneficiaire>Annuler</a> <button ng-hide=ctrl.disable type=submit class=\"btn btn-primary\">Enregistrer</button> </div> </div> </div> </div> </div> </form> </div>");
$templateCache.put("app/referentiel/beneficiaire/list/BeneficiaireList.html","<div> <h1>Bénéficiaire </h1> <hr> <div class=row> <div class=col-md-2> <div class=\"btn-group btn-group-justified\"> <div class=btn-group> <button ng-class=\"{\'active\': ctrl.filtreActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(true)>Actif</button> </div> <div class=btn-group> <button ng-class=\"{\'active\': !ctrl.filtreActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(false)>Inactif</button> </div> </div> </div> <div class=\"col-md-offset-5 col-md-4\"> <input id=searchBeneficiaire type=text class=form-control placeholder=Rechercher aria-describedby=basic-addon1 ng-model=ctrl.searchText ng-change=ctrl.onChangeSearchText(ctrl.searchText)> </div> <div class=col-md-1 ng-hide=ctrl.read> <button ng-click=ctrl.add() type=button class=\"pull-right btn btn-primary\">Ajouter</button> </div> </div> </div> <div ng-if=ctrl.page gif-paged-data=ctrl.onPagingOptionsChange(pagingOptions) gif-page-size={{ctrl.pageSize}}> <small class=text-muted> <strong>{{ctrl.page.number+1 * ctrl.page.size}}</strong> premiers bénéficiaires parmi <strong>{{ctrl.page.totalElements}}</strong> {{ctrl.page.totalElements > 1 ? \'résultats\' : \'résultat\'}} </small> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-3\" gif-sortable=nom class=col-md-3>Nom</th> <th class=\"text-primary col-md-2\" gif-sortable=prenom class=col-md-2>Prénom</th> <th class=\"text-primary col-md-2\" gif-sortable=etablissement.libelle class=col-md-2>Etablissement</th> <th class=\"text-primary col-md-1\" gif-sortable=telephone class=col-md-1>Téléphone</th> <th class=\"text-primary col-md-4\" gif-sortable=email class=col-md-4>Email</th> </thead> <tbody> <tr ng-click=ctrl.goTo(beneficiaire.id) occlass=table_row ng-repeat=\"beneficiaire in ctrl.page.content\"> <td>{{beneficiaire.nom}}</td> <td>{{beneficiaire.prenom}}</td> <td>{{beneficiaire.etablissement.libelle}}</td> <td>{{beneficiaire.telephone}}</td> <td>{{beneficiaire.email}}</td> </tr> </tbody> </table> <div class=\"col-md-2 col-md-offset-5\"> <button ng-click=ctrl.viewMore() class=\"btn btn-default btn-sm\" ng-hide=ctrl.page.last> Afficher davantage </button> </div> </div>");
$templateCache.put("app/referentiel/category/item/CategoryItem.html","<div class=header> <h1 ng-if=ctrl.isUpdate>Catégorie de dépenses - {{ctrl.category.libelle}}</h1> <h1 ng-if=!ctrl.isUpdate>Ajout d\'une catégorie de dépense</h1> <hr> </div> <div class=main> <form name=form ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.category)\" novalidate> <div class=row> <div class=col-md-6> <div class=form-group> <label class=control-label> Code </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.code.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=codeInput name=code ng-disabled=true ng-model=ctrl.category.code type=text class=form-control gif-validate-async=\"{unique: ctrl.validateCode}\"> </div> </div> <div class=col-md-2> <div class=form-group> <label>Statut</label> <div> <toggle-switch id=enabledInput ng-model=ctrl.category.actif on-label=Actif off-label=Inactif is-disabled=ctrl.disable> </toggle-switch> </div> </div> </div> <div class=\"form-group col-md-2\"> <label>Destination en France</label> <div> <toggle-switch id=sejour ng-model=ctrl.category.sejourEnFrance on-label=Oui off-label=Non is-disabled=ctrl.disable> </toggle-switch> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Libellé </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.libelle.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=libelle name=libelle ng-disabled=ctrl.disable ng-model=ctrl.category.libelle type=text class=form-control ng-maxlength=255 required> </div> </div> </div> <div class=row> <div class=\"col-md-12 table-responsive\"> <h3> Détails <button ng-hide=\"ctrl.disable || ctrl.category.typeCategorie === \'IJ\'\" ng-click=ctrl.addFrais() type=button class=\"btn btn-link btn-sm\"> <span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span> Ajouter </button> </h3><!-- TODO tableau � ins�rer --> </div> </div> <div class=row> <div class=\"col-md-12 table-responsive\"> <div class=form-group> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-4\">Libellé</th> <th class=\"text-primary col-md-2\">Type</th> <th class=\"text-primary col-md-2\">Compte charge</th> <th class=\"text-primary col-md-2\">Forfait</th> <th class=\"text-primary col-md-2\">Plafond</th> <th></th> </thead> <tbody> <tr class=table_row ng-repeat=\"frais in ctrl.category.details track by $index\"> <td ng-class=\"{\'has-error\': (form[\'libelle{{$index}}\'].$invalid && ( form.$submitted || form[\'libelle{{$index}}\'].$touched))} \"> <input style=\"white-space: normal\" name=libelle{{$index}} ng-model=frais.libelle type=text class=form-control ng-disabled=ctrl.disable required> <ng-messages class=\"pull-right text-danger has-error-messages\" for=\"form[\'libelle\' + $index].$error\"> <ng-messages-include src=app/default-messages.html> </ng-messages> </td> <td ng-class=\"{\'has-error\': (form[\'type_frais{{$index}}\'].$invalid && ( form.$submitted || form[\'type_frais{{$index}}\'].$touched))}\"> <select name=type_frais{{$index}} class=form-control ng-model=frais.typeFrais ng-disabled=ctrl.disable ng-options=\"typeFrais as typeFrais | translate for typeFrais in ctrl.typesFrais\" required><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> <ng-messages class=\"pull-right text-danger has-error-messages\" for=\"form[\'type_frais\' + $index].$error\"> <ng-messages-include src=app/default-messages.html> </ng-messages> </td> <td ng-class=\"{\'has-error\': (form[\'compte_charge{{$index}}\'].$invalid && ( form.$submitted || form[\'compte_charge{{$index}}\'].$touched))}\"> <select name=compte_charge{{$index}} class=form-control ng-model=frais.compteCharge ng-disabled=ctrl.disable ng-options=\"compte as (compte.numero + \' - \'+ compte.libelle) for compte in ctrl.compteCharge track by compte.id\" required><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> <ng-messages class=\"pull-right text-danger has-error-messages\" for=\"form[\'compte_charge\' + $index].$error\"> <ng-messages-include src=app/default-messages.html> </ng-messages> </td> <td ng-class=\"{\'has-error\': (form[\'forfait{{$index}}\'].$invalid && ( form.$submitted || form[\'forfait{{$index}}\'].$touched))} \"> <div ng-show=\"frais.typeFrais !== \'TRANSPORT1\' && frais.typeFrais !== \'TRANSPORT2\' && frais.typeFrais !== \'AUTRE\'\"> <input name=forfait{{$index}} type=number class=form-control ng-model=frais.forfait min=0 step=1 ng-disabled=ctrl.disable ng-required=\"frais.typeFrais !== \'TRANSPORT1\' && frais.typeFrais !== \'TRANSPORT2\' && frais.typeFrais !== \'AUTRE\'\"> <ng-messages class=\"pull-right text-danger has-error-messages\" for=\"form[\'forfait\' + $index].$error\"> <ng-messages-include src=app/default-messages.html> </ng-messages> </div> </td> <td ng-class=\"{\'has-error\': (form[\'reel{{$index}}\'].$invalid && ( form.$submitted || form[\'reel{{$index}}\'].$touched))} \"> <div ng-show=\"frais.typeFrais !== \'TRANSPORT1\' && frais.typeFrais !== \'TRANSPORT2\' && frais.typeFrais !== \'AUTRE\'\"> <input name=reel{{$index}} type=number class=form-control ng-model=frais.reel min=0 step=1 ng-disabled=ctrl.disable ng-required=\"frais.typeFrais !== \'TRANSPORT1\' && frais.typeFrais !== \'TRANSPORT2\' && frais.typeFrais !== \'AUTRE\'\"> <ng-messages class=\"pull-right text-danger has-error-messages\" for=\"form[\'reel\' + $index].$error\"> <ng-messages-include src=app/default-messages.html> </ng-messages> </div> </td> <td style=\"vertical-align: middle\"> <a ng-click=ctrl.removeFrais($index)> <span title=\"Supprimer Frais\" class=\"glyphicon glyphicon-trash\" aria-hidden=true ng-hide=ctrl.disable></span> </a> </td> </tr> </tbody> </table> </div> </div> </div> <div class=row> <div class=form-group> <div class=col-md-12> <div class=footer> <div class=pull-right> <a class=\"btn btn-link\" href=/#/referentiel/category>Annuler</a> <button ng-hide=ctrl.disable type=submit class=\"btn btn-primary\">Enregistrer</button> </div> </div> </div> </div> </div> </form> </div>");
$templateCache.put("app/referentiel/category/list/CategoryList.html","<div> <h1>Catégorie de dépenses</h1> <hr> <div class=row> <div class=col-md-2> <div class=\"btn-group btn-group-justified\"> <div class=btn-group> <button ng-class=\"{\'active\': ctrl.filtreActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(true)>Actif</button> </div> <div class=btn-group> <button ng-class=\"{\'active\': !ctrl.filtreActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(false)>Inactif</button> </div> </div> </div> <div class=\"col-md-offset-5 col-md-4\"> <input id=searchCategory type=text class=form-control placeholder=Rechercher aria-describedby=basic-addon1 ng-model=ctrl.searchText ng-change=ctrl.onChangeSearchText(ctrl.searchText)> </div> <div class=col-md-1 ng-hide=ctrl.read> <button ng-click=ctrl.add() type=button class=\"pull-right btn btn-primary\">Ajouter</button> </div> </div> </div> <div ng-if=ctrl.page gif-paged-data=ctrl.onPagingOptionsChange(pagingOptions) gif-page-size={{ctrl.pageSize}}> <small class=text-muted> <strong>{{ctrl.page.number+1 * ctrl.page.size}}</strong> premières catégories parmi <strong>{{ctrl.page.totalElements}}</strong> {{ctrl.page.totalElements > 1 ? \'résultats\' : \'résultat\'}} </small> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-2\" gif-sortable=code>Code</th> <th class=\"text-primary col-md-6\" gif-sortable=libelle>Libellé</th> </thead> <tbody> <tr ng-click=ctrl.goTo(category.id) occlass=table_row ng-repeat=\"category in ctrl.list\"> <td>{{category.code}}</td> <td>{{category.libelle}}</td> </tr> </tbody> </table> <div class=\"col-md-2 col-md-offset-5\"> <button ng-click=ctrl.viewMore() class=\"btn btn-default btn-sm\" ng-hide=ctrl.page.last>Afficher davantage</button> </div> </div>");
$templateCache.put("app/referentiel/etablissement/item/EtablissementItem.html","<div class=header> <h1 ng-if=ctrl.isUpdate>Etablissement - {{ctrl.etablissement.libelle}}</h1> <h1 ng-if=!ctrl.isUpdate>Ajout d\'un établissement</h1> <hr> </div> <div class=main> <form name=form ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.etablissement)\" novalidate> <div class=form-group> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Code</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.code.$error> <ng-messages-include src=app/default-messages.html>> </ng-messages> <input id=codeInput name=code ng-disabled=ctrl.disable ng-model=ctrl.etablissement.code ng-maxlength=255 type=text class=form-control gif-validate-async=\"{unique: ctrl.validateCode}\" required> </div> </div> <div class=col-md-6> <div class=form-group> <label>Statut</label> <div> <toggle-switch id=enabledInput is-disabled=ctrl.disable ng-model=ctrl.etablissement.actif on-label=Actif off-label=Inactif> </toggle-switch> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Libellé</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.libelle.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=libelle ng-disabled=ctrl.disable ng-model=ctrl.etablissement.libelle ng-maxlength=255 type=text class=form-control required> </div> </div> <div class=col-md-4> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.telephone.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label class=control-label> Téléphone </label> <input name=telephone ng-disabled=ctrl.disable ng-model=ctrl.etablissement.telephone type=tel pattern=^((\\+)33|0)[1-9](\\d{2}){4}$ class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.rue.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label> Adresse</label> <input name=rue ng-disabled=ctrl.disable ng-model=ctrl.etablissement.adresse.rue type=text ng-maxlength=255 class=form-control> </div> </div> <div class=col-md-2> <div class=\"form-group required\" gif-has-error> <label class=control-label> Frais de gestion </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.frais.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=input-group> <input type=number name=frais ng-disabled=ctrl.disable ng-model=ctrl.etablissement.pourcentageFrais class=form-control min=0 max=100 step=0.01 required> <span class=input-group-addon>%</span> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <label> Complément </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.complement.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=complement ng-disabled=ctrl.disable ng-model=ctrl.etablissement.adresse.complement type=text class=form-control ng-maxlength=255> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.codePostal.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.ville.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label> Code Postal / Ville</label> <div class=row> <div class=col-md-4> <input name=codePostal ng-disabled=ctrl.disable ng-model=ctrl.etablissement.adresse.codePostal ng-maxlength=255 type=text class=form-control> </div> <div class=col-md-8> <input name=ville ng-disabled=ctrl.disable ng-model=ctrl.etablissement.adresse.ville ng-maxlength=255 type=text class=form-control> </div> </div> </div> </div> </div> </div> <div class=row> <div class=\"form-group required col-md-6\" gif-has-error> <label class=control-label> Pays </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.pays.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=pays ng-disabled=ctrl.disable ng-model=ctrl.etablissement.adresse.pays type=text class=form-control ng-maxlength=255 required> </div> </div> <div class=row> <div class=form-group> <div class=col-md-12> <h3>Contacts <button ng-hide=ctrl.disable ng-click=ctrl.addContact() type=button class=\"btn btn-link btn-sm\"> <span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span> Ajouter </button> </h3> </div> <div class=col-md-12> <div class=table-responsive> <table class=\"table table-striped\"> <thead> <th class=text-primary>Nom</th> <th class=text-primary>Prénom</th> <th class=text-primary>Téléphone</th> <th class=text-primary>Email</th> <th class=text-primary>Information</th> <th></th> </thead> <tbody> <tr class=table_row ng-repeat=\"contact in ctrl.etablissement.contacts\"> <td> <input ng-disabled=ctrl.disable ng-model=contact.nom type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.prenom type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.telephone type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.email type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.information type=text class=form-control> </td> <td style=\"vertical-align: middle\"> <a ng-hide=ctrl.disable ng-click=ctrl.removeContact($index)> <span title=\"Retirer un contact\" class=\"glyphicon glyphicon-trash\" aria-hidden=true></span> </a> </td> </tr> </tbody> </table> </div> </div> </div> </div> </div> <div class=form-group> <div class=col-md-12> <div class=\"footer pull-right\"> <div class=pull-right> <a class=\"btn btn-link\" href=/#/referentiel/etablissement>Annuler</a> <button ng-hide=ctrl.disable type=submit class=\"btn btn-primary\">Enregistrer</button> </div> </div> </div> </div> </form> </div>");
$templateCache.put("app/referentiel/etablissement/list/EtablissementList.html","<div class=header> <h1>Etablissement</h1> <hr> <div class=row> <div class=col-md-2> <div class=\"btn-group btn-group-justified\"> <div class=btn-group> <button ng-class=\"{\'active\': ctrl.filtreActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(true)>Actif</button> </div> <div class=btn-group> <button ng-class=\"{\'active\': !ctrl.filtreActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(false)>Inactif</button> </div> </div> </div> <div class=\"col-md-offset-5 col-md-4\"> <input id=searchEtablissement type=text class=form-control placeholder=Rechercher aria-describedby=basic-addon1 ng-model=ctrl.searchText ng-change=ctrl.onChangeSearchText(ctrl.searchText)> </div> <div class=col-md-1 ng-hide=ctrl.read> <button ng-click=ctrl.add() type=button class=\"pull-right btn btn-primary\">Ajouter</button> </div> </div> </div> <div class=table-responsive> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-3\">Code</th> <th class=\"text-primary col-md-3\">Libellé</th> <th class=\"text-primary col-md-3\">Ville</th> <th class=\"text-primary col-md-3\">Actif</th> </thead> <tbody> <tr ng-click=ctrl.goTo(establishment.id) occlass=table_row ng-repeat=\"establishment in ctrl.list\"> <td>{{establishment.code}}</td> <td>{{establishment.libelle}}</td> <td>{{establishment.adresse.ville}}</td> <td>{{establishment.actif?\'Oui\':\'Non\'}}</td> </tr> </tbody> </table> </div>");
$templateCache.put("app/referentiel/financeur/item/FinanceurItem.html","*<div class=header> <h1 ng-if=ctrl.isUpdate>Financeur - {{ctrl.financeur.libelle}}</h1> <h1 ng-if=!ctrl.isUpdate>Ajout d\'un financeur</h1> <hr> </div> <div class=main> <form name=form ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.financeur)\" novalidate> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <label for=code class=control-label> Code</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.code.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=code name=code ng-disabled=true ng-model=ctrl.financeur.code type=text class=form-control gif-validate-async=\"{unique: ctrl.validateCode}\"> </div> </div> <div class=col-md-6> <div class=form-group> <label for=actif>Statut</label> <div> <toggle-switch id=actif on-state=true ng-model=ctrl.financeur.actif on-label=Actif off-label=Inactif is-disabled=ctrl.disable> </toggle-switch> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Libellé</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.libelle.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=libelle ng-disabled=ctrl.disable ng-model=ctrl.financeur.libelle ng-maxlength=255 type=text class=form-control required> </div> </div> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label for=compte_general class=control-label> Compte général financeur</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.compte_general.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <select id=compte_general name=compte_general class=form-control ng-disabled=ctrl.disable ng-model=ctrl.financeur.compteFinanceur ng-options=\"compte as (compte.numero + \' - \' +compte.libelle) for compte in ctrl.compteGeneralFinanceur track by compte.id\" required><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.rue.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label> Adresse</label> <input name=rue ng-disabled=ctrl.disable ng-model=ctrl.financeur.adresse.rue type=text ng-maxlength=255 class=form-control> </div> </div> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.telephone.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label for=telephone> Téléphone </label> <input name=telephone ng-disabled=ctrl.disable ng-model=ctrl.financeur.telephone type=tel pattern=^((\\+)33|0)[1-9](\\d{2}){4}$ class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <label> Complément </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.complement.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=complement ng-disabled=ctrl.disable ng-model=ctrl.financeur.adresse.complement type=text class=form-control ng-maxlength=255> </div> </div> <div class=col-md-6> <div class=form-group> <label for=siret> Numéro Siret </label> <input id=siret ng-disabled=ctrl.disable ng-model=ctrl.financeur.siret type=text class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.codePostal.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.ville.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label> Code Postal / Ville</label> <div class=row> <div class=col-md-4> <input name=codePostal ng-disabled=ctrl.disable ng-model=ctrl.financeur.adresse.codePostal ng-maxlength=255 type=text class=form-control> </div> <div class=col-md-8> <input name=ville ng-disabled=ctrl.disable ng-model=ctrl.financeur.adresse.ville ng-maxlength=255 type=text class=form-control> </div> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label for=numTvaCommunautaire> Numéro de TVA communautaire </label> <input id=numTvaCommunautaire ng-disabled=ctrl.disable ng-model=ctrl.financeur.numTvaCommunautaire type=text class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Pays </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.pays.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=pays ng-disabled=ctrl.disable ng-model=ctrl.financeur.adresse.pays type=text class=form-control ng-maxlength=255 required> </div> </div> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label for=tva class=control-label> Taux de TVA de facturation </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.tva.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <select id=tva name=tva class=form-control ng-disabled=ctrl.disable ng-model=ctrl.financeur.tauxTvaFacturation ng-options=\"tva as (tva.code + \' ( \' + tva.taux + \'% )\') for tva in ctrl.listTva track by tva.id\" required><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group> <label for=commentaire> Commentaire </label> <textarea id=commentaire ng-disabled=ctrl.disable ng-model=ctrl.financeur.commentaire type=text class=form-control maxlength=255>\n					</textarea> <small> Il vous reste <span>{{255 - ctrl.financeur.commentaire.length}}</span> <span ng-if=\"255 - ctrl.financeur.commentaire.length != 1 && 255 - ctrl.financeur.commentaire.length != 0\">caractères</span> <span ng-if=\"255 - ctrl.financeur.commentaire.length == 1 || 255 - ctrl.financeur.commentaire.length == 0\">caractère</span>  </small> </div> </div> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label for=condition class=control-label> Condition de paiement </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.condition.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <select id=condition name=condition class=form-control ng-disabled=ctrl.disable ng-model=ctrl.financeur.conditionPaiement ng-options=\"condition as condition | translate for condition in ctrl.conditionPaiement\" required><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> </div> </div> </div> <div class=row> <div class=col-md-12> <h3> Contacts <button ng-hide=ctrl.disable ng-click=ctrl.addContact() type=button class=\"btn btn-link btn-sm\"> <span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span> Ajouter </button> </h3> </div> <div class=col-md-12> <div class=table-responsive> <table class=\"table table-striped\"> <thead> <th class=text-primary>Nom</th> <th class=text-primary>Prénom</th> <th class=text-primary>Téléphone</th> <th class=text-primary>Email</th> <th class=text-primary>Information</th> <th></th> </thead> <tbody> <tr class=table_row ng-repeat=\"contact in ctrl.financeur.contacts\"> <td> <input ng-disabled=ctrl.disable ng-model=contact.nom type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.prenom type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.telephone type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.email type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.information type=text class=form-control> </td> <td style=\"vertical-align: middle\"> <a ng-hide=ctrl.disable ng-click=ctrl.removeContact($index)> <span title=\"Retirer un contact\" class=\"glyphicon glyphicon-trash\" aria-hidden=true></span> </a> </td> </tr> </tbody> </table> </div> </div> </div> <div class=row> <div class=form-group> <div class=col-md-12> <div class=footer> <div class=pull-left gif-role=ADMIN> <button ng-show=ctrl.isUpdate type=button ng-click=ctrl.confirmDelete(ctrl.financeur) class=\"btn btn-default\">Supprimer</button> </div> <div class=pull-right> <a class=\"btn btn-link\" href=/#/referentiel/financeur>Annuler</a> <button ng-hide=ctrl.disable type=submit class=\"btn btn-primary\">Enregistrer</button> </div> </div> </div> </div> </div> </form> </div>");
$templateCache.put("app/referentiel/financeur/list/FinanceurList.html","<div class=header> <h1>Financeur</h1> <hr> <div class=row> <div class=col-md-2> <div class=\"btn-group btn-group-justified\"> <div class=btn-group> <button ng-class=\"{\'active\': ctrl.filtreActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(true)>Actif</button> </div> <div class=btn-group> <button ng-class=\"{\'active\': !ctrl.filtreActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(false)>Inactif</button> </div> </div> </div> <div class=\"col-md-offset-5 col-md-4\"> <input id=searchFinanceur type=text class=form-control placeholder=Rechercher aria-describedby=basic-addon1 ng-model=ctrl.searchText ng-change=ctrl.onChangeSearchText(ctrl.searchText)> </div> <div class=col-md-1> <button ng-click=ctrl.add() type=button class=\"pull-right btn btn-primary\">Ajouter</button> </div> </div> </div> <div ng-if=ctrl.page gif-paged-data=ctrl.onPagingOptionsChange(pagingOptions) gif-page-size={{ctrl.pageSize}}> <small class=text-muted> <span> <strong>{{ctrl.page.number+1 * ctrl.page.size}}</strong> premiers financeurs parmi <strong>{{ctrl.page.totalElements}}</strong> {{ctrl.page.totalElements > 1 ? \'résultats\' : \'résultat\'}} </span> </small> <table class=\"table table-striped table-condensed\"> <thead> <th class=text-primary>Code</th> <th class=text-primary>Libellé / Compte client</th> <th class=text-primary>Ville</th> <th class=text-primary>Téléphone</th> </thead> <tbody> <tr ng-click=ctrl.goTo(financeur.id) occlass=table_row ng-repeat=\"financeur in ctrl.list\"> <td>{{financeur.code}}</td> <td>{{financeur.libelle}}</td> <td>{{financeur.adresse.ville}}</td> <td>{{financeur.telephone}}</td> </tr> </tbody> </table> <div class=\"col-md-2 col-md-offset-5\"> <button ng-click=ctrl.viewMore() class=\"btn btn-default btn-sm\" ng-hide=ctrl.page.last>Afficher davantage</button> </div> </div>");
$templateCache.put("app/referentiel/fournisseur/item/FournisseurItem.html","<div class=header> <h1 ng-if=ctrl.isUpdate>Fournisseur - {{ctrl.fournisseur.libelle}}</h1> <h1 ng-if=!ctrl.isUpdate>Ajout d\'un fournisseur</h1> <hr> </div> <div class=main> <form name=form ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.fournisseur)\" novalidate> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <label for=code class=control-label> Code </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.code.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=code name=code ng-disabled=true ng-model=ctrl.fournisseur.code type=text class=form-control gif-validate-async=\"{unique: ctrl.validateCode}\"> </div> </div> <div class=col-md-6> <div class=form-group> <label for=actif>Statut</label> <div> <toggle-switch id=actif ng-model=ctrl.fournisseur.actif on-label=Actif off-label=Inactif is-disabled=ctrl.disable> </toggle-switch> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Libellé</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.libelle.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=libelle ng-disabled=ctrl.disable ng-model=ctrl.fournisseur.libelle ng-maxlength=255 type=text class=form-control required> </div> </div> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label for=compte_general class=control-label> Compte général fournisseur</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.compte_general.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <select id=compte_general name=compte_general class=form-control ng-disabled=ctrl.disable ng-model=ctrl.fournisseur.compteFournisseur ng-options=\"compte as (compte.numero + \' - \' +compte.libelle) for compte in ctrl.compteGeneralFournisseur track by compte.id\" required><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.rue.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label> Adresse</label> <input name=rue ng-disabled=ctrl.disable ng-model=ctrl.fournisseur.adresse.rue type=text ng-maxlength=255 class=form-control> </div> </div> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Typologie</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.typologie.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <select name=typologie class=form-control ng-disabled=ctrl.disable ng-model=ctrl.fournisseur.typologie ng-options=\"typologie as typologie | translate for typologie in ctrl.typologies\" required><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <label> Complément </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.complement.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=complement ng-disabled=ctrl.disable ng-model=ctrl.fournisseur.adresse.complement type=text class=form-control ng-maxlength=255> </div> </div> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.telephone.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label for=telephone> Téléphone </label> <input name=telephone ng-disabled=ctrl.disable ng-model=ctrl.fournisseur.telephone type=tel pattern=^((\\+)33|0)[1-9](\\d{2}){4}$ class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.codePostal.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.ville.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label> Code Postal / Ville</label> <div class=row> <div class=col-md-4> <input name=codePostal ng-disabled=ctrl.disable ng-model=ctrl.fournisseur.adresse.codePostal ng-maxlength=255 type=text class=form-control> </div> <div class=col-md-8> <input name=ville ng-disabled=ctrl.disable ng-model=ctrl.fournisseur.adresse.ville ng-maxlength=255 type=text class=form-control> </div> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label for=siret> Numéro Siret </label> <input id=siret ng-disabled=ctrl.disable ng-model=ctrl.fournisseur.siret type=text class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Pays </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.pays.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=pays ng-disabled=ctrl.disable ng-model=ctrl.fournisseur.adresse.pays type=text class=form-control ng-maxlength=255 required> </div> </div> <div class=col-md-6> <div class=form-group> <label for=numTvaCommunautaire> Numéro de TVA communautaire </label> <input id=numTvaCommunautaire ng-disabled=ctrl.disable ng-model=ctrl.fournisseur.numTvaCommunautaire type=text class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label for=condition class=control-label> Condition de paiement </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.condition.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <select id=condition name=condition class=form-control ng-disabled=ctrl.disable ng-model=ctrl.fournisseur.conditionPaiement ng-options=\"condition as condition | translate for condition in ctrl.conditionPaiement\" required><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> </div> </div> <div class=col-md-6> <div class=form-group> <label for=rib> RIB </label> <input id=rib ng-disabled=ctrl.disable ng-model=ctrl.fournisseur.rib type=text class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6></div> <div class=col-md-6></div> </div> <div class=row> <div class=form-group> <div class=col-md-12> <h3> Contacts <button ng-hide=ctrl.disable ng-click=ctrl.addContact() type=button class=\"btn btn-link btn-sm\"> <span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span> Ajouter </button> </h3> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=table-responsive> <table class=\"table table-striped\"> <thead> <th class=text-primary>Nom</th> <th class=text-primary>Prénom</th> <th class=text-primary>Téléphone</th> <th class=text-primary>Email</th> <th class=text-primary>Information</th> <th></th> </thead> <tbody> <tr class=table_row ng-repeat=\"contact in ctrl.fournisseur.contacts\"> <td> <input ng-disabled=ctrl.disable ng-model=contact.nom type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.prenom type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.telephone type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.email type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.information type=text class=form-control> </td> <td style=\"vertical-align: middle\"> <a ng-hide=ctrl.disable ng-click=ctrl.removeContact($index)> <span title=\"Retirer un contact\" class=\"glyphicon glyphicon-trash\" aria-hidden=true></span> </a> </td> </tr> </tbody> </table> </div> </div> </div> <div class=row> <div class=form-group> <div class=col-md-12> <div class=footer> <div class=pull-right> <a class=\"btn btn-link\" href=/#/referentiel/fournisseur>Annuler</a> <button ng-hide=ctrl.disable type=submit class=\"btn btn-primary\">Enregistrer</button> </div> </div> </div> </div> </div> </form> </div>");
$templateCache.put("app/referentiel/fournisseur/list/FournisseurList.html","<div class=header> <h1>Fournisseur</h1> <hr> <div class=row> <div class=col-md-2> <div class=\"btn-group btn-group-justified\"> <div class=btn-group> <button ng-class=\"{\'active\': ctrl.filtreActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(true)>Actif</button> </div> <div class=btn-group> <button ng-class=\"{\'active\': !ctrl.filtreActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(false)>Inactif</button> </div> </div> </div> <div class=\"col-md-offset-5 col-md-4\"> <input id=searchFournisseur type=text class=form-control placeholder=Rechercher aria-describedby=basic-addon1 ng-model=ctrl.searchText ng-change=ctrl.onChangeSearchText(ctrl.searchText)> </div> <div class=col-md-1 ng-hide=ctrl.read> <button ng-click=ctrl.add() type=button class=\"pull-right btn btn-primary\">Ajouter</button> </div> </div> </div> <div ng-if=ctrl.page gif-paged-data=ctrl.onPagingOptionsChange(pagingOptions) gif-page-size={{ctrl.pageSize}}> <small class=text-muted> <span> <strong>{{ctrl.page.number+1 * ctrl.page.size}}</strong> premiers fournisseurs parmi <strong>{{ctrl.page.totalElements}}</strong> {{ctrl.page.totalElements > 1 ? \'résultats\' : \'résultat\'}} </span> </small> <table class=\"table table-striped table-condensed\"> <thead> <th class=text-primary>Code</th> <th class=text-primary>Libellé / Compte tiers</th> <th class=text-primary>Ville</th> <th class=text-primary>Téléphone</th> </thead> <tbody> <tr ng-click=ctrl.goTo(fournisseur.id) occlass=table_row ng-repeat=\"fournisseur in ctrl.list\"> <td>{{fournisseur.code}}</td> <td>{{fournisseur.libelle}}</td> <td>{{fournisseur.adresse.ville}}</td> <td>{{fournisseur.telephone}}</td> </tr> </tbody> </table> <div class=\"col-md-2 col-md-offset-5\"> <button ng-click=ctrl.viewMore() class=\"btn btn-default btn-sm\" ng-hide=ctrl.page.last>Afficher davantage</button> </div> </div>");
$templateCache.put("app/referentiel/investigateur/item/InvestigateurItem.html","<div class=header> <h1 ng-if=ctrl.isUpdate>Investigateur - {{ctrl.investigateur.prenom}} {{ctrl.investigateur.nom}}</h1> <h1 ng-if=!ctrl.isUpdate>Ajout d\'un investigateur</h1> <hr> </div> <div class=main><!-- Le ng-class permet de mettre les bordure en rouge pour les champ obligatoire --> <form name=form ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.investigateur)\" novalidate> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <label for=code class=control-label> Code </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.code.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=code name=code ng-disabled=true ng-model=ctrl.investigateur.code type=text class=form-control gif-validate-async=\"{unique: ctrl.validateCode}\"> </div> </div> <div class=col-md-6> <div class=form-group> <label for=actif> Statut</label> <div> <toggle-switch id=actif ng-model=ctrl.investigateur.actif on-label=Actif off-label=Inactif is-disabled=ctrl.disable> </toggle-switch> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label for=nom class=control-label> Nom </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.nom.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=nom name=nom ng-disabled=ctrl.disable ng-model=ctrl.investigateur.nom type=text class=form-control ng-maxlength=255 required> </div> </div> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label for=etablissement class=control-label> Etablissement </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.etablissement.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=custom-typeahead> <div class=\"input-group col-md-12\"> <input id=etablissement name=etablissement ng-disabled=ctrl.disable ng-model=ctrl.investigateur.etablissement uib-typeahead=\"etablissement as (etablissement.code +\' - \'+ etablissement.libelle) for etablissement in ctrl.autocompleteEtablissement($viewValue)\" typeahead-loading=etablissements type=text class=form-control typeahead-editable=false autocomplete=off placeholder=Rechercher... required> <span ng-show=ctrl.investigateur.etablissement class=input-group-btn> <a href=/#/referentiel/etablissement/{{ctrl.investigateur.etablissement.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label for=prenom class=control-label> Prénom </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.prenom.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=prenom name=prenom ng-disabled=ctrl.disable ng-model=ctrl.investigateur.prenom type=text class=form-control ng-maxlength=255 required> </div> </div> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.telephone.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label for=telephone> Téléphone </label> <input name=telephone ng-disabled=ctrl.disable ng-model=ctrl.investigateur.telephone type=tel pattern=^((\\+)33|0)[1-9](\\d{2}){4}$ class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label for=titre class=control-label> Titre </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.titre.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <select id=titre name=titre class=form-control ng-disabled=ctrl.disable ng-model=ctrl.investigateur.titre ng-options=\"titre as titre | translate for titre in ctrl.titres\" required><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> </div> </div> <div class=col-md-6> <div class=form-group gif-has-error> <label for=secretariat> Secrétariat </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.secretariat.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=secretariat name=secretariat ng-disabled=ctrl.disable ng-model=ctrl.investigateur.secretariat type=text class=form-control ng-maxlength=255> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.rue.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label> Adresse</label> <input name=rue ng-disabled=ctrl.disable ng-model=ctrl.investigateur.adresse.rue type=text ng-maxlength=255 class=form-control> </div> </div> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.telephonePortable.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label for=telephonePortable> Téléphone portable </label> <input name=telephonePortable ng-disabled=ctrl.disable ng-model=ctrl.investigateur.telephonePortable type=tel pattern=^((\\+)33|0)[1-9](\\d{2}){4}$ class=form-control> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <label> Complément </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.complement.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=complement ng-disabled=ctrl.disable ng-model=ctrl.investigateur.adresse.complement type=text class=form-control ng-maxlength=255> </div> </div> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label for=email class=control-label> Adresse email </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.email.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=email name=email ng-disabled=ctrl.disable ng-model=ctrl.investigateur.email type=email class=form-control ng-change=ctrl.verifyUser(ctrl.investigateur) required> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.codePostal.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.ville.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label> Code Postal / Ville</label> <div class=row> <div class=col-md-4> <input name=codePostal ng-disabled=ctrl.disable ng-model=ctrl.investigateur.adresse.codePostal ng-maxlength=255 type=text class=form-control> </div> <div class=col-md-8> <input name=ville ng-disabled=ctrl.disable ng-model=ctrl.investigateur.adresse.ville ng-maxlength=255 type=text class=form-control> </div> </div> </div> </div> <div class=col-md-6 ng-show=!ctrl.disable> <div class=form-group gif-has-error> <label for=iban class=control-label>IBAN</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.iban.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=iban name=iban ng-disabled=ctrl.disable ng-model=ctrl.investigateur.iban ng-iban type=text class=form-control> </div> </div> </div> <div class=row> <div class=col-md-12> <h3> Contacts <button ng-hide=ctrl.disable ng-click=ctrl.addContact() type=button class=\"btn btn-link btn-sm\"> <span class=\"glyphicon glyphicon-plus\" aria-hidden=true></span> Ajouter </button> </h3> </div> </div> <div class=row> <div class=col-md-12> <div class=table-responsive> <table class=\"table table-striped table-condensed\"> <thead> <th class=text-primary>Nom</th> <th class=text-primary>Prénom</th> <th class=text-primary>Téléphone</th> <th class=text-primary>Email</th> <th class=text-primary>Information</th> <th></th> </thead> <tbody> <tr class=table_row ng-repeat=\"contact in ctrl.investigateur.contacts\"> <td> <input ng-disabled=ctrl.disable ng-model=contact.nom type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.prenom type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.telephone type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.email type=text class=form-control> </td> <td> <input ng-disabled=ctrl.disable ng-model=contact.information type=text class=form-control> </td> <td style=\"vertical-align: middle\"> <a ng-hide=ctrl.disable ng-click=ctrl.removeContact($index)> <span title=\"Retirer un contact\" class=\"glyphicon glyphicon-trash\" aria-hidden=true></span> </a> </td> </tr> </tbody> </table> </div> </div> </div> <div class=row> <div class=form-group> <div class=col-md-12> <div class=footer> <div class=pull-left ng-hide=ctrl.disableConnexion> <button type=button ng-disabled=form.$invalid ng-click=ctrl.saveAndCreateUser(ctrl.investigateur) class=\"btn btn-default\">Ouvrir la connexion</button> </div> <div class=pull-right> <a class=\"btn btn-link\" href=/#/referentiel/investigateur>Annuler</a> <button ng-hide=ctrl.disable type=submit class=\"btn btn-primary\">Enregistrer</button> </div> </div> </div> </div> </div> </div></form> </div>");
$templateCache.put("app/referentiel/investigateur/list/InvestigateurList.html","<div> <h1>Investigateur</h1> <hr> <div class=row> <div class=col-md-2> <div class=\"btn-group btn-group-justified\"> <div class=btn-group> <button ng-class=\"{\'active\': ctrl.filtreActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(true)>Actif</button> </div> <div class=btn-group> <button ng-class=\"{\'active\': !ctrl.filtreActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(false)>Inactif</button> </div> </div> </div> <div class=\"col-md-offset-5 col-md-4\"> <input id=searchInvestigateur type=text class=form-control placeholder=Rechercher aria-describedby=basic-addon1 ng-model=ctrl.searchText ng-change=ctrl.onChangeSearchText(ctrl.searchText)> </div> <div class=col-md-1 ng-hide=ctrl.read> <button ng-click=ctrl.add() type=button class=\"pull-right btn btn-primary\">Ajouter</button> </div> </div> </div> <div ng-if=ctrl.page gif-paged-data=ctrl.onPagingOptionsChange(pagingOptions) gif-page-size={{ctrl.pageSize}}> <small class=text-muted> <strong>{{ctrl.page.number+1 * ctrl.pageSize}}</strong> premiers investigateurs parmi <strong>{{ctrl.page.totalElements}}</strong> {{ctrl.page.totalElements > 1 ? \'résultats\' : \'résultat\'}} </small> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-3\" gif-sortable=nom class=col-md-3>Nom</th> <th class=\"text-primary col-md-2\" gif-sortable=prenom class=col-md-2>Prénom</th> <th class=\"text-primary col-md-2\" gif-sortable=etablissement.libelle class=col-md-2>Etablissement</th> <th class=\"text-primary col-md-1\" gif-sortable=telephone class=col-md-1>Téléphone</th> <th class=\"text-primary col-md-4\" gif-sortable=email class=col-md-4>Email</th> </thead> <tbody> <tr ng-click=ctrl.goTo(investigateur.id) occlass=table_row ng-repeat=\"investigateur in ctrl.list\"> <td>{{investigateur.nom}}</td> <td>{{investigateur.prenom}}</td> <td>{{investigateur.etablissement.libelle}}</td> <td>{{investigateur.telephone}}</td> <td>{{investigateur.email}}</td> </tr> </tbody> </table> <div class=\"col-md-2 col-md-offset-5\"> <button ng-click=ctrl.viewMore() class=\"btn btn-default btn-sm\" ng-hide=ctrl.page.last>Afficher davantage</button> </div> </div>");
$templateCache.put("app/referentiel/promoteur/item/PromoteurItem.html","<div class=header> <h1 ng-if=ctrl.isUpdate>Promoteur - {{ctrl.promoteur.libelle}}</h1> <h1 ng-if=!ctrl.isUpdate>Ajout d\'un promoteur</h1> <hr> </div> <div class=main> <form id=promoteurForm name=form ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.promoteur)\" novalidate> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <label> Code </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.code.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=code ng-disabled=true ng-model=ctrl.promoteur.code gif-validate-async=\"{unique: ctrl.validateCode}\" type=text class=form-control ng-maxlength=255> </div> </div> <div class=col-md-6> <div class=form-group> <label>Statut</label> <div> <toggle-switch id=enabledInput ng-model=ctrl.promoteur.actif on-label=Actif off-label=Inactif is-disabled=ctrl.disable> </toggle-switch> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Libellé</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.libelle.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=libelle ng-disabled=ctrl.disable ng-model=ctrl.promoteur.libelle ng-maxlength=255 type=text class=form-control required> </div> </div> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Typologie </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.typologie.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <select name=typologie class=form-control ng-disabled=ctrl.disable ng-model=ctrl.promoteur.typologie ng-options=\"typologie as typologie | translate for typologie in ctrl.typologies\" required><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Raison sociale </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.raison.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=raison ng-disabled=ctrl.disable ng-model=ctrl.promoteur.raisonSociale type=text class=form-control ng-maxlength=255 required> </div> </div> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Etablissement</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.etablissement.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=custom-typeahead> <div ng-class=\"{\'input-group\': ctrl.promoteur.etablissement}\"> <input ng-disabled=ctrl.disable name=etablissement ng-model=ctrl.promoteur.etablissement uib-typeahead=\"etablissement as (etablissement.code +\' - \'+ etablissement.libelle) for etablissement in ctrl.autocompleteEtablissement($viewValue)\" typeahead-editable=false type=text class=\"form-control required\" placeholder=Rechercher... autocomplete=off required> <span ng-show=ctrl.promoteur.etablissement class=input-group-btn> <a href=/#/referentiel/etablissement/{{ctrl.promoteur.etablissement.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.rue.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label> Adresse</label> <input name=rue ng-disabled=ctrl.disable ng-model=ctrl.promoteur.adresse.rue type=text ng-maxlength=255 class=form-control> </div> </div> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.telephone.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label> Téléphone </label> <input name=telephone ng-disabled=ctrl.disable ng-model=ctrl.promoteur.telephone type=tel pattern=^((\\+)33|0)[1-9](\\d{2}){4}$ class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <label> Complément </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.complement.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=complement ng-disabled=ctrl.disable ng-model=ctrl.promoteur.adresse.complement type=text class=form-control ng-maxlength=255> </div> </div> <div class=col-md-6> <div class=form-group> <label> TVA communautaire </label> <input ng-disabled=ctrl.disable ng-model=ctrl.promoteur.tva type=text class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group gif-has-error> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.codePostal.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.ville.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <label> Code Postal / Ville</label> <div class=row> <div class=col-md-4> <input name=codePostal ng-disabled=ctrl.disable ng-model=ctrl.promoteur.adresse.codePostal ng-maxlength=255 type=text class=form-control> </div> <div class=col-md-8> <input name=ville ng-disabled=ctrl.disable ng-model=ctrl.promoteur.adresse.ville ng-maxlength=255 type=text class=form-control> </div> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label> N° SIRET </label> <input ng-disabled=ctrl.disable ng-model=ctrl.promoteur.siret type=text class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=\"form-group required\" gif-has-error> <label class=control-label> Pays </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.pays.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input name=pays ng-disabled=ctrl.disable ng-model=ctrl.promoteur.adresse.pays type=text class=form-control ng-maxlength=255 required> </div> </div> <div class=col-md-6> <div class=form-group> <label> N° FINESS </label> <input ng-disabled=ctrl.disable ng-model=ctrl.promoteur.finess type=text class=form-control> </div> </div> </div> <div class=row> <div class=col-md-6> <div class=form-group> <label> Commentaire </label> <textarea ng-disabled=ctrl.disable ng-model=ctrl.promoteur.commentaire class=form-control rows=3 maxlength=255>\n					</textarea> <small> Il vous reste <span>{{255 - ctrl.promoteur.commentaire.length}}</span> <span ng-if=\"255 - ctrl.promoteur.commentaire.length != 1 && 255 - ctrl.promoteur.commentaire.length != 0\">caractères</span> <span ng-if=\"255 - ctrl.promoteur.commentaire.length == 1 || 255 - ctrl.promoteur.commentaire.length == 0\">caractère</span>  </small> </div> </div> </div> <div class=row> <div class=form-group> <div class=col-md-12> <div class=footer> <div class=pull-right> <a class=\"btn btn-link\" href=/#/referentiel/promoteur>Annuler</a> <button type=submit ng-hide=ctrl.disable class=\"btn btn-primary\">Enregistrer</button> </div> </div> </div> </div> </div> </form> </div>");
$templateCache.put("app/referentiel/promoteur/list/PromoteurList.html","<div class=header> <h1>Promoteur</h1> <hr> <div class=row> <div class=col-md-2> <div class=\"btn-group btn-group-justified\"> <div class=btn-group> <button ng-class=\"{\'active\': ctrl.filtreActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(true)>Actif</button> </div> <div class=btn-group> <button ng-class=\"{\'active\': !ctrl.filtreActif}\" type=button class=\"btn btn-default\" ng-click=ctrl.onChangeActif(false)>Inactif</button> </div> </div> </div> <div class=\"col-md-offset-5 col-md-4\"> <input id=searchPromoteur type=text class=form-control placeholder=Rechercher aria-describedby=basic-addon1 ng-model=ctrl.searchText ng-change=ctrl.onChangeSearchText(ctrl.searchText)> </div> <div class=col-md-1 ng-hide=ctrl.read> <button ng-click=ctrl.add() type=button class=\"pull-right btn btn-primary\">Ajouter</button> </div> </div> </div> <div ng-if=ctrl.page gif-paged-data=ctrl.onPagingOptionsChange(pagingOptions) gif-page-size={{ctrl.pageSize}}> <small class=text-muted> <strong>{{ctrl.page.number+1 * ctrl.page.size}}</strong> premiers promoteurs parmi <strong>{{ctrl.page.totalElements}}</strong> {{ctrl.page.totalElements > 1 ? \'résultats\' : \'résultat\'}} </small> <div class=table-responsive> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-4\" gif-sortable=libelle>Libellé</th> <th class=\"text-primary col-md-4\" gif-sortable=raisonSociale>Raison sociale</th> <th class=\"text-primary col-md-2\" gif-sortable=adresse.ville>Ville</th> <th class=\"text-primary col-md-2\" gif-sortable=etablissement.libelle>Etablissement</th> </thead> <tbody> <tr ng-click=ctrl.goTo(promoteur.id) occlass=table_row ng-repeat=\"promoteur in ctrl.page.content\"> <td>{{promoteur.libelle}}</td> <td>{{promoteur.raisonSociale}}</td> <td>{{promoteur.adresse.ville}}</td> <td>{{promoteur.etablissement.libelle}}</td> </tr> </tbody> </table> <div class=\"col-md-2 col-md-offset-5\"> <button ng-click=ctrl.viewMore() class=\"btn btn-default btn-sm\" ng-hide=ctrl.page.last> Afficher davantage </button> </div> </div> </div>");
$templateCache.put("app/security/configuration-banner/item/ConfigurationBannerItem.html","<div> <h1>Bandeau d\'information</h1> <hr> <form name=form ng-class=\"{\'submitted\': submitted}\" ng-submit=\"form.$valid && ctrl.saveOrUpdate(ctrl.admin)\" novalidate> <div class=form-group> <div class=row> <div class=\"form-group col-md-12\"> <div class=col-md-12> <label class=control-label>Message à tous les utilisateurs</label> <textarea id=messageForAllUser name=messageForAllUser ng-model=ctrl.admin.messageForAllUser type=text class=form-control rows=8></textarea> </div> </div> <div class=col-md-12> <div class=form-group> <label class=control-label for=activationPopUp>Statut</label> <div> <toggle-switch id=activationPopUp ng-model=ctrl.admin.activationPopUp on-label=Actif off-label=Inactif> </toggle-switch> </div> </div> </div> </div> <div class=row> <div class=form-group> <div class=col-md-12> <div class=footer> <div class=pull-right> <a class=\"btn btn-link\" href=/#/security/configurationBanner>Annuler</a> <button ng-hide=ctrl.disable type=submit ng-click=\"submitted = true; \" class=\"btn btn-primary\">Enregistrer</button> </div> </div> </div> </div> </div> </div> </form> </div>");
$templateCache.put("app/security/configuration-banner/list/ConfigurationBannerList.html","<div> <h1>Bandeau d\'information</h1> <hr> <div> <div ng-if=\"ctrl.list[ctrl.list.length-1].activationPopUp \n			&& (ctrl.list[ctrl.list.length-1].messageForAllUser != null) && \n			(ctrl.list[ctrl.list.length-1].messageForAllUser != \'\') \"> <h2> Le message diffusé actuellement est :</h2> <div ng-repeat-start=\"admin in ctrl.list\" ng-repeat-end>{{admin.messageForAllUser}}</div> </div> <div ng-if=\"!ctrl.list[ctrl.list.length-1].activationPopUp \n			|| ctrl.list[ctrl.list.length-1].messageForAllUser == null \n			|| ctrl.list[ctrl.list.length-1].messageForAllUser == \'\' \"> <h2> Pas de message diffusé actuellement</h2> </div> <div class=col-md-12> <button ng-click=ctrl.goTo(ctrl.list[ctrl.list.length-1].id) type=button class=\"pull-right btn btn-primary\">Modifier</button> </div> </div> </div>");
$templateCache.put("app/security/utilisateur/item/UtilisateurItem.html","<div class=header> <h1 ng-if=ctrl.isUpdate>Utilisateur \'{{ctrl.utilisateur.username}}\'</h1> <h1 ng-if=!ctrl.isUpdate>Nouvel utilisateur</h1> <hr> </div> <div class=main> <form id=loginForm name=form ng-submit=\"form.$valid && ctrl.save(ctrl.utilisateur)\" gif-server-validate=ctrl.serverErrors novalidate> <div ng-if=\"form.$invalid && form.$submitted\" class=\"alert alert-danger\"> <strong>Certaines informations sont incorrectes.</strong><br> <ng-messages for=form.$error> <small ng-message=server.UniqueUsername>L\'identifiant choisi est déjà utilisé.</small> <small ng-message=server.UniqueEmail>Il existe déjà un compte pour l\'email renseigné.</small> </ng-messages> </div> <div class=row><!-- **************************** Login **************************** --> <div class=\"form-group col-md-3 required\" gif-has-error> <label class=control-label for=usernameInput>Identifiant</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.username.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div> <input id=usernameInput name=username class=\"form-control col-md-2\" type=text ng-model=ctrl.utilisateur.username placeholder=Identifiant required ng-pattern=/^\\S+$/ autofocus ng-disabled=\"ctrl.isUpdate || ctrl.disabled\" gif-validate-async=\"{unique: ctrl.validateUsername}\"> </div> </div><!-- **************************** Nom **************************** --> <div class=\"form-group col-md-3\" gif-has-error> <label class=control-label for=lastnameInput>Nom</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.lastname.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=lastnameInput name=lastname class=form-control type=text ng-maxlength=255 ng-model=ctrl.utilisateur.lastname placeholder=Nom> </div><!-- **************************** Prénom **************************** --> <div class=\"form-group col-md-3\" gif-has-error> <label class=control-label for=firstnameInput>Prénom</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.firstname.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=firstnameInput name=firstname class=form-control type=text ng-maxlength=255 ng-model=ctrl.utilisateur.firstname> </div><!-- **************************** Email **************************** --> <div class=\"form-group col-md-3 required\" gif-has-error> <label class=control-label for=emailInput>Email</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.email.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=emailInput name=email class=form-control type=email ng-model=ctrl.utilisateur.email gif-validate-async=\"{unique: ctrl.validateEmail}\" required> </div> </div> <div class=row><!-- **************************** Profil **************************** --> <div class=\"form-group col-md-3 required\" gif-has-error gif-role=ADMIN> <label class=control-label for=profilInput>Profil</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.role.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <select id=profilInput name=role class=form-control ng-model=ctrl.utilisateur.role ng-options=\"role as (role | translate) for role in ctrl.roles\" required><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> </div><!-- **************************** Etablissement **************************** --> <div class=\"form-group col-md-3 required\" gif-has-error gif-role=ADMIN> <label class=control-label> Code Etablissement</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.code.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div ng-class=\"{\'input-group\': ctrl.utilisateur.etablissement}\"> <input name=code ng-model=ctrl.utilisateur.etablissement uib-typeahead=\"etablissement as (etablissement.code +\' - \'+ etablissement.libelle) for etablissement in ctrl.autocompleteEtablissement($viewValue)\" type=text class=form-control typeahead-editable=false autocomplete=off required> <span ng-show=ctrl.utilisateur.etablissement class=input-group-btn> <a href=/#/referentiel/etablissement/{{ctrl.utilisateur.etablissement.id}} target=_blank class=\"btn btn-default\"> <span class=\"glyphicon glyphicon-new-window text-primary\"></span> </a> </span> </div> </div> <div class=\"form-group col-md-3 required\" gif-role=ADMIN> <label class=control-label for=enabledInput>Compte</label> <div> <toggle-switch id=enabledInput ng-model=ctrl.utilisateur.enabled on-label=Actif off-label=Inactif> </toggle-switch> </div> </div> </div> <div class=row><!-- **************************** Mot de passe **************************** --> <div class=\"form-group col-md-3 required\" gif-has-error ng-if=\"ctrl.editPassword && !ctrl.createFromInvestigateur && !ctrl.createFromBeneficiaire\"> <label class=control-label for=paswordInput>Mot de passe</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.password.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=paswordInput name=password ng-model=ctrl.utilisateur.password placeholder=\"Mot de passe\" class=form-control type=password required ng-pattern=\"/^(?=.*[A-Za-z])(?=.*\\d).{6,}$/\" autocomplete=off> <ng-messages class=\"pull-right text-danger\" for=form.password.$error ng-if=form.password.$touched> <small ng-message=pattern>Votre mot de passe doit être constitué d\'au moins 6 caractères dont au moins une lettre et un chiffre.</small> </ng-messages> </div><!-- **************************** Confirmation mot de passe **************************** --> <div class=\"form-group col-md-3\" gif-has-error ng-if=\"ctrl.editPassword && !ctrl.createFromInvestigateur && !ctrl.createFromBeneficiaire\"> <label class=control-label for=confirmPaswordInput>&nbsp;</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.passwordConfirmation.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=confirmPaswordInput name=passwordConfirmation class=form-control type=password ng-model=ctrl.utilisateur.passwordConfirmation placeholder=\"Confirmation mot de passe\" required match=form.password autocomplete=off> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.passwordConfirmation.$error> <small ng-message=match>Les deux mot de passe saisis ne coïncident pas</small> </ng-messages> </div> <div class=\"form-group col-md-3\" ng-if=\"!ctrl.editPassword && !ctrl.createFromInvestigateur && !ctrl.createFromBeneficiaire\"> <label class=control-label for=changePasswordButton>&nbsp;</label> <button id=changePasswordButton type=button class=\"btn btn-link\" ng-click=\"ctrl.editPassword = true\">Nouveau mot de passe</button> </div> </div> <div class=row></div> <div class=form-group> <div class=col-md-12> <div class=\"footer pull-right\"> <div class=pull-right> <a class=\"btn btn-link\" href=/#security/utilisateur>Annuler</a> <button type=submit class=\"btn btn-primary\">Enregistrer</button> </div> </div> </div> </div> </form> </div>");
$templateCache.put("app/security/utilisateur/list/UtilisateurList.html","<div> <h1>Compte utilisateur</h1> <hr> <div class=row> <div class=col-md-6> </div> <div class=col-md-5> <input id=searchFournisseur type=text class=\"form-control pull-right\" placeholder=Rechercher ng-model=ctrl.searchText ng-change=ctrl.loadUtilisateurs()> </div> <div class=col-md-1> <a href=/#/security/utilisateur/new class=\"pull-right btn btn-primary\">Ajouter</a> </div> </div> </div> <div ng-if=ctrl.page gif-paged-data=ctrl.onPagingOptionsChange(pagingOptions) gif-page-size={{ctrl.pageSize}}> <small class=text-muted> <strong>{{ctrl.page.number+1 * ctrl.page.size | number}}</strong> premiers utilisateurs parmi <strong>{{ctrl.page.totalElements | number}}</strong> {{ctrl.page.totalElements > 1 ? \'résultats\' : \'résultat\'}} </small> <table class=\"table table-striped table-condensed\"> <thead> <th class=\"text-primary col-md-3\" gif-sortable=username>Identifiant</th> <th class=\"text-primary col-md-2\" gif-sortable=lastname>Nom</th> <th class=\"text-primary col-md-2\" gif-sortable=firstname>Prénom</th> <th class=\"text-primary col-md-2\" gif-sortable=role>Profil</th> <th class=col-md-3>Établissement</th> </thead> <tbody> <tr ng-repeat=\"utilisateur in ctrl.page.content\" ng-click=ctrl.goTo(utilisateur.id)> <td>{{utilisateur.username}}</td> <td>{{utilisateur.lastname}}</td> <td>{{utilisateur.firstname}}</td> <td>{{utilisateur.role | translate}}</td> <td>{{utilisateur.etablissement.libelle}}</td> </tr> </tbody> </table> <div class=\"col-md-2 col-md-offset-5\"> <button ng-click=ctrl.viewMore() class=\"btn btn-default btn-sm\" ng-hide=ctrl.page.last> Afficher davantage </button> </div> </div>");
$templateCache.put("app/operation/item/demande_mission/detail/Detail.html","<div id=form-container> <div class=header> <div class=row> <div class=col-md-12> <h1>Nouvelle ligne de demande de mission</h1> </div> </div> <hr> </div><!-- the links to our nested states using relative paths --><!-- add the active class if the state matches our ui-sref --> <div id=status-buttons class=text-center> <a ng-class=\"{\'active\': layoutCtrl.currentState.indexOf(\'operation.item_demande_mission.detail.categorie\') != -1}\"> <span>1</span> Catégorie </a> <a ng-class=\"{\'active\': layoutCtrl.currentState.indexOf(\'operation.item_demande_mission.detail.information\') != -1}\"> <span>2</span> Informations </a> <a ng-class=\"{\'active\': layoutCtrl.currentState.indexOf(\'operation.item_demande_mission.detail.estimation\') != -1}\"> <span>3</span> Estimation </a> </div> <br> </div><!-- our nested state views will be injected here --> <div id=form-views ui-view></div><!-- show our formData as it is being typed --> <pre>\n        {{ ctrl.detail }}\n    </pre>");
$templateCache.put("app/operation/item/demande_mission/detail/DetailCategorie.html","<div class=row> <span ng-show=ctrl.libelleObligatoire class=\"pull-left text-danger col-md-12\"> <small>Sélectionner une valeur</small> </span> </div> <div class=row> <div class=\"form-group col-md-6\" ng-repeat=\"categorie in ctrl.listeCategorie\"> <uib-accordion id=libelle-buttons> <div uib-accordion-group class=panel-default is-open=status.open> <uib-accordion-heading> {{categorie.libelle}} <span class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}\"></span> </uib-accordion-heading> <div ng-repeat=\"detail in categorie.details\" class=col-md-2> <button ng-class=\"{\'active\':ctrl.detail.libelle === detail.libelle}\" type=button class=\"btn btn-default center-block\" ng-click=ctrl.getLibelleCategorie(detail,categorie)>{{detail.libelle}}</button> </div> </div> </uib-accordion> </div> </div> <div class=row> <div class=\"form-group col-md-1 pull-left\"> <button ng-click=ctrl.goToDemandeMission() class=\"btn btn-block btn-default\">Fermer</button> </div> <div class=\"form-group col-md-1 pull-right\"> <button ng-click=ctrl.nextStepCategorie() class=\"btn btn-block btn-primary\">Suivant</button> </div> </div>");
$templateCache.put("app/operation/item/demande_mission/detail/DetailEstimation.html","<form id=detailForm name=form ng-submit=\"form.$valid && ctrl.goToDemandeMission()\" novalidate> <div class=row> <div class=\"form-group col-md-3 required\" gif-has-error> <label class=control-label>Prix unitaire</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.unitaire.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=id_unitaire name=unitaire type=number class=form-control ng-change=ctrl.updateTotal() ng-model=ctrl.prixUnitaire required> </div> <div class=\"form-group col-md-3 required\" gif-has-error> <label class=control-label>Quantité</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.quantite.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=id_quantite name=quantite type=number class=form-control ng-model=ctrl.detail.quantite ng-change=ctrl.updateTotal() ng-init=\"ctrl.detail.quantite=1\" min=1 step=1 required> </div> <div class=\"form-group col-md-3 required\" gif-has-error> <label class=control-label>Total</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.total.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=id_total name=total type=number class=form-control ng-model=ctrl.detail.total ng-init=\"\" required ng-disabled=true> </div> </div> <div class=row> <div class=\"form-group col-md-6 required\" gif-has-error> <label class=control-label> Commentaire </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.commentaire.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <textarea name=commentaire ng-model=ctrl.detail.commentaire class=form-control rows=4 maxlength=255>\n            </textarea> <small> Il vous reste <span>{{255 - ctrl.detail.commentaire.length}}</span> <span ng-if=\"255 - ctrl.detail.commentaire.length != 1 && 255 - ctrl.detail.commentaire.length != 0\">caractères</span> <span ng-if=\"255 - ctrl.detail.commentaire.length == 1 || 255 - ctrl.detail.commentaire.length == 0\">caractère</span>  </small> </div> <div class=row> <div class=\"form-group col-md-1 pull-left\"> <a ui-sref=operation.item_demande_mission.detail.information class=\"btn btn-block btn-default\"> Précèdent </a> </div> <div class=\"form-group col-md-1 pull-right\"> <button type=submit ng-click=ctrl.addDetail() class=\"btn btn-block btn-primary\">Terminer</button> </div> </div> </div></form>");
$templateCache.put("app/operation/item/demande_mission/detail/DetailInformation.html","<div class=row> <div class=col-md-12> <h2>Informations complémentaires</h2> </div> </div> <div class=row> <div class=col-md-12> <legend>Pour les missions de France</legend> <div class=\"col-md-10 col-md-offset-1\"> <table class=\"table table-striped\"> <thead> <tr> <th class=\"bg-primary col-md-4\">Dépenses (TTC)</th> <th class=\"bg-primary col-md-4\">Forfait URSSAF</th> <th class=\"bg-primary col-md-4\">Frais réels</th> </tr> </thead> <tbody> <tr ng-repeat=\"detail in ctrl.getCategorie.details\"> <td class=bg-primary>{{detail.libelle}}</td> <td>{{detail.forfait}}</td> <td>{{detail.reel}}</td> </tr> </tbody> </table> </div> </div> </div> <div class=row> <div class=\"form-group col-md-1 pull-left\"> <a ui-sref=operation.item_demande_mission.detail.categorie class=\"btn btn-block btn-default\"> Précèdent </a> </div> <div class=\"form-group col-md-1 pull-right\"> <a ui-sref=operation.item_demande_mission.detail.estimation class=\"btn btn-block btn-primary\"> Suivant </a> </div> </div>");
$templateCache.put("app/operation/item/demande_mission/detail/Etape.html","<div class=header> <div class=row> <div class=col-md-6> <h1>Ajout d\'une étape</h1> </div> </div> </div> <hr> <form id=demandeMissionEtapeForm name=form ng-submit=\"form.$valid && ctrl.valider()\" novalidate> <div class=row> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=debut class=control-label> Date de début</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.debut.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=form-group> <div class=\"input-group date\" id=datetimepickerDebut> <input id=debut name=debut type=text class=form-control ng-model=ctrl.etape.dateDebut ng-change=ctrl.calculerPeriodes() gif-datetimepicker required> <span class=\"input-group-addon btn-default\"> <span class=\"glyphicon glyphicon-calendar text-primary\"></span> </span> </div> </div> </div> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=fin class=control-label> Date de fin</label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.fin.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <div class=form-group> <div class=\"input-group date\" id=datetimepickerFin> <input id=fin name=fin type=text class=form-control ng-model=ctrl.etape.dateFin ng-change=ctrl.calculerPeriodes() gif-datetimepicker required> <span class=input-group-addon> <span class=\"glyphicon glyphicon-calendar text-primary\"></span> </span> </div> </div> </div> <div class=\"form-group col-md-3 required\" gif-has-error> <label for=destination class=control-label> Destination </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.lieu.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <select id=destination name=lieu class=form-control ng-model=ctrl.destination ng-options=\"destination as destination.libelle for destination in ctrl.listCategories track by destination.id\" required><!-- Ici on met la balise option vide pour permettre de vérifier si le champ est vide pour le required --> <option></option> </select> </div> <div class=\"form-group col-md-3\" ng-show=\"ctrl.nbRepas || ctrl.nbNuit\"> <span class=control-label> Nombre de repas : {{ctrl.nbRepas}}</span> <br> <span class=control-label> Nombre de nuités : {{ctrl.nbNuit}}</span> </div> </div> <div class=row> <div class=\"form-group col-md-2\"> <label for=frais_repas>Forfait / réel pour les repas</label> <div> <toggle-switch id=frais_repas ng-model=ctrl.fraisRepas on-label=Réel off-label=Forfait> </toggle-switch> </div> </div> <div class=\"form-group col-md-2\"> <label for=frais_hotel>Forfait / Réel pour les nuités</label> <div> <toggle-switch id=frais_hotel ng-model=ctrl.fraisHotel on-label=Réel off-label=Forfait> </toggle-switch> </div> </div> </div> <div class=row> <div class=\"form-group col-md-2\"> <label for=vehicule>Véhicule personnel ?</label> <div> <toggle-switch id=vehicule ng-model=ctrl.vehicule on-label=Oui off-label=Non> </toggle-switch> </div> </div> <div class=\"form-group col-md-2\" ng-show=ctrl.vehicule gif-has-error> <label for=puissance class=control-label> Puissance fiscale </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.puissance.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <select id=puissance name=puissance class=form-control ng-model=ctrl.puissance ng-required=ctrl.vehicule> <option></option> <option value=3>3 CV et moins</option> <option value=4>4 CV</option> <option value=5>5 CV</option> <option value=6>6 CV</option> <option value=7>7 CV et plus</option> </select> </div> <div class=\"form-group col-md-2\" ng-show=ctrl.vehicule gif-has-error> <label for=distance class=control-label> Distance prévisionnelle (km) </label> <ng-messages class=\"pull-right text-danger has-error-messages\" for=form.distance.$error> <ng-messages-include src=app/default-messages.html> </ng-messages> <input id=distance name=distance type=number class=form-control ng-model=ctrl.distance min=0 step=1 ng-required=ctrl.vehicule> </div> </div> <div class=row> <div class=col-md-12> <div class=pull-right> <button type=button ng-click=ctrl.goToDemandeMission() class=\"btn btn-link\">Annuler</button> <button type=submit class=\"btn btn-primary\">Valider</button> </div> </div> </div> </form>");}]);